import * as React from 'react';
import React__default, { useState, useEffect, useRef, Children, Fragment, forwardRef, useId, useMemo, useCallback, createContext, useContext } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { createPortal } from 'react-dom';
import { Combobox, Transition, Switch } from '@headlessui/react';
import Chart from 'chart.js/auto';
import ChartJSPluginDataLabels from 'chartjs-plugin-datalabels';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import DateRangePicker from 'rsuite/DateRangePicker';
import 'rsuite/DateRangePicker/styles/index.css';
import * as SliderPrimitive from '@radix-ui/react-slider';

const Button = ({ type = "submit", size = "lg", ...props }) => {
    const _args = { onClick: props.onClick };
    //size
    let btnSize = ``;
    let textBtnSize = ``;
    if (size == "sm") {
        btnSize = `h-11 text-size-base`;
        textBtnSize = `initial:text-size-12`;
    }
    else if (size == "lg") {
        btnSize = `h-14 text-size-18`;
        textBtnSize = `initial:text-size-base`;
    }
    let defaultClasses = `rounded-5 px-8 py-2 font-opensans font-semibold  ${btnSize}`;
    defaultClasses = props.fullwidth
        ? `${defaultClasses} w-full`
        : `${defaultClasses}`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : defaultClasses;
    let primaryClasses = `${defaultClasses} bg-primary hover:bg-primary-110 text-white dark:bg-primary-dark dark:hover:bg-primary-110`;
    let secondaryClasses = `${defaultClasses} bg-neutral-0 hover:bg-neutral-5 border
  border-solid border-primary hover:border-primary-110
  text-primary hover:text-primary-110 dark:border-primary-dark dark:hover:border-primary-110 dark:text-primary-dark dark:hover:text-primary-110 dark:bg-neutral-dark-0 dark:hover:bg-neutral-dark-0`;
    let disabledClasses = `${defaultClasses} text-neutral-40 bg-neutral-20 hover:bg-neutral-20
  cursor-not-allowed dark:bg-neutral-dark-20 dark:text-neutral-dark-40`;
    let textClasses = `text-link-color hover:text-link-color-dark hover:underline  dark:text-link-color dark:hover:text-link-color-dark ${textBtnSize}`;
    let TextDisabled = `text-neutral-40 cursor-not-allowed  dark:text-neutral-dark-40 filter grayscale`;
    textClasses = props.disabled ? `${TextDisabled}` : `${textClasses}`;
    textClasses = props.customClass
        ? `${textClasses} ${props.customClass}`
        : textClasses;
    let textStatusSuccessClasses = `text-success hover:text-success hover:underline ${textBtnSize}`;
    let textStatusErrorClasses = `text-error hover:text-error hover:underline ${textBtnSize}`;
    textStatusSuccessClasses = props.customClass
        ? `${textStatusSuccessClasses} ${props.customClass}`
        : textStatusSuccessClasses;
    textStatusErrorClasses = props.customClass
        ? `${textStatusErrorClasses} ${props.customClass}`
        : textStatusErrorClasses;
    // let textDefaultClasses = props.status=="success" ? textStatusSuccessClasses: textClasses;
    let textDefaultClasses = "";
    if (props.status === "success") {
        textDefaultClasses = textStatusSuccessClasses;
    }
    else if (props.status === "error") {
        textDefaultClasses = textStatusErrorClasses;
    }
    else {
        textDefaultClasses = textClasses;
    }
    const buttonType = {
        primary: () => {
            return (React__default.createElement("button", { type: type, className: primaryClasses, ..._args }, props.children));
        },
        secondary: () => {
            return (React__default.createElement("button", { type: type, className: secondaryClasses, ..._args }, props.children));
        },
        disabled: () => {
            return (React__default.createElement("button", { type: type, className: disabledClasses, disabled: true }, props.children));
        },
        text: () => {
            return (React__default.createElement("button", { type: type, className: textDefaultClasses, disabled: props.disabled, ..._args }, props.children));
        },
    };
    const render = () => {
        return buttonType[props.variant || "primary"]();
    };
    return render();
};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

const CLASS_PART_SEPARATOR = '-';
const createClassGroupUtils = config => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = className => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
    if (classParts[0] === '' && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return undefined;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return classPartObject.validators.find(({
    validator
  }) => validator(classRest))?.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = className => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
    if (property) {
      // I use two dots here because one dot is used as prefix for class groups in plugins
      return 'arbitrary..' + property;
    }
  }
};
/**
 * Exported for testing only
 */
const createClassMap = config => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach(classDefinition => {
    if (typeof classDefinition === 'string') {
      const classPartObjectToEdit = classDefinition === '' ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === 'function') {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup]) => {
      processClassesRecursively(classGroup, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(pathPart => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = func => func.isThemeGetter;
const getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map(classDefinition => {
      if (typeof classDefinition === 'string') {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === 'object') {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};

// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
const createLruCache = maxCacheSize => {
  if (maxCacheSize < 1) {
    return {
      get: () => undefined,
      set: () => {}
    };
  }
  let cacheSize = 0;
  let cache = new Map();
  let previousCache = new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== undefined) {
        return value;
      }
      if ((value = previousCache.get(key)) !== undefined) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = '!';
const createParseClassName = config => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
  const parseClassName = className => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === '/') {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === '[') {
        bracketDepth++;
      } else if (currentCharacter === ']') {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return className => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */
const sortModifiers = modifiers => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach(modifier => {
    const isArbitraryVariant = modifier[0] === '[';
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
const createConfigUtils = config => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = '';
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        // Not a Tailwind class
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        // Not a Tailwind class
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(':');
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      // Tailwind class omitted due to conflict
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    // Tailwind class not in conflict
    result = originalClassName + (result.length > 0 ? ' ' + result : result);
  }
  return result;
};

/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = '';
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = mix => {
  if (typeof mix === 'string') {
    return mix;
  }
  let resolvedValue;
  let string = '';
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = key => {
  const themeGetter = theme => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /*#__PURE__*/new Set(['px', 'full', 'screen']);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isLength = value => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
const isArbitraryLength = value => getIsArbitraryValue(value, 'length', isLengthOnly);
const isNumber = value => Boolean(value) && !Number.isNaN(Number(value));
const isArbitraryNumber = value => getIsArbitraryValue(value, 'number', isNumber);
const isInteger = value => Boolean(value) && Number.isInteger(Number(value));
const isPercent = value => value.endsWith('%') && isNumber(value.slice(0, -1));
const isArbitraryValue = value => arbitraryValueRegex.test(value);
const isTshirtSize = value => tshirtUnitRegex.test(value);
const sizeLabels = /*#__PURE__*/new Set(['length', 'size', 'percentage']);
const isArbitrarySize = value => getIsArbitraryValue(value, sizeLabels, isNever);
const isArbitraryPosition = value => getIsArbitraryValue(value, 'position', isNever);
const imageLabels = /*#__PURE__*/new Set(['image', 'url']);
const isArbitraryImage = value => getIsArbitraryValue(value, imageLabels, isImage);
const isArbitraryShadow = value => getIsArbitraryValue(value, '', isShadow);
const isAny = () => true;
const getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === 'string' ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const isLengthOnly = value =>
// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
// For example, `hsl(0 0% 0%)` would be classified as a length without this check.
// I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
const isNever = () => false;
const isShadow = value => shadowRegex.test(value);
const isImage = value => imageRegex.test(value);
const getDefaultConfig = () => {
  const colors = fromTheme('colors');
  const spacing = fromTheme('spacing');
  const blur = fromTheme('blur');
  const brightness = fromTheme('brightness');
  const borderColor = fromTheme('borderColor');
  const borderRadius = fromTheme('borderRadius');
  const borderSpacing = fromTheme('borderSpacing');
  const borderWidth = fromTheme('borderWidth');
  const contrast = fromTheme('contrast');
  const grayscale = fromTheme('grayscale');
  const hueRotate = fromTheme('hueRotate');
  const invert = fromTheme('invert');
  const gap = fromTheme('gap');
  const gradientColorStops = fromTheme('gradientColorStops');
  const gradientColorStopPositions = fromTheme('gradientColorStopPositions');
  const inset = fromTheme('inset');
  const margin = fromTheme('margin');
  const opacity = fromTheme('opacity');
  const padding = fromTheme('padding');
  const saturate = fromTheme('saturate');
  const scale = fromTheme('scale');
  const sepia = fromTheme('sepia');
  const skew = fromTheme('skew');
  const space = fromTheme('space');
  const translate = fromTheme('translate');
  const getOverscroll = () => ['auto', 'contain', 'none'];
  const getOverflow = () => ['auto', 'hidden', 'clip', 'visible', 'scroll'];
  const getSpacingWithAutoAndArbitrary = () => ['auto', isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ['', isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ['auto', isNumber, isArbitraryValue];
  const getPositions = () => ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top'];
  const getLineStyles = () => ['solid', 'dashed', 'dotted', 'double', 'none'];
  const getBlendModes = () => ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity'];
  const getAlign = () => ['start', 'end', 'center', 'between', 'around', 'evenly', 'stretch'];
  const getZeroAndEmpty = () => ['', '0', isArbitraryValue];
  const getBreaks = () => ['auto', 'avoid', 'all', 'avoid-page', 'page', 'left', 'right', 'column'];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ':',
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ['none', '', isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ['none', '', 'full', isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ['auto', 'square', 'video', isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ['container'],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      'break-after': [{
        'break-after': getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      'break-before': [{
        'break-before': getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      'break-inside': [{
        'break-inside': ['auto', 'avoid', 'avoid-page', 'avoid-column']
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      'box-decoration': [{
        'box-decoration': ['slice', 'clone']
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ['border', 'content']
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ['block', 'inline-block', 'inline', 'flex', 'inline-flex', 'table', 'inline-table', 'table-caption', 'table-cell', 'table-column', 'table-column-group', 'table-footer-group', 'table-header-group', 'table-row-group', 'table-row', 'flow-root', 'grid', 'inline-grid', 'contents', 'list-item', 'hidden'],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ['right', 'left', 'none', 'start', 'end']
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ['left', 'right', 'both', 'none', 'start', 'end']
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ['isolate', 'isolation-auto'],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      'object-fit': [{
        object: ['contain', 'cover', 'fill', 'none', 'scale-down']
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      'object-position': [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-x': [{
        'overflow-x': getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-y': [{
        'overflow-y': getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-x': [{
        'overscroll-x': getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-y': [{
        'overscroll-y': getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ['static', 'fixed', 'absolute', 'relative', 'sticky'],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-x': [{
        'inset-x': [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-y': [{
        'inset-y': [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ['visible', 'invisible', 'collapse'],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ['auto', isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      'flex-direction': [{
        flex: ['row', 'row-reverse', 'col', 'col-reverse']
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      'flex-wrap': [{
        flex: ['wrap', 'wrap-reverse', 'nowrap']
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ['1', 'auto', 'initial', 'none', isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ['first', 'last', 'none', isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      'grid-cols': [{
        'grid-cols': [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start-end': [{
        col: ['auto', {
          span: ['full', isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start': [{
        'col-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-end': [{
        'col-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      'grid-rows': [{
        'grid-rows': [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start-end': [{
        row: ['auto', {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start': [{
        'row-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-end': [{
        'row-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      'grid-flow': [{
        'grid-flow': ['row', 'col', 'dense', 'row-dense', 'col-dense']
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      'auto-cols': [{
        'auto-cols': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      'auto-rows': [{
        'auto-rows': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-x': [{
        'gap-x': [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-y': [{
        'gap-y': [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      'justify-content': [{
        justify: ['normal', ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      'justify-items': [{
        'justify-items': ['start', 'end', 'center', 'stretch']
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      'justify-self': [{
        'justify-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      'align-content': [{
        content: ['normal', ...getAlign(), 'baseline']
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      'align-items': [{
        items: ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      'align-self': [{
        self: ['auto', 'start', 'end', 'center', 'stretch', 'baseline']
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      'place-content': [{
        'place-content': [...getAlign(), 'baseline']
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      'place-items': [{
        'place-items': ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      'place-self': [{
        'place-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      'space-x': [{
        'space-x': [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-x-reverse': ['space-x-reverse'],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      'space-y': [{
        'space-y': [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-y-reverse': ['space-y-reverse'],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ['auto', 'min', 'max', 'fit', 'svw', 'lvw', 'dvw', isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      'min-w': [{
        'min-w': [isArbitraryValue, spacing, 'min', 'max', 'fit']
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      'max-w': [{
        'max-w': [isArbitraryValue, spacing, 'none', 'full', 'min', 'max', 'fit', 'prose', {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      'min-h': [{
        'min-h': [isArbitraryValue, spacing, 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      'max-h': [{
        'max-h': [isArbitraryValue, spacing, 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit']
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      'font-size': [{
        text: ['base', isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      'font-smoothing': ['antialiased', 'subpixel-antialiased'],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      'font-style': ['italic', 'not-italic'],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      'font-weight': [{
        font: ['thin', 'extralight', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black', isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      'font-family': [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-normal': ['normal-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-ordinal': ['ordinal'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-slashed-zero': ['slashed-zero'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-figure': ['lining-nums', 'oldstyle-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-spacing': ['proportional-nums', 'tabular-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-fraction': ['diagonal-fractions', 'stacked-fractions'],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ['tighter', 'tight', 'normal', 'wide', 'wider', 'widest', isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      'line-clamp': [{
        'line-clamp': ['none', isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ['none', 'tight', 'snug', 'normal', 'relaxed', 'loose', isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      'list-image': [{
        'list-image': ['none', isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      'list-style-type': [{
        list: ['none', 'disc', 'decimal', isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      'list-style-position': [{
        list: ['inside', 'outside']
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      'placeholder-color': [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      'placeholder-opacity': [{
        'placeholder-opacity': [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      'text-alignment': [{
        text: ['left', 'center', 'right', 'justify', 'start', 'end']
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      'text-color': [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      'text-opacity': [{
        'text-opacity': [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      'text-decoration': ['underline', 'overline', 'line-through', 'no-underline'],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      'text-decoration-style': [{
        decoration: [...getLineStyles(), 'wavy']
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      'text-decoration-thickness': [{
        decoration: ['auto', 'from-font', isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      'underline-offset': [{
        'underline-offset': ['auto', isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      'text-decoration-color': [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      'text-transform': ['uppercase', 'lowercase', 'capitalize', 'normal-case'],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      'text-overflow': ['truncate', 'text-ellipsis', 'text-clip'],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      'text-wrap': [{
        text: ['wrap', 'nowrap', 'balance', 'pretty']
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      'vertical-align': [{
        align: ['baseline', 'top', 'middle', 'bottom', 'text-top', 'text-bottom', 'sub', 'super', isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ['normal', 'nowrap', 'pre', 'pre-line', 'pre-wrap', 'break-spaces']
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ['normal', 'words', 'all', 'keep']
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ['none', 'manual', 'auto']
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ['none', isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      'bg-attachment': [{
        bg: ['fixed', 'local', 'scroll']
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      'bg-clip': [{
        'bg-clip': ['border', 'padding', 'content', 'text']
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      'bg-opacity': [{
        'bg-opacity': [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      'bg-origin': [{
        'bg-origin': ['border', 'padding', 'content']
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      'bg-position': [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      'bg-repeat': [{
        bg: ['no-repeat', {
          repeat: ['', 'x', 'y', 'round', 'space']
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      'bg-size': [{
        bg: ['auto', 'cover', 'contain', isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      'bg-image': [{
        bg: ['none', {
          'gradient-to': ['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      'bg-color': [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from-pos': [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via-pos': [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to-pos': [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from': [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via': [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to': [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-s': [{
        'rounded-s': [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-e': [{
        'rounded-e': [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-t': [{
        'rounded-t': [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-r': [{
        'rounded-r': [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-b': [{
        'rounded-b': [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-l': [{
        'rounded-l': [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ss': [{
        'rounded-ss': [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-se': [{
        'rounded-se': [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ee': [{
        'rounded-ee': [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-es': [{
        'rounded-es': [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tl': [{
        'rounded-tl': [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tr': [{
        'rounded-tr': [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-br': [{
        'rounded-br': [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-bl': [{
        'rounded-bl': [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w': [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-x': [{
        'border-x': [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-y': [{
        'border-y': [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-s': [{
        'border-s': [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-e': [{
        'border-e': [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-t': [{
        'border-t': [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-r': [{
        'border-r': [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-b': [{
        'border-b': [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-l': [{
        'border-l': [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      'border-opacity': [{
        'border-opacity': [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      'border-style': [{
        border: [...getLineStyles(), 'hidden']
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x': [{
        'divide-x': [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x-reverse': ['divide-x-reverse'],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y': [{
        'divide-y': [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y-reverse': ['divide-y-reverse'],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      'divide-opacity': [{
        'divide-opacity': [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      'divide-style': [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color': [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-x': [{
        'border-x': [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-y': [{
        'border-y': [borderColor]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-s': [{
        'border-s': [borderColor]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-e': [{
        'border-e': [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-t': [{
        'border-t': [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-r': [{
        'border-r': [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-b': [{
        'border-b': [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-l': [{
        'border-l': [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      'divide-color': [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      'outline-style': [{
        outline: ['', ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      'outline-offset': [{
        'outline-offset': [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      'outline-w': [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      'outline-color': [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w': [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w-inset': ['ring-inset'],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      'ring-color': [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      'ring-opacity': [{
        'ring-opacity': [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      'ring-offset-w': [{
        'ring-offset': [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      'ring-offset-color': [{
        'ring-offset': [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ['', 'inner', 'none', isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      'shadow-color': [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      'mix-blend': [{
        'mix-blend': [...getBlendModes(), 'plus-lighter', 'plus-darker']
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      'bg-blend': [{
        'bg-blend': getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ['', 'none']
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      'drop-shadow': [{
        'drop-shadow': ['', 'none', isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      'hue-rotate': [{
        'hue-rotate': [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      'backdrop-filter': [{
        'backdrop-filter': ['', 'none']
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      'backdrop-blur': [{
        'backdrop-blur': [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      'backdrop-brightness': [{
        'backdrop-brightness': [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      'backdrop-contrast': [{
        'backdrop-contrast': [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      'backdrop-grayscale': [{
        'backdrop-grayscale': [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      'backdrop-hue-rotate': [{
        'backdrop-hue-rotate': [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      'backdrop-invert': [{
        'backdrop-invert': [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      'backdrop-opacity': [{
        'backdrop-opacity': [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      'backdrop-saturate': [{
        'backdrop-saturate': [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      'backdrop-sepia': [{
        'backdrop-sepia': [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      'border-collapse': [{
        border: ['collapse', 'separate']
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing': [{
        'border-spacing': [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-x': [{
        'border-spacing-x': [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-y': [{
        'border-spacing-y': [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      'table-layout': [{
        table: ['auto', 'fixed']
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ['top', 'bottom']
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ['none', 'all', '', 'colors', 'opacity', 'shadow', 'transform', isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ['linear', 'in', 'out', 'in-out', isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ['none', 'spin', 'ping', 'pulse', 'bounce', isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ['', 'gpu', 'none']
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-x': [{
        'scale-x': [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-y': [{
        'scale-y': [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-x': [{
        'translate-x': [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-y': [{
        'translate-y': [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-x': [{
        'skew-x': [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-y': [{
        'skew-y': [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      'transform-origin': [{
        origin: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left', isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ['auto', colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ['none', 'auto']
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ['auto', 'default', 'pointer', 'wait', 'text', 'move', 'help', 'not-allowed', 'none', 'context-menu', 'progress', 'cell', 'crosshair', 'vertical-text', 'alias', 'copy', 'no-drop', 'grab', 'grabbing', 'all-scroll', 'col-resize', 'row-resize', 'n-resize', 'e-resize', 's-resize', 'w-resize', 'ne-resize', 'nw-resize', 'se-resize', 'sw-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'zoom-in', 'zoom-out', isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      'caret-color': [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      'pointer-events': [{
        'pointer-events': ['none', 'auto']
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ['none', 'y', 'x', '']
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      'scroll-behavior': [{
        scroll: ['auto', 'smooth']
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-m': [{
        'scroll-m': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mx': [{
        'scroll-mx': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-my': [{
        'scroll-my': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ms': [{
        'scroll-ms': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-me': [{
        'scroll-me': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mt': [{
        'scroll-mt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mr': [{
        'scroll-mr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mb': [{
        'scroll-mb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ml': [{
        'scroll-ml': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-p': [{
        'scroll-p': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-px': [{
        'scroll-px': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-py': [{
        'scroll-py': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-ps': [{
        'scroll-ps': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pe': [{
        'scroll-pe': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pt': [{
        'scroll-pt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pr': [{
        'scroll-pr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pb': [{
        'scroll-pb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pl': [{
        'scroll-pl': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      'snap-align': [{
        snap: ['start', 'end', 'center', 'align-none']
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      'snap-stop': [{
        snap: ['normal', 'always']
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-type': [{
        snap: ['none', 'x', 'y', 'both']
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-strictness': [{
        snap: ['mandatory', 'proximity']
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ['auto', 'none', 'manipulation']
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-x': [{
        'touch-pan': ['x', 'left', 'right']
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-y': [{
        'touch-pan': ['y', 'up', 'down']
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-pz': ['touch-pinch-zoom'],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ['none', 'text', 'all', 'auto']
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      'will-change': [{
        'will-change': ['auto', 'scroll', 'contents', 'transform', isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, 'none']
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      'stroke-w': [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, 'none']
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ['sr-only', 'not-sr-only'],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      'forced-color-adjust': [{
        'forced-color-adjust': ['auto', 'none']
      }]
    },
    conflictingClassGroups: {
      overflow: ['overflow-x', 'overflow-y'],
      overscroll: ['overscroll-x', 'overscroll-y'],
      inset: ['inset-x', 'inset-y', 'start', 'end', 'top', 'right', 'bottom', 'left'],
      'inset-x': ['right', 'left'],
      'inset-y': ['top', 'bottom'],
      flex: ['basis', 'grow', 'shrink'],
      gap: ['gap-x', 'gap-y'],
      p: ['px', 'py', 'ps', 'pe', 'pt', 'pr', 'pb', 'pl'],
      px: ['pr', 'pl'],
      py: ['pt', 'pb'],
      m: ['mx', 'my', 'ms', 'me', 'mt', 'mr', 'mb', 'ml'],
      mx: ['mr', 'ml'],
      my: ['mt', 'mb'],
      size: ['w', 'h'],
      'font-size': ['leading'],
      'fvn-normal': ['fvn-ordinal', 'fvn-slashed-zero', 'fvn-figure', 'fvn-spacing', 'fvn-fraction'],
      'fvn-ordinal': ['fvn-normal'],
      'fvn-slashed-zero': ['fvn-normal'],
      'fvn-figure': ['fvn-normal'],
      'fvn-spacing': ['fvn-normal'],
      'fvn-fraction': ['fvn-normal'],
      'line-clamp': ['display', 'overflow'],
      rounded: ['rounded-s', 'rounded-e', 'rounded-t', 'rounded-r', 'rounded-b', 'rounded-l', 'rounded-ss', 'rounded-se', 'rounded-ee', 'rounded-es', 'rounded-tl', 'rounded-tr', 'rounded-br', 'rounded-bl'],
      'rounded-s': ['rounded-ss', 'rounded-es'],
      'rounded-e': ['rounded-se', 'rounded-ee'],
      'rounded-t': ['rounded-tl', 'rounded-tr'],
      'rounded-r': ['rounded-tr', 'rounded-br'],
      'rounded-b': ['rounded-br', 'rounded-bl'],
      'rounded-l': ['rounded-tl', 'rounded-bl'],
      'border-spacing': ['border-spacing-x', 'border-spacing-y'],
      'border-w': ['border-w-s', 'border-w-e', 'border-w-t', 'border-w-r', 'border-w-b', 'border-w-l'],
      'border-w-x': ['border-w-r', 'border-w-l'],
      'border-w-y': ['border-w-t', 'border-w-b'],
      'border-color': ['border-color-s', 'border-color-e', 'border-color-t', 'border-color-r', 'border-color-b', 'border-color-l'],
      'border-color-x': ['border-color-r', 'border-color-l'],
      'border-color-y': ['border-color-t', 'border-color-b'],
      'scroll-m': ['scroll-mx', 'scroll-my', 'scroll-ms', 'scroll-me', 'scroll-mt', 'scroll-mr', 'scroll-mb', 'scroll-ml'],
      'scroll-mx': ['scroll-mr', 'scroll-ml'],
      'scroll-my': ['scroll-mt', 'scroll-mb'],
      'scroll-p': ['scroll-px', 'scroll-py', 'scroll-ps', 'scroll-pe', 'scroll-pt', 'scroll-pr', 'scroll-pb', 'scroll-pl'],
      'scroll-px': ['scroll-pr', 'scroll-pl'],
      'scroll-py': ['scroll-pt', 'scroll-pb'],
      touch: ['touch-x', 'touch-y', 'touch-pz'],
      'touch-x': ['touch'],
      'touch-y': ['touch'],
      'touch-pz': ['touch']
    },
    conflictingClassGroupModifiers: {
      'font-size': ['leading']
    }
  };
};
const twMerge = /*#__PURE__*/createTailwindMerge(getDefaultConfig);

function Sanitize({ check, children, }) {
    if (!check)
        return React__default.createElement(React__default.Fragment, null);
    return React__default.createElement(React__default.Fragment, null, children);
}
function addCustomClassToBaseClass(baseClass, customClass) {
    return customClass ? `${baseClass} ${customClass}` : baseClass;
}
function sanitizeString(value) {
    return value ?? "";
}
function chooseBinaryClass(check, class1, class2) {
    return check ? class1 : class2;
}
function cn(...inputs) {
    return twMerge(clsx(inputs));
}

function DefaultTextInput({ onFocus, onBlur, name, suffix, prefix, wrapActiveClasses, wrapperClasses, inputClasses, customClass, variant, ...restProps }) {
    const [focused, setFocused] = useState(false);
    const onFocusHandler = (e) => {
        if (onFocus) {
            onFocus(e);
        }
        setFocused(true);
    };
    const onBlurHandler = (e) => {
        if (onBlur) {
            onBlur(e);
        }
        setFocused(false);
    };
    return (React__default.createElement("div", { className: focused ? wrapActiveClasses : wrapperClasses, "data-name": name },
        React__default.createElement(Sanitize, { check: Boolean(prefix) },
            React__default.createElement("span", { className: "block pl-2" }, prefix)),
        React__default.createElement("input", { ...restProps, className: inputClasses, onFocus: onFocusHandler, onBlur: onBlurHandler }),
        React__default.createElement(Sanitize, { check: Boolean(suffix) },
            React__default.createElement("span", { className: "block pr-2" }, suffix))));
}
function InputSecureTextInput({ onFocus, onBlur, name, suffix, prefix, wrapActiveClasses, wrapperClasses, inputClasses, value, onClick, onChange, customClass, variant, ...restProps }) {
    const _args = { onClick: onClick };
    const [focused, setFocused] = useState(false);
    const [originalPassword, setOriginalPassword] = useState("");
    const onFocusHandler = (e) => {
        if (onFocus) {
            onFocus(e);
        }
        setFocused(true);
    };
    const onBlurHandler = (e) => {
        if (onBlur) {
            onBlur(e);
        }
        setFocused(false);
    };
    useEffect(() => {
        if (value) {
            const val = value;
            setOriginalPassword(val);
        }
    }, [value]);
    const [currentCursorEndPosition, setCurrentCursorEndPosition] = useState(0);
    const [currentCursorStartPosition, setCurrentCursorStartPosition] = useState(0);
    const handlePasswordChange = (e) => {
        let enteredValue = e?.target?.value;
        const nativeEventData = e?.nativeEvent?.data;
        const nativeEventInputType = e?.nativeEvent?.inputType;
        if (e?.target?.value && nativeEventData) {
            //This condition occurs when multiple texts are selected and
            //we input by replacing all selected text with input text
            if (currentCursorStartPosition !== currentCursorEndPosition) {
                enteredValue =
                    originalPassword.slice(0, currentCursorStartPosition) +
                        nativeEventData +
                        originalPassword.slice(currentCursorEndPosition, originalPassword.length);
            }
            else {
                enteredValue =
                    originalPassword.slice(0, currentCursorStartPosition) +
                        nativeEventData +
                        originalPassword.slice(currentCursorStartPosition, originalPassword.length);
            }
            setOriginalPassword(enteredValue);
        }
        else if (nativeEventData === null) {
            //This condition occurs when multiple texts are selected and
            //we delete all selected texts
            if (currentCursorStartPosition !== currentCursorEndPosition) {
                //For deleting backward(delete)
                if (nativeEventInputType === "deleteContentBackward") {
                    enteredValue =
                        originalPassword.slice(0, currentCursorStartPosition) +
                            originalPassword.slice(currentCursorEndPosition, originalPassword.length);
                    //For deleting forward(fn + delete)
                }
                else if (nativeEventInputType === "deleteContentForward") {
                    enteredValue =
                        originalPassword.slice(0, currentCursorStartPosition) +
                            originalPassword.slice(currentCursorEndPosition + 1, originalPassword.length);
                }
            }
            else {
                if (nativeEventInputType === "deleteContentBackward") {
                    enteredValue =
                        originalPassword.slice(0, currentCursorStartPosition - 1) +
                            originalPassword.slice(currentCursorEndPosition, originalPassword.length);
                }
                else if (nativeEventInputType === "deleteContentForward") {
                    enteredValue =
                        originalPassword.slice(0, currentCursorStartPosition) +
                            originalPassword.slice(currentCursorEndPosition + 1, originalPassword.length);
                }
            }
            setOriginalPassword(enteredValue);
        }
        // Invoke the onChange prop callback with the event object
        if (onChange) {
            e.target.value = enteredValue;
            onChange(e);
        }
    };
    return (React__default.createElement("div", { className: chooseBinaryClass(focused, wrapActiveClasses, wrapperClasses), "data-name": name },
        React__default.createElement(Sanitize, { check: Boolean(prefix) },
            React__default.createElement("span", { className: "block pl-2" }, prefix)),
        React__default.createElement("input", { ...restProps, className: inputClasses, ..._args, onPaste: (e) => {
                e.preventDefault();
                return false;
            }, onCopy: (e) => {
                e.preventDefault();
                return false;
            }, onCut: (e) => {
                e.preventDefault();
                return false;
            }, value: "•".repeat(originalPassword?.length), onFocus: onFocusHandler, onBlur: onBlurHandler, onChange: handlePasswordChange, onSelect: (e) => {
                setCurrentCursorStartPosition(e?.target?.selectionStart);
                setCurrentCursorEndPosition(e?.target?.selectionEnd);
            } }),
        React__default.createElement(Sanitize, { check: Boolean(suffix) },
            React__default.createElement("span", { className: "block pr-2" }, suffix))));
}
function TextInput(props) {
    const { type, variant = "default", theme, placeholder, icon, fill, bgColor, prefix, suffix, customClass = "", disabled, status, onChange, name = null, value, onBlur, onInput, maxLength, ...restProps } = props;
    const propArray = { ...restProps };
    const notRequiredProp = ["prefix", "suffix", "variant", "customClass"];
    notRequiredProp.map((item) => {
        if (propArray[item]) {
            delete propArray[item];
        }
    });
    //For theming - Case & BackgroundColor
    let wrapperBg = ` bg-primary-N5`;
    let caseClass = "normal-case";
    if (theme) {
        //Background Color
        wrapperBg = chooseBinaryClass(theme.bgColorClass, theme.bgColorClass, wrapperBg);
        //Case format
        if (theme.format === "uppercase") {
            caseClass = `uppercase`;
        }
        else if (theme.format === "lowercase") {
            caseClass = `lowercase`;
        }
        else if (theme.format === "capitalize") {
            caseClass = `capitalize`;
        }
    }
    //Input border conditions.
    let borderDefaultClass = `border-primary-neutral-10 dark:border-neutral-dark-10`; //Default border color
    let borderFocusDefaultClass = `border-primary dark:border-primary-dark`; // Default focus class
    let borderErrorClass = `border-error dark:border-error`; // With error status
    let borderWarningClass = `border-warning dark:border-warning`; // with warning status
    let borderClass = borderDefaultClass;
    let focusClass = borderFocusDefaultClass;
    if (status === "error") {
        borderClass = borderErrorClass;
        focusClass = borderErrorClass;
    }
    else if (status === "alert") {
        borderClass = borderWarningClass;
        focusClass = borderWarningClass;
    }
    let wrapperDefaultClasses = `${wrapperBg} flex border border-solid rounded-md items-center hover:bg-neutral-0 focus:bg-neutral-0
  focus:border-primary py-2.5 h-12 outline-none font-opensans
   dark:bg-neutral-dark-10 dark:hover:bg-neutral-dark-5  dark:focus:border-primary-dark`;
    wrapperDefaultClasses = addCustomClassToBaseClass(wrapperDefaultClasses, customClass);
    let wrapperClasses = `${wrapperDefaultClasses} ${borderClass}`;
    //Focus style for input wrapper,
    let wrapActiveClasses = `${wrapperDefaultClasses} ${focusClass}`;
    let disabledClasses = `flex rounded-md items-center border border-solid border-neutral-20 bg-neutral-10 hover:bg-neutral-10 
  text-neutral placeholder-neutral-30 w-full py-2.5 h-12 outline-none dark:bg-neutral-dark-20 dark:text-neutral-dark-40 dark:border-neutral-dark-20 cursor-not-allowed`;
    //Text input styles
    let inputClasses = `${caseClass} text-neutral-dark-0 bg-transparent outline-none flex-1 placeholder-neutral-30
  py-4 px-2 outline-none h-12 text-size-16 dark:text-neutral-dark-110 rounded-md w-full`;
    if (disabled === true) {
        wrapActiveClasses = disabledClasses;
        wrapperClasses = disabledClasses;
        inputClasses = `${inputClasses} cursor-not-allowed dark:text-neutral-40 dark:placeholder-neutral-40`;
    }
    const render = () => {
        switch (variant) {
            case "default":
                return (React__default.createElement(DefaultTextInput, { wrapActiveClasses: wrapActiveClasses, wrapperClasses: wrapperClasses, inputClasses: inputClasses, ...props }));
            case "inputSecure":
                return (React__default.createElement(InputSecureTextInput, { wrapActiveClasses: wrapActiveClasses, wrapperClasses: wrapperClasses, inputClasses: inputClasses, ...props }));
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return render();
}

const Label = ({ message, customClass, required = false }) => {
    let defaultClasses = `font-opensans text-neutral-60 text-size-14 font-semibold block mb-1 dark:text-neutral-dark-80`;
    defaultClasses = customClass ? `${defaultClasses} ${customClass}` : defaultClasses;
    return (React__default.createElement("label", { className: defaultClasses },
        message,
        " ",
        required && React__default.createElement("span", { className: "text-error" }, "*")));
};

const has$1 = function (obj, key) {
    let keyParts = key.split(".");
    return (!!obj &&
        (keyParts.length > 1
            ? has$1(obj[key.split(".")[0]], keyParts.slice(1).join("."))
            : obj.hasOwnProperty(key)));
};
const IconList = (props) => {
    let { className, fill } = props;
    const { name = "Default" } = props;
    const primaryColor = "#3E74FF";
    className = `icon-svg ${className}`;
    if (!fill) {
        fill = primaryColor;
    }
    const svg = {
        Check: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React__default.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
            React__default.createElement("path", { d: "M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z", fill: fill }))),
        Alert: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14.002", viewBox: "0 0 14 14.002" },
            React__default.createElement("g", { id: "Group_7952", "data-name": "Group 7952", transform: "translate(0 0.001)" },
                React__default.createElement("path", { id: "Subtraction_16", "data-name": "Subtraction 16", d: "M2737-11923a7.009,7.009,0,0,1-7-7,7.009,7.009,0,0,1,7-7,7.008,7.008,0,0,1,7,7A7.008,7.008,0,0,1,2737-11923Zm0-13a6.007,6.007,0,0,0-6,6,6.008,6.008,0,0,0,6,6,6.008,6.008,0,0,0,6-6A6.007,6.007,0,0,0,2737-11936Z", transform: "translate(-2730 11937)", fill: "#ffd591" }),
                React__default.createElement("g", { id: "Group_6395", "data-name": "Group 6395", transform: "translate(0.868 0.868)" },
                    React__default.createElement("rect", { id: "Rectangle_4413", "data-name": "Rectangle 4413", width: "1.625", height: "5.688", rx: "0.813", transform: "translate(5.318 1.941)", fill: "#ffa940" }),
                    React__default.createElement("path", { id: "Path_20116", "data-name": "Path 20116", d: "M.813,0A.813.813,0,1,1,0,.813.813.813,0,0,1,.813,0Z", transform: "translate(5.318 8.71)", fill: "#ffa940" }))))),
        Info: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
            React__default.createElement("g", { id: "Group_6927", "data-name": "Group 6927", transform: "translate(-324 -687.001)" },
                React__default.createElement("g", { id: "Group_6850", "data-name": "Group 6850", transform: "translate(324 687.27)" },
                    React__default.createElement("g", { id: "Rectangle_3008", "data-name": "Rectangle 3008", transform: "translate(0 -0.269)", stroke: "#e7edf9", strokeWidth: "1", className: "fill-neutral-dark-110 dark:fill-neutral-dark-0" },
                        React__default.createElement("rect", { width: "16", height: "16", rx: "2", stroke: "none" }),
                        React__default.createElement("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "1.5", fill: "none" }))),
                React__default.createElement("g", { id: "Layer_x0020_1", transform: "translate(324.443 687.416)" },
                    React__default.createElement("path", { id: "Path_18950", "data-name": "Path 18950", d: "M9.437,4.524a1.339,1.339,0,0,1-1.8,0,1.1,1.1,0,0,1-.375-.839,1.115,1.115,0,0,1,.375-.841,1.274,1.274,0,0,1,.9-.349,1.26,1.26,0,0,1,.9.349,1.132,1.132,0,0,1,0,1.679Zm.094,7.648q-.641.253-1.023.385a2.7,2.7,0,0,1-.887.133,1.767,1.767,0,0,1-1.207-.379,1.223,1.223,0,0,1-.43-.961,3.483,3.483,0,0,1,.032-.463c.022-.157.056-.335.1-.534l.535-1.89c.047-.181.088-.354.12-.514A2.282,2.282,0,0,0,6.822,7.5.685.685,0,0,0,6.673,7,.847.847,0,0,0,6.1,6.859a1.491,1.491,0,0,0-.425.063c-.144.044-.269.084-.372.124l.141-.582Q5.971,6.25,6.451,6.1a2.973,2.973,0,0,1,.907-.153,1.735,1.735,0,0,1,1.19.373,1.238,1.238,0,0,1,.418.967q0,.123-.029.434a2.9,2.9,0,0,1-.107.57L8.3,10.173a5.289,5.289,0,0,0-.117.518,2.727,2.727,0,0,0-.051.44.632.632,0,0,0,.168.512.94.94,0,0,0,.582.137,1.682,1.682,0,0,0,.44-.068,2.531,2.531,0,0,0,.356-.119l-.143.582Z", transform: "translate(0 -0.01)", fill: "#9faabe", fillRule: "evenodd" }))))),
        infoRound: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14.002", height: "13.999", viewBox: "0 0 14.002 13.999" },
            React__default.createElement("g", { id: "Group_7953", "data-name": "Group 7953", transform: "translate(0.001)" },
                React__default.createElement("g", { id: "Group_6850", "data-name": "Group 6850", transform: "translate(0 0)" },
                    React__default.createElement("g", { id: "Subtraction_15", "data-name": "Subtraction 15", transform: "translate(-2730 11911)", fill: "none" },
                        React__default.createElement("path", { d: "M2737-11897a7.008,7.008,0,0,1-7-7,7.009,7.009,0,0,1,7-7,7.009,7.009,0,0,1,7,7A7.008,7.008,0,0,1,2737-11897Zm0-13a6.006,6.006,0,0,0-6,6,6.006,6.006,0,0,0,6,6,6.006,6.006,0,0,0,6-6A6.006,6.006,0,0,0,2737-11910Z", stroke: "none" }),
                        React__default.createElement("path", { d: "M 2736.999755859375 -11897.0009765625 C 2733.139404296875 -11897.0009765625 2729.998779296875 -11900.140625 2729.998779296875 -11903.9990234375 C 2729.998779296875 -11907.859375 2733.139404296875 -11911 2736.999755859375 -11911 C 2740.85986328125 -11911 2744.00048828125 -11907.859375 2744.00048828125 -11903.9990234375 C 2744.00048828125 -11900.140625 2740.85986328125 -11897.0009765625 2736.999755859375 -11897.0009765625 Z M 2736.999755859375 -11909.9990234375 C 2733.691650390625 -11909.9990234375 2731.000244140625 -11907.3076171875 2731.000244140625 -11903.9990234375 C 2731.000244140625 -11900.69140625 2733.691650390625 -11898 2736.999755859375 -11898 C 2740.307861328125 -11898 2742.9990234375 -11900.69140625 2742.9990234375 -11903.9990234375 C 2742.9990234375 -11907.3076171875 2740.307861328125 -11909.9990234375 2736.999755859375 -11909.9990234375 Z", stroke: "none", fill: "#7ea2ff" }))),
                React__default.createElement("g", { id: "Layer_x0020_1", transform: "translate(4.981 2.588)" },
                    React__default.createElement("path", { id: "Path_18950", "data-name": "Path 18950", d: "M8.779,4.2a1.125,1.125,0,0,1-1.51,0A.928.928,0,0,1,6.954,3.5a.938.938,0,0,1,.315-.707A1.071,1.071,0,0,1,8.025,2.5a1.059,1.059,0,0,1,.754.294.952.952,0,0,1,0,1.412Zm.079,6.43q-.539.213-.86.324a2.269,2.269,0,0,1-.746.112,1.486,1.486,0,0,1-1.015-.319,1.029,1.029,0,0,1-.361-.808A2.928,2.928,0,0,1,5.9,9.55c.018-.132.047-.281.087-.449l.45-1.589c.04-.152.074-.3.1-.432a1.918,1.918,0,0,0,.04-.374.576.576,0,0,0-.125-.424.712.712,0,0,0-.481-.119,1.254,1.254,0,0,0-.358.053c-.121.037-.226.071-.313.1l.119-.489q.442-.18.845-.308A2.5,2.5,0,0,1,7.031,5.4a1.459,1.459,0,0,1,1,.313,1.041,1.041,0,0,1,.351.813q0,.1-.024.365a2.435,2.435,0,0,1-.09.479L7.821,8.95a4.447,4.447,0,0,0-.1.435,2.293,2.293,0,0,0-.043.37.532.532,0,0,0,.141.43.79.79,0,0,0,.489.115,1.414,1.414,0,0,0,.37-.057,2.128,2.128,0,0,0,.3-.1l-.12.489Z", transform: "translate(-5.305 -2.496)", fill: "#5081ff", fillRule: "evenodd" }))))),
        Error: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14.002", height: "14.002", viewBox: "0 0 14.002 14.002" },
            React__default.createElement("g", { id: "Group_7950", "data-name": "Group 7950", transform: "translate(0 -0.008)" },
                React__default.createElement("path", { id: "Subtraction_18", "data-name": "Subtraction 18", d: "M2737-11973.99a7.009,7.009,0,0,1-7-7,7.009,7.009,0,0,1,7-7,7.009,7.009,0,0,1,7,7A7.009,7.009,0,0,1,2737-11973.99Zm0-13a6.006,6.006,0,0,0-6,6,6.006,6.006,0,0,0,6,6,6.006,6.006,0,0,0,6-6A6.006,6.006,0,0,0,2737-11986.99Z", transform: "translate(-2730 11988)", fill: "#ffa39e" }),
                React__default.createElement("path", { id: "Union_1", "data-name": "Union 1", d: "M4.559,5.642,2.933,4.017,1.308,5.642A.766.766,0,1,1,.224,4.559L1.85,2.933.225,1.309A.767.767,0,1,1,1.309.224L2.934,1.849,4.559.224A.766.766,0,1,1,5.642,1.308L4.018,2.932,5.643,4.559A.766.766,0,1,1,4.559,5.642Z", transform: "translate(4.067 4.345)", fill: "#ff4d4f" })))),
        successInfo: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
            React__default.createElement("g", { id: "Group_7951", "data-name": "Group 7951", transform: "translate(0 -0.017)" },
                React__default.createElement("path", { id: "Subtraction_17", "data-name": "Subtraction 17", d: "M2737-11948.983a7.006,7.006,0,0,1-7-7,7.008,7.008,0,0,1,7-7,7.009,7.009,0,0,1,7,7A7.008,7.008,0,0,1,2737-11948.983Zm0-13a6.007,6.007,0,0,0-6,6,6,6,0,0,0,6,6,6.007,6.007,0,0,0,6-6A6.009,6.009,0,0,0,2737-11961.983Z", transform: "translate(-2730 11963)", fill: "#8cedb9" }),
                React__default.createElement("path", { id: "Union_1", "data-name": "Union 1", d: "M2.336,5.01a.757.757,0,0,1-.552-.24L.228,3.134a.851.851,0,0,1,0-1.158.753.753,0,0,1,1.1,0L2.336,3.035,4.994.24a.75.75,0,0,1,1.1,0,.848.848,0,0,1,0,1.157L2.889,4.77a.758.758,0,0,1-.551.24Z", transform: "translate(3.839 4.679)", fill: "#15c87a" })))),
        Notfound: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "47.998", height: "47.998", viewBox: "0 0 47.998 47.998" },
            React__default.createElement("g", { id: "Group_7133", "data-name": "Group 7133", transform: "translate(0.024 0.023)" },
                React__default.createElement("path", { id: "Path_20209", "data-name": "Path 20209", d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z", transform: "translate(-0.024 -0.023)", fill: "#ffd591" }),
                React__default.createElement("g", { id: "Group_6395", "data-name": "Group 6395", transform: "translate(2.976 2.976)" },
                    React__default.createElement("path", { id: "Subtraction_3", "data-name": "Subtraction 3", d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z", transform: "translate(-0.001 -0.002)", fill: "#fff" }),
                    React__default.createElement("rect", { id: "Rectangle_4413", "data-name": "Rectangle 4413", width: "4.601", height: "16.102", rx: "2.3", transform: "translate(18.697 9.195)", fill: "#ffa940" }),
                    React__default.createElement("path", { id: "Path_20116", "data-name": "Path 20116", d: "M2.3,0A2.3,2.3,0,1,1,0,2.3,2.3,2.3,0,0,1,2.3,0Z", transform: "translate(18.697 28.203)", fill: "#ffa940" }))))),
        Success: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48" },
            React__default.createElement("g", { id: "Group_7023", "data-name": "Group 7023", transform: "translate(-198 -92)" },
                React__default.createElement("circle", { id: "Ellipse_845", "data-name": "Ellipse 845", cx: "24", cy: "24", r: "24", transform: "translate(198 92)", fill: "#8cedb9" }),
                React__default.createElement("circle", { id: "Ellipse_844", "data-name": "Ellipse 844", cx: "21", cy: "21", r: "21", transform: "translate(201 95)", fill: "#fff" }),
                React__default.createElement("path", { id: "right_1_", "data-name": "right (1)", d: "M16.217,29.972l2.471,2.472L7.127,44,0,36.877l2.471-2.472,4.656,4.656Z", transform: "translate(212.149 79.298)", fill: "#15c87a" })))),
        Unsuccessful: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48" },
            React__default.createElement("g", { id: "Group_7023", "data-name": "Group 7023", transform: "translate(-198 -92)" },
                React__default.createElement("circle", { id: "Ellipse_845", "data-name": "Ellipse 845", cx: "24", cy: "24", r: "24", transform: "translate(198 92)", fill: "#ffa39e" }),
                React__default.createElement("circle", { id: "Ellipse_844", "data-name": "Ellipse 844", cx: "21", cy: "21", r: "21", transform: "translate(201 95)", fill: "#fff" }),
                React__default.createElement("path", { id: "Union_1", "data-name": "Union 1", d: "M14077.177,21391.566l-5.1-5.09-5.089,5.09a2,2,0,0,1-2.83,0l-.424-.424a2,2,0,0,1,0-2.83l5.09-5.09-5.09-5.09a2,2,0,0,1,0-2.828l.43-.424a1.988,1.988,0,0,1,2.824,0l5.089,5.09,5.09-5.09a1.993,1.993,0,0,1,2.829,0l.425.424a2,2,0,0,1,0,2.828l-5.09,5.09,5.095,5.09a2,2,0,0,1,0,2.83l-.424.424a2,2,0,0,1-1.418.59A1.978,1.978,0,0,1,14077.177,21391.566Z", transform: "translate(-13850.151 -21267.291)", fill: "#ff4d4f" })))),
        Netbanking: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
            React__default.createElement("g", { id: "Group_6883", "data-name": "Group 6883", transform: "translate(-51 -291)" },
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "32", height: "32", transform: "translate(51 291)", fill: "none" }),
                React__default.createElement("g", { id: "_4987286121594941299", "data-name": "4987286121594941299", transform: "translate(54.827 297)" },
                    React__default.createElement("path", { id: "Path_19995", "data-name": "Path 19995", d: "M13.655,3,3,8.393V10.7H24.311V8.393Z", transform: "translate(-1.345 -3)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                    React__default.createElement("rect", { id: "Rectangle_4654", "data-name": "Rectangle 4654", width: "3.169", height: "7.447", transform: "translate(11.091 8.086)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                    React__default.createElement("rect", { id: "Rectangle_4655", "data-name": "Rectangle 4655", width: "3.169", height: "7.447", transform: "translate(18.221 8.086)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                    React__default.createElement("rect", { id: "Rectangle_4656", "data-name": "Rectangle 4656", width: "3.169", height: "7.447", transform: "translate(3.169 8.086)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                    React__default.createElement("rect", { id: "Rectangle_4657", "data-name": "Rectangle 4657", width: "21.389", height: "2.234", transform: "translate(1.584 15.533)", fill: "none", className: "dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                    React__default.createElement("rect", { id: "Rectangle_4658", "data-name": "Rectangle 4658", width: "24.558", height: "2.234", transform: "translate(0 17.767)", fill: "none", className: "stroke-base-color dark:stroke-neutral-40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }))))),
        Upi: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
            React__default.createElement("g", { id: "Group_6884", "data-name": "Group 6884", transform: "translate(-51 -291)" },
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "32", height: "32", transform: "translate(51 291)", fill: "none" }),
                React__default.createElement("g", { id: "upi-ar21", transform: "translate(42.999 286.937)" },
                    React__default.createElement("path", { id: "Path_20192", "data-name": "Path 20192", d: "M95.678,23.762l4.01-3.658-1.9-3.785Z", transform: "translate(-61.687 -0.087)", fill: "#097939" }),
                    React__default.createElement("path", { id: "Path_20193", "data-name": "Path 20193", d: "M90.854,23.762l4.01-3.658-1.9-3.785Z", transform: "translate(-58.214 -0.087)", fill: "#ed752e" }),
                    React__default.createElement("path", { id: "Path_20194", "data-name": "Path 20194", d: "M13.476,16.275l-1.688,6.013,5.994.042,1.646-6.055h1.52l-1.974,7.039a.706.706,0,0,1-.643.487H10.648a.606.606,0,0,1-.616-.812l1.883-6.714Zm18.531-.042h1.52L31.416,23.8H29.853Zm-10.89,3.153,7.6-.042.507-1.6H21.5l.464-1.472,8.232-.076a.664.664,0,0,1,.683.887L30.1,19.92a1.284,1.284,0,0,1-1.173.9h-6.8l-.8,3.112H19.85Z", transform: "translate(0)", className: "fill-base-color dark:fill-neutral-40" }))))),
        Emandate: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
            React__default.createElement("g", { id: "Group_6885", "data-name": "Group 6885", transform: "translate(-51 -291)" },
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "32", height: "32", transform: "translate(51 291)", fill: "none" }),
                React__default.createElement("path", { id: "_7117553871579156629", "data-name": "7117553871579156629", d: "M19.146,10.951l.718-.792a1.8,1.8,0,0,0,0-2.375s.126-.046-.588-.4-1.566.4-1.566.4L16.246,9.4V6.718L10.16,0H2.539A2.681,2.681,0,0,0,0,2.8V19.593a2.681,2.681,0,0,0,2.539,2.8H13.711a2.681,2.681,0,0,0,2.539-2.8V14.148l2.182-2.405.357.394-.718.792a.6.6,0,0,0-.012.792.475.475,0,0,0,.718.013l.012-.013,1.079-1.19a.6.6,0,0,0,0-.792Zm-8.482-8.8,3.63,4.01H12.188a1.608,1.608,0,0,1-1.523-1.679Zm4.57,17.446a1.608,1.608,0,0,1-1.523,1.679H2.539a1.608,1.608,0,0,1-1.523-1.679V2.8A1.608,1.608,0,0,1,2.539,1.12H9.648V4.478a2.681,2.681,0,0,0,2.539,2.8h3.047v3.241L10.529,15.7a1.8,1.8,0,0,0-.294,1.907l-.044.048A1.858,1.858,0,0,0,8.569,16.8a1.733,1.733,0,0,0-1.075.735c-.186.223-.309.363-.448.385-.06,0-.218-.2-.313-.324a1.729,1.729,0,0,0-1.091-.8c-.663-.087-1.309.35-1.988,1.338a.6.6,0,0,0,.087.787.476.476,0,0,0,.714-.1l.012-.013c.417-.608.8-.94,1.059-.9.127.017.258.171.436.407a1.435,1.435,0,0,0,1.071.722c.044,0,.091,0,.135-.009A1.733,1.733,0,0,0,8.244,18.3c.19-.227.309-.363.448-.385.254-.039.639.3,1.059.9a.493.493,0,0,0,.4.219H10.2a.476.476,0,0,0,.333-.162l.424-.468a1.4,1.4,0,0,0,1.73-.324l2.555-2.812v4.325Zm-3.269-2.309a.475.475,0,0,1-.718,0h0a.6.6,0,0,1,0-.792l5.745-6.333.718.792Zm6.463-7.124-.131-.144-.587-.647.718-.792a.6.6,0,0,1,.131-.1.417.417,0,0,1,.139-.052.59.59,0,0,1,.087-.009.329.329,0,0,1,.091.013.561.561,0,0,1,.167.066.59.59,0,0,1,.175.77.654.654,0,0,1-.075.109ZM3.555,8.4a.534.534,0,0,1,.508-.56H7.125a.562.562,0,0,1,0,1.12H4.063a.534.534,0,0,1-.508-.56Zm0,2.239a.534.534,0,0,1,.508-.56h6.11a.562.562,0,0,1,0,1.12H4.063A.534.534,0,0,1,3.555,10.636Z", transform: "translate(56.845 295.805)", className: "fill-neutral-80 dark:fill-neutral-40" })))),
        Trash: (React__default.createElement("svg", { className: className, fill: "#FF4D4F", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", width: "18px", height: "18px" },
            React__default.createElement("path", { d: "M 24 4 C 20.491685 4 17.570396 6.6214322 17.080078 10 L 10.238281 10 A 1.50015 1.50015 0 0 0 9.9804688 9.9785156 A 1.50015 1.50015 0 0 0 9.7578125 10 L 6.5 10 A 1.50015 1.50015 0 1 0 6.5 13 L 8.6386719 13 L 11.15625 39.029297 C 11.427329 41.835926 13.811782 44 16.630859 44 L 31.367188 44 C 34.186411 44 36.570826 41.836168 36.841797 39.029297 L 39.361328 13 L 41.5 13 A 1.50015 1.50015 0 1 0 41.5 10 L 38.244141 10 A 1.50015 1.50015 0 0 0 37.763672 10 L 30.919922 10 C 30.429604 6.6214322 27.508315 4 24 4 z M 24 7 C 25.879156 7 27.420767 8.2681608 27.861328 10 L 20.138672 10 C 20.579233 8.2681608 22.120844 7 24 7 z M 11.650391 13 L 36.347656 13 L 33.855469 38.740234 C 33.730439 40.035363 32.667963 41 31.367188 41 L 16.630859 41 C 15.331937 41 14.267499 40.033606 14.142578 38.740234 L 11.650391 13 z M 20.476562 17.978516 A 1.50015 1.50015 0 0 0 19 19.5 L 19 34.5 A 1.50015 1.50015 0 1 0 22 34.5 L 22 19.5 A 1.50015 1.50015 0 0 0 20.476562 17.978516 z M 27.476562 17.978516 A 1.50015 1.50015 0 0 0 26 19.5 L 26 34.5 A 1.50015 1.50015 0 1 0 29 34.5 L 29 19.5 A 1.50015 1.50015 0 0 0 27.476562 17.978516 z" }))),
        Back: (React__default.createElement("svg", { className: `fill-neutral-80 dark:fill-neutral-40 ${className}`, xmlns: "http://www.w3.org/2000/svg", width: "26px", height: "26px", viewBox: "0 0 24 24" },
            React__default.createElement("g", { "data-name": "Layer 2" },
                React__default.createElement("g", { "data-name": "arrow-back" },
                    React__default.createElement("rect", { width: "24", height: "24", opacity: "0", transform: "rotate(90 12 12)" }),
                    React__default.createElement("path", { d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" }))))),
        DownArrow: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
            React__default.createElement("g", { id: "Group_7454", "data-name": "Group 7454", transform: "translate(-371 -256.265)" },
                React__default.createElement("rect", { id: "Rectangle_5802", "data-name": "Rectangle 5802", width: "16", height: "16", transform: "translate(371 256.265)", fill: "none" }),
                React__default.createElement("g", { id: "Group_6928", "data-name": "Group 6928", transform: "translate(373.941 267.067) rotate(-90)" },
                    React__default.createElement("path", { id: "Vector_7", "data-name": "Vector 7", d: "M10.147,1.393A.8.8,0,0,0,9.069.208ZM5.2,4.8,4.665,5.4a.8.8,0,0,0,1.078,0ZM1.339.208A.8.8,0,0,0,.262,1.393Zm7.73,0-4.4,4L5.743,5.4l4.4-4Zm-3.326,4-4.4-4L.262,1.393l4.4,4Z", transform: "translate(5.605 0) rotate(90)", className: "fill-neutral-80 dark:fill-neutral-40" }))))),
        rightArrow: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "heroicons-mini/chevron-right" },
                React__default.createElement("path", { id: "Vector (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M7.20938 14.7698C6.92228 14.4713 6.93159 13.9965 7.23017 13.7094L11.1679 10L7.23017 6.29062C6.93159 6.00353 6.92228 5.52875 7.20938 5.23017C7.49647 4.93159 7.97125 4.92228 8.26983 5.20937L12.7698 9.45937C12.9169 9.60078 13 9.79599 13 10C13 10.204 12.9169 10.3992 12.7698 10.5406L8.26983 14.7906C7.97125 15.0777 7.49647 15.0684 7.20938 14.7698Z", fill: "#788393" })))),
        RightArrowDark: (React__default.createElement("svg", { className: className, width: "10", height: "16", viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M2 14L8 8L2 2", stroke: "#444444", strokeWidth: "2.4", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Language: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
            React__default.createElement("g", { id: "Group_7456", "data-name": "Group 7456", transform: "translate(-345.293 -830.293)" },
                React__default.createElement("g", { id: "Group_7450", "data-name": "Group 7450", transform: "translate(345 830)" },
                    React__default.createElement("rect", { id: "Rectangle_5802", "data-name": "Rectangle 5802", width: "16", height: "16", transform: "translate(0.293 0.293)", fill: "none" })),
                React__default.createElement("g", { id: "Group_7452", "data-name": "Group 7452", transform: "translate(346.844 833.292)" },
                    React__default.createElement("path", { id: "Union_2", "data-name": "Union 2", d: "M2.91,11.5,2.1,10.176a1.038,1.038,0,0,0-.071-.1l-.336-.422A2,2,0,0,1,0,7.675V2A2,2,0,0,1,2,0h8.9a2,2,0,0,1,2,2V7.675a2,2,0,0,1-2,2H5.813l-.317.4a.912.912,0,0,0-.072.1L4.617,11.5a1,1,0,0,1-1.707,0Z", transform: "translate(-0.001 0.001)", fill: "#9faabe" }),
                    React__default.createElement("path", { id: "Path_20254", "data-name": "Path 20254", d: "M17.1,12H16.01a.547.547,0,1,0,0,1.095v1.095h-.651a1.7,1.7,0,0,0,.1-.547,1.642,1.642,0,0,0-3.065-.821.547.547,0,0,0,.947.547h0a.547.547,0,1,1,.476.821.547.547,0,0,0,0,1.095.547.547,0,1,1-.476.821.548.548,0,0,0-.952.542h0a1.642,1.642,0,0,0,3.065-.821,1.7,1.7,0,0,0-.1-.547H16v1.642a.547.547,0,0,0,1.095,0V13.093A.547.547,0,1,0,17.1,12Z", transform: "translate(-8.534 -9.894)", fill: "#fff" }))))),
        Edit: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26" },
            React__default.createElement("g", { id: "Group_7442", "data-name": "Group 7442", transform: "translate(-50.529 -290.529)" },
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "26", height: "26", transform: "translate(50.529 290.529)", fill: "none" }),
                React__default.createElement("path", { id: "icons8-edit", d: "M14.841,2a2.064,2.064,0,0,0-1.464.606l-.858.858,2.929,2.929.858-.858A2.071,2.071,0,0,0,14.841,2ZM11.421,4.563,3,12.983v2.929H5.929l8.421-8.421Z", transform: "translate(54.073 295.073)", fill: "#3f567e" })))),
        Light: (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22" },
            React__default.createElement("g", { id: "Group_8203", "data-name": "Group 8203", transform: "translate(3431 -9582)" },
                React__default.createElement("rect", { id: "Rectangle_7169", "data-name": "Rectangle 7169", width: "22", height: "22", transform: "translate(-3431 9582)", fill: "none" }),
                React__default.createElement("g", { id: "dark-mode", transform: "translate(-3432.31 9580.666)" },
                    React__default.createElement("g", { id: "sun-8726", transform: "translate(3.808 3.831)" },
                        React__default.createElement("g", { id: "Group_6730", "data-name": "Group 6730", transform: "translate(0)" },
                            React__default.createElement("path", { id: "Path_20084", "data-name": "Path 20084", d: "M66.486,71.354a4.868,4.868,0,1,1,4.868-4.868A4.874,4.874,0,0,1,66.486,71.354Zm0-8.466a3.6,3.6,0,1,0,3.6,3.6A3.6,3.6,0,0,0,66.486,62.888Z", transform: "translate(-57.984 -57.984)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20085", "data-name": "Path 20085", d: "M118.312,12.628a.679.679,0,0,1-.679-.679V10.679a.679.679,0,1,1,1.357,0v1.271A.679.679,0,0,1,118.312,12.628Z", transform: "translate(-109.811 -10)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20086", "data-name": "Path 20086", d: "M118.312,205.529a.679.679,0,0,1-.679-.679V203.58a.679.679,0,0,1,1.357,0v1.271A.679.679,0,0,1,118.312,205.529Z", transform: "translate(-109.811 -188.526)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20087", "data-name": "Path 20087", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,1,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(13.935 2.108) rotate(45)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20088", "data-name": "Path 20088", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,0,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(3.966 12.077) rotate(45)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20089", "data-name": "Path 20089", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,1,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(17.003 7.823) rotate(90)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20090", "data-name": "Path 20090", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,0,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(2.628 7.823) rotate(90)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20091", "data-name": "Path 20091", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,1,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(14.895 13.935) rotate(135)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                            React__default.createElement("path", { id: "Path_20092", "data-name": "Path 20092", d: "M.679,2.628A.679.679,0,0,1,0,1.949V.679a.679.679,0,0,1,1.357,0V1.949A.679.679,0,0,1,.679,2.628Z", transform: "translate(4.926 3.966) rotate(135)", className: "fill-neutral-110 dark:fill-neutral-40" }))))))),
        Dark: (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22" },
            React__default.createElement("g", { id: "Group_8202", "data-name": "Group 8202", transform: "translate(3455 -9582)" },
                React__default.createElement("rect", { id: "Rectangle_7168", "data-name": "Rectangle 7168", width: "22", height: "22", transform: "translate(-3455 9582)", fill: "none" }),
                React__default.createElement("g", { id: "moon-6681", transform: "translate(-3451.148 9585.081)" },
                    React__default.createElement("g", { id: "Group_6729", "data-name": "Group 6729", transform: "translate(0.298 0.303)" },
                        React__default.createElement("path", { id: "Subtraction_24", "data-name": "Subtraction 24", d: "M7.63,15.231a7.646,7.646,0,0,1-6.608-3.808A7.614,7.614,0,0,1,7.6,0a7.539,7.539,0,0,1,.983.062.6.6,0,0,1,.507.462.6.6,0,0,1-.266.635A4.991,4.991,0,0,0,13.812,9.8a.608.608,0,0,1,.279-.07.6.6,0,0,1,.55.827A7.618,7.618,0,0,1,7.63,15.231ZM6.864,1.189h0l-.73.174a6.423,6.423,0,1,0,6.157,10.663l.516-.546-.748.073c-.192.018-.392.029-.6.029A6.191,6.191,0,0,1,6.428,1.8l.435-.611Z", transform: "translate(0 0)", className: "fill-neutral-110 dark:fill-neutral-40" })))))),
        System: (React__default.createElement("svg", { viewBox: "0 0 24 24", fill: "none", className: "mr-2 h-6 w-6" },
            React__default.createElement("path", { d: "M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z", strokeWidth: "1", strokeLinejoin: "round", className: "fill-neutral-20/20 stroke-neutral-80" }),
            React__default.createElement("path", { d: "M14 15c0 3 2 5 2 5H8s2-2 2-5", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round", className: "stroke-neutral-80" }))),
        Avatar: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "Icon/Outline/user-circle" },
                React__default.createElement("path", { id: "Icon", d: "M5.12104 17.8037C7.15267 16.6554 9.4998 16 12 16C14.5002 16 16.8473 16.6554 18.879 17.8037M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", className: "stroke-neutral-80 dark:stroke-neutral-40", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))),
        Calendar: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 24 24" },
            React__default.createElement("path", { d: "M12,19a1,1,0,1,0-1-1A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-1-1A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-1-1A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-1-1A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,0,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-1-1A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,7,19Z", fill: "#3f567e" }))),
        Close: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React__default.createElement("g", { id: "Group_7359", "data-name": "Group 7359", transform: "translate(0 0.398)" },
                React__default.createElement("rect", { id: "Rectangle_5670", "data-name": "Rectangle 5670", width: "24", height: "24", transform: "translate(0 -0.398)", fill: "none" }),
                React__default.createElement("g", { id: "Group_3819", "data-name": "Group 3819", transform: "translate(18 18.128) rotate(180)" },
                    React__default.createElement("g", { id: "Group_2994", "data-name": "Group 2994" },
                        React__default.createElement("path", { id: "Line_5", "data-name": "Line 5", d: "M.889,15.026H.878a.889.889,0,0,1-.878-.9L.167.878A.889.889,0,0,1,1.945.9L1.778,14.148A.889.889,0,0,1,.889,15.026Z", transform: "translate(12 10.625) rotate(135)", className: "fill-neutral-80 dark:fill-neutral-40" }),
                        React__default.createElement("path", { id: "Line_6", "data-name": "Line 6", d: "M.889,1.945A.889.889,0,0,1,.878.167L14.125,0a.889.889,0,1,1,.022,1.778L.9,1.945Z", transform: "translate(12 1.375) rotate(135)", className: "fill-neutral-80 dark:fill-neutral-40" })))))),
        Helper: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "14.001", height: "14.001", viewBox: "0 0 14.001 14.001" },
            React__default.createElement("g", { id: "Group_7954", "data-name": "Group 7954", transform: "translate(0.001 0.001)" },
                React__default.createElement("g", { id: "Subtraction_14", "data-name": "Subtraction 14", transform: "translate(-2730 11885)", className: "fill-neutral-20" },
                    React__default.createElement("path", { d: "M 2733.396484375 -11872.5927734375 C 2731.651123046875 -11873.7587890625 2730.499267578125 -11875.748046875 2730.499267578125 -11878 C 2730.499267578125 -11881.5849609375 2733.415283203125 -11884.5009765625 2736.999755859375 -11884.5009765625 C 2733.41650390625 -11884.5009765625 2730.50146484375 -11881.5849609375 2730.50146484375 -11878 C 2730.50146484375 -11875.748046875 2731.652099609375 -11873.759765625 2733.396484375 -11872.5927734375 Z", stroke: "none" }),
                    React__default.createElement("path", { d: "M 2736.999755859375 -11871 C 2733.1396484375 -11871 2729.999267578125 -11874.140625 2729.999267578125 -11878 C 2729.999267578125 -11881.8603515625 2733.1396484375 -11885.0009765625 2736.999755859375 -11885.0009765625 C 2740.85986328125 -11885.0009765625 2744.000244140625 -11881.8603515625 2744.000244140625 -11878 C 2744.000244140625 -11874.140625 2740.85986328125 -11871 2736.999755859375 -11871 Z M 2736.999755859375 -11884.0009765625 C 2733.6923828125 -11884.0009765625 2731.00146484375 -11881.30859375 2731.00146484375 -11878 C 2731.00146484375 -11874.69140625 2733.6923828125 -11871.9990234375 2736.999755859375 -11871.9990234375 C 2740.308837890625 -11871.9990234375 2743.0009765625 -11874.69140625 2743.0009765625 -11878 C 2743.0009765625 -11881.30859375 2740.308837890625 -11884.0009765625 2736.999755859375 -11884.0009765625 Z", stroke: "none", className: "fill-neutral-40" })),
                React__default.createElement("g", { id: "Layer_x0020_1", transform: "translate(4.981 2.588)" },
                    React__default.createElement("path", { id: "Path_18950", "data-name": "Path 18950", d: "M8.779,4.2a1.125,1.125,0,0,1-1.51,0A.928.928,0,0,1,6.954,3.5a.938.938,0,0,1,.315-.707A1.071,1.071,0,0,1,8.025,2.5a1.059,1.059,0,0,1,.754.294.952.952,0,0,1,0,1.412Zm.079,6.43q-.539.213-.86.324a2.269,2.269,0,0,1-.746.112,1.486,1.486,0,0,1-1.015-.319,1.029,1.029,0,0,1-.361-.808A2.928,2.928,0,0,1,5.9,9.55c.018-.132.047-.281.087-.449l.45-1.589c.04-.152.074-.3.1-.432a1.918,1.918,0,0,0,.04-.374.576.576,0,0,0-.125-.424.712.712,0,0,0-.481-.119,1.254,1.254,0,0,0-.358.053c-.121.037-.226.071-.313.1l.119-.489q.442-.18.845-.308A2.5,2.5,0,0,1,7.031,5.4a1.459,1.459,0,0,1,1,.313,1.041,1.041,0,0,1,.351.813q0,.1-.024.365a2.435,2.435,0,0,1-.09.479L7.821,8.95a4.447,4.447,0,0,0-.1.435,2.293,2.293,0,0,0-.043.37.532.532,0,0,0,.141.43.79.79,0,0,0,.489.115,1.414,1.414,0,0,0,.37-.057,2.128,2.128,0,0,0,.3-.1l-.12.489Z", transform: "translate(-5.305 -2.496)", className: "fill-neutral-40", fillRule: "evenodd" }))))),
        Play: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "100", height: "100", viewBox: "0 0 100 100" },
            React__default.createElement("g", { id: "Group_8114", "data-name": "Group 8114", transform: "translate(-5624.757 -19078.758)", opacity: "0.75" },
                React__default.createElement("path", { id: "Subtraction_21", "data-name": "Subtraction 21", d: "M50,100A50.013,50.013,0,0,1,30.538,3.929,50.013,50.013,0,0,1,69.462,96.071,49.686,49.686,0,0,1,50,100ZM50,6.25A43.762,43.762,0,0,0,32.97,90.312,43.762,43.762,0,0,0,67.03,9.688,43.476,43.476,0,0,0,50,6.25Z", transform: "translate(5624.757 19078.758)", fill: "#fff" }),
                React__default.createElement("path", { id: "Polygon_26", "data-name": "Polygon 26", d: "M23.307,5.49a3,3,0,0,1,5.387,0L49.88,48.679A3,3,0,0,1,47.187,53H4.813A3,3,0,0,1,2.12,48.679Z", transform: "translate(5706.757 19101.758) rotate(90)", fill: "#fff" })))),
        Upload: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React__default.createElement("g", { id: "Group_8129", "data-name": "Group 8129", transform: "translate(-51.035 -291.035)" },
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "24", height: "24", transform: "translate(51.035 291.035)", fill: "none" }),
                React__default.createElement("g", { id: "Image", transform: "translate(55.468 295.468)" },
                    React__default.createElement("path", { id: "Path_20233", "data-name": "Path 20233", d: "M14.432,2H4.7A2.7,2.7,0,0,0,2,4.7v9.729a2.7,2.7,0,0,0,2.7,2.7h9.729a2.7,2.7,0,0,0,2.7-2.7V4.7A2.7,2.7,0,0,0,14.432,2ZM4.7,3.081h9.729A1.622,1.622,0,0,1,16.053,4.7V7.724L15.037,6.708a1.622,1.622,0,0,0-2.292,0l-4.3,4.324L6.827,9.724a1.622,1.622,0,0,0-2.054,0L3.081,11.113V4.7A1.622,1.622,0,0,1,4.7,3.081Zm9.729,12.972H4.7a1.622,1.622,0,0,1-1.622-1.622V12.524l2.367-1.978a.541.541,0,0,1,.686,0l2.016,1.622a.541.541,0,0,0,.719-.038l4.638-4.643a.541.541,0,0,1,.768,0l1.778,1.762v5.184a1.622,1.622,0,0,1-1.622,1.622Z", transform: "translate(-2 -2)", fill: "#3f567e" }),
                    React__default.createElement("path", { id: "Path_20234", "data-name": "Path 20234", d: "M8.622,10.243A1.622,1.622,0,1,0,7,8.622,1.622,1.622,0,0,0,8.622,10.243Zm0-2.162a.541.541,0,1,1-.541.541A.541.541,0,0,1,8.622,8.081Z", transform: "translate(-4.297 -4.297)", fill: "#3f567e" }))))),
        Pdf: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" },
            React__default.createElement("g", { id: "Group_8149", "data-name": "Group 8149", transform: "translate(-77 -232)" },
                React__default.createElement("rect", { id: "Rectangle_7054", "data-name": "Rectangle 7054", width: "32", height: "32", transform: "translate(77 232)", fill: "none" }),
                React__default.createElement("path", { id: "file-pdf-svgrepo-com", d: "M23.071,9.329H22.4l.036-2.465a.6.6,0,0,0-.157-.388L16.521.175a.512.512,0,0,0-.134-.109.5.5,0,0,0-.1-.042A.48.48,0,0,0,16.151,0H4.1A1.042,1.042,0,0,0,3.075,1.023V9.329H2.4a1.375,1.375,0,0,0-.992.428A1.494,1.494,0,0,0,1,10.791v7.6a1.434,1.434,0,0,0,1.4,1.462h.672v5.2A1.042,1.042,0,0,0,4.1,26.082H21.418a1.034,1.034,0,0,0,1.017-1.023v-5.2h.635a1.434,1.434,0,0,0,1.4-1.462v-7.6a1.494,1.494,0,0,0-.411-1.034A1.375,1.375,0,0,0,23.071,9.329ZM4.847,1.8h9.071V7.766a.522.522,0,0,0,.144.362.481.481,0,0,0,.347.15h6.207V9.33H4.847Zm0,22.488V19.855H20.616v4.429Zm10.878-22.3.5.566,3.366,3.721.185.225H16.338q-.39,0-.493-.129a.727.727,0,0,1-.12-.409ZM3.608,18.56V10.736h2.5a8.948,8.948,0,0,1,1.853.117,2.023,2.023,0,0,1,1.111.766,2.452,2.452,0,0,1,.448,1.524,2.582,2.582,0,0,1-.258,1.212,2.137,2.137,0,0,1-.655.771A2.244,2.244,0,0,1,7.8,15.5a8.777,8.777,0,0,1-1.616.112H5.167V18.56Zm1.558-6.5v2.22H6.02a3.978,3.978,0,0,0,1.232-.123,1.025,1.025,0,0,0,.487-.384,1.062,1.062,0,0,0,.176-.608,1.019,1.019,0,0,0-.247-.7,1.074,1.074,0,0,0-.627-.347,7.39,7.39,0,0,0-1.121-.053Zm5.269-1.324h2.848a5.49,5.49,0,0,1,1.469.149,2.575,2.575,0,0,1,1.164.721,3.429,3.429,0,0,1,.737,1.268,5.848,5.848,0,0,1,.253,1.849,5.208,5.208,0,0,1-.237,1.665,3.458,3.458,0,0,1-.827,1.382,2.73,2.73,0,0,1-1.1.624,4.654,4.654,0,0,1-1.379.165H10.435Zm1.558,1.324v5.183h1.164a4.19,4.19,0,0,0,.942-.075,1.432,1.432,0,0,0,.629-.326,1.663,1.663,0,0,0,.408-.755,5.171,5.171,0,0,0,.158-1.433,4.735,4.735,0,0,0-.158-1.393,1.8,1.8,0,0,0-.442-.758,1.476,1.476,0,0,0-.721-.368,6.971,6.971,0,0,0-1.279-.075Zm5.885,6.5V10.736H23.17v1.324H19.437v1.852h3.222v1.324H19.437V18.56Z", transform: "translate(80.263 234.959)", fill: "#3f567e" })))),
        Copy: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React__default.createElement("g", { id: "Group_8178", "data-name": "Group 8178", transform: "translate(-336 -700)" },
                React__default.createElement("rect", { id: "Rectangle_7130", "data-name": "Rectangle 7130", width: "24", height: "24", transform: "translate(336 700)", fill: "none" }),
                React__default.createElement("g", { id: "copy", transform: "translate(323.653 705)" },
                    React__default.createElement("path", { id: "Path_20574", "data-name": "Path 20574", d: "M28.738,0H22.63A1.582,1.582,0,0,0,21.02,1.549v.19H19.956a1.582,1.582,0,0,0-1.609,1.549v9.161A1.582,1.582,0,0,0,19.956,14h6.108a1.582,1.582,0,0,0,1.609-1.549v-.19h1.064a1.582,1.582,0,0,0,1.609-1.549V1.549A1.582,1.582,0,0,0,28.738,0Zm-2.1,12.451a.562.562,0,0,1-.571.55H19.956a.562.562,0,0,1-.571-.55V3.289a.562.562,0,0,1,.571-.55h6.108a.561.561,0,0,1,.571.55v9.161Zm2.673-1.74a.562.562,0,0,1-.571.55H27.674V3.289A1.582,1.582,0,0,0,26.065,1.74H22.058v-.19A.562.562,0,0,1,22.63,1h6.108a.562.562,0,0,1,.571.55Z", transform: "translate(0 0)", className: "fill-primary" }))))),
        Search: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" },
            React__default.createElement("g", { id: "Group_8408", "data-name": "Group 8408", transform: "translate(-257.718 -7)" },
                React__default.createElement("path", { id: "download", d: "M21.054,19.855l-4.436-4.425a6.4,6.4,0,1,0-.938.938L20.1,20.8a.671.671,0,1,0,.949-.949ZM6.583,11.4a5.065,5.065,0,1,1,5.065,5.065A5.065,5.065,0,0,1,6.583,11.4Z", transform: "translate(256.468 6.301)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                React__default.createElement("rect", { id: "Rectangle_7245", "data-name": "Rectangle 7245", width: "24", height: "24", transform: "translate(257.718 7)", fill: "none" })))),
        Salary: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "42", height: "42", viewBox: "0 0 42 42" },
            React__default.createElement("g", { id: "Group_8163", "data-name": "Group 8163", transform: "translate(-364 -193)" },
                React__default.createElement("g", { id: "salary", transform: "translate(343.092 159.56)" },
                    React__default.createElement("path", { id: "Path_20571", "data-name": "Path 20571", d: "M5,4H15a5,5,0,0,1,5,5V19s-2.963,1.07-5.923,2.438L10.191,23C7.521,21.8,0,19,0,19V9A5,5,0,0,1,5,4Z", transform: "translate(31.908 38.44)", fill: "#fbfcfe" }),
                    React__default.createElement("path", { id: "Path_20571_-_Outline", "data-name": "Path 20571 - Outline", d: "M5,5A4,4,0,0,0,1,9v9.306c1.795.672,6.781,2.553,9.21,3.608l3.471-1.4C15.834,19.525,17.958,18.7,19,18.3V9a4,4,0,0,0-4-4H5M5,4H15a5,5,0,0,1,5,5V19s-2.963,1.07-5.923,2.438L10.191,23C7.521,21.8,0,19,0,19V9A5,5,0,0,1,5,4Z", transform: "translate(31.908 38.44)", fill: "#3f567e" }),
                    React__default.createElement("path", { id: "Path_20568", "data-name": "Path 20568", d: "M58.933,173.787a.464.464,0,0,0-.634-.432l-16.391,6.438-16.391-6.438a.464.464,0,0,0-.634.432v11.068a4.418,4.418,0,0,0,4.419,4.418H54.514a4.418,4.418,0,0,0,4.419-4.419Zm-.928.681v10.387a3.49,3.49,0,0,1-3.491,3.491H29.3a3.49,3.49,0,0,1-3.491-3.491V174.468l15.927,6.256a.464.464,0,0,0,.339,0Z", transform: "translate(0 -119.38)", fill: "#3f567e", fillRule: "evenodd" }),
                    React__default.createElement("path", { id: "Path_20569", "data-name": "Path 20569", d: "M25.812,54.408V48.786a3.49,3.49,0,0,1,1.735-3.017l.632-.368a.464.464,0,0,0-.467-.8l-.632.368a4.418,4.418,0,0,0-2.2,3.819v5.621a.464.464,0,1,0,.928,0Zm3.98-9.944L40.3,38.347a3.2,3.2,0,0,1,3.216,0c2.537,1.468,7.284,4.136,10.612,6.116a.464.464,0,1,0,.474-.8c-3.332-1.982-8.083-4.652-10.622-6.122a4.123,4.123,0,0,0-4.147,0l-10.51,6.116a.464.464,0,0,0,.467.8Zm25.879.932q.293.181.585.365A3.693,3.693,0,0,1,58,48.786v5.621a.464.464,0,0,0,.928,0V48.786a4.638,4.638,0,0,0-2.181-3.81q-.3-.187-.594-.371a.464.464,0,1,0-.487.79Z", fill: "#3f567e", fillRule: "evenodd" }),
                    React__default.createElement("g", { id: "layer1", transform: "translate(37.647 -756.492)" },
                        React__default.createElement("path", { id: "path4158", d: "M4.962,814.793.477,809.182.5,808.069c2.1.145,3.741-.078,4.122-2.069L.14,805.975l.726-1.215,3.577.051C3.9,803.678,2.4,803.539.062,803.622l.8-1.19,7.6-.011L7.71,803.6H5.61a2.147,2.147,0,0,1,.674,1.267l2.178-.026L7.71,806l-1.452.026c-.227,1.736-1.821,2.763-3.837,3l4.515,5.765H4.962Z", transform: "translate(0 0)", fill: "#3f567e" }))),
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "42", height: "42", transform: "translate(364 193)", fill: "none" })))),
        TrendingDown: (React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { className: "stroke-error", d: "M13 17H21M21 17V9M21 17L13 9L9 13L3 7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        TrendingUp: (React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { className: "stroke-success", d: "M13 7H21M21 7V15M21 7L13 15L9 11L3 17", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Hamburger: (React__default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26" },
            React__default.createElement("g", { id: "Group_7165", "data-name": "Group 7165", transform: "translate(-50.529 -290.529)" },
                React__default.createElement("rect", { id: "Rectangle_5713", "data-name": "Rectangle 5713", width: "26", height: "26", transform: "translate(50.529 290.529)", fill: "none" }),
                React__default.createElement("g", { id: "Group_7166", "data-name": "Group 7166", transform: "translate(-350.74 275.848)" },
                    React__default.createElement("g", { id: "Group_7135", "data-name": "Group 7135", transform: "translate(406 21)" },
                        React__default.createElement("path", { id: "Line_15895", "data-name": "Line 15895", d: "M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z", transform: "translate(0.27 -0.318)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                        React__default.createElement("path", { id: "Line_15896", "data-name": "Line 15896", d: "M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z", transform: "translate(0.27 6.682)", className: "fill-neutral-110 dark:fill-neutral-40" }),
                        React__default.createElement("path", { id: "Line_15897", "data-name": "Line 15897", d: "M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z", transform: "translate(0.27 13.682)", className: "fill-neutral-110 dark:fill-neutral-40" })))))),
        Star: (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", className: className },
            React__default.createElement("g", { id: "Group_8410", "data-name": "Group 8410", transform: "translate(-5635 -21929)" },
                React__default.createElement("rect", { id: "Rectangle_7246", "data-name": "Rectangle 7246", width: "16", height: "16", transform: "translate(5635 21929)", fill: "none" }),
                React__default.createElement("path", { id: "Polygon_61", "data-name": "Polygon 61", d: "M6.543,1.022a.5.5,0,0,1,.913,0l1.53,3.423a.5.5,0,0,0,.391.292l3.61.477a.5.5,0,0,1,.286.852L10.586,8.714a.5.5,0,0,0-.141.446l.687,3.776a.5.5,0,0,1-.742.522L7.25,11.641a.5.5,0,0,0-.5,0L3.61,13.458a.5.5,0,0,1-.742-.522L3.555,9.16a.5.5,0,0,0-.141-.446L.728,6.065a.5.5,0,0,1,.286-.852l3.61-.477a.5.5,0,0,0,.391-.292Z", transform: "translate(5636 21930)", className: "fill-neutral-40" })))),
        SuccessTick: (React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
            React__default.createElement("g", { id: "check-svgrepo-com 1" },
                React__default.createElement("g", { id: "Interface / Check" },
                    React__default.createElement("path", { id: "Vector", d: "M5 12L10.0003 17L20 7", stroke: "#3CAF7F", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }))))),
        Resume: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "resume-svgrepo-com 2" },
                React__default.createElement("g", { id: "Group 6975" },
                    React__default.createElement("g", { id: "Group 6974" },
                        React__default.createElement("path", { id: "Line 3", d: "M3.82608 5.80872L3.82608 19.0261", stroke: "#FFA940", strokeWidth: "2.5", strokeLinecap: "round" })),
                    React__default.createElement("path", { id: "Polygon 1", d: "M9 6.43782L19.5 12.5L9 18.5622L9 6.43782Z", stroke: "#FFA940", strokeWidth: "2.5" }))))),
        AlertFilled: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "alert-filled-svgrepo-com" },
                React__default.createElement("g", { id: "Alert-Filled" },
                    React__default.createElement("g", { id: "Group" },
                        React__default.createElement("path", { id: "Vector", d: "M12.8779 3.60947C12.4989 2.91461 11.5011 2.91461 11.1221 3.60948L2.80665 18.8545C2.44317 19.5209 2.92548 20.3333 3.68454 20.3333H20.3155C21.0745 20.3333 21.5568 19.5209 21.1934 18.8545L12.8779 3.60947ZM12.8333 16.8333C12.8333 17.2936 12.4602 17.6667 12 17.6667C11.5398 17.6667 11.1667 17.2936 11.1667 16.8333C11.1667 16.3731 11.5398 16 12 16C12.4602 16 12.8333 16.3731 12.8333 16.8333ZM12 15.1667C11.5398 15.1667 11.1667 14.7936 11.1667 14.3333V9.5C11.1667 9.03976 11.5398 8.66667 12 8.66667C12.4602 8.66667 12.8333 9.03976 12.8333 9.5V14.3333C12.8333 14.7936 12.4602 15.1667 12 15.1667Z", fill: "#F5222D" })))))),
        UserOutlined: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "heroicons-outline/user" },
                React__default.createElement("g", { id: "Vector" },
                    React__default.createElement("path", { d: "M15.7508 6C15.7508 8.07107 14.0719 9.75 12.0008 9.75C9.92975 9.75 8.25082 8.07107 8.25082 6C8.25082 3.92893 9.92975 2.25 12.0008 2.25C14.0719 2.25 15.7508 3.92893 15.7508 6Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
                    React__default.createElement("path", { d: "M4.50195 20.1182C4.57226 16.0369 7.90269 12.75 12.0008 12.75C16.099 12.75 19.4295 16.0371 19.4997 20.1185C17.2169 21.166 14.6772 21.75 12.0011 21.75C9.32481 21.75 6.78491 21.1659 4.50195 20.1182Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))))),
        ContactOutlined: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "heroicons-outline/identification" },
                React__default.createElement("path", { id: "Vector", d: "M15 9H18.75M15 12H18.75M15 15H18.75M4.5 19.5H19.5C20.7426 19.5 21.75 18.4926 21.75 17.25V6.75C21.75 5.50736 20.7426 4.5 19.5 4.5H4.5C3.25736 4.5 2.25 5.50736 2.25 6.75V17.25C2.25 18.4926 3.25736 19.5 4.5 19.5ZM10.5 9.375C10.5 10.4105 9.66053 11.25 8.625 11.25C7.58947 11.25 6.75 10.4105 6.75 9.375C6.75 8.33947 7.58947 7.5 8.625 7.5C9.66053 7.5 10.5 8.33947 10.5 9.375ZM11.7939 15.7114C10.8489 16.2147 9.77021 16.5 8.62484 16.5C7.47948 16.5 6.40074 16.2147 5.45581 15.7114C5.92986 14.4207 7.16983 13.5 8.62484 13.5C10.0799 13.5 11.3198 14.4207 11.7939 15.7114Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))),
        UsersOutlined: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "heroicons-outline/users" },
                React__default.createElement("path", { id: "Vector", d: "M15 19.1276C15.8329 19.37 16.7138 19.5 17.625 19.5C19.1037 19.5 20.5025 19.1576 21.7464 18.5478C21.7488 18.4905 21.75 18.4329 21.75 18.375C21.75 16.0968 19.9031 14.25 17.625 14.25C16.2069 14.25 14.956 14.9655 14.2136 16.0552M15 19.1276V19.125C15 18.0121 14.7148 16.9658 14.2136 16.0552M15 19.1276C15 19.1632 14.9997 19.1988 14.9991 19.2343C13.1374 20.3552 10.9565 21 8.625 21C6.29353 21 4.11264 20.3552 2.25092 19.2343C2.25031 19.198 2.25 19.1615 2.25 19.125C2.25 15.6042 5.10418 12.75 8.625 12.75C11.0329 12.75 13.129 14.085 14.2136 16.0552M12 6.375C12 8.23896 10.489 9.75 8.625 9.75C6.76104 9.75 5.25 8.23896 5.25 6.375C5.25 4.51104 6.76104 3 8.625 3C10.489 3 12 4.51104 12 6.375ZM20.25 8.625C20.25 10.0747 19.0747 11.25 17.625 11.25C16.1753 11.25 15 10.0747 15 8.625C15 7.17525 16.1753 6 17.625 6C19.0747 6 20.25 7.17525 20.25 8.625Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))),
        financeOutlined: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "heroicons-outline/banknotes" },
                React__default.createElement("path", { id: "Vector", d: "M2.25 18.75C7.71719 18.75 13.0136 19.4812 18.0468 20.8512C18.7738 21.0491 19.5 20.5086 19.5 19.7551V18.75M3.75 4.5V5.25C3.75 5.66421 3.41421 6 3 6H2.25M2.25 6V5.625C2.25 5.00368 2.75368 4.5 3.375 4.5H20.25M2.25 6V15M20.25 4.5V5.25C20.25 5.66421 20.5858 6 21 6H21.75M20.25 4.5H20.625C21.2463 4.5 21.75 5.00368 21.75 5.625V15.375C21.75 15.9963 21.2463 16.5 20.625 16.5H20.25M21.75 15H21C20.5858 15 20.25 15.3358 20.25 15.75V16.5M20.25 16.5H3.75M3.75 16.5H3.375C2.75368 16.5 2.25 15.9963 2.25 15.375V15M3.75 16.5V15.75C3.75 15.3358 3.41421 15 3 15H2.25M15 10.5C15 12.1569 13.6569 13.5 12 13.5C10.3431 13.5 9 12.1569 9 10.5C9 8.84315 10.3431 7.5 12 7.5C13.6569 7.5 15 8.84315 15 10.5ZM18 10.5H18.0075V10.5075H18V10.5ZM6 10.5H6.0075V10.5075H6V10.5Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))),
        BankOutlined: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { id: "heroicons-outline/building-library" },
                React__default.createElement("path", { id: "Vector", d: "M12 21V12.75M15.75 21V12.75M8.25 21V12.75M3 9L12 3L21 9M19.5 21V10.3325C17.0563 9.94906 14.5514 9.75 12 9.75C9.44861 9.75 6.94372 9.94906 4.5 10.3325V21M3 21H21M12 6.75H12.0075V6.7575H12V6.75Z", stroke: "#788393", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))),
        Plus: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M10.0003 4.16699V15.8337M4.16699 10.0003H15.8337", className: "stroke-primary", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Home: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M11.9004 2.53373C11.5784 2.28324 11.4174 2.158 11.2396 2.10986C11.0827 2.06738 10.9173 2.06738 10.7604 2.10986C10.5826 2.158 10.4216 2.28324 10.0996 2.53373L3.88244 7.36926C3.46685 7.69249 3.25906 7.85411 3.10936 8.05651C2.97675 8.2358 2.87797 8.43778 2.81786 8.65252C2.75 8.89495 2.75 9.1582 2.75 9.68469V16.3167C2.75 17.3435 2.75 17.8569 2.94982 18.249C3.12559 18.594 3.40605 18.8745 3.75102 19.0502C4.14319 19.25 4.65657 19.25 5.68333 19.25H7.51667C7.77336 19.25 7.9017 19.25 7.99975 19.2001C8.08599 19.1562 8.1561 19.086 8.20004 18.9998C8.25 18.9018 8.25 18.7734 8.25 18.5167V12.4667C8.25 11.9533 8.25 11.6966 8.34991 11.5006C8.43779 11.3281 8.57803 11.1878 8.75051 11.1C8.94659 11 9.20329 11 9.71667 11H12.2833C12.7967 11 13.0534 11 13.2495 11.1C13.422 11.1878 13.5622 11.3281 13.6501 11.5006C13.75 11.6966 13.75 11.9533 13.75 12.4667V18.5167C13.75 18.7734 13.75 18.9018 13.8 18.9998C13.8439 19.086 13.914 19.1562 14.0003 19.2001C14.0983 19.25 14.2266 19.25 14.4833 19.25H16.3167C17.3434 19.25 17.8568 19.25 18.249 19.0502C18.5939 18.8745 18.8744 18.594 19.0502 18.249C19.25 17.8569 19.25 17.3435 19.25 16.3167V9.68469C19.25 9.1582 19.25 8.89495 19.1821 8.65252C19.122 8.43778 19.0232 8.2358 18.8906 8.05651C18.7409 7.85411 18.5331 7.69249 18.1176 7.36926L11.9004 2.53373Z", className: "stroke-neutral-60", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Transaction: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.33301 6.41667L18.333 6.41667M18.333 6.41667L14.6663 2.75M18.333 6.41667L14.6663 10.0833M14.6663 15.5833L3.66634 15.5833M3.66634 15.5833L7.33301 19.25M3.66634 15.5833L7.33301 11.9167", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Users: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("ellipse", { cx: "8.24967", cy: "6.41667", rx: "3.66667", ry: "3.66667", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M2.75 19.25V17.4167C2.75 15.3916 4.39162 13.75 6.41667 13.75H10.0833C12.1084 13.75 13.75 15.3916 13.75 17.4167V19.25", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M14.667 2.86908C16.2894 3.28449 17.4242 4.7464 17.4242 6.42116C17.4242 8.09592 16.2894 9.55784 14.667 9.97325", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M19.25 19.2499V17.4166C19.2404 15.7524 18.1113 14.3034 16.5 13.8874", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Bell: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M13.7485 17.4167C13.7485 18.9355 12.5173 20.1667 10.9985 20.1667C9.47974 20.1667 8.24852 18.9355 8.24852 17.4167M12.6453 5.71872C13.0445 5.3063 13.2902 4.74436 13.2902 4.12504C13.2902 2.85939 12.2642 1.83337 10.9985 1.83337C9.73287 1.83337 8.70686 2.85939 8.70686 4.12504C8.70686 4.74436 8.95253 5.3063 9.35173 5.71872M16.4985 10.2667C16.4985 9.00251 15.9191 7.79009 14.8876 6.89617C13.8562 6.00224 12.4572 5.50004 10.9985 5.50004C9.53983 5.50004 8.14089 6.00224 7.10944 6.89617C6.07799 7.79009 5.49852 9.00251 5.49852 10.2667C5.49852 12.3584 4.97981 13.8881 4.33258 14.9827C3.59492 16.2302 3.22608 16.854 3.24065 17.003C3.25731 17.1734 3.288 17.2272 3.42625 17.3283C3.5471 17.4167 4.15424 17.4167 5.36853 17.4167H16.6285C17.8428 17.4167 18.45 17.4167 18.5708 17.3283C18.7091 17.2272 18.7397 17.1734 18.7564 17.003C18.771 16.854 18.4021 16.2302 17.6645 14.9827C17.0172 13.8881 16.4985 12.3584 16.4985 10.2667Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Filter: (React__default.createElement("svg", { className: className, width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.99961 4.95156V3.60156M8.99961 4.95156C8.25402 4.95156 7.64961 5.55598 7.64961 6.30156C7.64961 7.04715 8.25402 7.65156 8.99961 7.65156M8.99961 4.95156C9.74519 4.95156 10.3496 5.55598 10.3496 6.30156C10.3496 7.04715 9.74519 7.65156 8.99961 7.65156M4.94961 13.0516C5.69519 13.0516 6.29961 12.4471 6.29961 11.7016C6.29961 10.956 5.69519 10.3516 4.94961 10.3516M4.94961 13.0516C4.20402 13.0516 3.59961 12.4471 3.59961 11.7016C3.59961 10.956 4.20402 10.3516 4.94961 10.3516M4.94961 13.0516V14.4016M4.94961 10.3516V3.60156M8.99961 7.65156V14.4016M13.0496 13.0516C13.7952 13.0516 14.3996 12.4471 14.3996 11.7016C14.3996 10.956 13.7952 10.3516 13.0496 10.3516M13.0496 13.0516C12.304 13.0516 11.6996 12.4471 11.6996 11.7016C11.6996 10.956 12.304 10.3516 13.0496 10.3516M13.0496 13.0516V14.4016M13.0496 10.3516V3.60156", stroke: "#8B909A", strokeWidth: "1.35", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Config: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M6.36699 6.31548L9.96699 9.91548M6.36699 6.31548H3.96699L3.16699 3.91548L3.96699 3.11548L6.36699 3.91548V6.31548ZM9.96699 9.91548L10.0926 9.78985M9.96699 9.91548L4.36699 15.5155M14.767 11.9155C17.197 11.9155 19.167 9.94553 19.167 7.51548C19.167 6.92379 19.0502 6.35939 18.8384 5.84405L16.8721 7.81038C16.5553 8.12719 16.3969 8.2856 16.2142 8.34495C16.0535 8.39716 15.8805 8.39716 15.7198 8.34495C15.5371 8.2856 15.3787 8.12719 15.0619 7.81038L14.8721 7.62057C14.5553 7.30376 14.3969 7.14535 14.3375 6.96269C14.2853 6.80202 14.2853 6.62894 14.3375 6.46826C14.3969 6.2856 14.5553 6.12719 14.8721 5.81038L16.9742 3.70829C16.3254 3.33134 15.5714 3.11548 14.767 3.11548C12.3369 3.11548 10.367 5.08543 10.367 7.51548C10.367 7.80844 10.3956 8.09472 10.4502 8.37167C10.5269 8.76058 10.5653 8.95504 10.5536 9.07293C10.5411 9.19825 10.5223 9.26002 10.4628 9.37107C10.4069 9.47552 10.3022 9.5803 10.0926 9.78985M14.767 11.9155C14.6254 11.9155 14.4854 11.9088 14.3472 11.8957M14.767 11.9155C14.6205 11.9155 14.4757 11.9083 14.3329 11.8943M10.0926 9.78985L4.36699 15.5155M4.36699 15.5155C3.70425 16.1782 3.70425 17.2527 4.36699 17.9155C5.02973 18.5782 6.10425 18.5782 6.76699 17.9155M12.4926 12.1899L6.76699 17.9155M12.4926 12.1899C12.6619 12.0205 12.7629 11.9196 12.8505 11.8576M12.4926 12.1899L12.7187 11.9637M12.4926 12.1899L11.167 13.5154M6.76699 17.9155L11.167 13.5154M11.167 13.5154L15.567 17.9154C16.2297 18.5781 17.3042 18.5781 17.967 17.9154C18.6297 17.2526 18.6297 16.1781 17.967 15.5154L14.3472 11.8957M11.167 13.5154L12.7187 11.9637M14.3472 11.8957C14.3425 11.8953 14.3377 11.8948 14.3329 11.8943M12.7187 11.9637C12.7593 11.9231 12.8035 11.8878 12.8505 11.8576M13.9092 11.8319C13.8047 11.8113 13.7014 11.7869 13.5996 11.7589C13.4781 11.7256 13.352 11.7147 13.2298 11.7274M13.9092 11.8319C13.6185 11.7746 13.4366 11.7387 13.3142 11.7293C13.2823 11.7269 13.2545 11.7262 13.2298 11.7274M13.9092 11.8319L13.9108 11.8322C14.0493 11.8595 14.1901 11.8803 14.3329 11.8943M13.9092 11.8319C14.0482 11.8594 14.1895 11.8803 14.3329 11.8943M13.2298 11.7274C13.0947 11.7415 12.9644 11.7844 12.8505 11.8576M13.2298 11.7274C13.2228 11.7278 13.2161 11.7283 13.2095 11.7289C13.0842 11.7414 13.0224 11.7602 12.9114 11.8196C12.8913 11.8304 12.8713 11.8429 12.8505 11.8576", stroke: "#6F809E", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Data: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.9375 14.5833L7.25 17.3333L6.33333 18.25H13.6667L12.75 17.3333L12.0625 14.5833M1.75 10.9167H18.25M3.58333 14.5833H16.4167C17.4292 14.5833 18.25 13.7625 18.25 12.75V3.58333C18.25 2.57081 17.4292 1.75 16.4167 1.75H3.58333C2.57081 1.75 1.75 2.57081 1.75 3.58333V12.75C1.75 13.7625 2.57081 14.5833 3.58333 14.5833Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Operation: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.99902 9.63872C8.99902 9.4147 8.99902 9.30269 9.04262 9.21712C9.08097 9.14186 9.14216 9.08067 9.21743 9.04232C9.30299 8.99872 9.415 8.99872 9.63902 8.99872H12.359C12.583 8.99872 12.6951 8.99872 12.7806 9.04232C12.8559 9.08067 12.9171 9.14186 12.9554 9.21712C12.999 9.30269 12.999 9.4147 12.999 9.63872V12.3587C12.999 12.5827 12.999 12.6947 12.9554 12.7803C12.9171 12.8556 12.8559 12.9168 12.7806 12.9551C12.6951 12.9987 12.583 12.9987 12.359 12.9987H9.63902C9.415 12.9987 9.30299 12.9987 9.21743 12.9551C9.14216 12.9168 9.08097 12.8556 9.04262 12.7803C8.99902 12.6947 8.99902 12.5827 8.99902 12.3587V9.63872Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M14.999 15.6387C14.999 15.4147 14.999 15.3027 15.0426 15.2171C15.081 15.1419 15.1422 15.0807 15.2174 15.0423C15.303 14.9987 15.415 14.9987 15.639 14.9987H18.359C18.583 14.9987 18.6951 14.9987 18.7806 15.0423C18.8559 15.0807 18.9171 15.1419 18.9554 15.2171C18.999 15.3027 18.999 15.4147 18.999 15.6387V18.3587C18.999 18.5827 18.999 18.6947 18.9554 18.7803C18.9171 18.8556 18.8559 18.9168 18.7806 18.9551C18.6951 18.9987 18.583 18.9987 18.359 18.9987H15.639C15.415 18.9987 15.303 18.9987 15.2174 18.9551C15.1422 18.9168 15.081 18.8556 15.0426 18.7803C14.999 18.6947 14.999 18.5827 14.999 18.3587V15.6387Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M2.99902 3.63872C2.99902 3.4147 2.99902 3.30269 3.04262 3.21712C3.08097 3.14186 3.14216 3.08067 3.21743 3.04232C3.30299 2.99872 3.415 2.99872 3.63902 2.99872H6.35902C6.58304 2.99872 6.69506 2.99872 6.78062 3.04232C6.85588 3.08067 6.91708 3.14186 6.95543 3.21712C6.99902 3.30269 6.99902 3.4147 6.99902 3.63872V6.35872C6.99902 6.58274 6.99902 6.69475 6.95543 6.78031C6.91708 6.85558 6.85588 6.91677 6.78062 6.95512C6.69506 6.99872 6.58304 6.99872 6.35902 6.99872H3.63902C3.415 6.99872 3.30299 6.99872 3.21743 6.95512C3.14216 6.91677 3.08097 6.85558 3.04262 6.78031C2.99902 6.69475 2.99902 6.58274 2.99902 6.35872V3.63872Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M10.199 4.99872H16.039C16.9351 4.99872 17.3832 4.99872 17.7254 5.17311C18.0265 5.32651 18.2712 5.57127 18.4246 5.87233C18.599 6.21459 18.599 6.66263 18.599 7.55872V8.59872C18.599 9.34423 18.599 9.71698 18.4772 10.011C18.3148 10.4031 18.0034 10.7145 17.6113 10.8769C17.3173 10.9987 16.9445 10.9987 16.199 10.9987M11.799 16.9987H5.95902C5.06294 16.9987 4.6149 16.9987 4.27264 16.8243C3.97158 16.6709 3.72681 16.4262 3.57341 16.1251C3.39902 15.7828 3.39902 15.3348 3.39902 14.4387V13.3987C3.39902 12.6532 3.39902 12.2805 3.52082 11.9864C3.68321 11.5944 3.99469 11.2829 4.38673 11.1205C4.68076 10.9987 5.05352 10.9987 5.79902 10.9987M9.63902 12.9987H12.359C12.583 12.9987 12.6951 12.9987 12.7806 12.9551C12.8559 12.9168 12.9171 12.8556 12.9554 12.7803C12.999 12.6948 12.999 12.5827 12.999 12.3587V9.63872C12.999 9.4147 12.999 9.30269 12.9554 9.21712C12.9171 9.14186 12.8559 9.08067 12.7806 9.04232C12.6951 8.99872 12.583 8.99872 12.359 8.99872H9.63902C9.415 8.99872 9.30299 8.99872 9.21743 9.04232C9.14216 9.08067 9.08097 9.14186 9.04262 9.21712C8.99902 9.30269 8.99902 9.4147 8.99902 9.63872V12.3587C8.99902 12.5827 8.99902 12.6948 9.04262 12.7803C9.08097 12.8556 9.14216 12.9168 9.21743 12.9551C9.30299 12.9987 9.415 12.9987 9.63902 12.9987ZM15.639 18.9987H18.359C18.583 18.9987 18.6951 18.9987 18.7806 18.9551C18.8559 18.9168 18.9171 18.8556 18.9554 18.7803C18.999 18.6948 18.999 18.5827 18.999 18.3587V15.6387C18.999 15.4147 18.999 15.3027 18.9554 15.2171C18.9171 15.1419 18.8559 15.0807 18.7806 15.0423C18.6951 14.9987 18.583 14.9987 18.359 14.9987H15.639C15.415 14.9987 15.303 14.9987 15.2174 15.0423C15.1422 15.0807 15.081 15.1419 15.0426 15.2171C14.999 15.3027 14.999 15.4147 14.999 15.6387V18.3587C14.999 18.5827 14.999 18.6948 15.0426 18.7803C15.081 18.8556 15.1422 18.9168 15.2174 18.9551C15.303 18.9987 15.415 18.9987 15.639 18.9987ZM3.63902 6.99872H6.35902C6.58304 6.99872 6.69506 6.99872 6.78062 6.95512C6.85588 6.91677 6.91708 6.85558 6.95543 6.78031C6.99902 6.69475 6.99902 6.58274 6.99902 6.35872V3.63872C6.99902 3.4147 6.99902 3.30269 6.95543 3.21712C6.91708 3.14186 6.85588 3.08067 6.78062 3.04232C6.69506 2.99872 6.58304 2.99872 6.35902 2.99872H3.63902C3.415 2.99872 3.30299 2.99872 3.21743 3.04232C3.14216 3.08067 3.08097 3.14186 3.04262 3.21712C2.99902 3.30269 2.99902 3.4147 2.99902 3.63872V6.35872C2.99902 6.58274 2.99902 6.69475 3.04262 6.78031C3.08097 6.85558 3.14216 6.91677 3.21743 6.95512C3.30299 6.99872 3.415 6.99872 3.63902 6.99872Z", stroke: "#6F809E", strokeWidth: "1.83333", strokeLinecap: "round", strokeLinejoin: "round" }))),
        PlusDark: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M10.0003 4.16699V15.8337M4.16699 10.0003H15.8337", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", className: "stroke-base-color dark:stroke-neutral-40" }))),
        Collapse: (React__default.createElement("svg", { className: className, width: "11", height: "10", viewBox: "0 0 11 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M10 1L6.25 4.75L10 8.5M4.75 1L1 4.75L4.75 8.5", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Download: (React__default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", className: className, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M6.66699 9.99999L10.0003 13.3333M10.0003 13.3333L13.3337 9.99999M10.0003 13.3333V6.66666M18.3337 9.99999C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 9.99999C1.66699 5.39762 5.39795 1.66666 10.0003 1.66666C14.6027 1.66666 18.3337 5.39762 18.3337 9.99999Z", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round", className: "stroke-base-color dark:stroke-neutral-40" }))),
        Developer: (React__default.createElement("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
            React__default.createElement("path", { d: "M9.16634 18.3346L12.833 3.66797M16.4997 7.33464L20.1663 11.0013L16.4997 14.668M5.49967 14.668L1.83301 11.0013L5.49967 7.33464", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Action: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M17.4445 2.55546C18.5185 3.6294 18.5185 5.3706 17.4445 6.44454C16.3706 7.51849 14.6294 7.51849 13.5555 6.44454C12.4815 5.3706 12.4815 3.6294 13.5555 2.55546C14.6294 1.48151 16.3706 1.48151 17.4445 2.55546Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M9.08333 2.66667H6.15C4.60986 2.66667 3.83978 2.66667 3.25153 2.9664C2.73408 3.23005 2.31338 3.65075 2.04973 4.16819C1.75 4.75645 1.75 5.52652 1.75 7.06667V13.85C1.75 15.3901 1.75 16.1602 2.04973 16.7485C2.31338 17.2659 2.73408 17.6866 3.25153 17.9503C3.83978 18.25 4.60986 18.25 6.15 18.25H12.9333C14.4735 18.25 15.2436 18.25 15.8318 17.9503C16.3493 17.6866 16.7699 17.2659 17.0336 16.7485C17.3333 16.1602 17.3333 15.3901 17.3333 13.85V10.9167M10.9167 14.5833H5.41667M12.75 10.9167H5.41667M17.4445 2.55546C18.5185 3.6294 18.5185 5.3706 17.4445 6.44454C16.3706 7.51849 14.6294 7.51849 13.5555 6.44454C12.4815 5.3706 12.4815 3.6294 13.5555 2.55546C14.6294 1.48151 16.3706 1.48151 17.4445 2.55546Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        infoError: (React__default.createElement("svg", { className: className, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 0.631581C3.0351 0.631581 0.631581 3.0351 0.631581 6C0.631581 8.9649 3.0351 11.3684 6 11.3684C8.9649 11.3684 11.3684 8.9649 11.3684 6C11.3684 3.0351 8.9649 0.631581 6 0.631581ZM5.73704 4.54905C5.20532 4.79675 4.75309 5.22389 4.30051 5.84841C4.23597 5.93747 4.23336 5.99158 4.29967 6.03944C4.34628 6.07309 4.37337 6.06233 4.44127 5.98989C4.45035 5.98013 4.45035 5.98013 4.45964 5.97006C4.51834 5.90649 4.56562 5.85256 4.66661 5.73527C5.00031 5.34774 5.16331 5.18824 5.41663 5.04236C5.63585 4.91612 5.82851 5.10164 5.79182 5.33905C5.78153 5.4057 5.7638 5.45489 5.71813 5.5605C5.69996 5.60251 5.69229 5.62079 5.68377 5.64319C5.60144 5.85962 5.53209 6.04017 5.38678 6.41725L5.37983 6.43529C5.33589 6.5493 5.33589 6.5493 5.292 6.66329C5.10169 7.1579 4.98621 7.4612 4.86706 7.78196L4.86007 7.80076C4.83876 7.85796 4.81753 7.91519 4.79639 7.97244C4.65986 8.34268 4.58178 8.58325 4.5224 8.83912C4.51312 8.87893 4.51312 8.87893 4.50373 8.9194C4.47027 9.06414 4.45236 9.15741 4.44235 9.25328C4.42504 9.41904 4.43896 9.55478 4.49105 9.66886C4.55 9.79795 4.67666 9.89029 4.82117 9.91127C5.06191 9.94622 5.29419 9.94373 5.49314 9.89847C5.6051 9.87301 5.71588 9.83969 5.82457 9.79883C6.13928 9.68051 6.44246 9.49588 6.73611 9.25183C6.99305 9.03771 7.23616 8.77683 7.49104 8.45263C7.51326 8.42456 7.51326 8.42456 7.5354 8.39653C7.61239 8.29836 7.6501 8.23461 7.66418 8.16726C7.67949 8.09415 7.61769 8.02005 7.56829 8.04484C7.54387 8.05709 7.51833 8.08246 7.47941 8.13154C7.45158 8.16726 7.43644 8.18636 7.4213 8.20351C7.36086 8.27194 7.29703 8.34199 7.22788 8.41599C7.11388 8.53795 6.99804 8.65729 6.83003 8.82718C6.74447 8.9137 6.63686 8.98934 6.52116 9.04621C6.33597 9.13721 6.16892 9.02251 6.18898 8.81724C6.20222 8.68174 6.23504 8.54164 6.28413 8.4062C6.39136 8.11016 6.47902 7.87083 6.67298 7.3434C6.7571 7.11465 6.79342 7.01584 6.83878 6.89214C6.97327 6.52557 7.08063 6.23047 7.18278 5.94574C7.30897 5.59402 7.38026 5.33184 7.41326 5.06109C7.43818 4.85689 7.38137 4.66158 7.2518 4.52731C7.10814 4.37846 6.9038 4.30989 6.64931 4.31291C6.36773 4.31625 6.03926 4.40826 5.73704 4.54905ZM7.66442 2.12141C7.1584 1.92454 6.55121 2.26276 6.44953 2.79848C6.37581 3.18675 6.52086 3.52198 6.81691 3.66238C7.40377 3.9407 8.10808 3.49474 8.10811 2.84472C8.10814 2.48312 7.9537 2.23398 7.66442 2.12141Z", fill: "#FF2E00" }))),
        Pending: (React__default.createElement("svg", { className: className, width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("circle", { cx: "4", cy: "4", r: "4", fill: "#FF2E00" }))),
        UserProfile: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("circle", { cx: "11", cy: "11", r: "8.25", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("ellipse", { cx: "11", cy: "9.16666", rx: "2.75", ry: "2.75", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M5.65381 17.2782C6.11969 15.7277 7.54742 14.6662 9.16648 14.6667H12.8331C14.4544 14.6661 15.8836 15.7303 16.3476 17.2837", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        UserFilled: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M20.1666 19.25V17.4167C20.1666 15.7081 18.998 14.2726 17.4166 13.8655M14.2083 3.01653C15.552 3.56047 16.4999 4.87787 16.4999 6.41667C16.4999 7.95547 15.552 9.27287 14.2083 9.8168M15.5833 19.25C15.5833 17.5415 15.5833 16.6873 15.3041 16.0135C14.932 15.1151 14.2182 14.4013 13.3198 14.0291C12.6459 13.75 11.7917 13.75 10.0833 13.75H7.33325C5.6248 13.75 4.77057 13.75 4.09675 14.0291C3.19831 14.4013 2.4845 15.1151 2.11236 16.0135C1.83325 16.6873 1.83325 17.5415 1.83325 19.25M12.3749 6.41667C12.3749 8.44171 10.7333 10.0833 8.70825 10.0833C6.68321 10.0833 5.04159 8.44171 5.04159 6.41667C5.04159 4.39162 6.68321 2.75 8.70825 2.75C10.7333 2.75 12.3749 4.39162 12.3749 6.41667Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
        ExternalLink: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14", stroke: "#3E74FF", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        ExternalLinkWhite: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14", stroke: "#ffffff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        InfoGrey: (React__default.createElement("svg", { className: className, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.99999 10.6667V8M7.99999 5.33334H8.00666M14.6667 8C14.6667 11.6819 11.6819 14.6667 7.99999 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33334 7.99999 1.33334C11.6819 1.33334 14.6667 4.3181 14.6667 8Z", stroke: "#6F809E", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }))),
        InfoWhite: (React__default.createElement("svg", { className: className, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.00001 10.6667V8M8.00001 5.33333H8.00668M14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8C1.33334 4.3181 4.31811 1.33333 8.00001 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z", stroke: "white", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }))),
        tickWhite: (React__default.createElement("svg", { className: className, width: "12", height: "9", viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M11.3333 1L4.00001 8.33333L0.666672 5", stroke: "white", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round" }))),
        CrossGrey: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.5364 6.2636C7.18492 5.91213 6.61508 5.91213 6.2636 6.2636C5.91213 6.61508 5.91213 7.18492 6.2636 7.5364L10.7272 12L6.2636 16.4636C5.91213 16.8151 5.91213 17.3849 6.2636 17.7364C6.61508 18.0879 7.18492 18.0879 7.5364 17.7364L12 13.2728L16.4636 17.7364C16.8151 18.0879 17.3849 18.0879 17.7364 17.7364C18.0879 17.3849 18.0879 16.8151 17.7364 16.4636L13.2728 12L17.7364 7.5364C18.0879 7.18492 18.0879 6.61508 17.7364 6.2636C17.3849 5.91213 16.8151 5.91213 16.4636 6.2636L12 10.7272L7.5364 6.2636Z", fill: "#6F809E" }))),
        CrossWhite: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M7.5364 6.2636C7.18492 5.91213 6.61508 5.91213 6.2636 6.2636C5.91213 6.61508 5.91213 7.18492 6.2636 7.5364L10.7272 12L6.2636 16.4636C5.91213 16.8151 5.91213 17.3849 6.2636 17.7364C6.61508 18.0879 7.18492 18.0879 7.5364 17.7364L12 13.2728L16.4636 17.7364C16.8151 18.0879 17.3849 18.0879 17.7364 17.7364C18.0879 17.3849 18.0879 16.8151 17.7364 16.4636L13.2728 12L17.7364 7.5364C18.0879 7.18492 18.0879 6.61508 17.7364 6.2636C17.3849 5.91213 16.8151 5.91213 16.4636 6.2636L12 10.7272L7.5364 6.2636Z", fill: "#ffffff" }))),
        InfoRed: (React__default.createElement("svg", { className: className, width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 0.631581C3.0351 0.631581 0.631581 3.0351 0.631581 6C0.631581 8.9649 3.0351 11.3684 6 11.3684C8.9649 11.3684 11.3684 8.9649 11.3684 6C11.3684 3.0351 8.9649 0.631581 6 0.631581ZM5.73704 4.54905C5.20532 4.79675 4.75309 5.22389 4.30051 5.84841C4.23597 5.93747 4.23336 5.99158 4.29967 6.03944C4.34628 6.07309 4.37337 6.06233 4.44127 5.98989C4.45035 5.98013 4.45035 5.98013 4.45964 5.97006C4.51834 5.90649 4.56562 5.85256 4.66661 5.73527C5.00031 5.34774 5.16331 5.18824 5.41663 5.04236C5.63585 4.91612 5.82851 5.10164 5.79182 5.33905C5.78153 5.4057 5.7638 5.45489 5.71813 5.5605C5.69996 5.60251 5.69229 5.62079 5.68377 5.64319C5.60144 5.85962 5.53209 6.04017 5.38678 6.41725L5.37983 6.43529C5.33589 6.5493 5.33589 6.5493 5.292 6.66329C5.10169 7.1579 4.98621 7.4612 4.86706 7.78196L4.86007 7.80076C4.83876 7.85796 4.81753 7.91519 4.79639 7.97244C4.65986 8.34268 4.58178 8.58325 4.5224 8.83912C4.51312 8.87893 4.51312 8.87893 4.50373 8.9194C4.47027 9.06414 4.45236 9.15741 4.44235 9.25328C4.42504 9.41904 4.43896 9.55478 4.49105 9.66886C4.55 9.79795 4.67666 9.89029 4.82117 9.91127C5.06191 9.94622 5.29419 9.94373 5.49314 9.89847C5.6051 9.87301 5.71588 9.83969 5.82457 9.79883C6.13928 9.68051 6.44246 9.49588 6.73611 9.25183C6.99305 9.03771 7.23616 8.77683 7.49104 8.45263C7.51326 8.42456 7.51326 8.42456 7.5354 8.39653C7.61239 8.29836 7.6501 8.23461 7.66418 8.16726C7.67949 8.09415 7.61769 8.02005 7.56829 8.04484C7.54387 8.05709 7.51833 8.08246 7.47941 8.13154C7.45158 8.16726 7.43644 8.18636 7.4213 8.20351C7.36086 8.27194 7.29703 8.34199 7.22788 8.41599C7.11388 8.53795 6.99804 8.65729 6.83003 8.82718C6.74447 8.9137 6.63686 8.98934 6.52116 9.04621C6.33597 9.13721 6.16892 9.02251 6.18898 8.81724C6.20222 8.68174 6.23504 8.54164 6.28413 8.4062C6.39136 8.11016 6.47902 7.87083 6.67298 7.3434C6.7571 7.11465 6.79342 7.01584 6.83878 6.89214C6.97327 6.52557 7.08063 6.23047 7.18278 5.94574C7.30897 5.59402 7.38026 5.33184 7.41326 5.06109C7.43818 4.85689 7.38137 4.66158 7.2518 4.52731C7.10814 4.37846 6.9038 4.30989 6.64931 4.31291C6.36773 4.31625 6.03926 4.40826 5.73704 4.54905ZM7.66442 2.12141C7.1584 1.92454 6.55121 2.26276 6.44953 2.79848C6.37581 3.18675 6.52086 3.52198 6.81691 3.66238C7.40377 3.9407 8.10808 3.49474 8.10811 2.84472C8.10814 2.48312 7.9537 2.23398 7.66442 2.12141Z", fill: "#FF2E00" }))),
        Tenant: (React__default.createElement("svg", { className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("g", { clipPath: "url(#clip0_131_9801)" },
                React__default.createElement("path", { d: "M3.66661 19.9995C4.21897 20.1668 4.96504 20.1668 6.23325 20.1668H15.7666C17.0348 20.1668 17.7809 20.1668 18.3332 19.9995M3.66661 19.9995C3.54817 19.9636 3.43864 19.92 3.33478 19.8671C2.81733 19.6034 2.39664 19.1827 2.13298 18.6653C1.83325 18.077 1.83325 17.307 1.83325 15.7668V6.2335C1.83325 4.69335 1.83325 3.92328 2.13298 3.33502C2.39664 2.81758 2.81733 2.39688 3.33478 2.13323C3.92304 1.8335 4.69311 1.8335 6.23325 1.8335H15.7666C17.3067 1.8335 18.0768 1.8335 18.6651 2.13323C19.1825 2.39688 19.6032 2.81758 19.8669 3.33502C20.1666 3.92328 20.1666 4.69335 20.1666 6.2335V15.7668C20.1666 17.307 20.1666 18.077 19.8669 18.6653C19.6032 19.1827 19.1825 19.6034 18.6651 19.8671C18.5612 19.92 18.4517 19.9636 18.3332 19.9995M3.66661 19.9995C3.66691 19.2576 3.67136 18.865 3.73704 18.5348C4.02636 17.0803 5.16339 15.9433 6.61792 15.6539C6.97212 15.5835 7.39805 15.5835 8.24992 15.5835H13.7499C14.6018 15.5835 15.0277 15.5835 15.3819 15.6539C16.8364 15.9433 17.9735 17.0803 18.2628 18.5348C18.3285 18.865 18.3329 19.2576 18.3332 19.9995M14.6666 8.7085C14.6666 10.7335 13.025 12.3752 10.9999 12.3752C8.97487 12.3752 7.33325 10.7335 7.33325 8.7085C7.33325 6.68345 8.97487 5.04183 10.9999 5.04183C13.025 5.04183 14.6666 6.68345 14.6666 8.7085Z", stroke: "#6F809E", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" })),
            React__default.createElement("defs", null,
                React__default.createElement("clipPath", { id: "clip0_131_9801" },
                    React__default.createElement("rect", { width: "22", height: "22", fill: "white" }))))),
        FailureCode: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8 21H16M12 17V21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M18 7V10M18 13H18.0075", stroke: "#6F809E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M10.5 10H6M7.5 13H6M12 7H6", stroke: "#6F809E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        PIN: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M14.541 13.9997L14.6408 12.242L13.1652 13.2098L12.6357 12.2897L14.2112 11.4998L12.6357 10.71L13.1652 9.78988L14.6408 10.7577L14.541 9H15.5956L15.5001 10.7577L16.9757 9.78988L17.5052 10.71L15.9255 11.4998L17.5052 12.2897L16.9757 13.2098L15.5001 12.242L15.5956 13.9997H14.541Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M7.90526 13.9997L8.00508 12.242L6.52948 13.2098L6 12.2897L7.57542 11.4998L6 10.71L6.52948 9.78988L8.00508 10.7577L7.90526 9H8.95988L8.8644 10.7577L10.34 9.78988L10.8695 10.71L9.28972 11.4998L10.8695 12.2897L10.34 13.2098L8.8644 12.242L8.95988 13.9997H7.90526Z", fill: "#6F809E" }))),
        IFSC: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z", stroke: "#6F809E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M19 11.7826H17.7369C17.7279 11.6781 17.7041 11.5833 17.6652 11.4982C17.6279 11.4131 17.5757 11.3399 17.5085 11.2787C17.4428 11.216 17.3629 11.1683 17.2689 11.1354C17.1748 11.1011 17.0681 11.0839 16.9486 11.0839C16.7396 11.0839 16.5627 11.1347 16.4179 11.2362C16.2745 11.3377 16.1655 11.4833 16.0909 11.6729C16.0177 11.8625 15.9812 12.0902 15.9812 12.3559C15.9812 12.6366 16.0185 12.8717 16.0931 13.0613C16.1693 13.2495 16.279 13.3913 16.4223 13.4868C16.5657 13.5809 16.7381 13.6279 16.9397 13.6279C17.0546 13.6279 17.1576 13.6137 17.2487 13.5854C17.3398 13.5555 17.4189 13.513 17.4861 13.4577C17.5533 13.4025 17.6078 13.3361 17.6496 13.2584C17.6929 13.1793 17.722 13.0905 17.7369 12.9919L19 13.0009C18.985 13.195 18.9305 13.3928 18.8365 13.5943C18.7424 13.7944 18.6088 13.9795 18.4356 14.1497C18.2639 14.3184 18.0512 14.4543 17.7974 14.5573C17.5436 14.6603 17.2487 14.7118 16.9128 14.7118C16.4918 14.7118 16.114 14.6215 15.7796 14.4409C15.4467 14.2602 15.1832 13.9945 14.9891 13.6436C14.7965 13.2928 14.7002 12.8635 14.7002 12.3559C14.7002 11.8453 14.7987 11.4153 14.9958 11.066C15.1929 10.7151 15.4586 10.4501 15.7931 10.271C16.1275 10.0903 16.5007 10 16.9128 10C17.2024 10 17.4689 10.0396 17.7123 10.1187C17.9556 10.1978 18.1691 10.3135 18.3528 10.4658C18.5364 10.6166 18.6842 10.8025 18.7962 11.0234C18.9081 11.2444 18.9761 11.4975 19 11.7826Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M12.9902 11.496C12.9782 11.3467 12.9223 11.2302 12.8222 11.1466C12.7237 11.063 12.5736 11.0212 12.3721 11.0212C12.2437 11.0212 12.1384 11.0369 12.0563 11.0682C11.9757 11.0981 11.916 11.1391 11.8772 11.1914C11.8384 11.2436 11.8182 11.3034 11.8167 11.3706C11.8137 11.4258 11.8234 11.4758 11.8458 11.5206C11.8697 11.5639 11.907 11.6035 11.9578 11.6393C12.0086 11.6736 12.0735 11.705 12.1526 11.7333C12.2318 11.7617 12.3258 11.7871 12.4348 11.8095L12.811 11.8901C13.0648 11.9439 13.2821 12.0148 13.4627 12.1029C13.6434 12.1909 13.7912 12.2947 13.9061 12.4141C14.0211 12.5321 14.1054 12.665 14.1592 12.8128C14.2144 12.9606 14.2428 13.1218 14.2443 13.2965C14.2428 13.5981 14.1674 13.8534 14.0181 14.0624C13.8688 14.2714 13.6553 14.4304 13.3776 14.5394C13.1014 14.6484 12.7692 14.7029 12.3811 14.7029C11.9824 14.7029 11.6346 14.6439 11.3375 14.526C11.0419 14.408 10.8119 14.2266 10.6477 13.9818C10.485 13.7354 10.4029 13.4204 10.4014 13.0367H11.5838C11.5913 13.1771 11.6264 13.295 11.6891 13.3905C11.7518 13.4861 11.8398 13.5585 11.9533 13.6078C12.0683 13.657 12.2049 13.6817 12.3631 13.6817C12.496 13.6817 12.6072 13.6653 12.6968 13.6324C12.7864 13.5996 12.8543 13.554 12.9006 13.4958C12.9469 13.4376 12.9708 13.3711 12.9723 13.2965C12.9708 13.2263 12.9476 13.1651 12.9028 13.1129C12.8596 13.0591 12.7879 13.0113 12.6879 12.9695C12.5878 12.9262 12.4527 12.8859 12.2825 12.8486L11.8257 12.7501C11.4196 12.662 11.0993 12.5149 10.8649 12.3089C10.632 12.1014 10.5163 11.8184 10.5178 11.4601C10.5163 11.169 10.594 10.9144 10.7507 10.6965C10.909 10.477 11.1277 10.3061 11.4069 10.1836C11.6876 10.0612 12.0093 10 12.3721 10C12.7424 10 13.0626 10.062 13.3328 10.1859C13.6031 10.3098 13.8113 10.4845 13.9576 10.7099C14.1054 10.9339 14.1801 11.1959 14.1816 11.496H12.9902Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M6.83521 14.6489V10.0625H10.06V11.0658H8.08035V11.8541H9.86296V12.8573H8.08035V14.6489H6.83521Z", fill: "#6F809E" }),
            React__default.createElement("path", { d: "M6.24514 10.0625V14.6489H5V10.0625H6.24514Z", fill: "#6F809E" }))),
        CheckCircle: (React__default.createElement("svg", { className: className, width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M6.33333 9.66667L8.33333 11.6667L11.6667 7M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z", stroke: "#3CAF7F", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        CheckedCircle: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", fill: "#3CAF7F" }),
            React__default.createElement("path", { d: "M7 10.75L9.25 13L13 7.75M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", stroke: "#FBFCFE", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        CrossCircle: (React__default.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", fill: "#E20707" }),
            React__default.createElement("path", { d: "M7.75 7.75L12.25 12.25M12.25 7.75L7.75 12.25M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z", stroke: "#FBFCFE", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Link: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M12.459 16.1313L11.541 17.0493C10.2734 18.3169 8.21825 18.3169 6.95068 17.0493C5.68311 15.7817 5.68311 13.7266 6.95068 12.459L7.86874 11.541M16.1313 12.459L17.0493 11.541C18.3169 10.2734 18.3169 8.21825 17.0493 6.95068C15.7817 5.68311 13.7266 5.68311 12.459 6.95068L11.541 7.86874M9.72792 14.2721L14.2721 9.72791", stroke: "#2955D9", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        Refresh: (React__default.createElement("svg", { className: className, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z", className: "fill-neutral-110 dark:fill-neutral-40" }))),
        Date: (React__default.createElement("svg", { className: className, width: "14", height: "14", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", id: "calendar" },
            React__default.createElement("path", { className: "fill-neutral-80 dark:fill-neutral-40", d: "M58 5.5h-5.5V5a5 5 0 0 0-10 0v.5h-21V5a5 5 0 0 0-10 0v.5H6a6 6 0 0 0-6 6v41a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-41a6 6 0 0 0-6-6ZM46.5 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0Zm-31 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0ZM60 52.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V22h56ZM60 18H4v-6.5a2 2 0 0 1 2-2h5.5V11a5 5 0 0 0 10 0V9.5h21V11a5 5 0 0 0 10 0V9.5H58a2 2 0 0 1 2 2Z" }))),
        Default: React__default.createElement(React__default.Fragment, null),
    };
    const IconSvg = has$1(svg, name) ? svg[name] : svg.Default;
    return IconSvg;
};

function getCaseClass(theme) {
    if (theme?.format == "uppercase") {
        return `uppercase`;
    }
    else if (theme?.format == "lowercase") {
        return `lowercase`;
    }
    else if (theme?.format == "capitalize") {
        return `capitalize`;
    }
    return "normal-case";
}
function Description({ type = "default", text = "Button", onClick, customClass = "", children, logo, label, theme, footer, }) {
    let caseClass = getCaseClass(theme);
    let defaultClasses = `flex initial:items-center mt-1 mb-1 rounded-md`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    let bgwrapperClasses = `${defaultClasses} bg-primary-10 p-1 dark:bg-neutral-dark-5`;
    let verifiedClasses = `${defaultClasses} bg-secondary-5 p-1 dark:bg-neutral-dark-5`;
    //notes
    let notewrapperClasses = `flex initial:items-center justify-between px-4 py-2`;
    //labeldesc
    let labeldescClasses = `${caseClass} text-neutral-40 text-size-12 leading-tight mb-1 dark:text-neutral-40`;
    labeldescClasses = addCustomClassToBaseClass(labeldescClasses, customClass);
    let descTextClasses = `${caseClass} block text-size-12 text-neutra-N40 leading-tight dark:text-neutral-40`;
    let errorClasses = `${descTextClasses} text-error`;
    let notesClasses = `${caseClass} text-neutral-60 text-size-14 leading-tight block  dark:text-neutral-40`;
    //borderedNotes
    let borderedNotesClasses = `${caseClass} flex justify-between items-center border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-2 initial:mb-2 bg-primary-N5 dark:bg-neutral-dark-5`;
    borderedNotesClasses = addCustomClassToBaseClass(borderedNotesClasses, customClass);
    //keyValueNotes
    let keyValueNotesClasses = `flex justify-between items-center border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-1 mb-2`;
    keyValueNotesClasses = addCustomClassToBaseClass(keyValueNotesClasses, customClass);
    //text
    let textWrapClasses = `${caseClass} text-neutral-60 mb-6 leading-snug text-size-14`;
    let textClasses = addCustomClassToBaseClass(textWrapClasses, customClass);
    //Pop
    let popWrapClass = `${caseClass} rounded-md bg-primary-10 px-4 py-2 dark:bg-neutral-dark-10`;
    let popClasses = customClass ? `${popWrapClass} ${customClass}` : `${popWrapClass}`;
    //BorderedPop
    let borderPopWrapClass = `rounded-md border border-solid border-neutral-10 py-2 px-2 dark:border-neutral-dark-10`;
    let BorderPopClasses = addCustomClassToBaseClass(borderPopWrapClass, customClass);
    const descriptionType = {
        default: () => {
            return (React__default.createElement("div", { className: defaultClasses },
                React__default.createElement(IconList, { name: "Info", className: "mr-2" }),
                React__default.createElement("span", { className: descTextClasses }, text)));
        },
        withBg: () => {
            return (React__default.createElement("div", { className: bgwrapperClasses },
                React__default.createElement("i", { className: "block" },
                    React__default.createElement(IconList, { name: "infoRound", className: "mr-2" })),
                React__default.createElement("span", { className: descTextClasses }, text)));
        },
        verified: () => {
            return (React__default.createElement("div", { className: verifiedClasses },
                React__default.createElement(IconList, { name: "successInfo", className: "mr-2" }),
                React__default.createElement("span", { className: descTextClasses }, text)));
        },
        error: () => {
            return (React__default.createElement("div", { className: defaultClasses },
                React__default.createElement(IconList, { name: "Error", className: "mr-2" }),
                React__default.createElement("span", { className: errorClasses }, text)));
        },
        notes: () => {
            function renderFooter() {
                return (React__default.createElement(Sanitize, { check: Boolean(footer) },
                    React__default.createElement("div", { className: "bg-primary-20 dark:bg-neutral-dark-20 rounded-b-md px-4 py-2" }, footer)));
            }
            return (React__default.createElement("div", { className: "bg-primary-10 dark:bg-neutral-dark-5 mt-1 mb-1 rounded-md" },
                React__default.createElement("div", { className: notewrapperClasses },
                    React__default.createElement("span", { className: notesClasses }, text),
                    React__default.createElement("div", null, children)),
                renderFooter()));
        },
        borderedNotes: () => {
            function renderLogo() {
                return (React__default.createElement(Sanitize, { check: Boolean(logo) },
                    React__default.createElement("i", { className: "mr-2 block" },
                        React__default.createElement("img", { src: logo, alt: "placeholder logo", className: "w-6" }))));
            }
            return (React__default.createElement("div", { className: borderedNotesClasses },
                React__default.createElement("div", { className: "flex items-center" },
                    renderLogo(),
                    React__default.createElement("span", { className: "font-opensans text-size-base text-neutral dark:text-neutral-dark-110 font-semibold" }, text)),
                React__default.createElement("div", null, children)));
        },
        keyValueNotes: () => {
            return (React__default.createElement("div", { className: keyValueNotesClasses },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement("label", { className: "text-size-14 text-neutral-40 mr-2" }, label),
                    React__default.createElement("span", { className: "font-opensans text-size-14 text-neutral-dark-0 dark:text-neutral-dark-80 font-semibold" }, text))));
        },
        labelDesc: () => {
            return React__default.createElement("p", { className: labeldescClasses }, text);
        },
        text: () => {
            return React__default.createElement("p", { className: textClasses }, text);
        },
        pop: () => {
            return (React__default.createElement("div", { className: popClasses },
                React__default.createElement(Sanitize, { check: Boolean(label) },
                    React__default.createElement("span", { className: "font-opensans text-size-12 text-neutral-60 dark:text-neutral-40" }, label)),
                React__default.createElement("h5", { className: "size-base font-opensans text-neutral-110 dark:text-neutral-dark-110 font-semibold" }, text)));
        },
        borderedPop: () => {
            function renderLogo() {
                return (React__default.createElement(Sanitize, { check: Boolean(logo) },
                    React__default.createElement("div", { className: "mr-2" },
                        React__default.createElement("img", { src: logo, alt: logo, className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" }))));
            }
            return (React__default.createElement("div", { className: BorderPopClasses },
                React__default.createElement("div", { className: "flex items-center" },
                    renderLogo(),
                    React__default.createElement("span", { className: "text-size-14 text-neutral-60 block" }, label)),
                React__default.createElement("h5", { className: "text-size-12 text-neutral-40" }, text)));
        },
    };
    const render = () => {
        return descriptionType[type]();
    };
    return render();
}

const Icon = ({ name = "Alert", className, fill }) => {
    return React__default.createElement(IconList, { name: name, className: className, fill: fill });
};

function Dropdown({ variant = "default", dropdownOptions, placement, children, customClass = "", triggerContent, onClick, optionIcon, }) {
    const _args = { onClick: onClick };
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    const [toggle, setToggle] = useState(false);
    let wrapperClasses = "relative initial:inline-block";
    wrapperClasses = addCustomClassToBaseClass(wrapperClasses, customClass);
    let wrapperCustomOptionClasses = "relative block";
    wrapperCustomOptionClasses = addCustomClassToBaseClass(wrapperClasses, customClass);
    let wrapperStickyBottomClasses = "relative py-2 px-6 stickybottom-dropdown-wrapper";
    wrapperStickyBottomClasses = addCustomClassToBaseClass(wrapperStickyBottomClasses, customClass);
    let listItemClasses = `option py-1 px-1 text-neutral-dark-0 hover:bg-neutral-5 cursor-pointer truncate dark:bg-neutral-dark-5 dark:text-neutral-10 dark:hover:bg-neutral-dark-0`;
    let avatarClasses = `rounded-full w-6 h-6 flex items-center justify-center font-opensans text-size-14 text-neutral-110`;
    let defaultDropdownClasses = `w-24 shadow-5xl absolute overflow-hidden bg-neutral-0 w-full ease-in duration-200 z-10 rounded-md border border-solid border-neutral-5 dark:bg-neutral-dark-5 dark:shadow-D4xl dark:border-neutral-dark-0`;
    function getDropDownClassesMenuClass(defaultDropdownClasses) {
        //Dropdown Placement
        if (placement == "topRight") {
            return `${defaultDropdownClasses} bottom-6 right-0`;
        }
        else if (placement == "topLeft") {
            return `${defaultDropdownClasses} bottom-6 left-0`;
        }
        else if (placement == "bottomRight") {
            return `${defaultDropdownClasses}  right-0`;
        }
        else {
            return `${defaultDropdownClasses} left-0`;
        }
    }
    let dropdownClassesMenu = getDropDownClassesMenuClass(defaultDropdownClasses);
    let ButtonDropdownClasses = `shadow-5xl absolute overflow-hidden bg-neutral-0 w-full ease-in duration-200 z-10 rounded-md border border-solid border-neutral-5 dark:bg-neutral-dark-5 dark:shadow-D4xl dark:border-neutral-dark-0`;
    let stickyBottomClasses = `stickybottom-dropdown-menu max-w-56 w-full shadow-5xl absolute bottom-0 overflow-hidden bg-neutral-0 w-full ease-in duration-200 z-10 rounded-md border border-solid border-neutral-5 dark:bg-neutral-dark-5 dark:shadow-D4xl dark:border-neutral-dark-0`;
    //Detect click outside
    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setToggle(false);
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    const dropdownVariant = {
        default: () => {
            const handleClick = (item) => {
                item.clicked();
            };
            function renderDropDownMenu(toogle) {
                return toggle ? (React__default.createElement("ul", { className: dropdownClassesMenu }, dropdownOptions.map((item, index) => (React__default.createElement("li", { className: listItemClasses, key: item + index, onClick: () => handleClick(item) },
                    React__default.createElement("span", { className: "block w-11/12 truncate", ..._args }, item.label)))))) : null;
            }
            return (React__default.createElement("div", { className: wrapperClasses, ref: wrapperRef },
                React__default.createElement("div", { className: "block cursor-pointer py-2", onClick: () => setToggle(!toggle) }, children),
                renderDropDownMenu()));
        },
        buttonDriven: () => {
            const handleClick = (item) => {
                item.clicked();
            };
            const getListItemButtonClasses = (disabled) => {
                let listItemButtonClasses = `option py-4 px-4  hover:bg-neutral-5 cursor-pointer truncate dark:bg-neutral-dark-5 dark:text-neutral-10 dark:hover:bg-neutral-dark-0 flex justify-between`;
                return (listItemButtonClasses = disabled
                    ? `${listItemButtonClasses} cursor-not-allowed pointer-events-none bg-neutral-20 text-neutral-40`
                    : `${listItemButtonClasses} text-neutral-dark-0`);
            };
            function renderDropDownMenu(toogle) {
                return toggle ? (React__default.createElement("ul", { className: ButtonDropdownClasses }, dropdownOptions?.map((item, index) => (React__default.createElement("li", { className: getListItemButtonClasses(item?.disabled), key: item?.id, onClick: () => handleClick(item) },
                    React__default.createElement("span", { className: "block w-11/12 truncate", ..._args }, item.label),
                    React__default.createElement(Icon, { className: `${item?.disabled ? "opacity-20" : ""}`, name: optionIcon ? optionIcon : "PlusDark" })))))) : null;
            }
            return (React__default.createElement("div", { className: wrapperClasses, ref: wrapperRef },
                React__default.createElement("button", { className: "rounded-5 bg-primary font-opensans text-size-base hover:bg-primary-110 dark:bg-primary-dark dark:hover:bg-primary-110 flex h-11 w-full  items-center justify-between px-4 py-2 text-left font-semibold text-white", onClick: () => setToggle(!toggle) },
                    React__default.createElement("span", null,
                        " ",
                        children),
                    React__default.createElement("span", null,
                        React__default.createElement(Icon, { name: "DownArrow", fill: "#ffffff" }))),
                renderDropDownMenu()));
        },
        customOptions: () => {
            return (React__default.createElement("div", { className: wrapperCustomOptionClasses, ref: wrapperRef },
                React__default.createElement("div", { onClick: () => setToggle(!toggle) },
                    React__default.createElement("button", { className: "rounded-5 bg-primary font-opensans text-size-base hover:bg-primary-110 dark:bg-primary-dark dark:hover:bg-primary-110 flex h-11 w-full  items-center justify-between px-4 py-2 text-left font-semibold text-white", onClick: () => setToggle(!toggle) },
                        React__default.createElement("span", null, triggerContent),
                        React__default.createElement("span", null,
                            React__default.createElement(Icon, { name: "DownArrow", fill: "#ffffff" })))),
                React__default.createElement(Sanitize, { check: Boolean(toggle) },
                    React__default.createElement("div", { className: ButtonDropdownClasses }, children))));
        },
        stickyBottom: () => {
            return (React__default.createElement("div", { className: wrapperStickyBottomClasses, ref: wrapperRef },
                React__default.createElement("div", { onClick: () => setToggle(!toggle), className: "flex cursor-pointer items-center justify-between" },
                    React__default.createElement("div", null,
                        " ",
                        triggerContent),
                    React__default.createElement("div", null,
                        React__default.createElement(Icon, { className: `sticky-dropdown-arrow ${toggle ? "sticky-dropdown-open rotate-180" : "sticky-dropdown-collapse"}`, name: "rightArrow" }))),
                toggle ? React__default.createElement("div", { className: stickyBottomClasses }, children) : null));
        },
        withAvatar: () => {
            const handleClick = (item) => {
                item.clicked();
            };
            function renderDropDownMenu(toogle) {
                return toggle ? (React__default.createElement("ul", { className: dropdownClassesMenu }, dropdownOptions.map((item, index) => (React__default.createElement("li", { className: listItemClasses, key: item + index, onClick: () => handleClick(item) },
                    React__default.createElement("span", { className: "block w-11/12 truncate", ..._args }, item.label)))))) : null;
            }
            return (React__default.createElement("div", { className: wrapperClasses, ref: wrapperRef },
                React__default.createElement("div", { className: "block cursor-pointer", onClick: () => setToggle(!toggle) },
                    React__default.createElement("div", { className: avatarClasses }, children)),
                renderDropDownMenu()));
        },
    };
    const render = () => {
        return dropdownVariant[variant]();
    };
    return render();
}

const OptionList = ({ customClass = "", ...props }) => {
    let defaultClasses = `option-list`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const OptionListItem = ({ customClass = "", ...props }) => {
    const _args = { onClick: props.onClick };
    let defaultClasses = `option-list-item py-4 px-4  hover:bg-neutral-5 cursor-pointer truncate dark:bg-neutral-dark-5 dark:text-neutral-10 dark:hover:bg-neutral-dark-0 flex justify-between text-neutral-dark-0`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("div", { className: defaultClasses, ..._args }, props.children);
};

const OptionGroup = ({ customClass = "", ...props }) => {
    let defaultClasses = `option-group`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const OptionGroupTitle = ({ customClass = "", ...props }) => {
    let defaultClasses = `option-group-title text-neutral-60 text-size-12 dark:text-neutral-dark-80 px-4 py-2`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

function Modal({ variant = "default", fullWidth = false, contentHeightMax = false, children, isOpen, toggleModal, title, customClass = "", hideClose, desc, size = "sm", }) {
    let defaultClasses = `modal-wrapper flex flex-col justify-end 
   h-full max-h-screen w-full z-50 fixed left-0 right-0 top-0 bottom-0`;
    defaultClasses = chooseBinaryClass(Boolean(fullWidth), `${defaultClasses} md:max-w-full md:items-center md:justify-center bg-neutral-20/[.9] dark:bg-neutral-dark-0/[.9] backdrop-blur-sm`, defaultClasses);
    let customWidthClasses = `${defaultClasses} m-auto sm:max-w-29`;
    let modalContainerClasses = chooseBinaryClass(Boolean(fullWidth), defaultClasses, customWidthClasses);
    let defaultMaskClasses = `absolute top-0 bottom-0 w-full z-50 left-0 right-0 z-20 bg-neutral-dark-110/[.9] dark:bg-neutral-dark-0/[.9] backdrop-blur-sm`;
    let modalwrapperClasses = addCustomClassToBaseClass(modalContainerClasses, customClass);
    let maskClasses = addCustomClassToBaseClass(defaultMaskClasses, customClass);
    let modalClasses = `modal shadow-txl dark:shadow-none bg-neutral-0 relative z-50 dark:bg-neutral-dark-5`;
    let modalFullpageClasses = `modal bg-neutral-0 relative z-50 dark:bg-neutral-dark-5 flex-1`;
    modalFullpageClasses = chooseBinaryClass(Boolean(fullWidth), `${modalFullpageClasses} md:flex-none md:max-w-29`, modalFullpageClasses);
    let modalFullpageHeaderClasses = `px-8 py-4 flex justify-between items-center border-b border-solid border-neutral-10 dark:border-neutral-dark-20`;
    let contentDefaultClasses = `px-8 pt-6 overflow-y-auto`;
    let contentClass = chooseBinaryClass(Boolean(contentHeightMax), `${contentDefaultClasses} max-h-80vh`, `${contentDefaultClasses} max-h-70vh`);
    let mainContentClass = chooseBinaryClass(Boolean(fullWidth), `${contentDefaultClasses} max-h-80vh`, contentClass);
    let modalCurvedEdgeClasses = `modal rounded-xl bg-neutral-0 relative z-50 dark:bg-neutral-dark-5 flex-1 md:flex-none`;
    if (size === "sm") {
        modalCurvedEdgeClasses = addCustomClassToBaseClass(modalCurvedEdgeClasses, "md:max-w-29");
    }
    else if (size === "md") {
        modalCurvedEdgeClasses = addCustomClassToBaseClass(modalCurvedEdgeClasses, "max-w-2xl");
    }
    else if (size) {
        modalCurvedEdgeClasses = addCustomClassToBaseClass(modalCurvedEdgeClasses, `${size}`);
    }
    modalCurvedEdgeClasses = chooseBinaryClass(Boolean(title), `${modalCurvedEdgeClasses} py-6`, `${modalCurvedEdgeClasses} pb-6 pt-9`);
    let modalCurvedEdgeContentClasses = `overflow-y-auto max-h-80vh px-6`;
    const close = () => toggleModal(false);
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("overflow-hidden");
        }
        else {
            const modals = document.querySelectorAll("[data-component=modal]");
            if (!modals.length) {
                document.body.classList.remove("overflow-hidden");
            }
        }
    }, [isOpen]);
    const loaderVariant = {
        default: () => {
            return (React__default.createElement(Sanitize, { check: Boolean(isOpen) },
                React__default.createElement("div", { className: modalwrapperClasses, "data-component": "modal" },
                    React__default.createElement("div", { className: maskClasses, onClick: close }),
                    React__default.createElement("div", { className: modalClasses },
                        React__default.createElement("div", { className: modalFullpageHeaderClasses },
                            React__default.createElement("h4", { className: "text-neutral-dark-0 dark:text-neutral-dark-110" }, title),
                            React__default.createElement("i", { onClick: close, className: chooseBinaryClass(Boolean(hideClose), "hidden cursor-pointer", "cursor-pointer") },
                                React__default.createElement(IconList, { name: "Close" }))),
                        React__default.createElement("div", { className: "modal-content max-h-50vh overflow-y-auto px-8 py-4" }, children)))));
        },
        fullPage: () => {
            return (React__default.createElement(Sanitize, { check: Boolean(isOpen) },
                React__default.createElement("div", { className: modalwrapperClasses, "data-component": "modal" },
                    React__default.createElement("div", { className: modalFullpageClasses },
                        React__default.createElement("div", { className: modalFullpageHeaderClasses },
                            React__default.createElement("h4", { className: "text-neutral-dark-0 dark:text-neutral-dark-110" }, title),
                            React__default.createElement("i", { onClick: close, className: chooseBinaryClass(Boolean(hideClose), "hidden cursor-pointer", "cursor-pointer") },
                                React__default.createElement(IconList, { name: "Close" }))),
                        React__default.createElement("div", { className: mainContentClass }, children)))));
        },
        curvedEdge: () => {
            return (React__default.createElement(Sanitize, { check: Boolean(isOpen) },
                React__default.createElement("div", { className: modalwrapperClasses, "data-component": "modal" },
                    React__default.createElement("div", { className: modalCurvedEdgeClasses },
                        React__default.createElement("i", { onClick: close, className: chooseBinaryClass(Boolean(hideClose), "hidden cursor-pointer", "absolute right-4 top-4 cursor-pointer") },
                            React__default.createElement(IconList, { name: "Close" })),
                        React__default.createElement(Sanitize, { check: Boolean(title) },
                            React__default.createElement("div", { className: "modal-header px-6" },
                                React__default.createElement("h4", { className: "text-neutral-dark-0 dark:text-neutral-dark-110 mb-3" }, title),
                                React__default.createElement(Sanitize, { check: Boolean(desc) },
                                    React__default.createElement("p", { className: "text-size-14 text-neutral-60 mb-4 normal-case leading-snug" }, desc)))),
                        React__default.createElement("div", { className: modalCurvedEdgeContentClasses }, children)))));
        },
    };
    const render = () => {
        return loaderVariant[variant]();
    };
    return render();
}

function Radio({ variant = "pills", onChange, name, group = [], checked = 0, disabled = [], showOptions, size = "", equalWidth = false, customClass = "", }) {
    let pillsWrapper = `flex flex-wrap`;
    let pillsWrapperClasses = addCustomClassToBaseClass(pillsWrapper, customClass);
    let roundedWrapper = `flex flex-wrap`;
    let roundedWrapperClasses = addCustomClassToBaseClass(roundedWrapper, customClass);
    let solidWrapper = `mb-8 flex flex-wrap justify-center text-center`;
    let solidWrapperClasses = addCustomClassToBaseClass(solidWrapper, customClass);
    let solidWrapperIcon = `flex flex-wrap text-center`;
    let solidWrapperIconClasses = addCustomClassToBaseClass(solidWrapperIcon, customClass);
    let textWrapper = `radio-text flex flex-wrap`;
    let textWrapperClasses = addCustomClassToBaseClass(textWrapper, customClass);
    let barWrapper = `radio-bar flex flex-wrap`;
    let barWrapperClasses = addCustomClassToBaseClass(barWrapper, customClass);
    let iconBasedWrapper = `flex items-center`;
    let iconBasedWrapperClasses = addCustomClassToBaseClass(iconBasedWrapper, customClass);
    //Variant Pills
    let pillsDefaultClasses = `text-neutral-80 flex items-center rounded-2xl 
  border border-solid border-neutral-40 hover:bg-neutral-5 cursor-pointer font-opensans font-semibold
  dark:bg-neutral-dark-5 dark:text-neutral-40 dark:border-neutral-dark-20 dark:hover:bg-neutral-dark-10`;
    function getSizeClass(size) {
        return size === "sm" ? `h-8 px-5 text-size-14` : `h-10 px-4`;
    }
    let sizeClass = getSizeClass(size);
    let pillsClasses = `${pillsDefaultClasses} ${sizeClass}`;
    //Variant Solid
    let solidClasses = `border border-solid border-neutral-40 hover:bg-neutral-5 flex flex-1 
    items-center cursor-pointer text-base-color px-10 py-1 font-opensans dark:bg-neutral-dark-5 dark:border-neutral-dark-20 dark:hover:bg-neutral-dark-10 dark:text-neutral-40`;
    //Variant SolidIcon
    let solidIconClasses = `border border-solid border-neutral-40 hover:bg-neutral-5 flex flex-1 
items-center cursor-pointer text-base-color px-4 py-px font-opensans dark:bg-neutral-dark-5 dark:border-neutral-dark-20 dark:hover:bg-neutral-dark-10 dark:text-neutral-40`;
    let textClasses = `text-base-color text-size-14 font-semibold block 
    cursor-pointer font-opensans dark:text-neutral-40`;
    let iconClasses = `radio-label cursor-pointer flex items-center flex-col`;
    let iconLabelClasses = `block flex justify-center items-center mb-1 bg-neutral-5 
    border border-solid border-neutral-40 rounded-2xl h-60px w-60px font-opensans dark:bg-neutral-dark-5 dark:border-neutral-dark-20`;
    let radioOuterClass = `flex items-center justify-center border border-solid rounded-full w-5 h-5 p-px mr-4 cursor-pointer radio-outer border-neutral-20`;
    //Variant IconBased
    let iconBasedLabel = `font-opensans font-semibold text-center text-size-14 leading-tight block text-base-color dark:border-neutral-dark-20 dark:text-neutral-40`;
    // Variant bar
    let barTextClasses = `text-neutral-60 text-size-14 block 
  cursor-pointer font-opensans dark:text-neutral-40`;
    const isEmptyArray = (arr) => {
        if (Array.isArray(arr) && arr.length) {
            return false;
        }
        else {
            return true;
        }
    };
    function renderRadioPillsVariant() {
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: pillsWrapperClasses, "data-name": name }, !isEmptyArray(group) &&
            group.map((radio, index) => {
                const radioId = radio.label ? radio.label : radio;
                const id = `${radioId}_${index}_${name}`.toLowerCase().replace(" ", "_");
                return (React__default.createElement("div", { className: "radio-pills mr-2 mb-2 last:mr-0", key: index },
                    React__default.createElement("input", { id: id, type: "radio", name: name, value: radio, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                            if (onChange) {
                                onChange(e, radio);
                            }
                        } }),
                    React__default.createElement("label", { htmlFor: id, className: pillsClasses }, radio.label ? radio.label : radio)));
            })));
    }
    function renderRadioRoundedVariant() {
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: roundedWrapperClasses, "data-name": name }, !isEmptyArray(group) &&
            group.map((radio, index) => {
                const radioId = radio.label ? radio.label : radio;
                const id = `${radioId}_${index}_${name}`.toLowerCase().replace(" ", "_");
                return (React__default.createElement("div", { className: "radio-rounded mr-2 last:mr-0", key: id },
                    React__default.createElement("input", { id: id, type: "radio", name: name, value: radio, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                            if (onChange) {
                                onChange(e, radio);
                            }
                        } }),
                    React__default.createElement("label", { htmlFor: id, className: "flex items-center" },
                        React__default.createElement("span", { className: radioOuterClass }),
                        showOptions ? React__default.createElement("span", null,
                            " ",
                            radio.label ? radio.label : radio) : null)));
            })));
    }
    function renderRadioSolidVariant() {
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: solidWrapperClasses, "data-name": name }, !isEmptyArray(group) &&
            group.map((radio, index) => {
                const radioId = radio.label ? radio.label : radio;
                const id = `${radioId}_${index}_${name}`.toLowerCase().replace(" ", "_");
                return (React__default.createElement("div", { className: "radio-solid flex items-center", key: id },
                    React__default.createElement("input", { id: id, type: "radio", name: name, value: radio, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                            if (onChange) {
                                onChange(e, radio);
                            }
                        } }),
                    React__default.createElement("label", { htmlFor: id, className: solidClasses }, radio.label ? radio.label : radio)));
            })));
    }
    function renderRadioSolidIconVariant() {
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: solidWrapperIconClasses, "data-name": name }, !isEmptyArray(group) &&
            group.map((radio, index) => {
                const radioId = radio.label ? radio.label : radio;
                const id = `${radioId}_${index}_${name}`.toLowerCase().replace(" ", "_");
                return (React__default.createElement("div", { className: "radio-solid flex items-center", key: id },
                    React__default.createElement("input", { id: id, type: "radio", name: name, value: radio, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                            if (onChange) {
                                onChange(e, radio);
                            }
                        } }),
                    React__default.createElement("label", { htmlFor: id, className: solidIconClasses },
                        React__default.createElement(IconList, { name: radio.label ? radio.label : radio }))));
            })));
    }
    function renderRadioTextVariant() {
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: textWrapperClasses, "data-name": name }, !isEmptyArray(group) &&
            group.map((radio, index) => {
                const radioId = radio.label ? radio.label : radio;
                const id = `${radioId}_${index}_${name}`.toLowerCase().replace(" ", "_");
                return (React__default.createElement("div", { className: "mr-6 mb-2 last:mr-0", key: id },
                    React__default.createElement("input", { id: id, type: "radio", name: name, value: radio, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                            if (onChange) {
                                onChange(e, radio);
                            }
                        } }),
                    React__default.createElement("label", { htmlFor: id, className: textClasses }, radio.label ? radio.label : radio)));
            })));
    }
    function renderRadioBarVariant() {
        const equalWidthClasses = equalWidth ? "flex-1 text-center" : "px-4";
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: `${barWrapperClasses} flex`, "data-name": name }, !isEmptyArray(group) &&
            group.map((radio, index) => {
                const radioId = radio.label ? radio.label : radio;
                const id = `${radioId}_${index}_${name}`.toLowerCase().replace(" ", "_");
                return (React__default.createElement("div", { className: `relative border-r border-gray-300 last:border-r-0 ${equalWidthClasses}`, key: id },
                    React__default.createElement("input", { id: id, type: "radio", name: name, value: radio, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                            if (onChange) {
                                onChange(e, radio);
                            }
                        } }),
                    React__default.createElement("label", { htmlFor: id, className: barTextClasses }, radio.label ? radio.label : radio)));
            })));
    }
    function renderRadioIconBasedVariant() {
        if (isEmptyArray(group)) {
            return React__default.createElement(React__default.Fragment, null);
        }
        return (React__default.createElement("div", { className: iconBasedWrapperClasses, "data-name": name }, group.map((radio, index) => {
            const label = radio.label;
            const icon = radio.icon;
            const id = `${label}_${index}_${name}`.toLowerCase().replace(" ", "_");
            return (React__default.createElement("div", { className: "radio-icon", key: id },
                React__default.createElement("input", { id: id, type: "radio", name: name, value: radio.value, className: "hidden", checked: checked === index, disabled: disabled.includes(index), onChange: (e) => {
                        if (onChange) {
                            onChange(e, radio);
                        }
                    } }),
                React__default.createElement("label", { htmlFor: id, className: iconClasses },
                    React__default.createElement("div", { className: iconLabelClasses },
                        React__default.createElement(IconList, { name: icon ? icon : "Info", className: "block" })),
                    React__default.createElement("span", { className: iconBasedLabel }, radio.label))));
        })));
    }
    const render = () => {
        switch (variant) {
            case "pills":
                return renderRadioPillsVariant();
            case "rounded":
                return renderRadioRoundedVariant();
            case "solid":
                return renderRadioSolidVariant();
            case "solidIcon":
                return renderRadioSolidIconVariant();
            case "text":
                return renderRadioTextVariant();
            case "iconBased":
                return renderRadioIconBasedVariant();
            case "bar":
                return renderRadioBarVariant();
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return render();
}

const Checkbox = ({ variant = "default", children, description, disabled, onChange, id, value, required, checked, customClass, name = null, }) => {
    const _args = { onChange: onChange };
    let defaultWrapper = `flex relative`;
    let defaultwrapperClasses = customClass
        ? `${defaultWrapper} ${customClass}`
        : `${defaultWrapper}`;
    let cardTypeWrapper = `flex mr-4 initial:mb-8 p-2 border border-solid border-neutral-20 rounded-lg dark:border-neutral-dark-20`;
    let cardTypeWrapperClasses = customClass
        ? `${cardTypeWrapper} ${customClass}`
        : `${cardTypeWrapper}`;
    let defaultClasses = disabled
        ? `opacity-0 absolute h-5 w-5 checkbox cursor-not-allowed`
        : `opacity-0 absolute h-5 w-5 checkbox cursor-pointer`;
    let iconWrapClasses = `border-2 border-primary  w-5 h-5 rounded-md flex flex-shrink-0 justify-center items-center mr-2 dark:border-primary-dark`;
    //Plain
    let defaultClassesPlain = disabled
        ? `opacity-0 absolute h-4 w-4 checkbox cursor-not-allowed`
        : `opacity-0 absolute h-4 w-4 checkbox cursor-pointer`;
    let iconWrapClassesPlain = `border-2 border-primary  w-4 h-4 rounded-sm flex flex-shrink-0 justify-center items-center mr-2 dark:border-primary-dark`;
    let labelClassesPlain = `flex-1 select-none cursor-pointer text-base-color text-size-14 leading-normal mr-1 dark:text-neutral-40`;
    //Disabled
    let iconDisabledClasses = `border-2 border-neutral-10 w-5 h-5 rounded-md flex flex-shrink-0 justify-center items-center mr-2 dark:border-neutral-40`;
    iconWrapClasses = disabled ? `${iconDisabledClasses}` : iconWrapClasses;
    let iconClasses = `w-3 h-3 text-blue-600 pointer-events-none cursor-not-allowed hidden`;
    let labelClasses = `select-none cursor-pointer text-base-color text-size-14 leading-normal mr-1 dark:text-neutral-40`;
    let labelDisabledClasses = `select-none cursor-not-allowed text-base-color text-size-14 leading-normal mr-1 dark:text-neutral-40`;
    labelClasses = disabled ? `${labelDisabledClasses}` : `${labelClasses}`;
    const inputVariant = {
        default: () => {
            return (React__default.createElement("div", { className: defaultwrapperClasses, "data-name": name },
                React__default.createElement("div", null,
                    React__default.createElement("input", { type: "checkbox", id: id, checked: checked, required: required, value: value, className: defaultClasses, ..._args, disabled: disabled }),
                    React__default.createElement("div", { className: iconWrapClasses },
                        React__default.createElement(IconList, { name: "Check", className: iconClasses, fill: "#ffffff" }))),
                children ? (React__default.createElement("label", { htmlFor: id, className: labelClasses }, children)) : null));
        },
        square: () => {
            return (React__default.createElement("div", { className: defaultwrapperClasses, "data-name": name },
                React__default.createElement("div", null,
                    React__default.createElement("input", { type: "checkbox", id: id, checked: checked, required: required, value: value, className: defaultClassesPlain, ..._args, disabled: disabled }),
                    React__default.createElement("div", { className: iconWrapClassesPlain },
                        React__default.createElement(IconList, { name: "Check", className: iconClasses, fill: "#ffffff" }))),
                children ? (React__default.createElement("label", { htmlFor: id, className: labelClassesPlain }, children)) : null));
        },
        cardType: () => {
            return (React__default.createElement("div", { className: cardTypeWrapperClasses, "data-name": name },
                React__default.createElement("div", { className: "mt-1" },
                    React__default.createElement("input", { type: "checkbox", id: id, checked: checked, required: required, value: value, className: defaultClasses, ..._args, disabled: disabled }),
                    React__default.createElement("div", { className: iconWrapClasses },
                        React__default.createElement(IconList, { name: "Check", className: iconClasses, fill: "#ffffff" }))),
                React__default.createElement("div", null,
                    React__default.createElement("label", { htmlFor: id, className: labelClasses }, children),
                    React__default.createElement("p", { className: "text-size-12 text-neutral-40 mx-0 my-0 leading-tight" }, description))));
        },
    };
    const render = () => {
        return inputVariant[variant]();
    };
    return render();
};

const Loader = ({ variant = "default", customClass = "", size = "lg", msg, title, opaque = true, }) => {
    let inlineWrapClasses = ``;
    inlineWrapClasses = addCustomClassToBaseClass(inlineWrapClasses, customClass);
    const opacityClass = opaque ? "bg-opacity-100" : "bg-opacity-70";
    let fullpageWrapClasses = `loader-overlay top-0 bottom-0 left-0 h-full 
  flex flex-col justify-center items-center w-full absolute z-50 backdrop-blur-sm bg-primary-DN110 ${opacityClass} dark:bg-neutral-dark-10 dark:${opacityClass}`;
    fullpageWrapClasses = addCustomClassToBaseClass(fullpageWrapClasses, customClass);
    let containerWrapClasses = `loader-overlay top-0 bottom-0 left-0 h-full 
  flex flex-col justify-center items-center w-full absolute z-40 backdrop-blur-sm bg-primary-DN110 ${opacityClass} dark:bg-neutral-dark-10 dark:${opacityClass}`;
    containerWrapClasses = addCustomClassToBaseClass(containerWrapClasses, customClass);
    //size
    //screenCover
    let screenCoverWrapClasses = `loader-overlay top-0 bottom-0 left-0 h-full 
  flex flex-col justify-center items-center w-full fixed z-50 backdrop-blur-sm bg-primary-DN110 ${opacityClass} dark:bg-neutral-dark-10 dark:${opacityClass}`;
    screenCoverWrapClasses = addCustomClassToBaseClass(screenCoverWrapClasses, customClass);
    let loaderStyles = `loader-round relative`;
    if (size == "sm") {
        loaderStyles = `${loaderStyles}  h-8 w-8 scale-50`;
    }
    else if (size == "md") {
        loaderStyles = `${loaderStyles} h-8 w-8 scale-75`;
    }
    else if (size == "lg") {
        loaderStyles = `${loaderStyles} h-8 w-8`;
    }
    const loaderVariant = {
        default: () => {
            return (React__default.createElement("div", { className: inlineWrapClasses },
                React__default.createElement("div", { className: "loader-round relative h-8 w-8 scale-50" })));
        },
        fullpage: () => {
            return (React__default.createElement("div", { className: fullpageWrapClasses },
                React__default.createElement("div", { className: loaderStyles }),
                title ? (React__default.createElement("span", { className: "font-opensans text-size-20 text-neutral-dark-0 dark:text-neutral-40 mt-3 block px-8 text-center font-semibold" }, title)) : null,
                msg ? (React__default.createElement("span", { className: "text-size-14 text-primary-N60 mt-2 block px-8 text-center" }, msg)) : null));
        },
        container: () => {
            return (React__default.createElement("div", { className: containerWrapClasses },
                React__default.createElement("div", { className: loaderStyles }),
                title ? (React__default.createElement("span", { className: "font-opensans text-size-20 text-neutral-dark-0 dark:text-neutral-40 mt-3 block px-8 text-center font-semibold" }, title)) : null,
                msg ? (React__default.createElement("span", { className: "text-size-14 text-primary-N60 mt-2 block px-8 text-center" }, msg)) : null));
        },
        screenCover: () => {
            return (React__default.createElement("div", { className: screenCoverWrapClasses },
                React__default.createElement("div", { className: loaderStyles }),
                title ? (React__default.createElement("span", { className: "font-opensans text-size-20 text-neutral-dark-0 dark:text-neutral-40 mt-3 block px-8 text-center font-semibold" }, title)) : null,
                msg ? (React__default.createElement("span", { className: "text-size-14 text-primary-N60 mt-2 block px-8 text-center" }, msg)) : null));
        },
    };
    const render = () => {
        return loaderVariant[variant]();
    };
    return render();
};

const TabNavItem = ({ id, title, isSelected, setSelectedTab, disabled, disabledMessage, _args, onChange, navFullWidth = true, }) => {
    const [isDisabled, setIsDisabled] = useState(disabled);
    useEffect(() => {
        setIsDisabled(disabled);
    }, [disabled]);
    const defaultClasses = `${navFullWidth ? "flex-1" : "px-4"} text-center cursor-pointer
    border-b border-solid border-neutral-10 text-neutral py-1 dark:text-neutral-40 dark:border-neutral-40`;
    const disabledClass = `flex-1 text-center border-b border-solid border-neutral-10 text-neutral-20 dark:text-neutral-80 dark:border-neutral-80 relative`;
    const selectedClass = `${defaultClasses} relative active`;
    const handleClick = (e) => {
        if (!isDisabled) {
            e.target.value = id;
            setSelectedTab(id);
            if (onChange) {
                onChange(e);
            }
        }
    };
    return (React__default.createElement("li", { className: `group relative ${isDisabled ? disabledClass : isSelected ? selectedClass : defaultClasses}`, onClick: handleClick, ..._args },
        React__default.createElement("span", { className: isDisabled ? "pointer-events-none" : "" }, title),
        isDisabled && disabledMessage && (React__default.createElement("span", { className: "bg-neutral-40 absolute left-0 right-0 bottom-full z-10 mb-1 rounded-md px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100" },
            disabledMessage,
            React__default.createElement("span", { className: "border-t-neutral-40 absolute top-full left-1/2 -translate-x-1/2 transform border-4 border-transparent" })))));
};

const TabContent = ({ id, selectedTab, children }) => {
    return (React__default.createElement(React__default.Fragment, null, selectedTab === id ? React__default.createElement("div", { className: "pt-6 pb-2" }, children) : null));
};

const TabNavItemPill = ({ id, title, isSelected, setSelectedTab, disabled, onChange, _args, }) => {
    const [isDisabled, setIsDisabled] = useState(disabled);
    useEffect(() => {
        setIsDisabled(disabled);
    }, []);
    let defaultClasses = `
  border border-solid border-neutral-40 hover:bg-neutral-5 flex 
  items-center cursor-pointer text-base-color px-10 py-1 font-opensans tab-pill-item dark:bg-neutral-dark-5 dark:text-neutral-40 dark:border-neutral-dark-20`;
    let selectedClass = `${defaultClasses} active`;
    let disabledClass = ` 
    tab-pill-item
    border-solid  border-r border-neutral-20
    flex items-center
    px-10 py-1
    font-opensans
    bg-neutral-20
    text-neutral-40
    hover:bg-neutral-20
    pointer-events-none
    dark:bg-neutral-dark-10 dark:border-neutral-dark-20 dark:text-neutral-dark-20`;
    const handleClick = (e) => {
        e.target.value = id;
        setSelectedTab(id);
        if (onChange) {
            onChange(e);
        }
    };
    return (React__default.createElement("li", { className: isDisabled ? disabledClass : isSelected ? selectedClass : defaultClasses, onClick: handleClick, ..._args }, title));
};

const TabContentPill = ({ id, selectedTab, children }) => {
    return (React__default.createElement(React__default.Fragment, null, selectedTab === id ? React__default.createElement("div", { className: "pt-6 pb-2" }, children) : null));
};

const Tabs = ({ group, args, variant = "default", selected, onChange, navFullWidth = true, }) => {
    const [selectedTab, setSelectedTab] = useState(0);
    useEffect(() => {
        if (selected) {
            setSelectedTab(selected);
        }
    }, [selected]);
    const tabVariant = {
        default: () => {
            return (React__default.createElement("div", null,
                React__default.createElement("ul", { className: "tab-default border-neutral-1 flex border-b border-solid" }, group?.map((item, index) => {
                    let disabledValue = false;
                    disabledValue =
                        item.content === undefined || item.content.length === 0
                            ? true
                            : Boolean(item.disabled);
                    return (React__default.createElement(TabNavItem, { title: item.title, id: index, isSelected: selectedTab === index, setSelectedTab: setSelectedTab, disabled: disabledValue, disabledMessage: item.disabledMessage, key: `${item.title}_${index}`, onChange: () => onChange?.(index), navFullWidth: navFullWidth, ...args }));
                })),
                React__default.createElement("div", { className: "outlet" }, group?.map((item, index) => {
                    const id = index;
                    if (id === selectedTab) {
                        return (React__default.createElement(TabContent, { id: id, selectedTab: selectedTab, key: item + index },
                            React__default.createElement("div", null, item.content)));
                    }
                    else {
                        return null;
                    }
                }))));
        },
        pills: () => {
            return (React__default.createElement("div", null,
                React__default.createElement("ul", { className: "tab-pills flex justify-center" }, group?.map((item, index) => {
                    let disabledValue = false;
                    disabledValue =
                        item.content === undefined || item.content.length === 0
                            ? true
                            : Boolean(item.disabled);
                    return (React__default.createElement(TabNavItemPill, { title: item.title, id: index, isSelected: selectedTab === index, setSelectedTab: setSelectedTab, disabled: disabledValue, key: `${item.title}_${index}`, onChange: () => onChange?.(index), ...args }));
                })),
                React__default.createElement("div", { className: "outlet" }, group?.map((item, index) => {
                    const id = index;
                    if (id === selectedTab) {
                        return (React__default.createElement(TabContentPill, { id: id, selectedTab: selectedTab, key: item + index },
                            React__default.createElement("div", null, item.content)));
                    }
                    else {
                        return null;
                    }
                }))));
        },
    };
    const render = () => {
        return tabVariant[variant]();
    };
    return render();
};

function getBgClass(color, tagDefaultClasses) {
    let red = `${tagDefaultClasses} bg-warning-5 dark:bg-warning-20`;
    let blue = `${tagDefaultClasses} bg-primary-10 dark:bg-primary-40`;
    if (color === "red") {
        return red;
    }
    else if (color === "blue") {
        return blue;
    }
    else {
        return "";
    }
}
function getBorderClass(status) {
    const errorClass = `border-error-110 text-neutral-dark-0 dark:text-neutral-dark-110`;
    const successClass = `border-success-110 text-neutral-dark-0 dark:text-neutral-dark-110`;
    const warningClass = `border-warning-110 text-neutral-dark-0 dark:text-neutral-dark-110`;
    const defaultClass = `border-neutral-10 text-neutral-dark-0 dark:border-neutral-dark-10`;
    const processingClass = `border-primary text-primary dark:text-neutral-dark-110`;
    switch (status) {
        case "error":
            return errorClass;
        case "success":
            return successClass;
        case "warning":
            return warningClass;
        case "processing":
            return processingClass;
        case "default":
        default:
            return defaultClass;
    }
}
function getFilledBgClass(status) {
    let errorBgClass = `bg-error-110`; // With error status
    let successBgClass = `bg-success-110`; // with warning status
    let warningBgClass = `bg-warning-110`; // with warning status
    if (status === "error") {
        return errorBgClass;
    }
    else if (status === "success") {
        return successBgClass;
    }
    else if (status === "warning") {
        return warningBgClass;
    }
}
function Tag({ position, children, message, ButtonText, color = "", onClick, variant = "default", customClass = "", status = "error", size = "sm", fullWidth = false, }) {
    const _args = { onClick: onClick };
    let tagDefaultClasses = `py-2 px-4 text-base-color text-size-12`;
    let pillDefaultClass = `self-center leading-tight bg-primary-10 rounded-md py-1 px-2 text-size-10 text-size-12 dark:bg-neutral-dark-10 dark:text-neutral-40`;
    if (size === "lg") {
        pillDefaultClass = `self-center leading-tight bg-primary-10 rounded-md py-2 px-4 text-neutral-dark-0 dark:text-neutral-dark-110 text-size-16 dark:bg-neutral-dark-10 dark:text-neutral-dark-110`;
    }
    let radioClasses = `radio hidden flex items-center justify-center border border-solid rounded-full w-5 h-5 p-px mr-4 cursor-pointer radio-outer border-primary`;
    let checkBoxClasses = `checkbox hidden pointer-events-none`;
    let pillClass = addCustomClassToBaseClass(pillDefaultClass, customClass);
    pillClass = fullWidth ? `${pillClass} w-full` : `${pillClass}`;
    let bgClass = getBgClass(color, tagDefaultClasses);
    let bottomTagClasses = `${bgClass} ${tagDefaultClasses} rounded-b-md`;
    let topTagClasses = `${bgClass} ${tagDefaultClasses} rounded-t-md`;
    let tagClasses = chooseBinaryClass(position === "top", `${topTagClasses}`, `${bottomTagClasses}`);
    //Note tag
    let notTagDefaultStyles = "rounded-b-md border border-solid border-neutral-10 px-4 py-4 initial:mb-4 dark:border-neutral-dark-10 relative -top-1";
    let noteTagDefaultBg = "bg-neutral-5 dark:bg-neutral-dark-5";
    let noteTagWarningBg = "bg-warning-5 dark:bg-warning-20";
    let messageStyles = "initial:text-neutral-60 initial:text-size-12 initial:mb-2";
    let noteTagBg = "";
    if (status === "warning") {
        noteTagBg = noteTagWarningBg;
        messageStyles = `initial:text-neutral-60 initial:text-size-12 initial:mb-2 dark:text-neutral-80`;
    }
    else {
        noteTagBg = noteTagDefaultBg;
    }
    let notetagWrapperStyles = `${notTagDefaultStyles} ${noteTagBg}`;
    notetagWrapperStyles = addCustomClassToBaseClass(notetagWrapperStyles, customClass);
    //outline Tag
    let outlineClass = `self-center inline-block leading-tight border border-solid rounded-md py-1 px-2 text-size-12`;
    let borderClass = getBorderClass(status);
    outlineClass = chooseBinaryClass(Boolean(customClass), `${outlineClass} ${customClass} ${borderClass}`, `${outlineClass} ${borderClass}`);
    //Filled Tag
    let filledClass = `self-center inline-block leading-tight rounded-md py-1 px-2 text-size-12 text-neutral-0`;
    let filledBgClass = getFilledBgClass(status);
    filledClass = chooseBinaryClass(Boolean(customClass), `${filledClass} ${customClass} ${filledBgClass}`, `${filledClass} ${filledBgClass}`);
    function renderTagDefaultVariant() {
        return (React__default.createElement("div", { className: tagClasses },
            React__default.createElement("div", { className: "flex items-center" },
                React__default.createElement(Sanitize, { check: position === "top" },
                    React__default.createElement("div", { className: radioClasses }),
                    React__default.createElement("div", { className: checkBoxClasses },
                        React__default.createElement(Checkbox, null))),
                React__default.createElement("div", { className: "text-base-color flex-1" }, message)),
            React__default.createElement(Sanitize, { check: Boolean(ButtonText) },
                React__default.createElement("div", { className: "text-center" },
                    React__default.createElement(Button, { variant: "text", ..._args }, ButtonText)))));
    }
    function renderTagNoteVariant() {
        return (React__default.createElement("div", { className: notetagWrapperStyles, style: { top: "-4px" } },
            React__default.createElement("div", null,
                React__default.createElement(Sanitize, { check: Boolean(message) },
                    React__default.createElement("div", { className: messageStyles }, message))),
            React__default.createElement("div", null, children)));
    }
    function renderTagPillVariant() {
        return (React__default.createElement("span", { ..._args, className: pillClass },
            message,
            children));
    }
    function renderTagOutlineVariant() {
        return React__default.createElement("span", { className: outlineClass }, message);
    }
    function renderTagFilledVariant() {
        return React__default.createElement("span", { className: filledClass }, message);
    }
    const render = () => {
        switch (variant) {
            case "default":
                return renderTagDefaultVariant();
            case "note":
                return renderTagNoteVariant();
            case "pill":
                return renderTagPillVariant();
            case "outline":
                return renderTagOutlineVariant();
            case "filled":
                return renderTagFilledVariant();
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return render();
}

const Header = ({ children, logo, customClass, onClick, logoLink, targetBlank = true, web, }) => {
    const clickable = Boolean(onClick);
    let headerWrapClasses = `py-4 px-8 bg-neutral-dark-110 shadow-4xl dark:shadow-transparent fixed z-50 top-0 left-0 sm:left-auto sm:max-w-29 w-full dark:bg-neutral-dark-5`;
    let headerClasses = customClass
        ? `${headerWrapClasses} ${customClass}`
        : `${headerWrapClasses}`;
    headerClasses = web
        ? `${headerWrapClasses} md:max-w-full left-0 right-0 container`
        : `${headerWrapClasses}`;
    let innerWrapperClasses = web
        ? `flex items-center container m-auto`
        : `flex items-center`;
    return (React__default.createElement("div", { className: "pt-20" },
        React__default.createElement("div", { className: headerClasses },
            React__default.createElement("div", { className: innerWrapperClasses },
                clickable ? (React__default.createElement("button", { ...(clickable && { onClick }) },
                    React__default.createElement("img", { src: logo, alt: "placeholder logo", className: "max-h-6" }))) : (React__default.createElement("a", { href: logoLink, className: "block", target: targetBlank ? "_blank" : "_self" },
                    React__default.createElement("img", { src: logo, alt: "placeholder logo", className: "max-h-6" }))),
                React__default.createElement("div", { className: "flex-1" }, children)))));
};

const Footer = ({ logo, text, children, customClass, web = false, }) => {
    let footerWrapClasses = `py-2 px-8 bg-neutral-5 dark:bg-neutral-dark-5 fixed`;
    let footerMob = `sm:max-w-29 left-0 sm:left-auto bottom-0 w-full`;
    let footerWeb = `w-full left-0 right-0 bottom-0 w-full`;
    footerWrapClasses = web
        ? `${footerWrapClasses} ${footerWeb}`
        : `${footerWrapClasses} ${footerMob}`;
    let footerClasses = customClass
        ? `${footerWrapClasses} ${customClass}`
        : `${footerWrapClasses}`;
    let footerContainer = web
        ? `container flex justify-between m-auto`
        : `flex justify-between`;
    return (React__default.createElement("div", { className: footerClasses },
        React__default.createElement("div", { className: footerContainer },
            React__default.createElement("div", { className: "flex items-center" },
                text && React__default.createElement("span", { className: "mr-1 text-size-10" }, text),
                logo && (React__default.createElement("a", { href: "https://fintechprimitives.com/", target: "_blank", rel: "noopener noreferrer", className: "block" },
                    React__default.createElement("img", { src: logo, alt: "Fintech Primitives Logo", className: "" })))),
            React__default.createElement("div", null, children))));
};

const PageTitle = ({ title, icon, variant = "main", semiBold = false, customClass = "", onClick, }) => {
    const _args = { onClick: onClick };
    //Main title
    let fontWeightClass = semiBold ? `font-semibold text-size-18` : `font-bold`;
    let mainWrapClasses = `text-neutral-110 mb-2 flex items-center dark:text-neutral-dark-110 ${fontWeightClass}`;
    let mainTitleClasses = addCustomClassToBaseClass(mainWrapClasses, customClass);
    //Sub title
    let subWrapClasses = `text-neutral-dark-0 mb-1 text-size-14 dark:text-neutral-dark-110`;
    let subTitleClasses = addCustomClassToBaseClass(subWrapClasses, customClass);
    // Group title
    let groupTitleWrapClasses = `text-neutral-60 mb-1 pt-3 text-size-12 font-normal`;
    let groupTitleClasses = addCustomClassToBaseClass(groupTitleWrapClasses, customClass);
    const titleVariant = {
        main: () => {
            return (React__default.createElement("h4", { className: mainTitleClasses },
                icon ? (React__default.createElement("button", { type: "button", ..._args, className: "mr-3" },
                    React__default.createElement(IconList, { name: icon }))) : null,
                React__default.createElement("span", { className: "block" }, title)));
        },
        sub: () => {
            return React__default.createElement("h5", { className: subTitleClasses }, title);
        },
        group: () => {
            return React__default.createElement("h5", { className: groupTitleClasses }, title);
        },
    };
    const render = () => {
        return titleVariant[variant]();
    };
    return render();
};

const OrderStatus = ({ customClass, title, description, iconName, children }) => {
    let statusClasses = customClass ? `${customClass}` : ``;
    let statusMsgClasses = `text-primary-DN0 text-center font-semibold text-size-20 pb-2 font-opensans dark:text-primary-DN110`;
    let statusReasonClasses = `mb-6 text-primary-N60 text-center text-size-14 mt-0`;
    return (React__default.createElement("div", { className: statusClasses },
        React__default.createElement(IconList, { name: iconName, className: "mx-auto mb-4 block h-12 w-12" }),
        React__default.createElement("h3", { className: statusMsgClasses }, title),
        React__default.createElement("p", { className: statusReasonClasses }, description),
        React__default.createElement("div", null, children)));
};

function OutlineTableDefaultVariant({ tableData, title, defaultClasses, tableheaderClasses, tableValueClasses, listItemClasses, tableLabelClasses, }) {
    return (React__default.createElement("div", { className: defaultClasses },
        React__default.createElement(Sanitize, { check: Boolean(title) },
            React__default.createElement("div", { className: "border-neutral-20 dark:border-neutral-dark-20 border-b border-solid p-4" },
                React__default.createElement("h6", { className: tableheaderClasses }, title))),
        React__default.createElement("ul", { className: "flex flex-wrap px-4 pt-3" }, tableData?.map((item, index) => (React__default.createElement("li", { className: ` ${item.colSpan ? `${listItemClasses} ${item.colSpan}` : `${listItemClasses} `} `, key: item + index },
            React__default.createElement("span", { className: tableLabelClasses }, item.label),
            React__default.createElement("div", { className: "flex items-center" },
                item.logo && (React__default.createElement("span", { className: "mr-2" },
                    React__default.createElement("img", { src: item.logo, alt: "", className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" }))),
                React__default.createElement("span", { className: tableValueClasses },
                    React__default.createElement(Sanitize, { check: Boolean(item?.value) }, Array.isArray(item?.value) && item?.value?.length ? (React__default.createElement("ul", { className: "text-size-14 list-disc pl-5" }, item.value?.map((message, index) => (React__default.createElement("li", { key: index }, message))))) : item.onClick ? (React__default.createElement("button", { type: "button", onClick: item.onClick, className: "text-primary text-size-14 hover:underline" }, item.value)) : (item.value))))))))));
}
function OutlineTableWithIconVariant({ title, iconTableClasses, buttonText, bgTableIconClasses, icon, label, value, footer, }) {
    return (React__default.createElement("div", { className: "mb-8" },
        React__default.createElement("div", { className: iconTableClasses },
            React__default.createElement("div", { className: "p-4" },
                React__default.createElement("div", { className: "flex justify-between" },
                    React__default.createElement("h6", { className: "text-base-color dark:text-neutral-dark-110" }, title),
                    React__default.createElement(Button, { variant: "text" }, buttonText)),
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement("div", { className: bgTableIconClasses },
                        React__default.createElement(IconList, { name: icon })),
                    React__default.createElement("div", null,
                        React__default.createElement("span", { className: "font-opensans text-size-14 text-neutral-60 dark:text-neutral-40 block font-bold" }, label),
                        React__default.createElement("span", { className: "font-opensans text-size-14 text-neutral-60 dark:text-neutral-40 block font-semibold" },
                            React__default.createElement(Sanitize, { check: Boolean(value) }, Array.isArray(value) && value?.length ? (React__default.createElement("ul", { className: "text-size-14 list-disc pl-5" }, value?.map((message, index) => (React__default.createElement("li", { key: index }, message))))) : (value)))))),
            React__default.createElement(Sanitize, { check: Boolean(footer) },
                React__default.createElement(Tag, { message: footer?.title, color: footer?.bgColor, ButtonText: footer?.buttonText })))));
}
const OutlineTable = (props) => {
    const { variant = "default", customClass = "", view } = props;
    //Default table
    let statusDefault = "border border-solid border-neutral-20 dark:border-neutral-dark-20";
    let statusError = "border border-solid border-error bg-error-5 dark:bg-neutral-dark-10 dark:border-error-40";
    let tableWrapClasses = chooseBinaryClass(view === "error", `${statusError} rounded-lg mb-8`, `${statusDefault} rounded-lg mb-8`);
    let defaultClasses = addCustomClassToBaseClass(tableWrapClasses, customClass);
    let tableheaderClasses = `text-neutral-dark-0 text-size-14 font-semibold font-opensans dark:text-neutral-dark-110`;
    let tableLabelClasses = `text-neutral-40 text-size-14 block dark:text-neutral-40`;
    let tableValueClasses = `break-words overflow-auto leading-snug text-neutral-dark-0 text-size-14 block font-semibold font-opensans dark:text-neutral-dark-110`;
    //With Icon table
    let iconTableWrapClasses = `border border-solid border-neutral-10 rounded-lg bg-neutral-5 dark:border-neutral-dark-20 dark:bg-transparent`;
    let iconTableClasses = addCustomClassToBaseClass(iconTableWrapClasses, customClass);
    let bgTableIconClasses = `flex justify-center items-center rounded-xl border border-solid border-primary w-12 h-12 mr-2 dark:border-neutral-dark-20 dark:bg-neutral-dark-110`;
    let listItemClasses = "initial:basis-1/2 w-1/2 pb-3 pr-2";
    const render = () => {
        switch (variant) {
            case "default":
                return (React__default.createElement(OutlineTableDefaultVariant, { ...props, defaultClasses: defaultClasses, tableheaderClasses: tableheaderClasses, tableValueClasses: tableValueClasses, listItemClasses: listItemClasses, tableLabelClasses: tableLabelClasses }));
            case "withIcon":
                return (React__default.createElement(OutlineTableWithIconVariant, { ...props, iconTableClasses: iconTableClasses, bgTableIconClasses: bgTableIconClasses }));
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return render();
};

const Card = ({ children }) => {
    return (React__default.createElement("section", { className: "py-4 px-4 mb-4 bg-primary-DN110 rounded-md" }, children));
};

const Layout = ({ children, variant = "default" }) => {
    let layoutDefaultClasses = `mobile-center-layout sm:max-w-29 pb-9 bg-neutral-dark-110 flex flex-col min-h-screen m-auto relative dark:bg-neutral-dark-0 dark:text-neutral-dark-80`;
    let layoutClasses = `${layoutDefaultClasses} p-8`;
    let layoutPlainClasses = `${layoutDefaultClasses}`;
    const layoutVariant = {
        default: () => {
            return (React__default.createElement("div", { className: "bg-neutral-20 dark:bg-neutral-dark-10 mobile-center-wrapper" },
                React__default.createElement("div", { className: layoutClasses }, children)));
        },
        plain: () => {
            return (React__default.createElement("div", { className: "bg-neutral-20 dark:bg-neutral-dark-10 mobile-center-wrapper" },
                React__default.createElement("div", { className: layoutPlainClasses }, children)));
        },
        web: () => {
            return React__default.createElement("div", null, children);
        },
    };
    const render = () => {
        return layoutVariant[variant]();
    };
    return render();
};

const FileUploader = ({ inputName, customClass, handleFile, accept, value, uploadStatus, }) => {
    const [file, setFile] = useState(value || null);
    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFile = event.dataTransfer.files[0];
        const allAcceptValues = accept?.split(",");
        const fileFormatIncludesInAccept = allAcceptValues?.some((accept) => accept.includes(droppedFile?.name.split(".")[1]));
        const fileFormatIsPdfOrImages = droppedFile?.type?.includes("image") ||
            droppedFile?.type?.includes("pdf");
        if (accept && fileFormatIncludesInAccept) {
            handleFile(droppedFile);
            setFile(droppedFile);
        }
        else if (!accept && fileFormatIsPdfOrImages) {
            handleFile(droppedFile);
            setFile(droppedFile);
        }
    };
    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleFileChange = (event) => {
        const selectedFile = event.target.files && event.target.files[0];
        if (selectedFile) {
            handleFile(selectedFile);
            setFile(selectedFile);
        }
    };
    const handleRemove = () => {
        handleFile(null); // Notify parent component that file is removed
        setFile(null); // Clear file state in local component
    };
    useEffect(() => {
        // Update local state when value prop changes externally
        setFile(value || null);
    }, [value]);
    const renderIcon = () => {
        if (!file)
            return React__default.createElement(Icon, { name: "Upload" });
        if (file.type === "application/pdf") {
            return React__default.createElement(Icon, { name: "Pdf", className: "w-7" });
        }
        else {
            return React__default.createElement(Icon, { name: "Upload" });
        }
    };
    let wrapperDefaultClasses = `flex items-center rounded-md p-2 mb-2 dark:bg-neutral-dark-10`;
    wrapperDefaultClasses = customClass
        ? `${wrapperDefaultClasses} ${customClass}`
        : `${wrapperDefaultClasses}`;
    let wrapperClasses = `${wrapperDefaultClasses} border border-solid border-neutral-10 dark:border-neutral-dark-10`;
    let barWrapperClassesSuccess = `${wrapperDefaultClasses} border border-solid border-primary-dark`;
    let barWrapperClassesFailure = `${wrapperDefaultClasses} border border-solid border-error`;
    let barWrapperClass = uploadStatus == "uploadFailure"
        ? `${barWrapperClassesFailure}`
        : `${barWrapperClassesSuccess}`;
    return (React__default.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver }, file ? (React__default.createElement("div", { className: barWrapperClass },
        renderIcon(),
        React__default.createElement("div", { className: "block w-52 flex-1 truncate px-2 md:w-60" }, file.name),
        React__default.createElement("button", { onClick: handleRemove },
            React__default.createElement(Icon, { name: "Trash" })))) : (React__default.createElement("div", { className: wrapperClasses },
        React__default.createElement("label", { className: "flex flex-1 cursor-pointer \n        items-center rounded-md border border-dashed border-neutral-10 bg-neutral-5 px-2 text-primary dark:border-neutral-dark-20 dark:bg-transparent dark:text-primary-dark", htmlFor: inputName },
            React__default.createElement(Icon, { name: "Upload", className: "mr-2" }),
            React__default.createElement("div", null, "Choose file"),
            React__default.createElement("input", { type: "file", id: inputName, accept: accept || "image/*, application/pdf", onChange: handleFileChange, style: { display: "none" }, name: inputName }))))));
};

const Feature = ({ title, option, customClass, logo, placeholder, dataItem, action, }) => {
    let fundWrapClasses = `py-4 px-4 rounded-md border border-solid 
  border-neutral-10 initial:mb-4 dark:bg-neutral-dark-5 dark:border-neutral-dark-10`;
    let fundClasses = customClass
        ? `${fundWrapClasses} ${customClass}`
        : `${fundWrapClasses}`;
    let dummyLogoClasses = `mr-2 bg-neutral-10 rounded-full p-1  w-6 h-6 
    md:w-9 md:h-9 flex-shrink-0 flex justify-center items-center mt-1`;
    let fundnameClasses = `text-neutral leading-snug dark:text-neutral-dark-110`;
    const isEmptyArray = (arr) => {
        if (Array.isArray(arr) && arr.length) {
            return false;
        }
        else {
            return true;
        }
    };
    return (React__default.createElement("section", { className: fundClasses },
        React__default.createElement("div", { className: "flex" },
            logo ? (React__default.createElement("div", { className: "mr-2 pt-2" },
                React__default.createElement("img", { src: logo, alt: logo, className: "w-10" }))) : (React__default.createElement("div", null, placeholder ? React__default.createElement("div", { className: dummyLogoClasses }) : null)),
            React__default.createElement("div", null,
                React__default.createElement("div", { className: "flex" },
                    React__default.createElement("div", { className: "flex-1" },
                        React__default.createElement("h5", { className: fundnameClasses }, title)),
                    action ? React__default.createElement("div", { className: "pl-4" }, action) : null),
                React__default.createElement("div", { className: "-mr-4 -ml-4 flex flex-wrap items-center mt-1" }, !isEmptyArray(dataItem) &&
                    dataItem.map((data, index) => {
                        return (React__default.createElement("div", { className: "pr-4 pl-4", key: index },
                            data.label ? (React__default.createElement("span", { className: "block text-size-12 text-neutral-40 dark:text-neutral-60" }, data.label)) : null,
                            data.value ? (React__default.createElement("span", { className: "font-opensans font-semibold block text-size-14 leading-snug text-neutral-dark-0 dark:text-neutral-60" }, data.value)) : null));
                    }))))));
};

const SmartCard = ({ variant = "default", header, footer, footerNotes, children, selected, customClass, disabled = false, innerRef, onClick, cardSpacing = true, }) => {
    const _args = { onClick: onClick };
    let radioClasses = `radio hidden flex items-center justify-center border border-solid rounded-full w-5 h-5 p-px mr-4 cursor-pointer radio-outer border-primary`;
    let checkBoxClasses = `checkbox hidden pointer-events-none`;
    let wrapperdefaultClasses = `rounded-md border border-solid border-neutral-10 mb-4 bg-neutral-5 dark:bg-neutral-dark-5 dark:border-neutral-dark-10`;
    let wrapperClass = selected
        ? `${wrapperdefaultClasses}  border border-solid border-primary selected dark:border-primary-dark`
        : `${wrapperdefaultClasses}`;
    wrapperClass = customClass
        ? `${wrapperClass} ${customClass}`
        : `${wrapperClass}`;
    let cardSpaceClasses = cardSpacing ? "px-4 pt-2 pb-2" : "";
    const CardVariant = {
        default: () => {
            return (React__default.createElement("div", { className: wrapperClass, ref: innerRef },
                header ? (React__default.createElement(Tag, { message: header.title, color: header.bgColor, ButtonText: header.buttonText, position: "top" })) : null,
                React__default.createElement("div", { className: cardSpaceClasses },
                    React__default.createElement("div", { className: "flex items-center" },
                        !header ? (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement("div", { className: radioClasses }),
                            React__default.createElement("div", { className: checkBoxClasses },
                                React__default.createElement(Checkbox, null)))) : null,
                        React__default.createElement("div", { className: "flex-1" }, children))),
                footerNotes ? (React__default.createElement("div", { className: "bg-primary-20 px-2 py-2 font-roboto  text-size-12 font-normal text-neutral-80 dark:bg-info-20" }, footerNotes)) : null,
                footer ? (React__default.createElement(Tag, { message: footer.title, color: footer.bgColor, ButtonText: footer.buttonText, ..._args })) : null));
        },
    };
    const render = () => {
        return CardVariant[variant]();
    };
    return render();
};

function MutiSelectableSmartCardGroup({ multiSelected, onChange, children }) {
    const [selectedCards, setSelectedCards] = useState(multiSelected);
    const handleClick = (e, index) => {
        let selectedState = [];
        if (selectedCards.includes(index)) {
            const newCards = selectedCards;
            newCards.splice(selectedCards.indexOf(index), 1);
            selectedState = [...newCards];
        }
        else {
            setSelectedCards([...selectedCards, index]);
            selectedState = [...selectedCards, index];
        }
        e.target.value = selectedState;
        setSelectedCards(selectedState);
        if (onChange) {
            onChange(e);
        }
    };
    return (React__default.createElement(React__default.Fragment, null, children.length ? (children.map((child, index) => {
        return (React__default.createElement("section", { key: index },
            React__default.createElement("div", { className: "multiselect cursor-pointer", onClick: (e) => handleClick(e, index) }, React__default.cloneElement(child, {
                selected: selectedCards.includes(index),
            }))));
    })) : (React__default.createElement("section", null,
        React__default.createElement("div", { className: "multiselect cursor-pointer", onClick: () => { } }, React__default.cloneElement(children, {
            selected: true,
        }))))));
}
function SelectableSmartCardGroup({ selected, onChange, children }) {
    const [selectedCard, setSelectedCard] = useState(selected);
    const flattenedChildrenArray = Children.toArray(children);
    return (React__default.createElement(React__default.Fragment, null, flattenedChildrenArray.length ? (flattenedChildrenArray.map((child, index) => {
        if (index === selectedCard) {
            return (React__default.createElement("section", { key: index },
                React__default.createElement("div", { className: "select cursor-pointer" }, React__default.cloneElement(child, { selected: true }))));
        }
        else {
            const reactEle = child;
            if (!React__default.isValidElement(reactEle)) {
                return React__default.createElement(React__default.Fragment, null);
            }
            return (React__default.createElement("section", { key: index },
                React__default.createElement("div", { className: `select ${chooseBinaryClass(Boolean(child?.props?.disabled), "disabled cursor-not-allowed", "cursor-pointer")}`, onClick: (e) => {
                        if (!child?.props?.disabled) {
                            e.target.value = index;
                            setSelectedCard(index);
                            if (onChange) {
                                onChange(e);
                            }
                        }
                    } }, child)));
        }
    })) : (React__default.createElement("section", null,
        React__default.createElement("div", { className: "select cursor-pointer", onClick: (e) => {
                e.target.value = 0;
                setSelectedCard(0);
                if (onChange) {
                    onChange(e);
                }
            } }, React__default.cloneElement(children, {
            selected: true,
        }))))));
}
function SmartCardGroup({ variant = "default", selected, children, multiSelected, onChange, }) {
    function render() {
        switch (variant) {
            case "multiSelectable":
                return (React__default.createElement(MutiSelectableSmartCardGroup, { multiSelected: multiSelected, onChange: onChange }, children));
            case "selectable":
                return (React__default.createElement(SelectableSmartCardGroup, { selected: selected, onChange: onChange }, children));
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    }
    return render();
}

function getContainerStyles(wrapperClasses, direction, border) {
    if (direction === "row") {
        return `${wrapperClasses} flex flex-row items-center ${border
            ? "border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-2"
            : ""}`;
    }
    else if (direction === "column") {
        return (`${wrapperClasses} flex flex-col` +
            (border
                ? " border border-solid border-neutral-10 dark:border-neutral-dark-10 rounded-md px-4 py-2"
                : ""));
    }
}
function getLabelStyles(background, direction, symbol) {
    if (background) {
        return ("initial:font-opensans initial:text-size-12 text-neutral-60 initial:dark:text-neutral-40 leading-6" +
            (direction === "row" ? " mr-2" : "") +
            (symbol ? " font-roboto block text-size-14 text-neutral-60 dark:text-neutral-60" : ""));
    }
    else {
        return ("text-neutral-60 initial:font-opensans initial:text-size-12 initial:dark:text-neutral-40 leading-6" +
            (direction === "row" ? " mr-2" : "") +
            (symbol ? " font-roboto block text-size-14 text-neutral-60 dark:text-neutral-60" : ""));
    }
}
function DataItem({ label, value, icon, loader, symbol, logo, customClass, iconPlacement = "right", variant = "default", background = false, direction = "column", border = false, }) {
    /*Wrapper classes */
    let wrapperBase = customClass ? `${customClass}` : ``;
    let wrapperClasses = background
        ? `${wrapperBase} rounded-md bg-primary-10 px-4 py-2 dark:bg-neutral-dark-10`
        : wrapperBase;
    let containerStyles = getContainerStyles(wrapperClasses, direction, border);
    /* Label */
    let labelStyles = getLabelStyles(background, direction, symbol);
    /* Value */
    let valueStyles = background
        ? "initial:text-size-base font-opensans font-semibold initial:text-neutral-110 dark:text-neutral-dark-110 overflow-wrap-anywhere"
        : "block initial:text-neutral-dark-0 initial:text-size-14 leading-normal font-opensans font-semibold initial:dark:text-neutral-dark-110 overflow-wrap-anywhere";
    valueStyles = symbol
        ? `${valueStyles} block text-size-12 text-neutral-40 dark:text-neutral-40`
        : valueStyles;
    const dataItemVariant = {
        default: () => {
            return (React__default.createElement("div", { className: containerStyles },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement(Sanitize, { check: Boolean(symbol) },
                        React__default.createElement("div", { className: "mr-2 shrink-0" },
                            React__default.createElement("img", { src: symbol, alt: symbol, className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" }))),
                    React__default.createElement("span", { className: labelStyles }, label)),
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement(Sanitize, { check: Boolean(logo) },
                        React__default.createElement("div", { className: "mr-2 shrink-0" },
                            React__default.createElement("img", { src: logo, alt: logo, className: "border-neutral-10 dark:border-neutral-dark-10 w-6 rounded-full border border-solid" }))),
                    React__default.createElement(Sanitize, { check: Boolean(icon) },
                        React__default.createElement(Sanitize, { check: Boolean(iconPlacement === "left") },
                            React__default.createElement("span", { className: "mr-2" },
                                React__default.createElement(IconList, { name: icon })))),
                    React__default.createElement("span", { className: valueStyles }, value),
                    React__default.createElement(Sanitize, { check: Boolean(loader) },
                        React__default.createElement(Loader, null)),
                    React__default.createElement(Sanitize, { check: Boolean(icon) },
                        React__default.createElement(Sanitize, { check: Boolean(iconPlacement === "right") },
                            React__default.createElement("span", { className: "ml-3" },
                                React__default.createElement(IconList, { name: icon })))))));
        },
    };
    const render = () => {
        return dataItemVariant[variant]();
    };
    return render();
}

const tailWindClass = () => {
    let colorClasses = `border-primary-B100 
  text-neutral-0 
  shadow-lg shadow-3xl 
  bg-primary-40 bg-primary-20 
  hover:bg-primary hover:bg-primary-40 hover:bg-primary-20 bg-primary-110
  bg-secondary bg-secondary-10 bg-secondary-20 bg-secondary-40 bg-secondary-110
  bg-neutral bg-neutral-0 bg-neutral-5 bg-neutral-10 bg-neutral-30
  bg-neutral-40 bg-neutral-60 bg-neutral-80 bg-neutral-110
  bg-error bg-error-5 bg-error-20 bg-error-40 bg-error-110
  bg-success bg-success-5 bg-success-20 bg-success-40 bg-success-110
  bg-warning bg-warning-5 bg-warning-20 bg-warning-40 bg-warning-110
  bg-info dark:bg-neutral-80 dark:bg-neutral-85 
  bg-info-5 bg-info-20 bg-neutral-6 bg-info-40 bg-info-110 dark:border-error-40 dark:border-error-110 bg-neutral-85 text-neutral-85 border-neutral-40  
  bg-gradient-to-r from-primary-10 to-neutral-0`;
    const widthClasses = `
  w-0 w-1 w-2 w-3 w-4 w-5 w-6 w-7 w-8 w-9 w-10
  w-12 w-16 w-20 w-24 w-28 w-32 w-36 w-40 w-44 w-48
  w-52 w-56 w-60 w-64 w-72 w-80 w-96 w-auto w-1/2 w-1/3
  w-2/3 w-1/4 w-2/4 w-3/4 w-1/5 w-2/5 w-3/5 w-4/5 w-full
  w-screen-sm w-screen-md w-screen-lg w-screen-xl w-screen-2xl
  w-min w-max w-screen-xs-max w-screen-sm-max w-screen-md-max
  w-screen-lg-max w-screen-xl-max w-screen-2xl-max
  w-screen-xs-min w-screen-sm-min w-screen-md-min w-screen-lg-min
  w-screen-xl-min w-screen-2xl-min
  w-1/12 w-2/12 w-3/12 w-4/12 w-5/12 w-6/12 w-7/12 w-8/12 w-9/12
  w-10/12 w-11/12 max-w-64 max-w-44`;
    let heightClasses = `h-0 h-px h-0.5 h-1 h-1.5	h-2 h-2.5 h-3 h-3.5 h-4 h-4.5 h-5
  h-6  h-7 h-8 h-9 h-10 h-11 h-12 h-14 h-16 h-20 h-24 h-28 h-32 h-36 h-40 h-44 h-48 h-52 
  h-56 h-60 h-64 h-72 h-80 h-96 h-auto
  h-4/6 h-5/6 h-full h-screen h-min h-max max-h-full`;
    let lineHeightClasses = `leading-3 leading-4 leading-5 leading-7 leading-8 leading-9 leading-10
  leading-none leading-tight leading-snug leading-normal leading-relaxed leading-loose`;
    let flexClasses = `
  flex-row flex-row-reverse flex-col md:flex-col flex-col-reverse 
  flex-wrap flex-wrap-reverse flex-nowrap 
  shrink shrink-0  
  grow grow-0 
  justify-start justify-end justify-center justify-between justify-around justify-evenly
  items-baseline items-stretch items-center	items-end items-start
  content-center content-start content-end content-between content-around content-evenlycontent-baseline	
  justify-self-auto justify-self-start justify-self-end justify-self-center justify-self-stretch
  justify-items-start justify-items-end justify-items-center justify-items-stretch

  basis-0 basis-1 basis-2 basis-3 basis-4 basis-5 basis-6 basis-7 basis-8 basis-9 basis-10 basis-11 basis-12
  basis-14 basis-16 basis-20 basis-24 basis-28 basis-32 basis-40 basis-44 basis-48 basis-52 basis-56 basis-60
  basis-64 basis-72 basis-80 basis-96 basis-auto basis-px basis-0.5 basis-1.5 basis-2.5	 basis-3.5
  basis-1/2 basis-1/3 basis-2/3 
  basis-1/4 basis-2/4 basis-3/4 
  basis-1/5 basis-2/5 basis-3/5 basis-4/5
  basis-1/6 basis-2/6 basis-3/6 basis-4/6 basis-4/6 basis-5/6
  basis-1/12 basis-2/12 basis-3/12 basis-4/12 basis-5/12 basis-6/12 basis-7/12 basis-8/12 basis-9/12 basis-10/12 basis-11/12
  basis-full flex-1 flex-initial flex-none flex-auto`;
    let paddingClasses = `p-0 px-0 py-0 pt-0 pr-0 pb-0 pl-0 
  p-px px-px py-px pt-px pr-px pb-px pl-px 
  p-0.5 px-0.5 py-0.5 pt-0.5 pr-0.5 pb-0.5 pl-0.5 
  p-1 px-1 py-1 pt-1 pr-1 pb-1 pl-1 
  p-1.5 px-1.5 py-1.5 pt-1.5 pr-1.5 pb-1.5 pl-1.5
  p-2 px-2 py-2 pt-2 pr-2 pb-2 pl-2 
  p-2.5 px-2.5 py-2.5 pt-2.5 pr-2.5 pb-2.5 pl-2.5 
  p-3 px-3 py-3 pt-3 pr-3 pb-3 pl-3
  p-3.5 px-3.5 py-3.5 pt-3.5 pr-3.5 pb-3.5 pl-3.5 
  p-4 px-4 py-4 pt-4 pr-4 pb-4 pl-4 
  p-5 px-5 py-5 pt-5 pr-5 pb-5 pl-5 
  p-6 px-6 py-6 pt-6 pr-6 pb-6 pl-6 
  p-7 px-7 py-7 pt-7 pr-7 pb-7 pl-7 
  p-8 px-8 py-8 pt-8 pr-8 pb-8 pl-8 
  p-9 px-9 py-9 pt-9 pr-9 pb-9 pl-9 
  p-10 px-10 py-10 pt-10 pr-10 pb-10 pl-10 
  p-11 px-11 py-11 pt-11 pr-11 pb-11 pl-11 
  p-12 px-12 py-12 pt-12 pr-12 pb-12 pl-12 
  p-14 px-14 py-14 pt-14 pr-14 pb-14 pl-14 
  p-16 px-16 py-16 pt-16 pr-16 pb-16 pl-16 
  p-20 px-20 py-20 pt-20 pr-20 pb-20 pl-20 
  p-24 px-24 py-24 pt-24 pr-24 pb-24 pl-24 
  p-28 px-28 py-28 pt-28 pr-28 pb-28 pl-28 
  p-32 px-32 py-32 pt-32 pr-32 pb-32 pl-32 
  p-36 px-36 py-36 pt-36 pr-36 pb-36 pl-36 
  p-40 px-40 py-40 pt-40 pr-40 pb-40 pl-40 
  p-44 px-44 py-44 pt-44 pr-44 pb-44 pl-44 
  p-48 px-48 py-48 pt-48 pr-48 pb-48 pl-48 
  p-52 px-52 py-52 pt-52 pr-52 pb-52 pl-52 
  p-56 px-56 py-56 pt-56 pr-56 pb-56 pl-56 
  p-60 px-60 py-60 pt-60 pr-60 pb-60 pl-60 
  p-64 px-64 py-64 pt-64 pr-64 pb-64 pl-64 
  p-72 px-72 py-72 pt-72 pr-72 pb-72 pl-72 
  p-80 px-80 py-80 pt-80 pr-80 pb-80 pl-80 
  p-96 px-96 py-96 pt-96 pr-96 pb-96 pl-96 
  `;
    let marginClasses = `m-0 mx-0 my-0 mt-0 mr-0 mb-0 ml-0 
  m-mx mx-mx my-mx mt-mx mr-mx mb-mx ml-mx 
  m-0.5 mx-0.5 my-0.5 mt-0.5 mr-0.5 mb-0.5 ml-0.5 
  m-1 mx-1 my-1 mt-1 mr-1 mb-1 ml-1 
  m-1.5 mx-1.5 my-1.5 mt-1.5 mr-1.5 mb-1.5 ml-1.5
  m-2 mx-2 my-2 mt-2 mr-2 mb-2 ml-2 
  m-2.5 mx-2.5 my-2.5 mt-2.5 mr-2.5 mb-2.5 ml-2.5 
  m-3 mx-3 my-3 mt-3 mr-3 mb-3 ml-3
  m-3.5 mx-3.5 my-3.5 mt-3.5 mr-3.5 mb-3.5 ml-3.5 
  m-4 mx-4 my-4 mt-4 mr-4 mb-4 ml-4 
  m-5 mx-5 my-5 mt-5 mr-5 mb-5 ml-5 
  m-6 mx-6 my-6 mt-6 mr-6 mb-6 ml-6 
  m-7 mx-7 my-7 mt-7 mr-7 mb-7 ml-7 
  m-8 mx-8 my-8 mt-8 mr-8 mb-8 ml-8 
  m-9 mx-9 my-9 mt-9 mr-9 mb-9 ml-9 
  m-10 mx-10 my-10 mt-10 mr-10 mb-10 ml-10 
  m-11 mx-11 my-11 mt-11 mr-11 mb-11 ml-11 
  m-12 mx-12 my-12 mt-12 mr-12 mb-12 ml-12 
  m-14 mx-14 my-14 mt-14 mr-14 mb-14 ml-14 
  m-16 mx-16 my-16 mt-16 mr-16 mb-16 ml-16 
  m-20 mx-20 my-20 mt-20 mr-20 mb-20 ml-20 
  m-24 mx-24 my-24 mt-24 mr-24 mb-24 ml-24 
  m-28 mx-28 my-28 mt-28 mr-28 mb-28 ml-28 
  m-32 mx-32 my-32 mt-32 mr-32 mb-32 ml-32 
  m-36 mx-36 my-36 mt-36 mr-36 mb-36 ml-36 
  m-40 mx-40 my-40 mt-40 mr-40 mb-40 ml-40 
  m-44 mx-44 my-44 mt-44 mr-44 mb-44 ml-44 
  m-48 mx-48 my-48 mt-48 mr-48 mb-48 ml-48 
  m-52 mx-52 my-52 mt-52 mr-52 mb-52 ml-52 
  m-56 mx-56 my-56 mt-56 mr-56 mb-56 ml-56 
  m-60 mx-60 my-60 mt-60 mr-60 mb-60 ml-60 
  m-64 mx-64 my-64 mt-64 mr-64 mb-64 ml-64 
  m-72 mx-72 my-72 mt-72 mr-72 mb-72 ml-72 
  m-80 mx-80 my-80 mt-80 mr-80 mb-80 ml-80 
  m-96 mx-96 my-96 mt-96 mr-96 mb-96 ml-96 
  m-auto mx-auto my-auto mt-auto mr-auto mb-auto ml-auto
  `;
    let NegativeClasses = `-pr-2 pl-2 -mr-2 -ml-2 -mx-4 -ml-4 -mr-4`;
    let textcolorClasses = `text-primary-N110 text-primary-N60`;
    let textsizeClasses = `text-size-32 list-disc`;
    let borderRadiusClasses = `text-size-32 list-disc rounded-b-md`;
    let customClasses = `md:z-10   pt-28 dark:border-b dark:border-solid md:text-size-base md:pt-0 z-40 md:z-auto border-t border-solid border-neutral-10 md:border-0 pt-12 lg:w-auto lg:w-auto md:rotate-180  rotate-90 md:rotate-0 md:w-auto md:w-20 md:bg-neutral-5 md:dark:bg-neutral-dark-5 md:w-64 md:g-neutral-5 md:overflow-y-hidden md:w-56 md:w-20 md:w-64 md:fixed md:pt-6 md:w-20 md:ml-64 ml-64 md:dark:bg-transparent dark:bg-neutral-85 lg:mb-8 md:text-left svg-wrapper md:shadow-none md:bg-transparent md:pt-5 pt-20 lg:text-5xl md:text-5xl lg:pl-24 lg:pt-24 md:min-h-screen lg:pr-24 lg:pt-24 md:min-h-screen md:basis-1/2 lg:w-1/2 md:w-1/2 md:flex-row md:w-1/3 max-w-64 text-2xl text-5xl max-h-96 max-w-28 rotate-180 sticky left-16 left-60 transition-all transition ease-in-out ease-linear ease-in ease-in-out ease-out duration-100 duration-150 duration-200 duration-300 delay-100 delay-150 delay-500 ml-72 ml-64 dark:neutral-dark-10 gradient-black-to-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-error
  space-y-4 list-decimal list-inside 
  space-y-1 list-disc list-inside sm:hidden md:hidden md:block sm:basis-full lg:basis-3/5 lg:basis-1/5 md:basis-3/5 md:text-center md:basis-1/5`;
    let pseudoClasses = `last:pb-0 last:b-0 border-b-0 last:border-b-0 last:mb-0`;
    let placementClasses = `inset-0 inset-x-0 inset-y-0 top-0 right-0 bottom-0 left-0 
  inset-px inset-x-px inset-y-px
  top-px right-px bottom-px left-px
  inset-0.5 inset-x-0.5 inset-y-0.5 top-0.5 right-0.5 bottom-0.5 left-0.5
  inset-1 inset-x-1 inset-y-1
  top-1 right-1 bottom-1 left-1
  inset-1.5	 inset-x-1.5 inset-y ̰-1.5
  top-1.5 right-1.5 bottom-1.5 left-1.5 
  inset-2 inset-x-2 inset-y-2
  top-2 right-2 bottom-2 left-2
  inset-2.5 inset-x-2.5 inset-y-2.5
  top-2.5 right-2.5 bottom-2.5 left-2.5
  inset-3 inset-x-3 inset-y-3
  top-3 right-3 bottom-3 left-3
  inset-3.5 inset-x-3.5 inset-y-3.5
  top-3.5 right-3.5 bottom-3.5 left-3.5
  inset-4 inset-x-4 inset-y-4
  top-4 right-4 bottom-4 left-4
  inset-5 inset-x-5 inset-y-5
  top-5 right-5 bottom-5 left-5
  inset-6 inset-x-6 inset-y-6
  top-6 right-6 bottom-6 left-6
  inset-7 inset-x-7 inset-y-7
  top-7 right-7 bottom-7 left-7
  inset-8 inset-x-8 inset-y-8
  top-8 right-8 bottom-8 left-8
  inset-9 inset-x-9 inset-y-9 
  top-9 right-9 bottom-9 left-9
  inset-10 inset-x-10 inset-y-10
  top-10 right-10 bottom-10 left-10
  inset-11 inset-x-11 inset-y-11
  top-11 right-11 bottom-11 left-11
  inset-12 inset-x-12 inset-y-12
  top-12 right-12 bottom-12 left-12
  inset-14 inset-x-14 inset-y-14
  top-14 right-14 bottom-14 left-14
  inset-16 inset-x-16 inset-y-16
  top-16 right-16 bottom-16 left-16
  inset-20 inset-x-20 inset-y-20
  top-20 right-20 bottom-20 left-20
  inset-24 inset-x-24 inset-y-24
  top-24 right-24 bottom-24 left-24
  inset-28 inset-x-28 inset-y-28
  top-28 right-28 bottom-28 left-28
  inset-auto  inset-1/2 inset-1/3 inset-2/3 inset-1/4	inset-2/4 inset-3/4 inset-full
  inset-x-auto  inset-x-1/2 inset-x-1/3 inset-x-2/3 inset-x-1/4	inset-x-2/4 inset-x-3/4 inset-x-full
  inset-y-auto  inset-y-1/2 inset-y-1/3 inset-y-2/3 inset-y-1/4	inset-y-2/4 inset-y-3/4 inset-y-full
  top-auto top-1/2 top-1/3  top-2/3 top-1/4 top-2/4 top-3/4 top-full
  right-auto right-1/2 right-1/3  right-2/3 right-1/4 right-2/4 right-3/4 right-full
  bottom-auto bottom-1/2 bottom-1/3  bottom-2/3 bottom-1/4 bottom-2/4 bottom-3/4 bottom-full
  left-auto left-1/2 left-1/3  left-2/3 left-1/4 left-2/4 left-3/4 left-full`;
    let transitionClasses = `transition-none transition-all transition transition-colors transition-opacity transition-shadow transition-transform`;
    let transformClasses = `scale-0 scale-x-0 scale-y-0 scale-50 scale-x-50 scale-y-50 scale-75 scale-x-75 scale-y-75 scale-90 scale-x-90 scale-y-90
  scale-100  scale-x-100 scale-y-100
  rotate-0  rotate-1 rotate-2 rotate-3 rotate-6 rotate-12 rotate-45 rotate-90 rotate-180
  translate-x-0 translate-y-0 translate-x-full translate-y-full
  origin-center origin-top origin-top-right origin-right origin-bottom-right origin-bottom origin-bottom-left origin-left origin-top-left`;
    let containerClasses = `container 2xl:max-w-screen-2xl mx-auto`;
    let shadowClasses = `shadow-md shadow-r4xl `;
    return (React__default.createElement("div", null,
        React__default.createElement("div", { className: widthClasses }, "Width"),
        React__default.createElement("div", { className: heightClasses }, "Hieght"),
        React__default.createElement("div", { className: flexClasses }, "Flex"),
        React__default.createElement("div", { className: paddingClasses }, "Padding"),
        React__default.createElement("div", { className: marginClasses }, "Margin"),
        React__default.createElement("div", { className: NegativeClasses }, "Negative"),
        React__default.createElement("div", { className: textcolorClasses }, "textcolorClasses"),
        React__default.createElement("div", { className: colorClasses }, "colors"),
        React__default.createElement("div", { className: textsizeClasses }, "textsizeClasses"),
        React__default.createElement("div", { className: customClasses }, "textsizeClasses"),
        React__default.createElement("div", { className: borderRadiusClasses }, "border radius"),
        React__default.createElement("div", { className: pseudoClasses }, "Pseudo classes"),
        React__default.createElement("div", { className: placementClasses }, "PlacementClasses classes"),
        React__default.createElement("div", { className: lineHeightClasses }, "Linehieght classes"),
        React__default.createElement("div", { className: containerClasses }, "container"),
        React__default.createElement("div", { className: shadowClasses }, "shadowClasses"),
        React__default.createElement("div", { className: transitionClasses }, "transitionClasses"),
        React__default.createElement("div", { className: transformClasses }, "transformClasses")));
};

// tailwind.config.js

var tailwind_config = {
  content: ["./src/**/*.{js,ts,jsx,tsx}"],
  darkMode: "class", // or 'media' or 'class'
  theme: {
    fontFamily: {
      opensans: ["Open Sans", "sans-serif"],
      roboto: ["Roboto", "sans-serif"],
      inter: ["Inter", "sans-serif"]
    },
    extend: {
      fontSize: {
        "size-base": ["1rem", "1.5rem"],
        "size-56": ["3.5rem", "4rem"],
        "size-32": ["2rem", "2.5rem"],
        "size-26": ["1.625rem", "2rem"],
        "size-22": ["1.375rem", "1.8125rem"],
        "size-20": ["1.25rem", "1.75rem"],
        "size-18": ["1.125rem", "1.75rem"],
        "size-14": ["0.875rem", "1.375rem"],
        "size-12": ["0.75rem", "1.1rem"],
        "size-11": ["0.688rem", "1rem"],
        "size-10": ["0.625rem", "1rem"],
      },
      colors: {
        /* New palette */
        "base-color": "#3F567E",
        "link-color": {
          DEFAULT: "#3E74FF",
          dark: {
            DEFAULT: "#2955D9",
          },
        },
        primary: {
          DEFAULT: "#3E74FF",
          10: "#F0F7FF",
          20: "#E0EDFF",
          40: "#B8D3FF",
          110: "#2955D9",
          dark: {
            DEFAULT: "#5081FF",
          },
        },
        secondary: {
          DEFAULT: "#009666",
          10: "#E5F4EF",
          20: "#CCEAE0",
          40: "#99D5C2",
          110: "#007050",
          dark: {
            DEFAULT: "#109F72",
          },
        },
        neutral: {
          DEFAULT: "#0F2C5E",
          0: "#ffffff",
          5: "#FBFCFE",
          6: "#FAFAFA", 
          10: "#E7EDF9",
          15: "#ebf0ff",
          20: "#CFD4DF",
          30: "#B6BFCE",
          40: "#9FAABE",
          60: "#6F809E",
          80: "#3F567E",
          85: "#4A5263",
          110: "#061738",
          dark: {
            DEFAULT: "#E6E7E9",
            0: "#1F222A",
            5: "#2A2D34",
            10: "#34373E",
            20: "#4B4E54",
            30: "#616369",
            40: "#787A7F",
            60: "#A5A6A9",
            80: "#D2D2D4",
            100: "#E6E7E9",
            110: "#FFFFFF",
          },
        },
        success: {
          DEFAULT: "#15C87A",
          5: "#F3FFF8",
          20: "#BBFAD6",
          40: "#8CEDB9",
          110: "#0AA164",
        },
        error: {
          DEFAULT: "#FF4D4F",
          5: "#FFF8F7",
          20: "#FFCCC7",
          40: "#FFA39E",
          110: "#F5222D",
        },
        warning: {
          DEFAULT: "#FFA940",
          5: "#FFFBF2",
          20: "#FFE7BA",
          40: "#FFD591",
          110: "#FA8C16",
        },
        info: {
          DEFAULT: "#9254DE",
          5: "#FDFAFF",
          20: "#EFDBFF",
          40: "#D3ADF7",
          100: "#9254DE",
          110: "#722ED1",
        },

        /* Old Palette for fallback. --use new palette for new components */
        "primary-B110": "#2955D9",
        "primary-B100": "#3E74FF",
        "primary-B40": "#B8D3FF",
        "primary-B20": "#E0EDFF",
        "primary-B10": "#F0F7FF",

        "primary-G100": "#009666",
        "primary-G40": "#99D5C2",
        "primary-G20": "#CCEAE0",
        "primary-G10": "#E5F4EF",
        "primary-G110": "#007050",

        "primary-N0": "#ffffff",
        "primary-N10": "#E7EDF9",
        "primary-N30": "#B6BFCE",
        "primary-N40": "#9FAABE",
        "primary-N60": "#6F809E",
        "primary-N80": "#3F567E",
        "primary-N20": "#CFD4DF",
        "primary-N5": "#FBFCFE",
        "primary-N100": "#0F2C5E",
        "primary-N110": "#061738",

        "secondary-R100": "#FF4D4F",
        "secondary-R40": "#FFA39E",
        "secondary-R20": "#FFCCC7",
        "secondary-R5": "#FFF8F7",
        "secondary-R110": "#F5222D",

        "secondary-O100": "#FFA940",
        "secondary-O40": "#FFD591",
        "secondary-O20": "#FFE7BA",
        "secondary-O5": "#FFFBF2",
        "secondary-O110": "#FA8C16",

        "secondary-G100": "#15C87A",
        "secondary-G40": "#8CEDB9",
        "secondary-G20": "#BBFAD6",
        "secondary-G5": "#F3FFF8",
        "secondary-G110": "#0AA164",

        "secondary-P100": "#9254DE",
        "secondary-P40": "#D3ADF7",
        "secondary-P20": "#EFDBFF",
        "secondary-P5": "#FDFAFF",
        "secondary-P110": "#722ED1",

        // Darkmode
        "primary-DB100": "#5081FF",
        "primary-DG100": "#109F72",
        "primary-DN0": "#1F222A",
        "primary-DN05": "#2A2D34",
        "primary-DN10": "#34373E",
        "primary-DN20": "#4B4E54",
        "primary-DN30": "#616369",
        "primary-DN40": "#787A7F",
        "primary-DN60": "#A5A6A9",
        "primary-DN80": "#D2D2D4",
        "primary-DN100": "#E6E7E9",
        "primary-DN110": "#FFFFFF",
      },
      borderRadius: {
        5: "0.313rem",
      },
      borderWidth: {
        0.5: "0.03125rem",
      },
      spacing: {
        360: "360px",
        "60px": "60px",
        95: "95%",
        "50vh": "50vh",
        "70vh": "70vh",
        "80vh": "80vh",
        "90vh": "90vh",
        32: "32px",
      },
      zIndex: {
        "-1": "-1",
        1000: "1000",
      },
      minWidth: {
        12: "12rem",
      },
      maxWidth: {
        29: "28.75rem", // 460px
      },
      boxShadow: {
        "3xl": "0px 3px 6px #BACBDB",
        "4xl": "0px 0px 5px #E2E6EB",
        "5xl": "0px 6px 5px #3F567E26",
        "6xl": "0px 0px 6px #bacbdb",
        D4xl: "0px 0px 5px #10151EE3",
        txl: "0 0 6px #bacbdb",
        r4xl: "-5px 0px 10px #E2E6EB",
      },
    },
  },
  variants: {
    extend: {
      display: ["dark"],
      borderOpacity: ["active"],
    },
  },
  plugins: [
    function ({ addVariant }) {
      addVariant("initial", "html :where(&)");
    },
  ],
};

let primaryDefault = tailwind_config.theme.extend.colors.primary.DEFAULT;
let primary110 = tailwind_config.theme.extend.colors.primary[110];
let neutralDark0 = tailwind_config.theme.extend.colors.neutral.dark[0];
let neutral40 = tailwind_config.theme.extend.colors.neutral[40];
let neutral5 = tailwind_config.theme.extend.colors.neutral[5];
let neutral10 = tailwind_config.theme.extend.colors.neutral[10];
const materialTheme = createTheme({
    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: primaryDefault,
            },
        },
        MuiPickersDay: {
            day: {
                color: neutralDark0,
            },
            daySelected: {
                backgroundColor: primaryDefault,
                "&:hover": {
                    backgroundColor: primary110,
                },
            },
            dayDisabled: {
                color: neutral40,
            },
            current: {
                color: primaryDefault,
            },
        },
        MuiButton: {
            textPrimary: {
                color: primaryDefault,
            },
        },
        MuiPickersYear: {
            yearSelected: {
                color: primaryDefault,
            },
        },
        MuiPickersMonth: {
            monthSelected: {
                color: primaryDefault,
            },
        },
        MuiOutlinedInput: {
            root: {
                background: neutral5,
            },
            input: {
                height: "11px",
            },
            notchedOutline: {
                borderColor: neutral10,
            },
        },
    },
});
const DatePickerMui = ({ variant = "default", name = null, selectedDate, handleDateChange, onChange, ...props }) => {
    const datepickerVariant = {
        default: () => {
            return (React__default.createElement("div", { className: "datepicker-wrapper flex", "data-name": name },
                React__default.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils },
                    React__default.createElement(ThemeProvider, { theme: materialTheme },
                        React__default.createElement(DatePicker, { autoOk: true, inputVariant: "outlined", value: selectedDate, onChange: handleDateChange, format: "yyyy-MM-dd", ...props })))));
        },
        keyboardInputDOB: () => {
            return (React__default.createElement("div", { className: "datepicker-wrapper flex", "data-name": name },
                React__default.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils },
                    React__default.createElement(ThemeProvider, { theme: materialTheme },
                        React__default.createElement(KeyboardDatePicker, { autoOk: true, inputVariant: "outlined", format: "yyyy-MM-dd", value: selectedDate, openTo: "year", views: ["year", "month", "date"], disableFuture: true, onChange: (date, value) => handleDateChange(date, value), ...props })))));
        },
    };
    const render = () => {
        return datepickerVariant[variant]();
    };
    return render();
};

const Tooltip = ({ content, children, delay, variant = "default", placement = "bottom", customClass = "", size = "md", hidden = false, }) => {
    let toolTipWrapperDefault = "cursor-pointer initial:inline-block";
    let toolTipWrapper = addCustomClassToBaseClass(toolTipWrapperDefault, customClass);
    let mdClass = "max-w-sm w-max";
    let smClass = "w-56";
    let tooltip = "absolute block bg-primary-B10 py-2 px-2 shadow-md z-50 rounded-md text-primary-N40 dark:text-neutral-dark-80 dark:bg-neutral-dark-10 dark:border-neutral-dark-20 text-size-12";
    tooltip = size === "sm" ? `${tooltip} ${smClass}` : `${tooltip} ${mdClass}`;
    const timeoutRef = useRef(null);
    const [active, setActive] = useState(false);
    const [tooltipCoords, setTooltipCoords] = useState({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        width: 0,
        height: 0,
    });
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const showTip = (e) => {
        e.stopPropagation();
        const { left, right, top, bottom, width, height } = e.currentTarget.getBoundingClientRect();
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            setTooltipCoords({ left, right, top, bottom, width, height });
            setActive(true);
        }, delay ?? 400);
    };
    const hideTip = (e) => {
        e.stopPropagation();
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setActive(false);
    };
    const getTooltipStyle = () => {
        const spacingOffset = 4;
        switch (placement) {
            case "bottom-start":
                return {
                    left: tooltipCoords.left,
                    top: tooltipCoords.top + tooltipCoords.height + spacingOffset,
                };
            case "bottom-end":
                return {
                    left: tooltipCoords.left + tooltipCoords.width,
                    top: tooltipCoords.top + tooltipCoords.height + spacingOffset,
                    transform: "translateX(-100%)",
                };
            case "top":
                return {
                    left: tooltipCoords.left + tooltipCoords.width / 2,
                    top: tooltipCoords.top - spacingOffset,
                    transform: "translate(-50%, -100%)",
                };
            case "top-start":
                return {
                    left: tooltipCoords.left,
                    top: tooltipCoords.top - spacingOffset,
                    transform: "translateY(-100%)",
                };
            case "top-end":
                return {
                    left: tooltipCoords.left + tooltipCoords.width,
                    top: tooltipCoords.top - spacingOffset,
                    transform: "translate(-100%,-100%)",
                };
            case "right":
                return {
                    left: tooltipCoords.right + spacingOffset,
                    top: tooltipCoords.top + tooltipCoords.height / 2,
                    transform: "translateY(-50%)",
                };
            case "right-start":
                return {
                    left: tooltipCoords.right + spacingOffset,
                    top: tooltipCoords.top,
                };
            case "right-end":
                return {
                    left: tooltipCoords.right + spacingOffset,
                    top: tooltipCoords.top + tooltipCoords.height,
                    transform: "translateY(-100%)",
                };
            case "left":
                return {
                    left: tooltipCoords.left - spacingOffset,
                    top: tooltipCoords.top + tooltipCoords.height / 2,
                    transform: "translate(-100%, -50%)",
                };
            case "left-start":
                return {
                    left: tooltipCoords.left - spacingOffset,
                    top: tooltipCoords.top,
                    transform: "translate(-100%, 0)",
                };
            case "left-end":
                return {
                    left: tooltipCoords.left - spacingOffset,
                    top: tooltipCoords.top + tooltipCoords.height,
                    transform: "translate(-100%, -100%)",
                };
            case "bottom":
            default:
                return {
                    left: tooltipCoords.left + tooltipCoords.width / 2,
                    top: tooltipCoords.top + tooltipCoords.height + spacingOffset,
                    transform: "translateX(-50%)",
                };
        }
    };
    const tooltipVariant = {
        default: () => {
            if (hidden) {
                return children;
            }
            return (React__default.createElement("div", { onMouseEnter: showTip, onMouseLeave: hideTip, className: toolTipWrapper },
                children,
                React__default.createElement(Sanitize, { check: active }, createPortal(React__default.createElement("div", { className: tooltip, style: {
                        ...getTooltipStyle(),
                    } },
                    React__default.createElement("div", null, content)), document.body))));
        },
    };
    const render = () => {
        return tooltipVariant[variant]();
    };
    return render();
};

const isEmptyArray = (arr) => {
    if (Array.isArray(arr) && arr.length) {
        return false;
    }
    else {
        return true;
    }
};
const Autocomplete = ({ options, onChange, defaultValue, customClass, name = null, }) => {
    function getinitialSelectedOptions() {
        if (isEmptyArray(options)) {
            return { label: "No options" };
        }
        else if (defaultValue) {
            return defaultValue;
        }
        else if (!defaultValue) {
            return options[0];
        }
    }
    const initialSelectedOptions = getinitialSelectedOptions();
    const [selectedOption, setSelectedOption] = useState(initialSelectedOptions);
    const [query, setQuery] = useState("");
    const filteredOptions = query === ""
        ? options
        : options.filter((option) => {
            return option.label.toLowerCase().includes(query.toLowerCase());
        });
    let wrapperClass = customClass ? `${customClass}` : ``;
    let inputwrapClasses = ` 
    relative w-full cursor-default overflow-hidden rounded-md 
    border border-solid border-neutral-10 dark:border-neutral-dark-10
    text-left  
    focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-primary`;
    let inputClasses = `bg-neutral-5 hover:bg-white h-12 w-full rounded-md border-none py-2 pl-4 pr-6 text-size-base text-neutral-dark-0 focus:ring-0 dark:bg-neutral-dark-10 dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-5 dark:border-neutral-dark-10`;
    let optionWrapClasses = `absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md  bg-neutral-0 text-base text-neutral-dark-0 shadow-6xl dark:shadow-none focus:outline-none dark:bg-neutral-dark-10 dark:text-neutral-dark-110 dark:border dark:border-solid dark:border-neutral-dark-5`;
    let nothingFoundClasses = `relative cursor-default select-none py-2 px-4 text-neutral-dark-0 dark:text-neutral-40`;
    let optionInnerWrapClasses = `block py-1.5 px-4 dark:text-neutral-40`;
    function renderComboboxOption() {
        if (isEmptyArray(filteredOptions) && query !== "") {
            return React__default.createElement("div", { className: nothingFoundClasses }, "Nothing found.");
        }
        else if (!isEmptyArray(filteredOptions)) {
            return filteredOptions.map((option) => (React__default.createElement(Combobox.Option, { key: option.id, value: option, as: Fragment }, ({ active, selected }) => (React__default.createElement("li", { className: `dark:text-neutral-dark-110 ${active
                    ? "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0"
                    : "bg-transparent"}` },
                React__default.createElement("span", { className: `${optionInnerWrapClasses} ${selected ? "bg-neutral-20 dark:bg-neutral-dark-20 font-medium" : "font-normal"}` }, option.label))))));
        }
        else if (isEmptyArray(filteredOptions)) {
            return (React__default.createElement(Combobox.Option, { value: selectedOption, disabled: true },
                React__default.createElement("li", null,
                    React__default.createElement("span", { className: `${optionInnerWrapClasses} bg-neutral-20 text-neutral-30 dark:bg-neutral-dark-20 dark:text-neutral-dark-110` }, "No options available"))));
        }
    }
    return (React__default.createElement("div", { className: wrapperClass, "data-name": name },
        React__default.createElement(Combobox, { value: selectedOption, onChange: (changedValue) => {
                setSelectedOption(changedValue);
                if (onChange) {
                    onChange(null, changedValue);
                }
            } }, ({ open }) => (React__default.createElement("div", { className: "relative mt-1" },
            React__default.createElement("div", { className: inputwrapClasses },
                React__default.createElement(Combobox.Input, { className: inputClasses, onChange: (event) => setQuery(event.target.value), displayValue: (option) => {
                        return option?.label;
                    } }),
                React__default.createElement(Combobox.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2" },
                    React__default.createElement(Icon, { name: "DownArrow", className: `duration-300 ease-in ${open ? "rotate-180" : ""}` }))),
            React__default.createElement(Transition, { as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => setQuery("") },
                React__default.createElement(Combobox.Options, { className: optionWrapClasses }, renderComboboxOption())))))));
};

const TextArea = ({ name = null, onChange, ...props }) => {
    const _args = { onChange: onChange };
    //Removing set of not required props.
    // TODO find a simpler way to extract these props
    const propArray = { ...props };
    const notRequiredProp = ["customClass"];
    notRequiredProp.map((item) => {
        if (propArray[item]) {
            delete propArray[item];
        }
    });
    let borderClass = `border-primary-neutral-10 dark:border-neutral-dark-10 focus:border-primary dark:focus:border-primary-dark`; //Default border color
    let borderErrorClass = `border-error dark:border-error`; // With error status
    let borderWarningClass = `border-warning dark:border-warning`; // with warning status
    if (props.status == "error") {
        borderClass = borderErrorClass;
    }
    else if (props.status == "alert") {
        borderClass = borderWarningClass;
    }
    let textAreaBasicStyles = `block w-full leading-normal placeholder-neutral-30 py-2 px-2 text-size-16 
  outline-none rounded-md font-opensans`;
    let textAreaDefaultStyles = `${textAreaBasicStyles} bg-primary-N5 text-neutral-dark-0 
  hover:bg-neutral-0 focus:bg-neutral-0 dark:bg-neutral-dark-10 dark:hover:bg-neutral-dark-5 
   dark:text-neutral-dark-110 border border-solid ${borderClass}`;
    let disabledStyles = `${textAreaBasicStyles} border border-solid border-neutral-20 bg-neutral-10 hover:bg-neutral-10 
  text-neutral placeholder-neutral-30  dark:bg-neutral-dark-20 dark:text-neutral-dark-40 dark:border-neutral-dark-20 cursor-not-allowed`;
    disabledStyles = props.customClass
        ? `${disabledStyles} ${props.customClass}`
        : `${disabledStyles}`;
    textAreaDefaultStyles = props.customClass
        ? `${textAreaDefaultStyles} ${props.customClass}`
        : `${textAreaDefaultStyles}`;
    let textAreaStyles = props.disabled ? disabledStyles : textAreaDefaultStyles;
    return (React__default.createElement("textarea", { className: textAreaStyles, ...propArray, ..._args, "data-name": name }));
};

const Message = ({ variant = "field", customClass, title, content, type, iconVisibility = true, loader = false, }) => {
    let wrapperDefaultClass = `flex text-size-12`;
    wrapperDefaultClass = customClass
        ? `${wrapperDefaultClass} ${customClass}`
        : `${wrapperDefaultClass}`;
    //Icon name, background color, field title depends on the message type.
    let iconName;
    let bgColor = ``;
    let fieldTitleClass = "";
    switch (type) {
        case "helper":
            iconName = "Helper";
            bgColor = `bg-neutral-10 dark:bg-primary-40`;
            fieldTitleClass = `text-neutral-60 text-size-12 font-roboto font-normal`;
            break;
        case "important":
            iconName = "infoRound";
            bgColor = `bg-primary-20 dark:bg-info-20`;
            fieldTitleClass = `text-primary-dark text-size-12 font-roboto font-normal`;
            break;
        case "alert":
            iconName = "Alert";
            bgColor = `bg-warning-5 dark:bg-warning-40`;
            fieldTitleClass = `text-warning text-size-12 font-roboto font-normal`;
            break;
        case "success":
            iconName = "successInfo";
            bgColor = `bg-success-5 dark:bg-success-20`;
            fieldTitleClass = `text-success text-size-12 font-roboto font-normal`;
            break;
        case "error":
            iconName = "Error";
            bgColor = `bg-error-5 dark:bg-error-20`;
            fieldTitleClass = `text-error text-size-12 font-roboto font-normal`;
            break;
    }
    //Title classes
    let flashTitleClasses = `text-neutral-80 text-size-12 font-roboto font-normal`;
    let spotTitleClasses = `text-neutral-80 text-size-14 leading-tight`;
    //Icon Classes
    let iconClasses = `block mr-2 mt-0.5`;
    //Wrapper for field
    let WrapperFieldClass = `mt-1 ${wrapperDefaultClass}`;
    //Wrapper classes for Flash and Spot
    let WrapperClass = `${bgColor} px-2 py-2 rounded-md ${wrapperDefaultClass}`;
    const messageVariant = {
        field: () => {
            return (React__default.createElement("div", { className: WrapperFieldClass },
                loader
                    ? null
                    : iconVisibility && (React__default.createElement("i", { className: iconClasses },
                        React__default.createElement(Icon, { name: iconName }))),
                loader ? (React__default.createElement("div", { className: "flex items-center justify-center" },
                    React__default.createElement("h4", { className: fieldTitleClass }, title),
                    React__default.createElement(Loader, null))) : (React__default.createElement("h4", { className: fieldTitleClass }, title))));
        },
        flash: () => {
            return (React__default.createElement("div", { className: WrapperClass },
                iconVisibility && (React__default.createElement("i", { className: iconClasses },
                    React__default.createElement(Icon, { name: iconName }))),
                React__default.createElement("div", null,
                    React__default.createElement("h4", { className: flashTitleClasses }, title))));
        },
        spot: () => {
            return (React__default.createElement("div", { className: WrapperClass },
                iconVisibility && (React__default.createElement("i", { className: iconClasses },
                    React__default.createElement(Icon, { name: iconName }))),
                React__default.createElement("div", null,
                    React__default.createElement("h4", { className: spotTitleClasses }, title),
                    React__default.createElement("div", { className: "text-size-12 dark:text-neutral-80" }, content))));
        },
    };
    const render = () => {
        return messageVariant[variant]();
    };
    return render();
};

/* Primary */
const primaryColors = {
    base: {
        default: tailwind_config.theme.extend.colors.primary.DEFAULT,
        extended: {
            10: tailwind_config.theme.extend.colors.primary[10],
            20: tailwind_config.theme.extend.colors.primary[20],
            40: tailwind_config.theme.extend.colors.primary[40],
            110: tailwind_config.theme.extend.colors.primary[110],
        },
    },
    dark: {
        default: tailwind_config.theme.extend.colors.primary.dark.DEFAULT,
    },
};
/* Secondary */
const secondaryColors = {
    base: {
        default: tailwind_config.theme.extend.colors.secondary.DEFAULT,
        extended: {
            10: tailwind_config.theme.extend.colors.secondary[10],
            20: tailwind_config.theme.extend.colors.secondary[20],
            40: tailwind_config.theme.extend.colors.secondary[40],
            110: tailwind_config.theme.extend.colors.secondary[110],
        },
    },
    dark: {
        default: tailwind_config.theme.extend.colors.secondary.dark.DEFAULT,
    },
};
/* Neutral */
const neutralColors = {
    base: {
        default: tailwind_config.theme.extend.colors.neutral.DEFAULT,
        extended: {
            0: tailwind_config.theme.extend.colors.neutral[0],
            5: tailwind_config.theme.extend.colors.neutral[5],
            6: tailwind_config.theme.extend.colors.neutral[6],
            10: tailwind_config.theme.extend.colors.neutral[10],
            15: tailwind_config.theme.extend.colors.neutral[15],
            20: tailwind_config.theme.extend.colors.neutral[20],
            30: tailwind_config.theme.extend.colors.neutral[30],
            40: tailwind_config.theme.extend.colors.neutral[40],
            60: tailwind_config.theme.extend.colors.neutral[60],
            80: tailwind_config.theme.extend.colors.neutral[80],
            85: tailwind_config.theme.extend.colors.neutral[85],
            110: tailwind_config.theme.extend.colors.neutral[110],
        },
    },
    dark: {
        default: tailwind_config.theme.extend.colors.neutral.dark.DEFAULT,
    },
};
/* Error */
const errorColors = {
    base: {
        default: tailwind_config.theme.extend.colors.error.DEFAULT,
        extended: {
            5: tailwind_config.theme.extend.colors.error[5],
            20: tailwind_config.theme.extend.colors.error[20],
            40: tailwind_config.theme.extend.colors.error[40],
            110: tailwind_config.theme.extend.colors.error[110],
        },
    },
};
/* Success */
const successColors = {
    base: {
        default: tailwind_config.theme.extend.colors.success.DEFAULT,
        extended: {
            5: tailwind_config.theme.extend.colors.success[5],
            20: tailwind_config.theme.extend.colors.success[20],
            40: tailwind_config.theme.extend.colors.success[40],
            110: tailwind_config.theme.extend.colors.success[110],
        },
    },
};
/* Success */
const warningColors = {
    base: {
        default: tailwind_config.theme.extend.colors.warning.DEFAULT,
        extended: {
            5: tailwind_config.theme.extend.colors.warning[5],
            20: tailwind_config.theme.extend.colors.warning[20],
            40: tailwind_config.theme.extend.colors.warning[40],
            110: tailwind_config.theme.extend.colors.warning[110],
        },
    },
};
/* Info */
const infoColors = {
    base: {
        default: tailwind_config.theme.extend.colors.info.DEFAULT,
        extended: {
            5: tailwind_config.theme.extend.colors.info[5],
            20: tailwind_config.theme.extend.colors.info[20],
            40: tailwind_config.theme.extend.colors.info[40],
            110: tailwind_config.theme.extend.colors.info[110],
        },
    },
};

const Colors = () => {
    const [copiedColor, setCopiedColor] = useState("");
    const handleSwatchClick = (color) => {
        navigator.clipboard
            .writeText(color)
            .then(() => {
            setCopiedColor(color);
            setTimeout(() => setCopiedColor(""), 2000);
        })
            .catch((err) => {
            // eslint-disable-next-line no-console
            console.error("Failed to copy color: ", err);
        });
    };
    const getColorValue = (color) => {
        return typeof color === "object" ? Object.values(color)[0] : color;
    };
    const colorCategories = [
        { name: "Primary", colors: primaryColors },
        { name: "Secondary", colors: secondaryColors },
        { name: "Neutral", colors: neutralColors },
        { name: "Error", colors: errorColors },
        { name: "Success", colors: successColors },
        { name: "Warning", colors: warningColors },
        { name: "Info", colors: infoColors },
    ];
    return (React__default.createElement("div", { className: "wrapper-canvas" },
        React__default.createElement("div", { className: "border-neutral-10 mb-10 border-b-2 pb-2" },
            React__default.createElement("h2", { className: "text-neutral-dark-10" }, "Colour"),
            React__default.createElement("p", { className: "text-neutral-dark-10" }, "A defined colour palette helps maintain consistency across products and brands with ease of accessibility and control.")),
        React__default.createElement("div", { className: "colour-wrapper text-neutral-dark-10" }, colorCategories.map((category, index) => (React__default.createElement("section", { className: "border-neutral-10 mb-5 border-b-2 pb-2", key: index },
            React__default.createElement("h3", { className: "mb-5" }, category.name),
            React__default.createElement("div", { className: "palette text-size-14 flex flex-row" },
                React__default.createElement("div", { className: "palette-item" },
                    React__default.createElement("h4", { className: "mb-4" }, "Base colour"),
                    React__default.createElement("div", { className: "mr-8 mb-8" },
                        React__default.createElement("div", { className: "styleguide-swatch relative inline-block h-20 w-40 cursor-pointer", style: { backgroundColor: getColorValue(category.colors.base.default) }, onClick: () => handleSwatchClick(getColorValue(category.colors.base.default)) },
                            React__default.createElement("span", { className: "absolute top-0 left-0 right-0 bottom-0 opacity-0" }, getColorValue(category.colors.base.default)),
                            copiedColor === getColorValue(category.colors.base.default) && (React__default.createElement("div", { className: "text-neutral-0 bg-neutral-40 absolute left-0 right-0 top-0 flex h-full items-center justify-center rounded-sm" }, "Copied!"))),
                        React__default.createElement("div", { className: "palette-desc flex flex-row justify-between" },
                            React__default.createElement("span", null, getColorValue(category.colors.base.default)),
                            React__default.createElement("span", null, "default")))),
                React__default.createElement("div", { className: "palette-item" },
                    React__default.createElement("h4", { className: "mb-4" }, "Extended palette"),
                    React__default.createElement("div", { className: "palette-group flex flex-row flex-wrap" }, Object.entries(category.colors.base.extended).map(([key, value], i) => {
                        const fillColor = getColorValue(value);
                        return (React__default.createElement("div", { className: "mr-8 mb-8", key: i },
                            React__default.createElement("div", { className: "styleguide-swatch relative inline-block h-20 w-28 cursor-pointer", style: { backgroundColor: fillColor }, onClick: () => handleSwatchClick(fillColor) },
                                React__default.createElement("span", { className: "absolute top-0 left-0 right-0 bottom-0 opacity-0" }, fillColor),
                                copiedColor === fillColor && (React__default.createElement("div", { className: "text-neutral-0 bg-primary absolute left-0 right-0 top-0 flex h-full items-center justify-center rounded-sm" }, "Copied!"))),
                            React__default.createElement("div", { className: "palette-desc flex flex-row justify-between" },
                                React__default.createElement("span", null, fillColor),
                                React__default.createElement("span", null, key))));
                    })))))))),
        React__default.createElement("div", { className: "colour-wrapper text-neutral-dark-10" },
            React__default.createElement("section", { className: "mb-5 pb-2" },
                React__default.createElement("h3", { className: "mb-3" }, "Semantics"),
                React__default.createElement("p", { className: "text-neutral-dark-10" }, "Semantic color helps users identify status, see actions, locate help, and understand next steps."),
                React__default.createElement("table", { className: "table-palette text-size-14 w-full table-fixed" },
                    React__default.createElement("thead", null,
                        React__default.createElement("tr", { className: "border-primary-N10 font-opensans text-primary-N100 border-b-2 font-bold" },
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }),
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }, "Blue"),
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }, "Neutral"),
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }, "Green"),
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }, "Orange"),
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }, "Red"),
                            React__default.createElement("th", { className: "text-primary-N60 p-4 text-left font-normal lg:whitespace-nowrap" }, "Purple"))),
                    React__default.createElement("tbody", null,
                        React__default.createElement("tr", null,
                            React__default.createElement("td", { className: "text-size-base border-primary-N10 text-primary-N60 border-r-2 p-6 align-top" }, "Actions"),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-primary-B100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Primary"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-primary-N20 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Secondary"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-G100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Confirm"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-O100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Warning"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-R100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Remove"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-P100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Help")))),
                        React__default.createElement("tr", null,
                            React__default.createElement("td", { className: "text-size-base border-primary-N10 text-primary-N60 border-r-2 p-6 align-top" }, "Messages"),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" }),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" }),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-G100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Success"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-O100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Warning"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-R100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Error"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-P100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Information")))),
                        React__default.createElement("tr", null,
                            React__default.createElement("td", { className: "text-size-base border-primary-N10 text-primary-N60 border-r-2 p-6 align-top" }, "Connectiviity"),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" }),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-primary-N20 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Unavailable"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-G100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Available"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" }),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-R100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Busy"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-P100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Focus")))),
                        React__default.createElement("tr", null,
                            React__default.createElement("td", { className: "text-size-base border-primary-N10 text-primary-N60 border-r-2 p-6 align-top" }, "Status"),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-primary-B100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "In progress"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-primary-N20 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Default/To do"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-G100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Added/ Complete"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-O100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Moved"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-R100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Removed/ Failed"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-P100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "New")))),
                        React__default.createElement("tr", null,
                            React__default.createElement("td", { className: "text-size-base border-primary-N10 text-primary-N60 border-r-2 p-6 align-top" }, "Priority"),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" }),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-primary-N20 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Trivial"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-G100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Minor"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-O100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Medium"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" },
                                React__default.createElement("div", { className: "flex items-center leading-5" },
                                    React__default.createElement("span", { className: "bg-secondary-R100 mr-1 block h-6 w-6 shrink-0" }),
                                    React__default.createElement("span", null, "Critical"))),
                            React__default.createElement("td", { className: "text-size-base p-6 align-top" }))))))));
};

const Typo = () => {
    return (React__default.createElement("div", { className: "px-5 lg:px-24" },
        React__default.createElement("h3", { className: "text-primary-DN10" }, "Typography"),
        React__default.createElement("p", { className: "text-primary-DN10" }, "Typography used to organize information hierarchies, and guide users through product and its experience."),
        React__default.createElement("div", { className: "" },
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("h1", null, "This is for layout headings. Commonly used for marketing pages and editorials.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "H1"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Open Sans"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "56px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "700 / Semi Bold"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 64px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("h2", null, "This is for layout headings. Commonly used for documents and product screens.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "H2"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Open Sans"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "32px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "700 /Bold"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 43px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("h3", null, "This is for layout subheadings (Secondary level).")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "H3"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Open Sans"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "26px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "600 / Semi Bold"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 32px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("h4", { className: "text-primary-DN0" }, "This is for layout sub headings (Tertiary level).")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "H4"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Open Sans"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "20px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "600 / Semi Bold"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 28px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("h4", { className: "font-normal" }, "This is for Intro/Kicker text. commonly used as explanatory text that appears below/above headings.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "Kicker"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Open Sans"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "20px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "400 / regular"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 28px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("h5", null, "This is for component headings")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "H5"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Open Sans"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "16px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "600 / Semi Bold"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 22px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("p", null, "This is for long paragraphs with more than four lines. Commonly used for body copy.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "Body"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Roboto"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "16px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "400 / Regular"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 28px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("p", { className: "font-bold" }, "This is for short paragraphs with no more than four lines. Commonly used to highlight important words/sentences.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "Body+"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Roboto"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "16px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "700 / Bold"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 28px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("pre", { className: "bg-transparent p-0 text-primary-DN0" },
                        React__default.createElement("code", { className: "bg-transparent p-0 text-primary-DN0" }, "This is for code snippets."))),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "Code"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Roboto Mono"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "16px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "400 / Regular"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 28px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("code", { className: "bg-transparent p-0 text-primary-DN0" }, "This is for inline code snippets.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "Code+"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Roboto Mono"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "14px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "400 / Regular"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 28px")))),
            React__default.createElement("div", { className: "flex flex-col py-5 border-b-2 border-primary-N10 md:flex-row" },
                React__default.createElement("div", { className: "typo-item text-primary-DN0 w-4/5 pr-10" },
                    React__default.createElement("p", { className: "text-size-14" }, "This is for captions and helper text appears in layout and components.")),
                React__default.createElement("div", { className: "typo-item flex-1" },
                    React__default.createElement("h3", { className: "text-primary-DN30" }, "Captions/ Helper text"),
                    React__default.createElement("ul", { className: "typo-desc" },
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Roboto"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "14px"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "400 / Regular"),
                        React__default.createElement("li", { className: "font-opensans text-size-22 font-bold text-primary-DN30" }, "Line height: 26px"))))),
        React__default.createElement("div", { className: "text-primary-DN10" },
            React__default.createElement("h3", { className: "mt-4 mb-6" }, "Font stack"),
            React__default.createElement("div", { className: "pb-2" },
                React__default.createElement("h2", { className: "font-normal mb-2" }, "Open Sans"),
                React__default.createElement("p", { className: "text-size-14" },
                    "Open Sans was designed with an upright stress, open forms and a neutral, yet friendly appearance. It was optimized for print, web, and mobile interfaces, and has excellent legibility characteristics in its letterforms. Source: ",
                    React__default.createElement("a", { href: "https://fonts.google.com/specimen/Open+Sans?sort=popularity", target: "_blank" }, "https://fonts.google.com/specimen/Open+Sans?sort=popularity"))),
            React__default.createElement("div", { className: "pb-2" },
                React__default.createElement("h2", { className: "font-normal mb-2" }, "Roboto"),
                React__default.createElement("p", { className: "text-size-14" },
                    "Roboto has a dual nature. It has a mechanical skeleton and the forms are largely geometric. At the same time, the font features friendly and open curves. Source: ",
                    React__default.createElement("a", { href: "https://fonts.google.com/specimen/Roboto?sort=popularity", target: "_blank" }, "https://fonts.google.com/specimen/Roboto?sort=popularity"))),
            React__default.createElement("div", { className: "pb-2" },
                React__default.createElement("h2", { className: "font-normal mb-2" }, "Roboto Mono"),
                React__default.createElement("p", { className: "text-size-14" },
                    "Roboto Mono is optimized for readability on screens across a wide variety of devices and reading environments. Special consideration is given to glyphs important for reading and writing software source code. Letters with similar shapes are easy to tell apart. Source: ",
                    React__default.createElement("a", { href: "https://fonts.google.com/specimen/Roboto+Mono#glyphs", target: "_blank" }, "https://fonts.google.com/specimen/Roboto+Mono#glyphs"))))));
};

const VideoPlayer = forwardRef(({ customClass, portrait, children, ...props }, ref) => {
    let portraitClasses = `h-full object-cover`;
    let videoClasses = ``;
    videoClasses = customClass
        ? `${videoClasses} ${customClass}`
        : `${videoClasses}`;
    videoClasses = portrait
        ? `${videoClasses} ${portraitClasses}`
        : `${videoClasses}`;
    return (React__default.createElement("video", { className: videoClasses, ...props, ref: ref }, children));
});

const Status = ({ customClass, title, msg, children, value }) => {
    let statusClasses = customClass ? `${customClass}` : ``;
    //Icon name, background color, field title depends on the message type.
    let iconTitle;
    switch (value) {
        case "success":
            iconTitle = "successInfo";
            break;
        case "error":
            iconTitle = "Error";
            break;
    }
    let statusMsgClasses = `text-primary-DN0 text-center font-semibold text-size-20 pb-2 font-opensans dark:text-primary-DN110`;
    let statusReasonClasses = `mb-6 text-primary-N60 text-center text-size-14 mt-0`;
    return (React__default.createElement("div", { className: statusClasses },
        React__default.createElement(Icon, { name: iconTitle, className: "mx-auto mb-4 block h-12 w-12" }),
        title ? React__default.createElement("h3", { className: statusMsgClasses }, title) : null,
        msg ? React__default.createElement("p", { className: statusReasonClasses }, msg) : null,
        React__default.createElement("div", null, children)));
};

const Selector = ({ value, onChange, options, status, variant = "default", showClear = false, name = null, iconName, placement, placeholder, selectDisable, }) => {
    const data = value;
    const [isOpen, setIsOpen] = useState(false);
    const clearOptions = () => {
        onChange(undefined);
    };
    const selectOption = (option) => {
        onChange(option);
    };
    const isOptionSelected = (option) => {
        return option.value === data?.value;
    };
    let wrapperClasses = `box-border h-12 py-2 px-4 w-full relative 
  cursor-pointer text-size-base text-neutral-dark-0 flex items-center  rounded-md 
  appearance-none bg-neutral-5 hover:bg-neutral-0 dark:bg-neutral-dark-10 dark:text-neutral-dark110 dark:hover:bg-neutral-dark-05 dark:border-neutral-dark-10`;
    let wrapperDefaultClasses = `${wrapperClasses} border border-solid border-neutral-10`;
    let wrapperErrorClasses = `${wrapperClasses} border border-solid border-error`;
    let wrapperStatusClasses = chooseBinaryClass(status === "error", wrapperErrorClasses, wrapperDefaultClasses);
    let wrapperDisabledClasses = `box-border h-12 py-2 px-4 w-full relative 
  cursor-pointer text-size-base flex items-center  rounded-md 
  appearance-none bg-neutral-10 border border-neutral-20 dark:bg-neutral-dark-20 dark:border-neutral-dark-10 border-solid cursor-not-allowed pointer-events-none`;
    let wrapperMainClasses = chooseBinaryClass(Boolean(selectDisable), wrapperDisabledClasses, wrapperStatusClasses);
    let selectorLabelClass = "flex-1 text-neutral-dark-0 dark:text-neutral-40 truncate";
    let selectorLabelClassDisabled = "flex-1 text-neutral-60 dark:text-neutral-40";
    let selectorLabelMainClasses = chooseBinaryClass(Boolean(selectDisable), selectorLabelClassDisabled, selectorLabelClass);
    let dropdownDefaultClasses = `w-full z-50 shadow-6xl top-12 absolute left-0 bg-neutral-0 ease-in duration-200 z-50 rounded-b-md max-h-56 overflow-y-auto dark:bg-neutral-dark-5 dark:shadow-D4xl`;
    let dropdownMenuClasses = chooseBinaryClass(Boolean(isOpen), `${dropdownDefaultClasses} block`, `${dropdownDefaultClasses} hidden`);
    let optionDefaultClasses = `cursor-pointer text-neutral-dark-0 py-1.5 px-4 hover:bg-neutral-5 dark:text-neutral-40 dark:hover:bg-neutral-dark-0`;
    let optionSelectedClasses = `bg-neutral-20 hover:bg-neutral-20 dark:bg-neutral-dark-20`;
    //variant-Menu option classes
    let iconBasedWrapperClasses = `relative inline-flex`;
    let iconBasedDropdownClasses = `w-28 z-50 shadow-6xl top-7 absolute right-0 overflow-y-auto bg-neutral-0 ease-in duration-200 z-50  rounded-md max-h-56 dark:bg-neutral-dark-5 dark:shadow-D4xl`;
    let iconBaseddropdownMenuClasses = chooseBinaryClass(Boolean(isOpen), `${iconBasedDropdownClasses} block`, `${iconBasedDropdownClasses} hidden`);
    let iconBasedoptionClasses = `option py-1 px-2 text-neutral-dark-0 hover:bg-neutral-5 cursor-pointer dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-0 flex items-center`;
    //MenuPicker
    //variant-Menu option classes
    let menuPickerWrapperClasses = `relative inline-flex`;
    let menuPickerDropdownClasses = `w-28 z-50 shadow-6xl  absolute overflow-y-auto bg-neutral-0 ease-in duration-200 z-50  rounded-md max-h-56 dark:bg-neutral-dark-5 dark:shadow-D4xl`;
    let menuPickerdropdownMenuClasses = chooseBinaryClass(Boolean(isOpen), `${menuPickerDropdownClasses} block`, `${menuPickerDropdownClasses} hidden`);
    let menuPickeroptionBaseClasses = `option py-1 px-2 text-neutral-dark-0 hover:bg-neutral-5 cursor-pointer dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-0 flex items-center`;
    let menuPickeroptionSelected = `text-primary bg-neutral-10 hover:bg-neutral-10 dark:bg-neutral-dark-0 dark:hover:bg-neutral-dark-0 dark:text-primary-dark `;
    let menuPickerDisabled = `py-1 px-2 pointer-events-none bg-neutral-20 text-neutral-30  dark:bg-neutral-dark-10 dark:text-neutral-dark-20`;
    //MenuPicker dropdown Placement
    let menuPickerOptionWrapper = `${menuPickerdropdownMenuClasses} ${placement === "top" ? "bottom-6" : "top-7"} right-0`;
    //BorderLess selector styles
    let borderLessWrapper = `inline-flex items-center relative py-1`;
    let borderLessdropdownDefaultClasses = `w-full z-50 shadow-6xl absolute left-0 overflow-y-auto bg-neutral-0 ease-in duration-200 z-50  rounded-b-md  dark:bg-neutral-dark-5 dark:shadow-D4xl`;
    let borderLessdropdownMenuClasses = chooseBinaryClass(Boolean(isOpen), `${borderLessdropdownDefaultClasses} block`, `${borderLessdropdownDefaultClasses} hidden`);
    let optionDefaultBorderlessClasses = `break-words cursor-pointer text-neutral-dark-0 py-1.5 px-4 hover:bg-neutral-5 dark:text-neutral-40 dark:hover:bg-neutral-dark-0`;
    let optionSelectedBorderlessClasses = `bg-neutral-20 hover:bg-neutral-20 dark:bg-neutral-dark-20`;
    /*Selector label */
    let labelClasses = `text-neutral-40 dark:text-neutral-dark-110`;
    let labelDisabledClasses = `dark:text-neutral-40`;
    let labelDefaultClasses = chooseBinaryClass(Boolean(selectDisable), labelDisabledClasses, labelClasses);
    function renderDefaultVariant() {
        return (React__default.createElement("div", { onBlur: () => setIsOpen(false), onClick: () => setIsOpen(!isOpen), tabIndex: 0, className: wrapperMainClasses, "data-name": name },
            React__default.createElement("div", { className: selectorLabelMainClasses }, placeholder && !data?.label ? (React__default.createElement("span", { className: labelDefaultClasses }, placeholder)) : (data?.label)),
            React__default.createElement(Sanitize, { check: Boolean(showClear && data?.label) },
                React__default.createElement("button", { onClick: (e) => {
                        e.stopPropagation();
                        clearOptions();
                    } },
                    React__default.createElement(Icon, { name: "Close", className: "mr-2 w-4" }))),
            React__default.createElement("div", null,
                React__default.createElement(Icon, { name: "DownArrow" })),
            React__default.createElement("ul", { className: dropdownMenuClasses }, options.map((option, i) => (React__default.createElement("li", { key: i, className: `${optionDefaultClasses}  ${chooseBinaryClass(isOptionSelected(option), `${optionSelectedClasses}`, "")} `, onClick: (e) => {
                    e.stopPropagation();
                    selectOption(option);
                    setIsOpen(!isOpen);
                } }, option.label))))));
    }
    function renderMenuPickerVariant() {
        return (React__default.createElement("div", { className: "inline-flex" },
            React__default.createElement("div", { onBlur: () => setIsOpen(false), onClick: () => setIsOpen(!isOpen), tabIndex: 0, className: menuPickerWrapperClasses, "data-name": name },
                React__default.createElement("div", { className: "text-size-10 dark:text-neutral-40 flex flex-1 cursor-pointer" },
                    React__default.createElement("span", null, data?.label),
                    React__default.createElement(Icon, { name: "DownArrow" })),
                React__default.createElement("ul", { className: menuPickerOptionWrapper }, options.map((option, i) => (React__default.createElement("li", { key: i, className: `${option.disabled
                        ? `${menuPickerDisabled}`
                        : `${menuPickeroptionBaseClasses}  ${isOptionSelected(option) ? `${menuPickeroptionSelected}` : ""}`} `, onClick: (e) => {
                        e.stopPropagation();
                        selectOption(option);
                        setIsOpen(!isOpen);
                    } }, option.label)))))));
    }
    function renderIconBasedVariant() {
        return (React__default.createElement("div", { className: "inline-flex" },
            React__default.createElement("div", { onBlur: () => setIsOpen(false), onClick: () => setIsOpen(!isOpen), tabIndex: 0, className: iconBasedWrapperClasses, "data-name": name },
                React__default.createElement("div", { className: "flex-1 cursor-pointer" },
                    React__default.createElement(Icon, { name: iconName })),
                React__default.createElement("ul", { className: iconBaseddropdownMenuClasses }, options.map((option, i) => (React__default.createElement("li", { key: i, className: `${iconBasedoptionClasses}`, onClick: (e) => {
                        e.stopPropagation();
                        selectOption(option);
                        setIsOpen(!isOpen);
                    } },
                    React__default.createElement("span", { className: "mr-2 inline-block" },
                        React__default.createElement(Icon, { name: option.icon, className: "w-4" })),
                    React__default.createElement("span", null, option.label))))))));
    }
    function renderBorderLessVariant() {
        return (React__default.createElement("div", { onBlur: () => setIsOpen(false), onClick: () => setIsOpen(!isOpen), tabIndex: 0, className: borderLessWrapper, "data-name": name },
            React__default.createElement("div", { className: "font-opensans text-size-base text-neutral-dark-0 dark:text-neutral-40 mr-2 font-semibold" }, data?.label),
            React__default.createElement("div", null,
                React__default.createElement(Icon, { name: "DownArrow", fill: "#768395" })),
            React__default.createElement("ul", { className: borderLessdropdownMenuClasses, style: { maxWidth: "200px", minWidth: "175px", top: "35px", maxHeight: "390px" } }, options.map((option, i) => (React__default.createElement("li", { key: i, className: `${optionDefaultBorderlessClasses}  ${chooseBinaryClass(isOptionSelected(option), `${optionSelectedBorderlessClasses}`, "")} `, onClick: (e) => {
                    e.stopPropagation();
                    selectOption(option);
                    setIsOpen(!isOpen);
                } }, option.label))))));
    }
    const render = () => {
        switch (variant) {
            case "default":
                return renderDefaultVariant();
            case "menuPicker":
                return renderMenuPickerVariant();
            case "iconBased":
                return renderIconBasedVariant();
            case "borderLess":
                return renderBorderLessVariant();
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return render();
};

const FixedWrapper = ({ children, customClass = "", variant = "default" }) => {
    let defaultClasses = `fixed-wrapper sticky border-y border-solid border-neutral-10 dark:border-neutral-dark-10 dark:bg-neutral-dark-5 bg-neutral-0 left-0 initial:bottom-32 right-0 w-full py-2`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    let containedClasses = `shadow-4xl dark:shadow-transparent bg-neutral-0  dark:bg-neutral-dark-20 fixed bottom-0 right-auto -translate-x-4 w-72 px-4 py-2`;
    containedClasses = addCustomClassToBaseClass(containedClasses, customClass);
    const containerVariant = {
        default: () => {
            return React__default.createElement("section", { className: defaultClasses }, children);
        },
        contained: () => {
            return React__default.createElement("section", { className: containedClasses }, children);
        },
    };
    const render = () => {
        return containerVariant[variant]();
    };
    return render();
};

const List = ({ children, title, ...props }) => {
    let defaultClasses = `text-size-14 py-3 px-3 rounded-md border border-solid 
  border-neutral-10 mb-4 bg-neutral-5 dark:bg-neutral-dark-5 dark:border-neutral-dark-10`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return (React__default.createElement("div", { className: defaultClasses },
        title ? (React__default.createElement("h5", { className: "mb-4 leading-6 text-neutral dark:text-neutral-dark-110" }, title)) : null,
        children));
};

const ListItem = ({ children, label, title, ...props }) => {
    let wrapperClasses = `initial:mb-3`;
    let boxClasses = `block bg-neutral-5 border-2 border-dashed 
  border-neutral-10 flex px-3 py-0.5 rounded-md bg-neutral-0 dark:bg-transparent dark:border-neutral-dark-20 dark:text-primary-dark flex items-center justify-between`;
    wrapperClasses = props.customClass
        ? `${wrapperClasses} ${props.customClass}`
        : `${wrapperClasses}`;
    return (React__default.createElement("div", { className: wrapperClasses },
        React__default.createElement("h5", { className: "text-neutral-60 dark:text-neutral-dark-40 mb-1 text-size-14" }, title),
        React__default.createElement("div", { className: boxClasses },
            React__default.createElement("h5", { className: "font-semibold uppercase text-neutral-80 dark:text-neutral-dark-110" }, label),
            React__default.createElement("div", { className: "flex items-center cursor-pointer" }, children))));
};

const NavList = ({ ...props }) => {
    let defaultClasses = ``;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("ul", { className: defaultClasses }, props.children);
};

const NavListItem = ({ ...props }) => {
    let navItemClasses = `px-8 py-4 font-opensans font-semibold text-size-14 border-b border-solid 
  border-neutral-10 dark:border-neutral-dark-20`;
    navItemClasses = props.customClass
        ? `${navItemClasses} ${props.customClass}`
        : `${navItemClasses}`;
    return React__default.createElement("li", { className: navItemClasses }, props.children);
};

const SelectableListItem = ({ ...props }) => {
    let navItemClasses = `px-4 py-2 font-opensans font-semibold text-size-14 border-b border-solid 
  border-neutral-10 dark:border-neutral-dark-20`;
    navItemClasses = props.customClass
        ? `${navItemClasses} ${props.customClass}`
        : `${navItemClasses}`;
    let listItemClasses = props.selected
        ? `${navItemClasses} bg-primary-10 dark:bg-neutral-dark-10`
        : navItemClasses;
    return React__default.createElement("li", { className: listItemClasses }, props.children);
};

const Chip = ({ onClick, ...props }) => {
    const _args = { onClick: onClick };
    let defaultClasses = `font-opensans leading-tight bg-primary-10 rounded-md py-1 px-2 text-neutral-dark-0 dark:text-neutral-dark-110 text-size-14 dark:bg-neutral-dark-10 mb-2 flex items-center justify-between`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    let valueClasses = `block`;
    valueClasses = props.truncate
        ? `${valueClasses} truncate max-w-44`
        : valueClasses;
    return (React__default.createElement("div", { className: defaultClasses },
        React__default.createElement("div", { className: "flex items-center" },
            props.title && (React__default.createElement("span", { className: "mr-1 text-neutral-40" },
                props.title,
                ":")),
            React__default.createElement("span", { className: valueClasses, style: {
                    maxWidth: props.truncate ? props.maxWidth || "160px" : "none",
                } }, props.children)),
        onClick ? (React__default.createElement("span", { className: "block", ..._args },
            React__default.createElement(Icon, { name: "Close", className: "cursor-pointer" }))) : (React__default.createElement(React__default.Fragment, null))));
};

const ChipContainer = ({ onClick, children, maxWidth = "400px", customClass, }) => {
    const _args = { onClick: onClick };
    const parentRef = useRef(null);
    const [showAdditionalFilterModal, setShowAdditionalFilterModal] = useState(false);
    useEffect(() => {
        const parentElement = parentRef.current;
        if (!parentElement)
            return;
        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const currentScrollHeight = entry.target.scrollHeight;
                const parentOffSetHeight = parentRef.current?.offsetHeight;
                if (parentOffSetHeight && currentScrollHeight > parentOffSetHeight) {
                    setShowAdditionalFilterModal(true);
                }
                else {
                    setShowAdditionalFilterModal(false);
                }
            }
        });
        if (parentRef.current) {
            observer.observe(parentRef.current);
        }
        return () => {
            if (parentRef.current) {
                observer.unobserve(parentRef.current);
            }
        };
    }, []);
    return (React__default.createElement("div", { className: "flex items-center" },
        React__default.createElement("div", { ref: parentRef, style: { maxWidth: maxWidth, maxHeight: "40px" }, className: "flex flex-wrap overflow-hidden" }, children),
        showAdditionalFilterModal ? (React__default.createElement(Button, { variant: "text", customClass: "uppercase", size: "sm", ..._args }, "More +")) : (React__default.createElement(React__default.Fragment, null))));
};

//Core imports
const SelectableList = ({ selectedValues, options, inputPlaceholder = "Search", inputIcon = "Search", modalTitle, onChange, customClass, }) => {
    const [searchQueryText, setSearchQueryText] = useState("");
    const [pillContainerModal, setPillContainerModal] = useState(false);
    const selectAllCheckboxId = useId();
    const filteredOptions = useMemo(() => {
        return options.filter((option) => option.label.toLowerCase().includes(searchQueryText.toLowerCase()));
    }, [options, searchQueryText]);
    const renderPills = useCallback(() => {
        return selectedValues.map((option) => (React__default.createElement(Chip, { key: option.id, customClass: "mr-2", onClick: () => {
                const updatedData = selectedValues?.filter((selectedOption) => selectedOption.id !== option.id);
                onChange(updatedData);
            }, truncate: true }, option.label)));
    }, [selectedValues]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ChipContainer, { onClick: (e) => {
                e.preventDefault();
                setPillContainerModal(true);
            }, maxWidth: "90%" }, renderPills()),
        React__default.createElement(TextInput, { type: "text", placeholder: inputPlaceholder, suffix: React__default.createElement(Icon, { name: inputIcon }), customClass: "mb-3", onChange: (e) => setSearchQueryText(e?.target?.value) }),
        React__default.createElement("div", { className: "border-neutral-10 bg-primary-10 dark:border-neutral-dark-20 dark:bg-neutral-dark-20 border border-solid px-4 py-2" },
            React__default.createElement(Checkbox, { id: `select-all-search-${selectAllCheckboxId}`, customClass: "items-center", checked: selectedValues.length === options.length, onChange: (e) => {
                    const checked = e.target.checked;
                    onChange(checked ? options : []);
                }, variant: "square" }, "Select All")),
        React__default.createElement("ul", { className: cn("border-neutral-10 dark:border-neutral-dark-20 border border-solid", customClass) }, filteredOptions?.map((item) => {
            const isItemSelected = selectedValues.some((selectedValue) => selectedValue.id === item.id);
            return (React__default.createElement(SelectableListItem, { selected: isItemSelected, key: item.id },
                React__default.createElement(Checkbox, { id: item.id.toString(), customClass: "mr-2 items-center", variant: "square", checked: isItemSelected, onChange: (e) => {
                        const checked = e.target.checked;
                        if (checked) {
                            onChange([...selectedValues, item]);
                        }
                        else {
                            const updatedData = selectedValues.filter((selectedValue) => selectedValue.id !== item.id);
                            onChange(updatedData);
                        }
                    } }, item?.label)));
        })),
        React__default.createElement(Modal, { variant: "curvedEdge", title: modalTitle, isOpen: pillContainerModal, toggleModal: () => setPillContainerModal(!pillContainerModal), fullWidth: true, contentHeightMax: false },
            React__default.createElement("div", { className: "overflow-auto px-2", style: { maxHeight: "280px" } }, renderPills()),
            React__default.createElement("div", { className: "px-2" },
                React__default.createElement(Button, { variant: "primary", type: "button", size: "sm", fullwidth: true, customClass: "mb-4", onClick: () => {
                        onChange([]);
                        setPillContainerModal(false);
                    } }, "Clear all")))));
};

const SnippetList = ({ ...props }) => {
    let defaultClasses = `-mr-2 -ml-2 flex flex-wrap`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("ul", { className: defaultClasses }, props.children);
};

const SnippetListItem = ({ ...props }) => {
    let snippetItemClasses = `leading-tight px-2 initial:text-size-10 text-neutral-40 border-l border-neutral-40 border-solid first:border-0`;
    snippetItemClasses = props.customClass
        ? `${snippetItemClasses} ${props.customClass}`
        : `${snippetItemClasses}`;
    return React__default.createElement("li", { className: snippetItemClasses }, props.children);
};

const Drawer = ({ variant = "default", fullWidth = false, children, isOpen, toggleDrawer, customClass, }) => {
    let defaultClasses = `origin-bottom   justify-end 
   h-full max-h-screen w-full z-50 fixed left-0 right-0 top-0 bottom-0 `;
    let customWidthClasses = `${defaultClasses} m-auto sm:max-w-29`;
    let drawerContainerClasses = fullWidth ? defaultClasses : customWidthClasses;
    let defaultMaskClasses = `drawer-mask absolute top-0 bottom-0 w-full z-50 left-0 right-0 z-20 bg-neutral-dark-110/[.9] dark:bg-neutral-dark-0/[.9] backdrop-blur-sm`;
    let drawerwrapperClasses = customClass
        ? `${drawerContainerClasses} ${customClass}`
        : `${drawerContainerClasses}`;
    let maskClasses = customClass
        ? `${defaultMaskClasses} ${customClass}`
        : `${defaultMaskClasses}`;
    let drawerClasses = `drawer shadow-txl dark:shadow-none bg-neutral-0 relative z-50 dark:bg-neutral-dark-5 w-80`;
    let closeDrawerClasses = `${drawerwrapperClasses} hidden`;
    let openDrawerClasses = `${drawerwrapperClasses} flex`;
    const close = () => toggleDrawer(false);
    const drawerVariant = {
        default: () => {
            return (React__default.createElement("div", { className: isOpen ? openDrawerClasses : closeDrawerClasses },
                React__default.createElement("div", { className: maskClasses, onClick: close }),
                React__default.createElement("div", { className: drawerClasses },
                    React__default.createElement("i", { onClick: close, className: "cursor-pointer absolute right-6 top-3" },
                        React__default.createElement(IconList, { name: "Close", className: "h-8 w-8" })),
                    React__default.createElement("div", { className: "max-80vh overflow-y-auto" }, children))));
        },
    };
    const render = () => {
        return drawerVariant[variant]();
    };
    return render();
};

const Avatar = ({ ...props }) => {
    let defaultClasses = `font-opensans text-neutral-110 initial:text-size-32 dark:text-neutral-dark-80
  rounded-full initial:w-14 initial:h-14 bg-neutral-10 flex items-center justify-center dark:bg-neutral-dark-10`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const DataCard = ({ children, variant = "default", footer, ...props }) => {
    const _args = { onClick: props.onClick };
    let wrapperDefaultClasses = `cursor-pointer rounded-md border border-solid border-neutral-10 mb-4 dark:border-neutral-dark-10`;
    wrapperDefaultClasses = props.customClass
        ? `${wrapperDefaultClasses} ${props.customClass}`
        : wrapperDefaultClasses;
    let wrapperClasses = props.selected
        ? `${wrapperDefaultClasses} border-primary dark:border-border-primary-dark`
        : `${wrapperDefaultClasses} border-neutral-10 dark:border-neutral-dark-10`;
    const DataCardVariant = {
        default: () => {
            return (React__default.createElement("div", { className: wrapperClasses, ..._args },
                React__default.createElement("div", null, children),
                footer ? (React__default.createElement("div", { className: "px-4 py-4 flex justify-between items-center" },
                    React__default.createElement("div", { className: "basis-1/2 text-center" }, footer.leftCol),
                    React__default.createElement("div", { className: "basis-1/2" }, footer.rightCol))) : null));
        },
    };
    const render = () => {
        return DataCardVariant[variant]();
    };
    return render();
};

const Banner = ({ ...props }) => {
    let defaultClasses = `font-opensans bg-primary-10 dark:bg-neutral-dark-10 px-4 py-2`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const Spotlight = ({ customClass, logo, placeholder, ...props }) => {
    let fundWrapClasses = `pb-1`;
    let fundClasses = customClass
        ? `${fundWrapClasses} ${customClass}`
        : `${fundWrapClasses}`;
    let dummyLogoClasses = `mr-2 bg-neutral-10 rounded-full p-1  w-6 h-6 
    md:w-9 md:h-9 flex-shrink-0 flex justify-center items-center`;
    let titleClasses = `font-opensans text-size-base font-semibold text-neutral leading-snug dark:text-neutral-dark-110 mb-1`;
    return (React__default.createElement("section", { className: fundClasses },
        React__default.createElement("div", { className: "flex  mb-2" },
            logo ? (React__default.createElement("div", { className: "mr-2" },
                React__default.createElement("img", { src: logo, alt: logo, className: "w-10" }))) : (React__default.createElement("div", null, placeholder ? React__default.createElement("div", { className: dummyLogoClasses }) : null)),
            React__default.createElement("div", { className: "flex-1" },
                React__default.createElement("h5", { className: titleClasses }, props.title),
                React__default.createElement("div", null, props.children))),
        React__default.createElement("div", { className: titleClasses }, props.subTitle)));
};

function SearchAutocomplete({ variant = "default", value, options, searchAttribute, placeholder, disabled, onChange, autocomplete = "off", getQueryText, shouldFocusAndSelectInputOnDropdown, }) {
    const borderlessInputRef = useRef(null);
    const [query, setQuery] = useState("");
    let inputwrapClasses = ` 
    relative w-full cursor-default overflow-hidden rounded-md 
    border border-solid border-neutral-10 dark:border-neutral-dark-10
    text-left  
    focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-primary`;
    let inputBgClasses = chooseBinaryClass(Boolean(disabled), `cursor-not-allowed bg-neutral-10 hover:bg-neutral-10 dark:bg-neutral-dark-20 hover:dark:bg-neutral-dark-20 dark:text-neutral-40 text-neutral-40`, `bg-neutral-5 dark:bg-neutral-dark-10 text-neutral-dark-0 dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-5 hover:bg-white`);
    let inputClasses = `h-12 w-full rounded-md border-none py-2 pl-4 pr-12 text-size-base focus:outline-none focus:ring-0 dark:border-neutral-dark-10 ${inputBgClasses}`;
    let inputwrapBorderlessClasses = `relative w-full cursor-default overflow-hidden text-left focus:outline-none rounded-md border border-solid border-neutral-10 dark:border-neutral-dark-10`;
    let inputBorderlessBgClasses = chooseBinaryClass(Boolean(disabled), `cursor-not-allowed bg-neutral-10 hover:bg-neutral-10 dark:bg-neutral-dark-20 hover:dark:bg-neutral-dark-20 dark:text-neutral-40 text-neutral-40`, `bg-neutral-0 text-neutral-dark-0 dark:text-neutral-dark-110`);
    let inputBorderlessClasses = `w-full border-none text-size-14 font-medium focus:ring-0  px-2 py-1 focus:outline-none ${inputBorderlessBgClasses} ${inputBgClasses}`;
    let searchIconClasses = `absolute inset-y-0 right-3 top-1/2 -translate-y-1/2 flex items-center pointer-events-none
  absolute inset-y-0 right-3 top-1/2 -translate-y-1/2 flex items-center pointer-events-none`;
    let comboboxOptionsClasses = `left-0 right-0 absolute z-10 mt-1 overflow-y-auto shadow-6xl dark:shadow-none rounded-md bg-neutral-0 dark:bg-neutral-dark-10 dark:text-neutral-dark-110 dark:border dark:border-solid dark:border-neutral-dark-5 max-h-56`;
    let titleClasses = `text-neutral-60 font-opensans text-size-12 dark:text-neutral-dark-80`;
    const filteredOptions = query === ""
        ? options
        : options.filter((option) => {
            return option[searchAttribute].toLowerCase().includes(query.toLowerCase());
        });
    function renderDefaultVariant() {
        return (React__default.createElement(Combobox, { value: value, disabled: disabled, onChange: onChange, nullable: true },
            React__default.createElement("div", { className: "relative mt-1" },
                React__default.createElement("div", { className: inputwrapClasses },
                    React__default.createElement(Combobox.Input, { className: inputClasses, onChange: (e) => {
                            setQuery(e.target.value);
                            getQueryText?.(e.target.value);
                        }, displayValue: (value) => value?.[searchAttribute], autoComplete: autocomplete }),
                    React__default.createElement(Sanitize, { check: Boolean(value) },
                        React__default.createElement("button", { onClick: () => onChange(null), className: "absolute right-0 h-12 px-3" },
                            React__default.createElement(Icon, { name: "Close" }))),
                    React__default.createElement(Sanitize, { check: !Boolean(value) },
                        React__default.createElement(Icon, { name: "Search", className: searchIconClasses }))),
                React__default.createElement(Transition, { as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => setQuery("") },
                    React__default.createElement(Combobox.Options, { className: comboboxOptionsClasses }, filteredOptions.map((option) => {
                        return (React__default.createElement("div", { key: option.id, className: "border-neutral-10 dark:border-neutral-dark-5 cursor-pointer border-b border-solid" },
                            React__default.createElement(Combobox.Option, { value: option, as: Fragment }, ({ active, selected }) => {
                                return (React__default.createElement("li", { className: `dark:text-neutral-dark-110 px-3 py-3 ${chooseBinaryClass(active, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` }, option[searchAttribute]));
                            })));
                    }))))));
    }
    function renderFundVariant() {
        return (React__default.createElement(Combobox, { value: value, disabled: disabled, onChange: onChange, nullable: true },
            React__default.createElement("div", { className: "relative mt-1" },
                React__default.createElement("div", { className: inputwrapClasses },
                    React__default.createElement(Combobox.Input, { className: inputClasses, onChange: (e) => setQuery(e.target.value), displayValue: (value) => value?.[searchAttribute], autoComplete: autocomplete }),
                    React__default.createElement(Sanitize, { check: Boolean(value) },
                        React__default.createElement("button", { onClick: () => onChange(null), className: "absolute right-0 h-12 px-3" },
                            React__default.createElement(Icon, { name: "Close" }))),
                    React__default.createElement(Sanitize, { check: !Boolean(value) },
                        React__default.createElement(Icon, { name: "Search", className: searchIconClasses }))),
                React__default.createElement(Transition, { as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => setQuery("") },
                    React__default.createElement(Combobox.Options, { className: comboboxOptionsClasses }, filteredOptions.map((option) => {
                        return (React__default.createElement("div", { key: option.id },
                            React__default.createElement(Combobox.Option, { value: option, as: Fragment }, ({ active, selected }) => {
                                return (React__default.createElement("div", { className: `border-neutral-10 dark:border-neutral-dark-5 cursor-pointer border-b border-solid px-3 py-3 ${chooseBinaryClass(active, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` },
                                    React__default.createElement("h5", { className: titleClasses }, option.fundName),
                                    React__default.createElement(Sanitize, { check: option.type || option.risk || option.rating },
                                        React__default.createElement(SnippetList, null,
                                            React__default.createElement(Sanitize, { check: option.type },
                                                React__default.createElement(SnippetListItem, null, option.type)),
                                            React__default.createElement(Sanitize, { check: option.risk },
                                                React__default.createElement(SnippetListItem, null, option.risk)),
                                            React__default.createElement(Sanitize, { check: option.rating },
                                                React__default.createElement(SnippetListItem, null,
                                                    React__default.createElement("div", { className: "flex items-center" },
                                                        React__default.createElement(Icon, { name: "Star", className: "mr-1 h-2 w-2" }),
                                                        React__default.createElement("span", null, option.rating))))))));
                            })));
                    }))))));
    }
    function renderAutoCompleteVariant() {
        return (React__default.createElement(Combobox, { value: value, disabled: disabled, onChange: onChange, nullable: true }, ({ open }) => (React__default.createElement("div", { className: "relative mt-1" },
            React__default.createElement("div", { className: inputwrapClasses },
                React__default.createElement(Combobox.Input, { className: inputClasses, onChange: (e) => setQuery(e.target.value), displayValue: (value) => value?.[searchAttribute], placeholder: sanitizeString(placeholder), autoComplete: autocomplete }),
                !disabled && value ? (React__default.createElement("button", { onClick: () => onChange(null), className: "absolute right-0 h-12 px-3" },
                    React__default.createElement(Icon, { name: "Close" }))) : (React__default.createElement(Combobox.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2" },
                    React__default.createElement(Icon, { name: "DownArrow", className: `duration-300 ease-in ${chooseBinaryClass(open, "rotate-180", "")}` })))),
            React__default.createElement(Transition, { as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => setQuery("") },
                React__default.createElement(Combobox.Options, { className: comboboxOptionsClasses }, filteredOptions.map((option) => {
                    return (React__default.createElement("div", { key: option.id, className: "border-neutral-10 dark:border-neutral-dark-5 cursor-pointer border-b border-solid" },
                        React__default.createElement(Combobox.Option, { value: option, as: Fragment }, ({ active, selected }) => {
                            return (React__default.createElement("li", { className: `dark:text-neutral-dark-110 px-3 py-3  ${chooseBinaryClass(active, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` }, option[searchAttribute]));
                        })));
                })))))));
    }
    function renderBorderlessVariant() {
        return (React__default.createElement(Combobox, { value: value, disabled: disabled, onChange: onChange, nullable: true }, ({ open }) => (React__default.createElement("div", { className: "relative mt-1" },
            React__default.createElement("div", { className: inputwrapBorderlessClasses },
                React__default.createElement(Combobox.Input, { className: inputBorderlessClasses, onChange: (e) => setQuery(e.target.value), displayValue: (value) => value?.[searchAttribute], placeholder: sanitizeString(placeholder), ref: borderlessInputRef, autoComplete: autocomplete }),
                React__default.createElement(Combobox.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2", onClick: () => {
                        if (shouldFocusAndSelectInputOnDropdown) {
                            borderlessInputRef.current?.focus();
                            borderlessInputRef.current?.select();
                        }
                    } },
                    React__default.createElement(Icon, { name: "DownArrow", className: `duration-300 ease-in ${chooseBinaryClass(open, "rotate-180", "")}` }))),
            React__default.createElement(Transition, { as: Fragment, leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterLeave: () => setQuery("") },
                React__default.createElement(Combobox.Options, { className: comboboxOptionsClasses, style: { maxWidth: "200px", minWidth: "175px", top: "35px", maxHeight: "390px" } }, filteredOptions.map((option) => {
                    return (React__default.createElement("li", { key: option.id, className: "cursor-pointer" },
                        React__default.createElement(Combobox.Option, { value: option, as: Fragment }, ({ active, selected }) => {
                            return (React__default.createElement("div", { className: `dark:text-neutral-dark-110 py-1.5 px-4  ${chooseBinaryClass(active, "bg-neutral-5 text-neutral-dark-0 dark:bg-neutral-dark-0", "bg-transparent")}` }, option[searchAttribute]));
                        })));
                })))))));
    }
    const renderContent = () => {
        switch (variant) {
            case "default":
                return renderDefaultVariant();
            case "fund":
                return renderFundVariant();
            case "autocomplete":
                return renderAutoCompleteVariant();
            case "borderless":
                return renderBorderlessVariant();
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return renderContent();
}

const Container = ({ children, customClass, variant = "default", }) => {
    let containerClasses = `container m-auto`;
    containerClasses = customClass
        ? `${containerClasses} ${customClass}`
        : `${containerClasses}`;
    const containerVariant = {
        default: () => {
            return React__default.createElement("div", { className: containerClasses }, children);
        },
    };
    const render = () => {
        return containerVariant[variant]();
    };
    return render();
};

const InfoCard = ({ variant = "default", status, icon, disabled, title, subtitle, onClick, ...props }) => {
    let InfoCardBasic = `flex bg-neutral-5 initial:px-2 py-2 rounded-md border border-solid initial:mb-2`;
    let InfoCardDefault = `border-neutral-10 dark:bg-neutral-dark-10 dark:border-neutral-dark-20  text-neutral-110 dark:text-neutral-dark-80`;
    let InfoCardStyles = disabled
        ? `${InfoCardBasic} text-neutral-20 dark:bg-neutral-dark-5 dark:bg-neutral-dark-20 dark:text-neutral-dark-40 dark:border-neutral-dark-20 step-disabled`
        : `${InfoCardBasic} ${InfoCardDefault}`;
    // Conditionally add "clickable" class if onClick is provided
    InfoCardStyles = onClick ? `${InfoCardStyles} cursor-pointer` : `${InfoCardStyles}`;
    let infoCardPlusStyles = `${InfoCardStyles} flex items-center relative overflow-hidden pl-4`;
    let statusIcon;
    switch (status) {
        case "success":
            statusIcon = "SuccessTick";
            break;
        case "error":
            statusIcon = "AlertFilled";
            break;
        case "resume":
            statusIcon = "Resume";
            break;
        default:
            statusIcon = "Default";
            break;
    }
    let statusPlusIcon;
    let statusBorder = ``;
    switch (status) {
        case "success":
            statusPlusIcon = "SuccessTick";
            statusBorder = `bg-success`;
            break;
        case "error":
            statusPlusIcon = "AlertFilled";
            statusBorder = `bg-error`;
            break;
        case "resume":
            statusPlusIcon = "Resume";
            statusBorder = `bg-warning`;
            break;
        default: // You can set a default icon here if needed
            statusPlusIcon = "Default";
            statusBorder = ``;
            break;
    }
    const selectedIcon = status ? statusIcon : icon;
    const selectedPlusIcon = status ? statusPlusIcon : icon;
    statusBorder = `absolute w-1 block left-0 h-full ${statusBorder}`;
    const loaderVariant = {
        default: () => {
            return (React__default.createElement("li", { className: InfoCardStyles, onClick: onClick },
                React__default.createElement("span", { className: "mr-4 w-5 flex-shrink-0" }, selectedIcon && React__default.createElement(Icon, { name: selectedIcon })),
                React__default.createElement("div", { className: "font-opensans flex flex-1 font-semibold" },
                    React__default.createElement("div", { className: "flex-1" }, props.children),
                    onClick && (React__default.createElement("span", { className: "ml-2 w-5 flex-shrink-0" },
                        React__default.createElement(Icon, { name: "rightArrow" }))))));
        },
        plus: () => {
            return (React__default.createElement("li", { className: infoCardPlusStyles, onClick: onClick },
                status && React__default.createElement("span", { className: statusBorder }),
                React__default.createElement("div", { className: "flex-1" },
                    title && React__default.createElement("h5", null, title),
                    subtitle && (React__default.createElement("div", { className: "flex items-start" },
                        selectedPlusIcon && (React__default.createElement("span", { className: "mr-2 w-4 flex-shrink-0" },
                            React__default.createElement(Icon, { name: selectedPlusIcon, className: "h-4 w-4" }))),
                        React__default.createElement("p", { className: "text-neutral-60 text-size-12 dark:text-neutral-dark-80" }, subtitle)))),
                onClick && (React__default.createElement("span", { className: "ml-2 w-5 flex-shrink-0" },
                    React__default.createElement(Icon, { name: "rightArrow" })))));
        },
    };
    const render = () => {
        return loaderVariant[variant]();
    };
    return render();
};

const predefinedColorPalettes = {
    bright: ["#FFD976", "#FA8C16", "#E44632", "#009666", "#2955D9", "#E967E4", "#722ED1"],
    dull: ["#EABE6E", "#D67C1C", "#A52535", "#5E7D56", "#37509B", "#DFB5DD", "#7B5AA9"],
    neutral: ["#E8E8E8", "#C7C7C7", "#A4A4A4", "#828282", "#5B5B5B", "#505050", "#383838"],
};
function DoughnutChart(props) {
    const { chartData, innerRadius, colorPalette } = props;
    const [data, setData] = useState(null);
    useEffect(() => {
        const modifiedChartData = {
            ...chartData,
        };
        if (colorPalette && predefinedColorPalettes[colorPalette]) {
            modifiedChartData["datasets"][0]["backgroundColor"] = predefinedColorPalettes[colorPalette];
        }
        setData(modifiedChartData);
    }, [chartData, innerRadius, colorPalette]);
    function labelCallback(context) {
        if (context?.dataset?.customLegendLabel) {
            return context?.dataset?.customLegendLabel[context.dataIndex];
        }
        return sanitizeString(context?.label); // Fallback to label if customLegendLabel is not available
    }
    function afterLabelCallback(context) {
        if (context?.dataset?.customLegendValue) {
            return context?.dataset?.customLegendValue[context.dataIndex];
        }
        return ""; // No customLegendValue available
    }
    useEffect(() => {
        if (data) {
            const ctx = document.getElementById("doughnutChart");
            new Chart(ctx, {
                type: "doughnut",
                data: data,
                options: {
                    cutout: innerRadius ? `${innerRadius}%` : "0%",
                    plugins: {
                        legend: {
                            display: false,
                        },
                        datalabels: {
                            color: "#6F809E",
                            align: "end",
                            anchor: "end",
                            formatter: function (value, context) {
                                return context?.chart?.data?.labels?.[context.dataIndex] ?? value;
                            },
                            font: {
                                size: 11,
                                weight: "bold",
                            },
                        },
                        tooltip: {
                            backgroundColor: "#F0F0F0",
                            callbacks: {
                                label: labelCallback,
                                afterLabel: afterLabelCallback,
                                title: function (context) {
                                    return sanitizeString(context?.title); // Fallback to title if customLegendLabel is not available
                                },
                                labelTextColor: (context) => {
                                    return "#000000";
                                },
                                labelPointStyle: function (context) {
                                    return {
                                        pointStyle: "circle",
                                        rotation: 0,
                                    };
                                },
                            },
                        },
                    },
                    layout: {
                        padding: {
                            left: 40,
                            right: 40,
                            top: 30,
                            bottom: 30,
                        },
                    },
                },
                plugins: [ChartJSPluginDataLabels],
            });
        }
    }, [data, innerRadius, colorPalette]);
    const isCustomLegendEnabled = data?.datasets?.[0]?.customLegendLabel && data?.datasets?.[0]?.customLegendValue;
    function getBasisClass(isCustomLegendEnabled) {
        return isCustomLegendEnabled
            ? "md:basis-3/5 md:w-3/5 w-1/2 basis-3/4 flex justify-center"
            : "basis-full";
    }
    const basisClass = getBasisClass(isCustomLegendEnabled);
    function renderCustomLegend() {
        if (!isCustomLegendEnabled)
            return null;
        return (React__default.createElement("div", { className: "custom-legends max-h-72 shrink-0  basis-1/4 overflow-y-auto pr-1 md:basis-2/5 md:pr-2" }, data?.datasets?.[0]?.customLegendLabel?.map((legendData, index) => {
            const label = legendData;
            const value = data?.datasets?.[0]?.customLegendValue?.[index];
            const legendBackgroundColor = data?.datasets?.[0]?.backgroundColor?.[index];
            const uniqueKey = `${legendBackgroundColor}${label}${value}`;
            return (React__default.createElement("div", { key: uniqueKey, className: "font-roboto text-size-10 md:text-size-12 mb-4 font-normal" },
                React__default.createElement("div", { className: "text-neutral-40 dark:text-neutral-40 flex font-bold" },
                    React__default.createElement("i", { className: "mr-1 mt-1 block h-2 w-2 shrink-0 rounded-full", style: { backgroundColor: legendBackgroundColor } }),
                    label,
                    ":"),
                React__default.createElement("div", { className: "text-neutral-dark-0 dark:text-neutral-dark-110 pl-3 font-bold" }, value)));
        })));
    }
    function render() {
        if (!data)
            return React__default.createElement(React__default.Fragment, null);
        return (React__default.createElement("div", { className: "container flex items-center justify-center" },
            renderCustomLegend(),
            React__default.createElement("div", { className: basisClass },
                React__default.createElement("canvas", { id: "doughnutChart" }))));
    }
    return render();
}

const Row = ({ customClass, children }) => {
    const rowClasses = `flex flex-row -mr-2 -ml-2 flex-wrap ${customClass || ""}`;
    return React__default.createElement("div", { className: rowClasses }, children);
};

const Col = ({ span, verticalGap = true, customClass, children }) => {
    let colClasses = "flex-grow pr-2 pl-2";
    if (span) {
        colClasses += span === 12 ? " w-full" : ` w-${span}/12`;
    }
    else {
        colClasses += " max-w-1/2 flex-basis-1/2";
    }
    if (verticalGap) {
        colClasses += " mb-3"; // Add vertical spacing class if verticalGap is true
    }
    if (customClass) {
        colClasses += ` ${customClass}`;
    }
    return React__default.createElement("div", { className: colClasses }, children);
};

const MultiSelector = ({ customClass, value: selectedValues = [], options, onChange, // Include the onChange prop
enableSelectAll = false, disabled = false, }) => {
    const [selectAll, setSelectAll] = useState(() => {
        return selectedValues.length === options.length;
    });
    let iconClasses = `w-3 h-3 text-blue-600 pointer-events-none fill-primary`;
    return (React__default.createElement("div", null,
        React__default.createElement(Combobox, { multiple: true, disabled: disabled, value: selectedValues, onChange: (selectedValue) => {
                if (enableSelectAll) {
                    if (selectedValue.length === options.length) {
                        !selectAll && setSelectAll(true);
                    }
                    else {
                        selectAll && setSelectAll(false);
                    }
                }
                onChange?.(selectedValue);
            } }, ({ open }) => (React__default.createElement("div", { className: "relative" },
            React__default.createElement(Combobox.Button, { className: "border-neutral-10 bg-neutral-5 text-size-base text-neutral-dark-0 dark:border-neutral-dark-10 dark:border-neutral-dark-10 dark:bg-neutral-dark-10 dark:text-neutral-dark-110 dark:hover:bg-neutral-dark-5  w-full rounded-md border border-solid py-2  pl-4 pr-6 text-left hover:bg-white focus:outline-none" }, selectedValues.length > 0 ? (selectedValues.map((option) => option.label).join(", ")) : (React__default.createElement("span", { className: "text-neutral-20" }, "Select"))),
            React__default.createElement(Combobox.Options, { className: "bg-neutral-0 text-neutral-dark-0 shadow-6xl dark:border-neutral-dark-5 dark:bg-neutral-dark-10 dark:text-neutral-dark-110 absolute z-10 max-h-60 w-full overflow-auto text-base focus:outline-none dark:border dark:border-solid dark:shadow-none" },
                enableSelectAll && (React__default.createElement("li", { className: "bg-primary-10 py-2 px-4" },
                    React__default.createElement(Checkbox, { variant: "square", id: "selectAll", name: "selectAll", customClass: "customClassName", checked: selectAll, onChange: (e) => {
                            const selected = e.target.checked;
                            onChange?.(selected ? options : []);
                            setSelectAll(selected);
                        } }, "Select All"))),
                options.map((option) => (React__default.createElement(Combobox.Option, { key: option.id, value: option, className: ({ active }) => `${active
                        ? "bg-neutral-10 text-neutral-dark-0 dark:bg-neutral-dark-0  dark:text-neutral-10"
                        : "text-neutral-dark-0 dark:text-neutral-40"}
                       relative cursor-default select-none py-2 pl-4 pr-4` }, ({ selected, active }) => (React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement("span", { className: "mr-1 block" },
                        React__default.createElement("span", { className: "border-primary dark:border-primary-dark mr-2 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-sm border-2" }, selected && (React__default.createElement("span", { className: `${active ? "text-neutral-dark-0 dark:text-neutral-10" : "text-primary"}
                              inset-y-0 left-0 flex items-center` },
                            React__default.createElement(Icon, { name: "Check", className: iconClasses }))))),
                    React__default.createElement("span", { className: `${selected ? "dark:text-neutral-10 font-medium" : "font-normal"} block truncate` }, option.label))))))))))));
};

const NoRowsOverlay = () => (React.createElement("svg", { width: "198", height: "150", className: "mb-4", viewBox: "0 0 198 150", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0_842_8271)" },
        React.createElement("path", { d: "M195.233 3.05176e-05H2.76549C2.03203 0.000841571 1.32884 0.291576 0.810199 0.80844C0.291562 1.3253 -0.000162727 2.02609 -0.000976562 2.75704V132.73C-0.000161683 133.461 0.291563 134.162 0.810199 134.679C1.32884 135.196 2.03203 135.487 2.76549 135.487H195.233C195.966 135.487 196.669 135.196 197.188 134.679C197.706 134.162 197.998 133.461 197.999 132.73V2.75704C197.998 2.02609 197.706 1.3253 197.188 0.80844C196.669 0.291576 195.966 0.000841571 195.233 3.05176e-05ZM197.209 132.73C197.208 133.253 197 133.753 196.63 134.123C196.259 134.492 195.757 134.699 195.233 134.7H2.76549C2.24147 134.699 1.73898 134.492 1.36844 134.123C0.997906 133.753 0.789652 133.253 0.789443 132.73V2.75704C0.789652 2.23482 0.997906 1.73404 1.36844 1.36477C1.73898 0.995505 2.24147 0.787957 2.76549 0.787748H195.233C195.757 0.787957 196.259 0.995505 196.63 1.36477C197 1.73404 197.208 2.23482 197.209 2.75704V132.73Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M197.603 11.0442H0.393555V11.8319H197.603V11.0442Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M7.11149 8.26967C8.4211 8.26967 9.48275 7.21165 9.48275 5.90652C9.48275 4.60138 8.4211 3.54337 7.11149 3.54337C5.80188 3.54337 4.74023 4.60138 4.74023 5.90652C4.74023 7.21165 5.80188 8.26967 7.11149 8.26967Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M13.9308 8.26967C15.2404 8.26967 16.3021 7.21165 16.3021 5.90652C16.3021 4.60138 15.2404 3.54337 13.9308 3.54337C12.6212 3.54337 11.5596 4.60138 11.5596 5.90652C11.5596 7.21165 12.6212 8.26967 13.9308 8.26967Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M20.7472 8.26967C22.0568 8.26967 23.1185 7.21165 23.1185 5.90652C23.1185 4.60138 22.0568 3.54337 20.7472 3.54337C19.4376 3.54337 18.376 4.60138 18.376 5.90652C18.376 7.21165 19.4376 8.26967 20.7472 8.26967Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M159.594 37.9938H37.0789C35.4542 37.9938 33.8961 37.3507 32.7473 36.2058C31.5985 35.0609 30.9531 33.5081 30.9531 31.889C30.9531 30.2699 31.5985 28.7171 32.7473 27.5723C33.8961 26.4274 35.4542 25.7842 37.0789 25.7842H159.594C161.218 25.7842 162.777 26.4274 163.925 27.5723C165.074 28.7171 165.72 30.2699 165.72 31.889C165.72 33.5081 165.074 35.0609 163.925 36.2058C162.777 37.3507 161.218 37.9938 159.594 37.9938ZM37.0789 26.5719C35.6639 26.5719 34.3068 27.1321 33.3062 28.1293C32.3057 29.1264 31.7435 30.4788 31.7435 31.889C31.7435 33.2992 32.3057 34.6516 33.3062 35.6488C34.3068 36.6459 35.6639 37.2061 37.0789 37.2061H159.594C161.009 37.2061 162.366 36.6459 163.367 35.6488C164.367 34.6516 164.929 33.2992 164.929 31.889C164.929 30.4788 164.367 29.1264 163.367 28.1293C162.366 27.1321 161.009 26.5719 159.594 26.5719H37.0789Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M68.6967 69.1074H44.9841C43.3595 69.1074 41.8014 68.4643 40.6526 67.3194C39.5038 66.1745 38.8584 64.6217 38.8584 63.0026C38.8584 61.3835 39.5038 59.8308 40.6526 58.6859C41.8014 57.541 43.3595 56.8978 44.9841 56.8978H68.6967C70.3214 56.8978 71.8795 57.541 73.0283 58.6859C74.1771 59.8308 74.8225 61.3835 74.8225 63.0026C74.8225 64.6217 74.1771 66.1745 73.0283 67.3194C71.8795 68.4643 70.3214 69.1074 68.6967 69.1074ZM44.9841 57.6855C43.5691 57.6855 42.2121 58.2457 41.2115 59.2429C40.2109 60.24 39.6488 61.5925 39.6488 63.0026C39.6488 64.4128 40.2109 65.7652 41.2115 66.7624C42.2121 67.7595 43.5691 68.3197 44.9841 68.3197H68.6967C70.1117 68.3197 71.4688 67.7595 72.4694 66.7624C73.4699 65.7652 74.0321 64.4128 74.0321 63.0026C74.0321 61.5925 73.4699 60.24 72.4694 59.2429C71.4688 58.2457 70.1117 57.6855 68.6967 57.6855H44.9841Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M68.6967 89.5882H44.9841C43.3595 89.5882 41.8014 88.945 40.6526 87.8001C39.5038 86.6552 38.8584 85.1024 38.8584 83.4834C38.8584 81.8643 39.5038 80.3115 40.6526 79.1666C41.8014 78.0217 43.3595 77.3785 44.9841 77.3785H68.6967C70.3214 77.3785 71.8795 78.0217 73.0283 79.1666C74.1771 80.3115 74.8225 81.8643 74.8225 83.4834C74.8225 85.1024 74.1771 86.6552 73.0283 87.8001C71.8795 88.945 70.3214 89.5882 68.6967 89.5882ZM44.9841 78.1663C43.5691 78.1663 42.2121 78.7265 41.2115 79.7236C40.2109 80.7208 39.6488 82.0732 39.6488 83.4834C39.6488 84.8935 40.2109 86.246 41.2115 87.2431C42.2121 88.2403 43.5691 88.8004 44.9841 88.8004H68.6967C70.1117 88.8004 71.4688 88.2403 72.4694 87.2431C73.4699 86.246 74.0321 84.8935 74.0321 83.4834C74.0321 82.0732 73.4699 80.7208 72.4694 79.7236C71.4688 78.7265 70.1117 78.1663 68.6967 78.1663H44.9841Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M68.6967 110.069H44.9841C43.3595 110.069 41.8014 109.426 40.6526 108.281C39.5038 107.136 38.8584 105.583 38.8584 103.964C38.8584 102.345 39.5038 100.792 40.6526 99.6473C41.8014 98.5024 43.3595 97.8592 44.9841 97.8592H68.6967C70.3214 97.8592 71.8795 98.5024 73.0283 99.6473C74.1771 100.792 74.8225 102.345 74.8225 103.964C74.8225 105.583 74.1771 107.136 73.0283 108.281C71.8795 109.426 70.3214 110.069 68.6967 110.069ZM44.9841 98.6469C43.5691 98.6469 42.2121 99.2071 41.2115 100.204C40.2109 101.201 39.6488 102.554 39.6488 103.964C39.6488 105.374 40.2109 106.727 41.2115 107.724C42.2121 108.721 43.5691 109.281 44.9841 109.281H68.6967C70.1117 109.281 71.4688 108.721 72.4694 107.724C73.4699 106.727 74.0321 105.374 74.0321 103.964C74.0321 102.554 73.4699 101.201 72.4694 100.204C71.4688 99.2071 70.1117 98.6469 68.6967 98.6469H44.9841Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M72.2531 34.646H39.0555C38.3218 34.646 37.6182 34.3555 37.0993 33.8385C36.5805 33.3215 36.2891 32.6202 36.2891 31.889C36.2891 31.1578 36.5805 30.4565 37.0993 29.9395C37.6182 29.4225 38.3218 29.132 39.0555 29.132H72.2531C72.9868 29.132 73.6905 29.4225 74.2093 29.9395C74.7281 30.4565 75.0196 31.1578 75.0196 31.889C75.0196 32.6202 74.7281 33.3215 74.2093 33.8385C73.6905 34.3555 72.9868 34.646 72.2531 34.646Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M155.447 33.2683C154.9 33.2683 154.365 33.1067 153.91 32.8037C153.455 32.5008 153.101 32.0702 152.891 31.5664C152.682 31.0626 152.627 30.5083 152.734 29.9735C152.841 29.4387 153.104 28.9474 153.491 28.5618C153.878 28.1763 154.371 27.9137 154.907 27.8073C155.444 27.7009 156 27.7555 156.506 27.9642C157.011 28.1729 157.443 28.5262 157.747 28.9796C158.051 29.433 158.214 29.9661 158.214 30.5113C158.213 31.2423 157.921 31.9431 157.402 32.4599C156.884 32.9768 156.181 33.2675 155.447 33.2683ZM155.447 28.542C155.056 28.542 154.674 28.6575 154.349 28.8739C154.024 29.0903 153.771 29.3979 153.622 29.7577C153.472 30.1176 153.433 30.5135 153.509 30.8955C153.585 31.2775 153.774 31.6284 154.05 31.9038C154.326 32.1793 154.678 32.3668 155.062 32.4428C155.445 32.5188 155.842 32.4798 156.203 32.3307C156.564 32.1817 156.873 31.9293 157.09 31.6054C157.307 31.2816 157.423 30.9008 157.423 30.5113C157.423 29.9892 157.214 29.4887 156.844 29.1195C156.473 28.7503 155.971 28.5426 155.447 28.542Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M159.726 35.7616C159.674 35.7617 159.622 35.7515 159.574 35.7317C159.526 35.7119 159.483 35.6829 159.446 35.6462L156.669 32.8788C156.633 32.8423 156.604 32.7988 156.584 32.7511C156.564 32.7033 156.554 32.6521 156.554 32.6004C156.554 32.5486 156.564 32.4974 156.584 32.4497C156.604 32.4019 156.633 32.3585 156.669 32.3219C156.706 32.2853 156.75 32.2563 156.798 32.2365C156.846 32.2167 156.897 32.2065 156.949 32.2065C157.001 32.2065 157.052 32.2167 157.1 32.2365C157.148 32.2563 157.192 32.2853 157.228 32.3219L160.005 35.0893C160.06 35.1444 160.098 35.2145 160.113 35.2909C160.128 35.3673 160.121 35.4465 160.091 35.5185C160.061 35.5904 160.01 35.6519 159.945 35.6952C159.88 35.7385 159.804 35.7616 159.726 35.7616Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M153.863 66.7453H140.426C139.431 66.7453 138.476 66.3511 137.772 65.6494C137.067 64.9477 136.672 63.996 136.672 63.0037C136.672 62.0113 137.067 61.0596 137.772 60.3579C138.476 59.6562 139.431 59.262 140.426 59.262H153.863C154.859 59.262 155.814 59.6562 156.518 60.3579C157.222 61.0596 157.618 62.0113 157.618 63.0037C157.618 63.996 157.222 64.9477 156.518 65.6494C155.814 66.3511 154.859 66.7453 153.863 66.7453Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M153.863 87.226H140.426C139.431 87.226 138.476 86.8318 137.772 86.1301C137.067 85.4284 136.672 84.4767 136.672 83.4843C136.672 82.492 137.067 81.5403 137.772 80.8386C138.476 80.1369 139.431 79.7427 140.426 79.7427H153.863C154.859 79.7427 155.814 80.1369 156.518 80.8386C157.222 81.5403 157.618 82.492 157.618 83.4843C157.618 84.4767 157.222 85.4284 156.518 86.1301C155.814 86.8318 154.859 87.226 153.863 87.226Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M153.863 107.707H140.426C139.431 107.707 138.476 107.312 137.772 106.611C137.067 105.909 136.672 104.957 136.672 103.965C136.672 102.973 137.067 102.021 137.772 101.319C138.476 100.618 139.431 100.223 140.426 100.223H153.863C154.859 100.223 155.814 100.618 156.518 101.319C157.222 102.021 157.618 102.973 157.618 103.965C157.618 104.957 157.222 105.909 156.518 106.611C155.814 107.312 154.859 107.707 153.863 107.707Z", fill: "#2955D9" })),
    React.createElement("path", { d: "M161.166 135.74C161.17 138.508 160.353 141.218 158.815 143.534C158.492 144.022 158.139 144.49 157.757 144.934C156.861 145.981 155.817 146.895 154.657 147.65C154.342 147.856 154.018 148.049 153.685 148.228C151.952 149.174 150.039 149.754 148.067 149.934C147.619 149.978 147.163 149.998 146.703 149.998C145.443 149.999 144.189 149.838 142.971 149.517C142.281 149.338 141.606 149.107 140.953 148.826C140.618 148.683 140.292 148.529 139.973 148.362C139.205 147.964 138.476 147.498 137.794 146.97C137.477 146.727 137.171 146.47 136.877 146.2C135.116 144.591 133.789 142.575 133.015 140.333C132.242 138.092 132.047 135.696 132.448 133.362C132.849 131.027 133.833 128.828 135.312 126.963C136.791 125.097 138.717 123.624 140.918 122.676C143.118 121.729 145.523 121.336 147.916 121.534C150.309 121.733 152.614 122.515 154.623 123.812C156.632 125.108 158.283 126.877 159.425 128.96C160.567 131.042 161.165 133.373 161.166 135.74V135.74Z", fill: "#2955D9" }),
    React.createElement("path", { d: "M152.935 142.102L149.721 138.899M145.547 131.058C147.587 131.058 149.241 132.706 149.241 134.739M151.458 134.739C151.458 137.993 148.811 140.63 145.547 140.63C142.283 140.63 139.637 137.993 139.637 134.739C139.637 131.486 142.283 128.849 145.547 128.849C148.811 128.849 151.458 131.486 151.458 134.739Z", stroke: "white", strokeWidth: "1.47256", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_842_8271" },
            React.createElement("rect", { width: "198", height: "135.487", fill: "white" })))));

const NoRowsCustomOverlay = () => {
    return (React__default.createElement("div", { className: "font-inter flex flex-col items-center text-center" },
        React__default.createElement(NoRowsOverlay, null),
        React__default.createElement("h4", { className: "text-size-24 text-neutral-110 dark:text-neutral-dark-80 mb-2 font-semibold " }, "No data available"),
        React__default.createElement("p", { className: "dark:text-neutral-40" },
            "There is currently no data to display in this table. Check back later or ",
            React__default.createElement("br", null),
            " adjust your filters.")));
};
const CustomHeaderComponent = (headerProps, gridApiRef) => {
    const { column, displayName } = headerProps;
    const colDef = column?.getColDef();
    return (React__default.createElement("div", { className: `flex ${colDef?.type === "rightAligned" ? "flex-1 justify-between" : "items-center"}` },
        React__default.createElement("div", { className: "relative mr-3 block h-4 w-4 cursor-pointer" },
            React__default.createElement("input", { type: "checkbox", onClick: (event) => {
                    const checkbox = event.currentTarget;
                    gridApiRef?.forEachNode((row) => {
                        gridApiRef?.getRowNode(row?.id)?.setSelected(checkbox.checked);
                    });
                }, className: "ag-grid-checkbox absolute h-4 w-4 cursor-pointer opacity-0" }),
            React__default.createElement("span", { className: "ag-grid-checkbox-check border-soild border-neutral-40 pointer-events-none absolute top-0 left-0 block h-4 w-4 border", style: { borderRadius: "4px" } })),
        displayName));
};
const DataTable = ({ columnDefs, height, fetchData, cacheBlockSize, isRowSelection = false, batchFilters, rowData, onRowSelection, theme = "light", ...props }) => {
    const { rowModelType } = props;
    const gridApiRef = useRef(null);
    const [colDefs, setColDefs] = useState(columnDefs);
    const [sortable, setSortable] = useState(true);
    const showLoading = useCallback(() => {
        gridApiRef?.current?.showLoadingOverlay();
    }, []);
    const ShowNoRows = useCallback(() => {
        gridApiRef?.current.showNoRowsOverlay();
    }, []);
    const hideLoading = useCallback(() => {
        gridApiRef?.current.hideOverlay();
    }, []);
    useEffect(() => {
        if (isRowSelection && columnDefs?.length) {
            const newColumnsDefs = [...colDefs];
            if (newColumnsDefs?.length > 0) {
                newColumnsDefs[0] = {
                    ...newColumnsDefs[0],
                    checkboxSelection: true,
                    headerComponent: (headerProps) => CustomHeaderComponent(headerProps, gridApiRef?.current),
                };
                setColDefs(newColumnsDefs);
            }
        }
    }, []);
    const fetchDataOnFilterOrSortChanged = () => {
        const dataSource = {
            rowCount: undefined,
            getRows: async (params) => {
                const cacheBlockSizeState = gridApiRef?.current?.getCacheBlockState();
                const currentPageLimit = cacheBlockSizeState?.[0].endRow;
                const currentPageNumber = Math.floor(params.endRow / currentPageLimit);
                let lastRow = -1;
                const currentSortModel = Object.keys(params?.sortModel)?.length
                    ? params?.sortModel[0]
                    : undefined;
                if (currentPageNumber === 1) {
                    showLoading();
                }
                const filteredData = (await fetchData?.(currentPageNumber, currentSortModel)) ?? [];
                hideLoading();
                if (filteredData?.length < cacheBlockSize) {
                    lastRow = params?.startRow + filteredData?.length;
                }
                //Only show now rows if fetched data is empty and it's first page
                if (filteredData?.length === 0 && params?.startRow === 0) {
                    setSortable(false);
                    ShowNoRows();
                }
                filteredData?.length
                    ? params.successCallback(filteredData, lastRow)
                    : params.failCallback();
            },
        };
        gridApiRef?.current?.setGridOption("datasource", dataSource);
    };
    useEffect(() => {
        const isBatchFilterPresent = () => {
            if (!batchFilters)
                return false;
            return Array.isArray(batchFilters)
                ? batchFilters.length > 0
                : Object.keys(batchFilters).length > 0;
        };
        if (!isBatchFilterPresent() && !gridApiRef.current) {
            return;
        }
        fetchDataOnFilterOrSortChanged();
    }, [batchFilters]);
    const onGridReady = useCallback(async (gridParams) => {
        gridApiRef.current = gridParams.api;
        const dataSource = {
            rowCount: undefined,
            getRows: async (params) => {
                const cacheBlockSizeState = gridApiRef?.current?.getCacheBlockState();
                const currentPageLimit = cacheBlockSizeState?.[0].endRow;
                const currentPageNumber = Math.floor(params.endRow / currentPageLimit);
                let lastRow = -1;
                const currentSortModel = Object.keys(params?.sortModel)?.length
                    ? params?.sortModel[0]
                    : undefined;
                if (currentPageNumber === 1) {
                    showLoading();
                }
                const data = (await fetchData?.(currentPageNumber, currentSortModel)) ?? [];
                hideLoading();
                if (data?.length < cacheBlockSize) {
                    lastRow = params?.startRow + data?.length;
                }
                //Only show now rows if fetched data is empty and it's first page
                if (data?.length === 0 && params?.startRow === 0) {
                    setSortable(false);
                    ShowNoRows();
                }
                data?.length ? params.successCallback(data, lastRow) : params.failCallback();
            },
        };
        gridParams.api.setGridOption("datasource", dataSource);
    }, []);
    const getRowStyle = (params) => {
        if (params.data === undefined && params?.rowIndex === 0) {
            return { display: "none" };
        }
    };
    const defaultColDef = {
        sortable: sortable,
    };
    const themeClass = theme === "dark" ? "ag-theme-quartz-dark" : "ag-theme-quartz";
    const pixelThemeClass = theme === "dark" ? "ag-theme-pixel-dark" : "ag-theme-pixel";
    return (React__default.createElement("div", { style: { height: height ?? 500 }, className: `${themeClass} ${pixelThemeClass}` }, rowModelType === "clientSide" ? (React__default.createElement(AgGridReact, { rowData: rowData, columnDefs: colDefs, rowSelection: "multiple", getRowStyle: getRowStyle, defaultColDef: defaultColDef, noRowsOverlayComponent: NoRowsCustomOverlay, onRowSelected: () => onRowSelection && onRowSelection(gridApiRef?.current?.getSelectedRows()), ...props })) : (React__default.createElement(AgGridReact, { onGridReady: onGridReady, columnDefs: colDefs, cacheBlockSize: cacheBlockSize, rowSelection: "multiple", getRowStyle: getRowStyle, defaultColDef: defaultColDef, noRowsOverlayComponent: NoRowsCustomOverlay, onRowSelected: () => onRowSelection && onRowSelection(gridApiRef?.current?.getSelectedRows()), ...props }))));
};

const Breadcrumbs = ({ ...props }) => {
    let defaultClasses = ``;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("nav", { "aria-label": "breadcrumb", className: "breadcrumbs" },
        React__default.createElement("ul", { className: "flex flex-wrap list-none font-opensans text-size-14 font-medium" }, React__default.Children.map(props.children, (child, index) => (React__default.createElement("li", { key: index, className: "breadcrumb-item flex items-center initial:text-size-14 font-medium breadcrumb-link text-primary hover:text-primary-dark" },
            child,
            index < props.children.length - 1 && (React__default.createElement("span", { "aria-hidden": "true", className: "breadcrumb-separator inline-block px-2" },
                React__default.createElement(Icon, { name: "rightArrow" }))))))));
};

const BreadcrumbText = ({ ...props }) => {
    let defaultClasses = `breadcrumb-text font-opensans text-size-14 font-medium`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    let statusClass = props.active ? `${defaultClasses} text-neutral-110` : `${defaultClasses} text-primary`;
    return React__default.createElement("span", { className: statusClass }, props.children);
};

const AccordionContext = createContext(null);
const Accordion = ({ expanded = false, variant = "default", onChange, children, bg, }) => {
    const value = useMemo(() => {
        return { expanded, onChange };
    }, [expanded, onChange]);
    let defaultClass = bg
        ? `py-1 bg-neutral-6 rounded-md mb-2 accordion-wrapper dark:bg-neutral-dark-5`
        : `py-2 accordion-wrapper`;
    let panelAccordionClass = `bg-neutral-0 shadow-4xl rounded-lg mb-2 accordion-wrapper dark:bg-neutral-dark-5 dark:border-neutral-dark-10 dark:shadow-transparent`;
    const accordionVariant = {
        default: () => {
            return (React__default.createElement("div", { className: defaultClass },
                React__default.createElement(AccordionContext.Provider, { value: value }, children)));
        },
        panel: () => {
            return (React__default.createElement("div", { className: panelAccordionClass },
                React__default.createElement(AccordionContext.Provider, { value: value }, children)));
        },
    };
    const render = () => {
        return accordionVariant[variant]();
    };
    return render();
};

const AccordionSummary = ({ variant = "default", children, ...props }) => {
    const accordionContext = useContext(AccordionContext);
    let titleWrap = `accordion-summary flex justify-between items-center cursor-pointer font-inter py-1`;
    titleWrap = props.bg ? `${titleWrap} text-neutral-110 font-semibold px-2` : titleWrap;
    let contentWrapper = props.active
        ? `accordion-content-active flex items-center`
        : `flex items-center`;
    let summaryTitle = props.active
        ? `accordion-title font-inter text-neutral-110 font-semibold dark:text-neutral-dark-80`
        : `accordion-title font-inter  text-neutral-60 dark:text-neutral-40`;
    contentWrapper = props.bg
        ? `${contentWrapper} text-size-12 text-neutral-110 py-1 px-2 dark:text-neutral-40`
        : `${contentWrapper} text-size-base`;
    let arrowIconStyles = props.active ? `icon-active ` : ``;
    let paneltitleWrap = `flex justify-between items-center cursor-pointer font-inter p-3`;
    const accordionVariant = {
        default: () => {
            return (React__default.createElement("div", { onClick: (e) => accordionContext?.onChange?.(e, !accordionContext.expanded), className: titleWrap },
                React__default.createElement("div", { className: contentWrapper }, children),
                React__default.createElement("div", { className: "accordion-arrow" }, accordionContext?.expanded ? (React__default.createElement(Icon, { name: "DownArrow", className: `${arrowIconStyles} rotate-180` })) : (React__default.createElement(Icon, { name: "DownArrow", className: arrowIconStyles, fill: "#768395" })))));
        },
        panel: () => {
            return (React__default.createElement("div", { onClick: (e) => accordionContext?.onChange?.(e, !accordionContext.expanded), className: paneltitleWrap },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement("div", { className: summaryTitle }, children)),
                React__default.createElement("div", null, accordionContext?.expanded ? (React__default.createElement(Icon, { name: "DownArrow", className: `${arrowIconStyles} rotate-180` })) : (React__default.createElement(Icon, { name: "DownArrow", className: arrowIconStyles })))));
        },
    };
    const render = () => {
        return accordionVariant[variant]();
    };
    return render();
};

const AccordionDetails = ({ children, variant = "default", ...props }) => {
    const accordionContext = useContext(AccordionContext);
    const displayClass = accordionContext?.expanded ? "block" : "hidden";
    let defaultClass = ``;
    defaultClass = props.bg ? `${defaultClass} text-size-12` : `${defaultClass} pl-8 pr-4`;
    let panelDefaultClass = "p-3";
    const accDetailsVariant = {
        default: () => {
            return (React__default.createElement("div", { className: `${displayClass} ${defaultClass}` }, children));
        },
        panel: () => {
            return (React__default.createElement("div", { className: `${displayClass} ${panelDefaultClass}` }, children));
        },
    };
    const render = () => {
        return accDetailsVariant[variant]();
    };
    return render();
};

const AccordionIcon = ({ customClass = "", ...props }) => {
    let iconStyle = "accordion-icon mr-4";
    iconStyle = addCustomClassToBaseClass(iconStyle, customClass);
    return (React__default.createElement("span", { className: "accordion-icon-wrapper" },
        React__default.createElement(Icon, { name: props.children, className: iconStyle })));
};

const AccordionTitle = ({ customClass = "", ...props }) => {
    let summaryTitle = "accordion-title font-inter  text-neutral-60 dark:text-neutral-40";
    summaryTitle = addCustomClassToBaseClass(summaryTitle, customClass);
    return React__default.createElement("div", { className: summaryTitle }, props.children);
};

const WidgetList = ({ ...props }) => {
    let defaultClasses = `font-inter`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("ul", { className: defaultClasses }, props.children);
};

const WidgetListItem = ({ ...props }) => {
    let defaultClasses = `widgetListItem text-neutral-40 py-2 cursor-pointer`;
    let navItemClasses = props.active
        ? `active ${defaultClasses} bg-neutral-15 font-semibold text-neutral-110 rounded-sm`
        : `${defaultClasses}`;
    navItemClasses = props.customClass
        ? `${navItemClasses} ${props.customClass}`
        : `${navItemClasses}`;
    navItemClasses = props.bg ? `${navItemClasses} px-4` : `${navItemClasses} px-2`;
    return React__default.createElement("li", { className: navItemClasses }, props.children);
};

const Menu = ({ children, customClass }) => {
    let defaultClasses = `font-inter`;
    defaultClasses = customClass
        ? `${defaultClasses} ${customClass}`
        : defaultClasses;
    return React__default.createElement("ul", { className: defaultClasses }, children);
};

const MenuItem = ({ children, customClass }) => {
    let defaultClasses = `menu-item font-inter flex items-center py-1`;
    defaultClasses = customClass
        ? `${defaultClasses} ${customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("li", { className: defaultClasses }, children);
};

const MenuIconIcon = ({ customClass = "", ...props }) => {
    let iconStyle = props.active ? `icon-active` : "";
    iconStyle = addCustomClassToBaseClass(iconStyle, customClass);
    return (React__default.createElement("span", { className: "sidebar-nav-icon mr-4 block" },
        React__default.createElement(Icon, { name: props.children, className: iconStyle })));
};

const MenuText = ({ ...props }) => {
    let textStyle = props.active
        ? `font-semibold text-size-base text-neutral-110`
        : "text-neutral-60 text-size-base";
    textStyle = props.hasPending ? `${textStyle} relative block` : textStyle;
    return (React__default.createElement("span", { className: `sidebar-nav-text dark:text-neutral-40 ${textStyle}` },
        props.children,
        props.hasPending && (React__default.createElement("span", { className: "absolute top-0", style: { right: "-10px" } },
            React__default.createElement(Icon, { name: "Pending" })))));
};

const Checklist = ({ customClass = "", ...props }) => {
    let defaultClasses = `checklist`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("ul", { className: defaultClasses }, props.children);
};

const ChecklistItem = ({ customClass = "", ...props }) => {
    let defaultClasses = `checklist-item flex flex-wrap relative items-baseline pl-8 pb-4`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("li", { className: defaultClasses }, props.children);
};

const ChecklistDesc = ({ customClass = "", ...props }) => {
    let defaultClasses = `checklist-desc font-inter text-size-12 text-neutral-60`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const ChecklistTitle = ({ customClass = "", ...props }) => {
    let defaultClasses = `checklist-title font-inter font-semibold text-size-14 text-neutral-110 mr-2 dark:text-neutral-dark-110`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const ChecklistStatus = ({ customClass = "", status = "default", ...props }) => {
    const getIconName = (status) => {
        switch (status) {
            case "success":
                return "CheckedCircle";
            case "error":
                return "CrossCircle";
            default:
                return "CheckCircle";
        }
    };
    const iconName = getIconName(status);
    let defaultClasses = `checklist-status absolute top-0 left-0`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return React__default.createElement("span", { className: defaultClasses },
        React__default.createElement(Icon, { name: iconName, className: "mr-2" }));
};

const Daterangepicker = (props) => {
    return React__default.createElement(DateRangePicker, { ...props });
};

const Panel = ({ ...props }) => {
    let defaultClasses = `panel font-inter bg-neutral-0 p-4 rounded-md mb-4 shadow-4xl dark:bg-neutral-dark-5 dark:border-neutral-dark-10 dark:shadow-transparent`;
    const _args = { onClick: props.onClick };
    if (props.onClick) {
        defaultClasses += " cursor-pointer";
    }
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return (React__default.createElement("div", { className: defaultClasses, ..._args }, props.children));
};

const PanelTitle = ({ ...props }) => {
    let defaultClasses = `text-neutral-110 text-size-18 font-inter font-semibold mb-4 dark:text-neutral-dark-80`;
    defaultClasses = props.customClass ? `${defaultClasses} ${props.customClass}` : defaultClasses;
    return React__default.createElement("h5", { className: defaultClasses }, props.children);
};

const PanelBlock = ({ ...props }) => {
    let defaultClasses = `panel-block border-b border-solid border-neutral-10 py-2 dark:border-neutral-dark-10`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const PanelBlockTitle = ({ ...props }) => {
    let defaultClasses = props.type == "sub"
        ? `text-neutral-110 text-size-16 font-inter dark:text-neutral-dark-80`
        : `text-neutral-60 text-size-16 font-inter mb-2 dark:text-neutral-dark-110`;
    defaultClasses = props.customClass ? `${defaultClasses} ${props.customClass}` : defaultClasses;
    return React__default.createElement("h6", { className: defaultClasses }, props.children);
};

const PanelBlockInfo = ({ ...props }) => {
    let defaultClasses = `text-neutral-40 text-size-14 font-inter`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return (React__default.createElement("p", { className: defaultClasses }, props.children));
};

const PanelCard = ({ customClass = "", ...props }) => {
    let defaultClasses = `panel-card rounded-md border border-solid border-neutral-10 dark:border-neutral-dark-10 bg-neutral-5 dark:bg-neutral-dark-10`;
    let innerContentWrapper = "panel-card-inner";
    if (props.header || props.footer) {
        defaultClasses = addCustomClassToBaseClass(defaultClasses, "p-0");
        innerContentWrapper = addCustomClassToBaseClass(innerContentWrapper, "p-4");
    }
    else {
        defaultClasses = addCustomClassToBaseClass(defaultClasses, "p-4");
    }
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    let headerClasses = "panel-card-header py-2 px-4 text-base-color text-size-12 bg-primary-10 rounded-t-md dark:bg-neutral-80";
    if (!props.removeHeaderSpacing) {
        headerClasses = addCustomClassToBaseClass(headerClasses, "py-2 px-4");
    }
    let footerClasses = "panel-card-footer text-base-color text-size-12 bg-primary-10 rounded-b-md";
    if (!props.removeFoooterSpacing) {
        footerClasses = addCustomClassToBaseClass(footerClasses, "py-2 px-4");
    }
    return (React__default.createElement("div", { className: defaultClasses },
        React__default.createElement(Sanitize, { check: Boolean(props.header) },
            React__default.createElement("div", { className: headerClasses }, props.header)),
        React__default.createElement("div", { className: innerContentWrapper }, props.children),
        React__default.createElement(Sanitize, { check: Boolean(props.footer) },
            React__default.createElement("div", { className: footerClasses }, props.footer))));
};

const PanelCol = ({ span, ...props }) => {
    let colClasses = "panel-col px-4 ";
    if (span) {
        colClasses += span === 12 ? "flex-grow w-full" : `w-${span}/12 basis-${span}/12`;
    }
    if (props.customClass) {
        colClasses += ` ${props.customClass}`;
    }
    if (props.verticalGap) {
        colClasses += " mb-3"; // Add vertical spacing class if verticalGap is true
    }
    return React__default.createElement("div", { className: colClasses }, props.children);
};

const PanelRow = ({ ...props }) => {
    let defaultClasses = `panel-row flex flex-row -mx-4 flex-wrap`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const PairList = ({ ...props }) => {
    let defaultClasses = `font-inter`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const PairListItem = ({ ...props }) => {
    let defaultClasses = `pair-listitem py-2 flex py-2 font-inter border-b border-solid border-neutral-10  dark:border-neutral-dark-20`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const PairListKey = ({ ...props }) => {
    let defaultClasses = `pairlist-key basis-1/4 shrink-0 font-semibold text-neutral-60 pr-4`;
    defaultClasses = props.customClass
        ? `${defaultClasses} ${props.customClass}`
        : `${defaultClasses}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};

const PairListValue = ({ isOverflowYScrollable, isHighlighted = false, customClass = "", ...props }) => {
    let defaultClasses = `pairlist-value font-opensans flex-1`;
    let pariListValueClasses = chooseBinaryClass(Boolean(isHighlighted), `${defaultClasses} font-bold text-neutral dark:text-neutral-dark-110`, `${defaultClasses} text-neutral-60 dark:text-neutral-dark-80 `);
    pariListValueClasses = addCustomClassToBaseClass(pariListValueClasses, customClass);
    return (React__default.createElement("div", { style: { overflowY: isOverflowYScrollable ? "scroll" : "initial" }, className: pariListValueClasses }, props.children));
};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs));
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

const Toast = ({ message, duration = 3000, onClose, variant = "default", }) => {
    const [isOpen, setIsOpen] = useState(true);
    const defaultText = `font-opensans text-neutral-60 text-size-14 flex-1 block`;
    const defaultWrapper = `toast shadow-4xl fixed bottom-5 right-5 z-50 rounded-md border border-solid bg-neutral-0 px-3 py-3 border-neutral-10`;
    const infoWrapper = `toast shadow-4xl fixed bottom-5 right-5 z-50 rounded-md border border-solid bg-primary px-3 py-3 border-primary`;
    const infoText = `font-opensans text-neutral-0 text-size-14 flex-1 block`;
    const successWrapper = `toast shadow-4xl fixed bottom-5 right-5 z-50 rounded-md border border-solid bg-success px-3 py-3 border-success`;
    const successText = `font-opensans text-neutral-0 text-size-14 flex-1 block`;
    const errorWrapper = `toast shadow-4xl fixed bottom-5 right-5 z-50 rounded-md border border-solid bg-error px-3 py-3 border-error`;
    const errorText = `font-opensans text-neutral-0 text-size-14 flex-1 block`;
    // Close Toast after duration
    setTimeout(() => {
        setIsOpen(false);
        if (onClose)
            onClose();
    }, duration);
    // Render only if isOpen is true
    const loaderVariant = {
        default: () => {
            return (React__default.createElement("div", { className: `${defaultWrapper} ${isOpen ? "block" : "hidden"}`, style: { width: "356px" } },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement(Icon, { name: "InfoGrey", className: "mr-2" }),
                    React__default.createElement("span", { className: defaultText }, message),
                    React__default.createElement("button", { onClick: () => setIsOpen(false) },
                        React__default.createElement(Icon, { name: "Close" })))));
        },
        info: () => {
            return (React__default.createElement("div", { className: `${infoWrapper} ${isOpen ? "block" : "hidden"}`, style: { width: "356px" } },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement(Icon, { name: "InfoWhite", className: "mr-2" }),
                    React__default.createElement("span", { className: infoText }, message),
                    React__default.createElement("button", { onClick: () => setIsOpen(false) },
                        React__default.createElement(Icon, { name: "CrossWhite" })))));
        },
        success: () => {
            return (React__default.createElement("div", { className: `${successWrapper} ${isOpen ? "block" : "hidden"}`, style: { width: "356px" } },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement(Icon, { name: "tickWhite", className: "mr-2" }),
                    React__default.createElement("span", { className: successText }, message),
                    React__default.createElement("button", { onClick: () => setIsOpen(false) },
                        React__default.createElement(Icon, { name: "CrossWhite" })))));
        },
        error: () => {
            return (React__default.createElement("div", { className: `${errorWrapper} ${isOpen ? "block" : "hidden"}`, style: { width: "356px" } },
                React__default.createElement("div", { className: "flex items-center" },
                    React__default.createElement(Icon, { name: "InfoWhite", className: "mr-2" }),
                    React__default.createElement("span", { className: errorText }, message),
                    React__default.createElement("button", { onClick: () => setIsOpen(false) },
                        React__default.createElement(Icon, { name: "CrossWhite" })))));
        },
    };
    const render = () => {
        return loaderVariant[variant]();
    };
    return render();
};
// PropTypes for Toast Component (optional)
Toast.propTypes = {
    message: propTypes.exports.string.isRequired,
    duration: propTypes.exports.number,
    onClose: propTypes.exports.func,
};

const StatusBadge = ({ variant = "default", customClass = "", children, type, iconPlacement = "right", }) => {
    let wrapperDefaultClass = `flex text-size-12`;
    wrapperDefaultClass = addCustomClassToBaseClass(wrapperDefaultClass, customClass);
    let defaultIconName;
    let defaultFieldTitleClass = "";
    let buttonBadgeTextcolorClass = "";
    let iconComponent;
    switch (type) {
        case "success":
            defaultIconName = "successInfo";
            defaultFieldTitleClass = `font-inter font-medium text-success text-size-12`;
            buttonBadgeTextcolorClass = `text-success`;
            iconComponent = React__default.createElement(Icon, { name: "SuccessTick", className: "mr-2" });
            break;
        case "inprogress":
            buttonBadgeTextcolorClass = `text-primary `;
            iconComponent = React__default.createElement(Loader, null);
            break;
        case "error":
            defaultIconName = "InfoRed";
            defaultFieldTitleClass = `font-inter font-medium text-error text-size-12`;
            buttonBadgeTextcolorClass = `text-error`;
            break;
        default:
            iconComponent = null;
    }
    //Icon Classes
    let iconClassesLeft = `block mr-2 mt-0.5`;
    let iconClassesRight = `block ml-2 mt-0.5`;
    //BadgeButton
    let badegButtondefaultClasses = `bg-primary-10 rounded-md px-4 py-3 flex justify-center items-center h-11`;
    badegButtondefaultClasses = addCustomClassToBaseClass(badegButtondefaultClasses, customClass);
    const statusBadgeVariant = {
        default: () => {
            return (React__default.createElement("div", { className: wrapperDefaultClass },
                iconPlacement === "left" && (React__default.createElement("i", { className: iconClassesLeft },
                    React__default.createElement(Icon, { name: defaultIconName }))),
                React__default.createElement("div", { className: "block" },
                    React__default.createElement("span", { className: defaultFieldTitleClass }, children)),
                iconPlacement === "right" && (React__default.createElement("i", { className: iconClassesRight },
                    React__default.createElement(Icon, { name: defaultIconName })))));
        },
        badgeButton: () => {
            return (React__default.createElement("div", { className: badegButtondefaultClasses },
                React__default.createElement("div", { className: "mr-2" }, iconComponent),
                React__default.createElement("h5", { className: buttonBadgeTextcolorClass }, children)));
        },
    };
    const render = () => {
        return statusBadgeVariant[variant]();
    };
    return render();
};

const LayoutContext = createContext(null);
const LayoutContextProvider = ({ children }) => {
    const [isSideBarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileMenuCollapsed, setIsMobileMenuCollapsed] = useState(true);
    const memoizedValue = useMemo(() => ({
        isSideBarCollapsed,
        setIsSidebarCollapsed,
        isMobileMenuCollapsed,
        setIsMobileMenuCollapsed,
    }), [isSideBarCollapsed, setIsSidebarCollapsed, isMobileMenuCollapsed, setIsMobileMenuCollapsed]);
    return React__default.createElement(LayoutContext.Provider, { value: memoizedValue }, children);
};
const useLayoutContext = () => {
    const context = useContext(LayoutContext);
    if (context === null) {
        throw new Error("LayoutContext must be used within LayoutContextProvider");
    }
    return context;
};

const LayoutRoot = ({ isClosed, isMobileClosed, ...props }) => {
    const { setIsSidebarCollapsed, isSideBarCollapsed } = useLayoutContext();
    const { setIsMobileMenuCollapsed, isMobileMenuCollapsed } = useLayoutContext();
    useEffect(() => {
        setIsSidebarCollapsed(isClosed);
    }, [isClosed]);
    // Set the state for mobile menu collapse
    useEffect(() => {
        setIsMobileMenuCollapsed(isMobileClosed);
    }, [isMobileClosed, setIsMobileMenuCollapsed]);
    let defaultClasses = `font-inter ${isSideBarCollapsed ? "sidebar-collapsed" : ""} ${isMobileMenuCollapsed ? "mobile-menu-close" : "mobile-menu-open"}`;
    return React__default.createElement("div", { className: defaultClasses }, props.children);
};
function DashboardLayout({ isClosed, isMobileClosed, ...props }) {
    return (React__default.createElement(LayoutContextProvider, null,
        React__default.createElement(LayoutRoot, { isClosed: isClosed, isMobileClosed: isMobileClosed, ...props })));
}

// Content.tsx
const Content = ({ children, spacingMobile = false }) => {
    const { isSideBarCollapsed, isMobileMenuCollapsed } = useLayoutContext();
    const spacingClasses = spacingMobile
        ? "pl-6 pr-10 pt-12 pt-6 pb-16"
        : "md:pl-6 md:pr-10 pt-12 md:pt-6 pb-16";
    let defaultClasses = `dashboard-container relative min-h-screen bg-neutral-5 ${spacingClasses} dark:bg-neutral-dark-0 
  ${isSideBarCollapsed ? "md:ml-20 w-collapsed" : "md:ml-64 w-non-collapsed"} 
  ${isMobileMenuCollapsed ? "mobile-menu-close" : "mobile-menu-open"}`;
    return React__default.createElement("main", { className: defaultClasses }, children);
};

// Sidebar.tsx
const Sidebar = ({ children }) => {
    const { isSideBarCollapsed } = useLayoutContext();
    let sidebarDefaultClasses = `sidebar shadow-r4xl transition-width pt-16 px-6 md:px-0 md:pt-6 duration-300 ease-in-out bg-neutral-0 fixed z-20 md:z-10 h-full dark:bg-neutral-dark-5 dark:shadow-transparent`;
    let sidebarClasses = isSideBarCollapsed
        ? `${sidebarDefaultClasses}`
        : `${sidebarDefaultClasses} w-64`;
    return React__default.createElement("aside", { className: sidebarClasses }, children);
};

const CollapseButton = ({ ...props }) => {
    const { isSideBarCollapsed } = useLayoutContext();
    const _args = { onClick: props.onClick };
    let collapseButtonStyles = `hidden md:flex btn-collapse transition-transform duration-300 ease-in-out bg-primary fixed flex h-6 w-6 items-center justify-center rounded-full`;
    return (React__default.createElement("button", { style: {
            left: isSideBarCollapsed ? "4rem" : "15rem",
            top: "28px",
            zIndex: "10",
        }, className: collapseButtonStyles, ..._args },
        React__default.createElement(Icon, { name: "Collapse", className: `transition-all delay-300 ease-in ${isSideBarCollapsed ? "rotate-180" : ""}` })));
};

const hamburgerButton = ({ ...props }) => {
    const { isMobileMenuCollapsed } = useLayoutContext();
    const _args = { onClick: props.onClick };
    let hamburgerButtonStyles = `block md:hidden btn-hamburger`;
    return (React__default.createElement("button", { className: hamburgerButtonStyles, ..._args },
        React__default.createElement(Icon, { name: isMobileMenuCollapsed ? "Hamburger" : "Close", className: "transition-all delay-300 ease-in" })));
};

const CodeBlock = ({ customClass = "", copyQuery = true, ...props }) => {
    const [isCopied, setIsCopied] = useState(false);
    const handleCopyQuery = () => {
        const textToCopy = props.children;
        if ('clipboard' in navigator) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 2000);
            })
                .catch((err) => console.error(err.name, err.message));
        }
        else {
            const textArea = document.createElement('textarea');
            textArea.value = textToCopy;
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                const success = document.execCommand('copy');
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 2000);
            }
            catch (err) {
                console.error(err.name, err.message);
            }
            document.body.removeChild(textArea);
        }
    };
    let defaultClasses = `bg-neutral-85 tracking-wide overflow-auto whitespace-pre-wrap px-4 py-4 rounded-none`;
    defaultClasses = addCustomClassToBaseClass(defaultClasses, customClass);
    return (React__default.createElement("div", null,
        React__default.createElement(Sanitize, { check: Boolean(copyQuery) },
            React__default.createElement("div", { className: "flex justify-between bg-neutral-20 px-4 py-2" },
                React__default.createElement("h4", { className: "text-neutral-85 text-size-12 font-semibold" }, "Query"),
                React__default.createElement("button", { className: "text-neutral-85 text-size-10", onClick: handleCopyQuery }, isCopied ? "Copied!" : "Copy query"))),
        React__default.createElement("pre", { className: defaultClasses },
            React__default.createElement("code", { className: "text-size-11 text-neutral-0 bg-transparent" }, props.children))));
};

const Text = ({ children, customClass = "", status }) => {
    const defaultTextClasses = `dark:text-neutral-dark-110`;
    // Determine the status class
    const getStatusClass = (status) => {
        switch (status) {
            case "error":
                return `text-error-110 dark:text-error-110`;
            case "success":
                return `text-success-110 dark:text-success-110`;
            case "warning":
                return `text-warning-110 dark:text-warning-110`;
            case "processing":
                return `text-primary dark:text-primary`;
            case "default":
            default:
                return `dark:text-neutral-dark-110`;
        }
    };
    const textClasses = addCustomClassToBaseClass(`${defaultTextClasses} ${getStatusClass(status)}`, customClass);
    return React__default.createElement("span", { className: textClasses }, children);
};

const DaySelector = ({ name, isOpen = false, title, toggleDaySelector, selectedDay, onSelectDay, customClass = "", hideClose, ...restProps }) => {
    const close = () => toggleDaySelector?.(false);
    const updateSelectedDay = (day) => {
        onSelectDay(day);
        close();
    };
    let wrapperDefaultClasses = `modal-wrapper flex flex-col justify-end 
    h-full max-h-screen w-full z-50 fixed left-0 right-0 top-0 bottom-0 m-auto sm:max-w-29`;
    let wrapperClasses = addCustomClassToBaseClass(wrapperDefaultClasses, customClass);
    let overlayClasses = `absolute top-0 bottom-0 w-full z-50 left-0 right-0 dark:bg-neutral-dark-0/[.9] backdrop-blur-sm`;
    let dayModalClasses = `modal shadow-txl dark:shadow-none bg-neutral-0 relative z-50 dark:bg-neutral-dark-5`;
    let titleClasses = `text-neutral-dark-0 mb-1 text-size-14 dark:text-neutral-dark-110`;
    return (React__default.createElement(Sanitize, { check: Boolean(isOpen) },
        React__default.createElement("div", { className: wrapperClasses, "data-component": "dayselector" },
            React__default.createElement("div", { className: overlayClasses }),
            React__default.createElement("div", { className: dayModalClasses },
                React__default.createElement("div", { className: "flex flex-col px-4 pt-4 pb-6" },
                    React__default.createElement("div", { className: "flex items-center justify-between pb-4" },
                        React__default.createElement("h4", { className: titleClasses }, title),
                        React__default.createElement("i", { onClick: close, className: chooseBinaryClass(Boolean(hideClose), "hidden cursor-pointer", "cursor-pointer") },
                            React__default.createElement(IconList, { name: "Close" }))),
                    React__default.createElement("div", { className: "grid grid-cols-7 gap-2", "data-name": name }, Array.from({ length: 28 }, (_, i) => i + 1).map((day) => (React__default.createElement("button", { type: "button", key: day, ...restProps, onClick: () => updateSelectedDay(day), className: `w-full rounded-md py-2 text-center ${selectedDay === day
                            ? "bg-primary dark:bg-primary-110 text-white"
                            : "hover:bg-primary-10 text-neutral-60 dark:bg-neutral-dark-10 bg-white"}` }, day)))))))));
};

const Slider = React__default.forwardRef(({ className, ...props }, ref) => (React__default.createElement(SliderPrimitive.Root, { ref: ref, className: cn("relative flex w-full touch-none select-none items-center", className), ...props },
    React__default.createElement(SliderPrimitive.Track, { className: "bg-neutral-20 dark:bg-neutral-dark-10 relative h-1.5 w-full grow overflow-hidden rounded-full" },
        React__default.createElement(SliderPrimitive.Range, { className: "bg-primary absolute h-full" })),
    React__default.createElement(SliderPrimitive.Thumb, { className: "dark:bg-neutral-dark-80 bg-neutral-5 block h-5 w-5 rounded-[10px] shadow-[0_1px_5px_rgba(0,0,0,0.5)] hover:bg-white focus:shadow-[0_0_0_5px_rgba(62,116,255,0.5)] focus:outline-none dark:focus:shadow-[0_0_0_5px_rgba(0,0,0,0.4)]" }))));
Slider.displayName = SliderPrimitive.Root.displayName;

const ToggleSwitch = ({ enabled, onChange, customClass = "" }) => {
    let switchDefaultClasses = `group relative flex h-7 w-14 cursor-pointer rounded-full p-1 transition-colors duration-200 ease-in-out focus:outline-none ${enabled ? "bg-primary" : "bg-neutral-20 dark:bg-neutral-dark-10"} data-[focus]:outline-1 data-[focus]:outline-white`;
    switchDefaultClasses = addCustomClassToBaseClass(switchDefaultClasses, customClass);
    return (React__default.createElement(Switch, { checked: enabled, onChange: onChange, className: switchDefaultClasses },
        React__default.createElement("span", { "aria-hidden": "true", className: `pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out ${enabled ? "translate-x-7" : "translate-x-0"}` })));
};

const ErrorSvg = () => (React.createElement("svg", { width: "198", height: "135", viewBox: "0 0 198 135", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0_14_714)" },
        React.createElement("path", { d: "M195.232 3.05176e-05H2.765C2.03154 0.000838654 1.32835 0.290527 0.809711 0.805532C0.291074 1.32054 -0.000651008 2.0188 -0.00146484 2.74712V132.253C-0.000649964 132.981 0.291074 133.68 0.809711 134.195C1.32835 134.71 2.03154 134.999 2.765 135H195.232C195.966 134.999 196.669 134.71 197.187 134.195C197.706 133.68 197.998 132.981 197.999 132.253V2.74712C197.998 2.0188 197.706 1.32054 197.187 0.805532C196.669 0.290527 195.966 0.000838654 195.232 3.05176e-05ZM197.208 132.253C197.208 132.773 197 133.272 196.629 133.64C196.259 134.008 195.756 134.215 195.232 134.215H2.765C2.24099 134.215 1.73849 134.008 1.36795 133.64C0.997418 133.272 0.789164 132.773 0.788954 132.253V2.74712C0.789164 2.22678 0.997418 1.7278 1.36795 1.35986C1.73849 0.991924 2.24099 0.785122 2.765 0.784914H195.232C195.756 0.785122 196.259 0.991924 196.629 1.35986C197 1.7278 197.208 2.22678 197.208 2.74712V132.253Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M197.604 11.0045H0.393921V11.7894H197.604V11.0045Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M7.11137 8.23993C8.42098 8.23993 9.48263 7.18571 9.48263 5.88528C9.48263 4.58484 8.42098 3.53062 7.11137 3.53062C5.80176 3.53062 4.74011 4.58484 4.74011 5.88528C4.74011 7.18571 5.80176 8.23993 7.11137 8.23993Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M13.9309 8.23993C15.2406 8.23993 16.3022 7.18571 16.3022 5.88528C16.3022 4.58484 15.2406 3.53062 13.9309 3.53062C12.6213 3.53062 11.5597 4.58484 11.5597 5.88528C11.5597 7.18571 12.6213 8.23993 13.9309 8.23993Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M20.7476 8.23993C22.0572 8.23993 23.1189 7.18571 23.1189 5.88528C23.1189 4.58484 22.0572 3.53062 20.7476 3.53062C19.438 3.53062 18.3763 4.58484 18.3763 5.88528C18.3763 7.18571 19.438 8.23993 20.7476 8.23993Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M159.594 37.8572H37.0791C35.4545 37.8572 33.8964 37.2163 32.7476 36.0755C31.5988 34.9348 30.9534 33.3876 30.9534 31.7743C30.9534 30.161 31.5988 28.6139 32.7476 27.4731C33.8964 26.3323 35.4545 25.6915 37.0791 25.6915H159.594C161.219 25.6915 162.777 26.3323 163.926 27.4731C165.074 28.6139 165.72 30.161 165.72 31.7743C165.72 33.3876 165.074 34.9348 163.926 36.0755C162.777 37.2163 161.219 37.8572 159.594 37.8572ZM37.0791 26.4764C35.6641 26.4764 34.307 27.0345 33.3065 28.0281C32.3059 29.0217 31.7438 30.3692 31.7438 31.7743C31.7438 33.1794 32.3059 34.527 33.3065 35.5206C34.307 36.5141 35.6641 37.0723 37.0791 37.0723H159.594C161.009 37.0723 162.366 36.5141 163.367 35.5206C164.367 34.527 164.929 33.1794 164.929 31.7743C164.929 30.3692 164.367 29.0217 163.367 28.0281C162.366 27.0345 161.009 26.4764 159.594 26.4764H37.0791Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M72.2536 34.5214H39.056C38.3223 34.5214 37.6186 34.232 37.0998 33.7168C36.581 33.2016 36.2896 32.5029 36.2896 31.7743C36.2896 31.0457 36.581 30.347 37.0998 29.8318C37.6186 29.3166 38.3223 29.0272 39.056 29.0272H72.2536C72.9873 29.0272 73.691 29.3166 74.2098 29.8318C74.7286 30.347 75.0201 31.0457 75.0201 31.7743C75.0201 32.5029 74.7286 33.2016 74.2098 33.7168C73.691 34.232 72.9873 34.5214 72.2536 34.5214Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M155.447 33.1487C154.9 33.1487 154.365 32.9876 153.91 32.6857C153.455 32.3839 153.1 31.9548 152.891 31.4529C152.681 30.9509 152.627 30.3986 152.733 29.8657C152.84 29.3328 153.104 28.8433 153.491 28.4591C153.877 28.0749 154.37 27.8133 154.907 27.7073C155.444 27.6013 156 27.6557 156.505 27.8636C157.011 28.0715 157.443 28.4236 157.747 28.8754C158.051 29.3272 158.213 29.8583 158.213 30.4016C158.212 31.1299 157.921 31.8282 157.402 32.3432C156.883 32.8582 156.18 33.1479 155.447 33.1487ZM155.447 28.4394C155.056 28.4394 154.674 28.5545 154.349 28.7701C154.024 28.9857 153.771 29.2921 153.621 29.6507C153.472 30.0092 153.432 30.4038 153.509 30.7844C153.585 31.165 153.773 31.5147 154.049 31.7891C154.326 32.0635 154.678 32.2504 155.061 32.3261C155.445 32.4018 155.842 32.363 156.203 32.2144C156.564 32.0659 156.873 31.8144 157.09 31.4917C157.307 31.1691 157.423 30.7897 157.423 30.4016C157.422 29.8814 157.214 29.3826 156.843 29.0148C156.473 28.6469 155.971 28.44 155.447 28.4394Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M159.725 35.633C159.673 35.633 159.622 35.6229 159.574 35.6032C159.526 35.5834 159.482 35.5545 159.446 35.518L156.669 32.7606C156.632 32.7241 156.603 32.6809 156.583 32.6332C156.563 32.5856 156.553 32.5346 156.553 32.4831C156.553 32.4316 156.563 32.3805 156.583 32.3329C156.603 32.2853 156.632 32.242 156.669 32.2056C156.706 32.1692 156.749 32.1403 156.797 32.1206C156.845 32.1008 156.897 32.0907 156.948 32.0907C157 32.0907 157.052 32.1008 157.1 32.1206C157.148 32.1403 157.191 32.1692 157.228 32.2056L160.005 34.963C160.06 35.0179 160.097 35.0879 160.113 35.164C160.128 35.2401 160.12 35.319 160.09 35.3907C160.06 35.4624 160.01 35.5237 159.945 35.5668C159.88 35.6099 159.803 35.633 159.725 35.633Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M98.9996 79V84.3333M98.9996 89.6667H99.013M97.1534 72.189L86.1869 91.1311C85.5786 92.1818 85.2745 92.7071 85.3194 93.1382C85.3586 93.5143 85.5557 93.856 85.8615 94.0784C86.2121 94.3333 86.8191 94.3333 88.0331 94.3333H109.966C111.18 94.3333 111.787 94.3333 112.138 94.0784C112.444 93.856 112.641 93.5143 112.68 93.1382C112.725 92.7071 112.421 92.1818 111.812 91.1311L100.846 72.1889C100.24 71.1421 99.9367 70.6186 99.5414 70.4428C99.1965 70.2895 98.8028 70.2895 98.4579 70.4428C98.0625 70.6186 97.7595 71.1421 97.1534 72.189Z", stroke: "#2955D9", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_14_714" },
            React.createElement("rect", { width: "198", height: "135", fill: "white" })))));

const ErrorCrossSvg = () => (React.createElement("svg", { width: "198", height: "135", viewBox: "0 0 198 135", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0_12_467)" },
        React.createElement("path", { d: "M195.232 3.05176e-05H2.765C2.03154 0.000838654 1.32835 0.290527 0.809711 0.805532C0.291074 1.32054 -0.000651008 2.0188 -0.00146484 2.74712V132.253C-0.000649964 132.981 0.291074 133.68 0.809711 134.195C1.32835 134.71 2.03154 134.999 2.765 135H195.232C195.966 134.999 196.669 134.71 197.187 134.195C197.706 133.68 197.998 132.981 197.999 132.253V2.74712C197.998 2.0188 197.706 1.32054 197.187 0.805532C196.669 0.290527 195.966 0.000838654 195.232 3.05176e-05ZM197.208 132.253C197.208 132.773 197 133.272 196.629 133.64C196.259 134.008 195.756 134.215 195.232 134.215H2.765C2.24099 134.215 1.73849 134.008 1.36795 133.64C0.997418 133.272 0.789164 132.773 0.788954 132.253V2.74712C0.789164 2.22678 0.997418 1.7278 1.36795 1.35986C1.73849 0.991924 2.24099 0.785122 2.765 0.784914H195.232C195.756 0.785122 196.259 0.991924 196.629 1.35986C197 1.7278 197.208 2.22678 197.208 2.74712V132.253Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M197.604 11.0045H0.393921V11.7894H197.604V11.0045Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M7.11137 8.23993C8.42098 8.23993 9.48263 7.18571 9.48263 5.88528C9.48263 4.58484 8.42098 3.53062 7.11137 3.53062C5.80176 3.53062 4.74011 4.58484 4.74011 5.88528C4.74011 7.18571 5.80176 8.23993 7.11137 8.23993Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M13.9309 8.23993C15.2406 8.23993 16.3022 7.18571 16.3022 5.88528C16.3022 4.58484 15.2406 3.53062 13.9309 3.53062C12.6213 3.53062 11.5597 4.58484 11.5597 5.88528C11.5597 7.18571 12.6213 8.23993 13.9309 8.23993Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M20.7476 8.23993C22.0572 8.23993 23.1189 7.18571 23.1189 5.88528C23.1189 4.58484 22.0572 3.53062 20.7476 3.53062C19.438 3.53062 18.3763 4.58484 18.3763 5.88528C18.3763 7.18571 19.438 8.23993 20.7476 8.23993Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M98.8182 9.31907H35.1818C34.3379 9.31907 33.5286 8.9862 32.9319 8.39367C32.3352 7.80114 32 6.9975 32 6.15954C32 5.32157 32.3352 4.51794 32.9319 3.92541C33.5286 3.33288 34.3379 3 35.1818 3H98.8182C99.662 3 100.471 3.33288 101.068 3.92541C101.665 4.51794 102 5.32157 102 6.15954C102 6.9975 101.665 7.80114 101.068 8.39367C100.471 8.9862 99.662 9.31907 98.8182 9.31907ZM35.1818 3.40768C34.4468 3.40768 33.742 3.69761 33.2222 4.21368C32.7025 4.72976 32.4106 5.4297 32.4106 6.15954C32.4106 6.88937 32.7025 7.58932 33.2222 8.10539C33.742 8.62147 34.4468 8.91139 35.1818 8.91139H98.8182C99.5532 8.91139 100.258 8.62147 100.778 8.10539C101.297 7.58932 101.589 6.88937 101.589 6.15954C101.589 5.4297 101.297 4.72976 100.778 4.21368C100.258 3.69761 99.5532 3.40768 98.8182 3.40768H35.1818Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M53.4521 7.58641H36.2087C35.8276 7.58641 35.4621 7.43608 35.1926 7.16849C34.9231 6.90089 34.7717 6.53796 34.7717 6.15952C34.7717 5.78109 34.9231 5.41816 35.1926 5.15056C35.4621 4.88297 35.8276 4.73264 36.2087 4.73264H53.4521C53.8332 4.73264 54.1987 4.88297 54.4682 5.15056C54.7376 5.41816 54.889 5.78109 54.889 6.15952C54.889 6.53796 54.7376 6.90089 54.4682 7.16849C54.1987 7.43608 53.8332 7.58641 53.4521 7.58641Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M96.664 6.87339C96.3798 6.87339 96.102 6.78971 95.8657 6.63292C95.6294 6.47614 95.4452 6.25329 95.3364 5.99256C95.2277 5.73183 95.1992 5.44492 95.2547 5.16813C95.3101 4.89135 95.447 4.6371 95.6479 4.43755C95.8489 4.23799 96.1049 4.1021 96.3837 4.04704C96.6624 3.99198 96.9513 4.02024 97.2139 4.12824C97.4765 4.23624 97.7009 4.41912 97.8588 4.65377C98.0167 4.88842 98.1009 5.16429 98.1009 5.44651C98.1005 5.82481 97.949 6.1875 97.6796 6.455C97.4102 6.7225 97.045 6.87297 96.664 6.87339ZM96.664 4.4273C96.461 4.4273 96.2626 4.48708 96.0938 4.59907C95.925 4.71106 95.7934 4.87024 95.7157 5.05647C95.6381 5.24271 95.6177 5.44764 95.6573 5.64535C95.6969 5.84305 95.7947 6.02466 95.9382 6.1672C96.0818 6.30974 96.2647 6.4068 96.4638 6.44613C96.6629 6.48545 96.8692 6.46527 97.0568 6.38813C97.2443 6.31099 97.4046 6.18036 97.5174 6.01275C97.6302 5.84514 97.6904 5.64809 97.6904 5.44651C97.6901 5.17629 97.5818 4.91724 97.3894 4.72616C97.197 4.53509 96.9361 4.42761 96.664 4.4273Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M98.8863 8.16379C98.8594 8.16382 98.8327 8.15857 98.8078 8.14832C98.7829 8.13807 98.7602 8.12303 98.7412 8.10407L97.2989 6.67181C97.2798 6.65289 97.2647 6.63041 97.2544 6.60569C97.2441 6.58096 97.2388 6.55446 97.2388 6.52769C97.2388 6.50092 97.2441 6.47442 97.2544 6.44969C97.2647 6.42496 97.2798 6.40249 97.2989 6.38356C97.318 6.36464 97.3406 6.34963 97.3655 6.33938C97.3904 6.32914 97.4171 6.32387 97.444 6.32387C97.471 6.32387 97.4977 6.32914 97.5226 6.33938C97.5475 6.34963 97.5701 6.36464 97.5892 6.38356L99.0315 7.81582C99.0602 7.84433 99.0797 7.88065 99.0876 7.92019C99.0956 7.95972 99.0915 8.0007 99.076 8.03794C99.0604 8.07518 99.0341 8.10702 99.0004 8.12942C98.9666 8.15182 98.9269 8.16378 98.8863 8.16379Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M102 70L94 78M94 70L102 78M111.333 74C111.333 81.3638 105.364 87.3333 98 87.3333C90.6362 87.3333 84.6666 81.3638 84.6666 74C84.6666 66.6362 90.6362 60.6667 98 60.6667C105.364 60.6667 111.333 66.6362 111.333 74Z", stroke: "#2955D9", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_12_467" },
            React.createElement("rect", { width: "198", height: "135", fill: "white" })))));

const LandingImage = ({ customClass = "" }) => (React.createElement("svg", { width: "520", height: "301", viewBox: "0 0 520 301", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: customClass },
    React.createElement("mask", { id: "mask0_5_991", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "520", height: "301" },
        React.createElement("path", { d: "M520 0H0V300.398H520V0Z", fill: "white" })),
    React.createElement("g", { mask: "url(#mask0_5_991)" },
        React.createElement("path", { d: "M504.787 219.372C503.942 219.371 503.101 219.269 502.28 219.069C499.684 218.431 497.432 216.827 495.98 214.583C494.529 212.34 493.987 209.627 494.468 206.998C494.945 204.37 496.413 202.023 498.564 200.438C500.715 198.854 503.392 198.15 506.044 198.471C508.697 198.792 511.127 200.113 512.837 202.165C514.552 204.217 515.413 206.845 515.255 209.513C515.094 212.18 513.921 214.686 511.976 216.518C510.031 218.351 507.46 219.371 504.787 219.372ZM504.787 203.126C503.396 203.131 502.058 203.644 501.018 204.569C499.979 205.494 499.316 206.766 499.15 208.147C498.989 209.527 499.332 210.92 500.121 212.063C500.913 213.207 502.094 214.021 503.444 214.354C504.225 214.542 505.038 214.562 505.83 214.414C506.619 214.265 507.367 213.951 508.026 213.492C508.685 213.033 509.243 212.439 509.655 211.75C510.068 211.061 510.334 210.293 510.427 209.495C510.525 208.697 510.448 207.887 510.209 207.12C509.971 206.353 509.57 205.646 509.037 205.044C508.503 204.442 507.852 203.961 507.116 203.63C506.384 203.299 505.592 203.127 504.787 203.126Z", fill: "#E7F6FF" }),
        React.createElement("path", { d: "M495.217 230.494C495.811 228.035 494.303 225.558 491.841 224.962C489.382 224.366 486.908 225.876 486.309 228.335C485.715 230.794 487.223 233.27 489.681 233.867C492.144 234.463 494.618 232.953 495.217 230.494Z", fill: "#E7F6FF" }),
        React.createElement("path", { d: "M22.3147 218.372C19.5375 218.312 16.8963 217.158 14.9644 215.162C13.0326 213.166 11.9662 210.488 11.9965 207.711C12.0268 204.933 13.1516 202.279 15.1265 200.326C17.1015 198.372 19.7673 197.276 22.5452 197.276C25.323 197.276 27.9888 198.372 29.9638 200.326C31.9387 202.279 33.0635 204.933 33.0938 207.711C33.1242 210.488 32.0577 213.166 30.1258 215.162C28.1941 217.158 25.5529 218.312 22.7756 218.372H22.3147ZM22.3147 202.13H22.0761C20.5762 202.163 19.1496 202.785 18.106 203.863C17.0625 204.941 16.4864 206.387 16.5026 207.888C16.5188 209.388 17.1262 210.821 18.1928 211.876C19.2594 212.931 20.6991 213.523 22.1994 213.523C23.6998 213.523 25.1395 212.931 26.2061 211.876C27.2727 210.821 27.88 209.388 27.8963 207.888C27.9125 206.387 27.3363 204.941 26.2928 203.863C25.2493 202.785 23.8227 202.163 22.3228 202.13H22.3147Z", fill: "#E7F6FF" }),
        React.createElement("path", { d: "M14.7941 236.075C17.3219 235.966 19.2827 233.829 19.1736 231.301C19.0646 228.773 16.927 226.812 14.3992 226.921C11.8715 227.03 9.9107 229.168 10.0197 231.696C10.1288 234.223 12.2663 236.184 14.7941 236.075Z", fill: "#E7F6FF" }),
        React.createElement("path", { d: "M286.711 47.8159C284.193 47.8179 281.758 46.919 279.847 45.2815C277.935 43.6439 276.672 41.3759 276.288 38.888C275.903 36.4003 276.422 33.857 277.75 31.7186C279.079 29.5803 281.129 27.9881 283.529 27.2303C285.929 26.4724 288.522 26.5991 290.837 27.5872C293.153 28.5754 295.038 30.3598 296.151 32.6174C297.265 34.875 297.533 37.4568 296.908 39.8952C296.283 42.3338 294.806 44.4679 292.743 45.9114C290.975 47.1487 288.869 47.8134 286.711 47.8159ZM286.678 31.5774C285.205 31.5758 283.789 32.1428 282.723 33.1601C281.658 34.1774 281.027 35.5665 280.961 37.0379C280.895 38.5094 281.399 39.9496 282.368 41.0585C283.338 42.1672 284.698 42.859 286.165 42.9896C287.632 43.1203 289.093 42.6799 290.243 41.7596C291.394 40.8398 292.145 39.5114 292.34 38.0515C292.534 36.5915 292.158 35.1126 291.29 33.9231C290.421 32.7336 289.127 31.9252 287.677 31.6663C287.347 31.6075 287.013 31.5778 286.678 31.5774Z", fill: "#E7F6FF" }),
        React.createElement("path", { d: "M265.2 47.2405C267.272 45.7877 267.773 42.9311 266.321 40.8592C264.868 38.7879 262.011 38.2862 259.94 39.7388C257.868 41.1916 257.366 44.0483 258.819 46.1201C260.272 48.1916 263.129 48.6933 265.2 47.2405Z", fill: "#E7F6FF" }),
        React.createElement("path", { d: "M385.815 300.398H144.625V295.141H385.815C386.512 295.141 387.18 295.418 387.673 295.911C388.166 296.404 388.443 297.072 388.443 297.769C388.443 298.467 388.166 299.135 387.673 299.628C387.18 300.121 386.512 300.398 385.815 300.398Z", fill: "#426572" }),
        React.createElement("path", { d: "M133.836 300.398H119.089C118.392 300.398 117.724 300.121 117.231 299.628C116.738 299.135 116.461 298.467 116.461 297.769C116.461 297.072 116.738 296.404 117.231 295.911C117.724 295.418 118.392 295.141 119.089 295.141H133.836C134.533 295.141 135.201 295.418 135.694 295.911C136.187 296.404 136.464 297.072 136.464 297.769C136.464 298.467 136.187 299.135 135.694 299.628C135.201 300.121 134.533 300.398 133.836 300.398Z", fill: "#426572" }),
        React.createElement("path", { d: "M109.518 300.398H104.82C104.123 300.398 103.454 300.121 102.961 299.628C102.468 299.135 102.191 298.467 102.191 297.769C102.191 297.072 102.468 296.404 102.961 295.911C103.454 295.418 104.123 295.141 104.82 295.141H109.518C110.215 295.141 110.884 295.418 111.376 295.911C111.869 296.404 112.146 297.072 112.146 297.769C112.146 298.467 111.869 299.135 111.376 299.628C110.884 300.121 110.215 300.398 109.518 300.398Z", fill: "#426572" }),
        React.createElement("path", { d: "M470.386 300.398H396.254V295.141H470.386C471.081 295.141 471.753 295.418 472.246 295.911C472.739 296.404 473.014 297.072 473.014 297.769C473.014 298.467 472.739 299.135 472.246 299.628C471.753 300.121 471.081 300.398 470.386 300.398Z", fill: "#426572" }),
        React.createElement("path", { d: "M91.3822 300.398H17.2461V295.141H91.3822C92.0793 295.141 92.7477 295.418 93.2406 295.911C93.7334 296.404 94.0104 297.072 94.0104 297.769C94.0104 298.467 93.7334 299.135 93.2406 299.628C92.7477 300.121 92.0793 300.398 91.3822 300.398Z", fill: "#426572" }),
        React.createElement("path", { d: "M285.156 218.946H222.079C219.399 218.946 217.227 221.119 217.227 223.799V284.45C217.227 287.13 219.399 289.302 222.079 289.302H285.156C287.836 289.302 290.008 287.13 290.008 284.45V223.799C290.008 221.119 287.836 218.946 285.156 218.946Z", fill: "#E8EDF7" }),
        React.createElement("path", { d: "M290.008 248.059H217.227V270.298H290.008V248.059Z", fill: "#C1CEDE" }),
        React.createElement("path", { d: "M284.152 292.537H221.075C219.145 292.537 217.294 291.77 215.929 290.405C214.563 289.041 213.797 287.189 213.797 285.259V224.608C213.797 222.677 214.563 220.826 215.929 219.461C217.294 218.096 219.145 217.329 221.075 217.329H284.152C286.083 217.329 287.934 218.096 289.299 219.461C290.664 220.826 291.431 222.677 291.431 224.608V285.259C291.431 287.189 290.664 289.041 289.299 290.405C287.934 291.77 286.083 292.537 284.152 292.537ZM221.075 222.181C220.432 222.181 219.815 222.437 219.359 222.892C218.905 223.347 218.649 223.964 218.649 224.608V285.259C218.649 285.903 218.905 286.52 219.359 286.974C219.815 287.429 220.432 287.685 221.075 287.685H284.152C284.796 287.685 285.413 287.429 285.868 286.974C286.323 286.52 286.578 285.903 286.578 285.259V224.608C286.578 223.964 286.323 223.347 285.868 222.892C285.413 222.437 284.796 222.181 284.152 222.181H221.075Z", fill: "#426572" }),
        React.createElement("path", { d: "M437.795 51.9454V238.751C437.795 243.21 436.32 247.542 433.602 251.076C430.885 254.609 427.076 257.145 422.766 258.289C421.08 258.734 419.341 258.958 417.594 258.956H90.0492C84.6872 258.956 79.5447 256.826 75.7536 253.035C71.9621 249.244 69.8321 244.101 69.8321 238.739V51.9333C69.8264 48.1992 70.8595 44.5367 72.8161 41.3557C73.0708 40.9514 73.3417 40.547 73.6248 40.1428C75.8515 37.0415 78.9103 34.6333 82.4475 33.1962C84.855 32.2173 87.4298 31.716 90.0289 31.7204H417.566C420.223 31.7187 422.855 32.2408 425.309 33.2566C427.764 34.2724 429.996 35.762 431.872 37.6404C433.752 39.5187 435.24 41.7487 436.259 44.2035C437.274 46.6583 437.795 49.2889 437.795 51.9454Z", fill: "#E8EDF7" }),
        React.createElement("path", { d: "M415.168 262.211H87.651C81.6457 262.211 75.8862 259.825 71.6398 255.579C67.3934 251.332 65.0078 245.573 65.0078 239.568V52.7616C65.0018 47.0418 67.1698 41.5334 71.073 37.3521C71.3317 37.0691 71.6229 36.7739 71.9787 36.4302C76.1879 32.3766 81.807 30.1165 87.651 30.1265H415.168C421.173 30.1265 426.934 32.5121 431.18 36.7585C435.426 41.005 437.811 46.7644 437.811 52.7697V239.576C437.815 242.55 437.229 245.496 436.093 248.244C434.957 250.993 433.291 253.491 431.188 255.594C429.081 257.697 426.587 259.365 423.837 260.502C421.088 261.639 418.144 262.222 415.168 262.219V262.211ZM87.651 34.9705C83.0589 34.9619 78.6435 36.7396 75.3388 39.9277C75.0598 40.1946 74.8374 40.421 74.6392 40.6354C71.5654 43.9259 69.8595 48.2629 69.868 52.7656V239.572C69.868 244.29 71.7425 248.815 75.0788 252.152C78.4154 255.488 82.9404 257.363 87.6591 257.363H415.176C417.513 257.366 419.83 256.908 421.989 256.015C424.148 255.122 426.11 253.812 427.763 252.159C429.417 250.506 430.727 248.544 431.621 246.384C432.514 244.224 432.971 241.909 432.967 239.572V52.7656C432.967 48.047 431.091 43.522 427.755 40.1854C424.419 36.849 419.895 34.9746 415.176 34.9746L87.651 34.9705Z", fill: "#426572" }),
        React.createElement("path", { d: "M411.373 44.6751H92.2418C85.5713 44.6751 80.1641 50.0828 80.1641 56.7528V236.386C80.1641 243.056 85.5713 248.464 92.2418 248.464H411.373C418.044 248.464 423.45 243.056 423.45 236.386V56.7528C423.45 50.0828 418.044 44.6751 411.373 44.6751Z", fill: "#C1CEDE" }),
        React.createElement("path", { d: "M94.0591 51.1439H409.551C411.358 51.1439 413.089 51.8612 414.367 53.1385C415.644 54.4155 416.36 56.1473 416.36 57.953V215.711H87.25V57.953C87.25 56.1473 87.9673 54.4155 89.2442 53.1385C90.5211 51.8612 92.2533 51.1439 94.0591 51.1439Z", fill: "white" }),
        React.createElement("path", { d: "M422.642 214.903V235.577C422.642 238.78 421.368 241.852 419.104 244.117C416.84 246.381 413.767 247.654 410.564 247.655H91.4332C88.23 247.655 85.1578 246.383 82.8931 244.118C80.6279 241.853 79.3555 238.781 79.3555 235.577V214.903H86.4436V215.712H415.554V214.903H422.642Z", fill: "#E8EDF7" }),
        React.createElement("path", { d: "M422.833 214.094H80.3555V221.373H422.833V214.094Z", fill: "#C1CEDE" }),
        React.createElement("path", { d: "M422.44 212.477H81.1758V217.33H422.44V212.477Z", fill: "#426572" }),
        React.createElement("path", { d: "M373.501 65.2958H126.044C123.364 65.2958 121.191 67.4683 121.191 70.1479V194.685C121.191 197.365 123.364 199.537 126.044 199.537H373.501C376.18 199.537 378.353 197.365 378.353 194.685V70.1479C378.353 67.4683 376.18 65.2958 373.501 65.2958Z", fill: "white" }),
        React.createElement("path", { d: "M125.239 88.7476H379.165V71.6925L374.313 65.2958H151.925H130.091L122.004 71.6925V88.7476H125.239Z", fill: "#E2F2FF" }),
        React.createElement("path", { d: "M374.31 201.964H126.852C124.922 201.964 123.071 201.197 121.706 199.832C120.341 198.467 119.574 196.616 119.574 194.686V70.1483C119.574 68.2179 120.341 66.3669 121.706 65.0018C123.071 63.6371 124.922 62.8701 126.852 62.8701H374.31C376.24 62.8701 378.091 63.6371 379.456 65.0018C380.821 66.3669 381.588 68.2179 381.588 70.1483V194.686C381.588 196.616 380.821 198.467 379.456 199.832C378.091 201.197 376.24 201.964 374.31 201.964ZM126.852 67.7222C126.209 67.7222 125.592 67.9778 125.137 68.4331C124.682 68.8879 124.426 69.505 124.426 70.1483V194.686C124.426 195.329 124.682 195.946 125.137 196.401C125.592 196.856 126.209 197.112 126.852 197.112H374.31C374.953 197.112 375.57 196.856 376.025 196.401C376.48 195.946 376.736 195.329 376.736 194.686V70.1483C376.736 69.505 376.48 68.8879 376.025 68.4331C375.57 67.9778 374.953 67.7222 374.31 67.7222H126.852Z", fill: "#426572" }),
        React.createElement("path", { d: "M311.31 280.81H193.372C190.692 280.81 188.52 282.983 188.52 285.663V290.919C188.52 293.599 190.692 295.771 193.372 295.771H311.31C313.99 295.771 316.162 293.599 316.162 290.919V285.663C316.162 282.983 313.99 280.81 311.31 280.81Z", fill: "#E8EDF7" }),
        React.createElement("path", { d: "M311.846 298.602H193.907C191.977 298.602 190.126 297.836 188.761 296.471C187.396 295.106 186.629 293.255 186.629 291.324V286.068C186.629 284.138 187.396 282.286 188.761 280.921C190.126 279.557 191.977 278.79 193.907 278.79H311.846C313.776 278.79 315.627 279.557 316.992 280.921C318.357 282.286 319.124 284.138 319.124 286.068V291.324C319.124 293.255 318.357 295.106 316.992 296.471C315.627 297.836 313.776 298.602 311.846 298.602ZM193.907 283.642C193.264 283.642 192.647 283.897 192.191 284.353C191.737 284.807 191.481 285.425 191.481 286.068V291.324C191.481 291.968 191.737 292.585 192.191 293.04C192.647 293.495 193.264 293.75 193.907 293.75H311.846C312.489 293.75 313.106 293.495 313.561 293.04C314.016 292.585 314.272 291.968 314.272 291.324V286.068C314.272 285.425 314.016 284.807 313.561 284.353C313.106 283.897 312.489 283.642 311.846 283.642H193.907Z", fill: "#426572" }),
        React.createElement("path", { d: "M136.766 81.167C138.552 81.167 140.001 79.719 140.001 77.9322C140.001 76.1459 138.552 74.6975 136.766 74.6975C134.98 74.6975 133.531 76.1459 133.531 77.9322C133.531 79.719 134.98 81.167 136.766 81.167Z", fill: "#CADCE8" }),
        React.createElement("path", { d: "M146.469 81.167C148.255 81.167 149.704 79.719 149.704 77.9322C149.704 76.1459 148.255 74.6975 146.469 74.6975C144.683 74.6975 143.234 76.1459 143.234 77.9322C143.234 79.719 144.683 81.167 146.469 81.167Z", fill: "#CADCE8" }),
        React.createElement("path", { d: "M156.172 81.167C157.959 81.167 159.407 79.719 159.407 77.9322C159.407 76.1459 157.959 74.6975 156.172 74.6975C154.386 74.6975 152.938 76.1459 152.938 77.9322C152.938 79.719 154.386 81.167 156.172 81.167Z", fill: "#CADCE8" }),
        React.createElement("path", { d: "M366.633 74.6975H169.718C168.266 74.6975 167.09 75.8741 167.09 77.3257V78.5388C167.09 79.9903 168.266 81.167 169.718 81.167H366.633C368.084 81.167 369.261 79.9903 369.261 78.5388V77.3257C369.261 75.8741 368.084 74.6975 366.633 74.6975Z", fill: "#CADCE8" }),
        React.createElement("path", { d: "M361.982 99.2617H141.211C138.532 99.2617 136.359 101.434 136.359 104.114V140.505C136.359 143.185 138.532 145.357 141.211 145.357H361.982C364.662 145.357 366.834 143.185 366.834 140.505V104.114C366.834 101.434 364.662 99.2617 361.982 99.2617Z", fill: "#3E74FF" }),
        React.createElement("path", { d: "M361.58 148.591H140.809C138.879 148.591 137.028 147.824 135.663 146.459C134.298 145.094 133.531 143.243 133.531 141.313V104.922C133.531 102.992 134.298 101.14 135.663 99.7754C137.028 98.4107 138.879 97.6437 140.809 97.6437H361.58C363.51 97.6437 365.362 98.4107 366.727 99.7754C368.092 101.14 368.858 102.992 368.858 104.922V141.313C368.858 143.243 368.092 145.094 366.727 146.459C365.362 147.824 363.51 148.591 361.58 148.591ZM140.809 102.496C140.166 102.496 139.549 102.751 139.094 103.207C138.639 103.661 138.383 104.279 138.383 104.922V141.313C138.383 141.956 138.639 142.573 139.094 143.028C139.549 143.483 140.166 143.739 140.809 143.739H361.58C362.223 143.739 362.84 143.483 363.296 143.028C363.751 142.573 364.006 141.956 364.006 141.313V104.922C364.006 104.279 363.751 103.661 363.296 103.207C362.84 102.751 362.223 102.496 361.58 102.496H140.809Z", fill: "#426572" }),
        React.createElement("path", { d: "M202.253 159.508H142.891C140.212 159.508 138.039 161.68 138.039 164.36V180.129C138.039 182.809 140.212 184.981 142.891 184.981H202.253C204.932 184.981 207.105 182.809 207.105 180.129V164.36C207.105 161.68 204.932 159.508 202.253 159.508Z", fill: "#009666" }),
        React.createElement("path", { d: "M201.386 187.813H142.02C140.09 187.813 138.239 187.046 136.874 185.681C135.509 184.316 134.742 182.465 134.742 180.535V164.765C134.742 162.835 135.509 160.984 136.874 159.619C138.239 158.254 140.09 157.487 142.02 157.487H201.386C203.316 157.487 205.167 158.254 206.532 159.619C207.897 160.984 208.664 162.835 208.664 164.765V180.535C208.664 182.465 207.897 184.316 206.532 185.681C205.167 187.046 203.316 187.813 201.386 187.813ZM142.024 162.339C141.381 162.339 140.764 162.595 140.309 163.05C139.854 163.505 139.598 164.122 139.598 164.765V180.535C139.598 181.178 139.854 181.795 140.309 182.25C140.764 182.705 141.381 182.961 142.024 182.961H201.386C202.029 182.961 202.646 182.705 203.101 182.25C203.556 181.795 203.812 181.178 203.812 180.535V164.765C203.812 164.122 203.556 163.505 203.101 163.05C202.646 162.595 202.029 162.339 201.386 162.339H142.024Z", fill: "#426572" }),
        React.createElement("path", { d: "M281.307 159.508H221.946C219.266 159.508 217.094 161.68 217.094 164.36V180.129C217.094 182.809 219.266 184.981 221.946 184.981H281.307C283.987 184.981 286.159 182.809 286.159 180.129V164.36C286.159 161.68 283.987 159.508 281.307 159.508Z", fill: "#009666" }),
        React.createElement("path", { d: "M280.444 187.813H221.079C219.149 187.813 217.298 187.046 215.932 185.681C214.567 184.316 213.801 182.465 213.801 180.535V164.765C213.801 162.835 214.567 160.984 215.932 159.619C217.298 158.254 219.149 157.487 221.079 157.487H280.444C282.375 157.487 284.226 158.254 285.591 159.619C286.956 160.984 287.723 162.835 287.723 164.765V180.535C287.723 182.465 286.956 184.316 285.591 185.681C284.226 187.046 282.375 187.813 280.444 187.813ZM221.083 162.339C220.44 162.339 219.823 162.595 219.367 163.05C218.912 163.505 218.657 164.122 218.657 164.765V180.535C218.657 181.178 218.912 181.795 219.367 182.25C219.823 182.705 220.44 182.961 221.083 182.961H280.444C281.088 182.961 281.705 182.705 282.16 182.25C282.615 181.795 282.87 181.178 282.87 180.535V164.765C282.87 164.122 282.615 163.505 282.16 163.05C281.705 162.595 281.088 162.339 280.444 162.339H221.083Z", fill: "#426572" }),
        React.createElement("path", { d: "M360.366 159.508H301.004C298.325 159.508 296.152 161.681 296.152 164.36V180.13C296.152 182.81 298.325 184.982 301.004 184.982H360.366C363.045 184.982 365.218 182.81 365.218 180.13V164.36C365.218 161.681 363.045 159.508 360.366 159.508Z", fill: "#009666" }),
        React.createElement("path", { d: "M359.499 187.813H300.134C298.203 187.813 296.352 187.046 294.987 185.681C293.622 184.316 292.855 182.465 292.855 180.535V164.765C292.855 162.835 293.622 160.984 294.987 159.619C296.352 158.254 298.203 157.487 300.134 157.487H359.499C361.429 157.487 363.281 158.254 364.646 159.619C366.011 160.984 366.777 162.835 366.777 164.765V180.535C366.777 182.465 366.011 184.316 364.646 185.681C363.281 187.046 361.429 187.813 359.499 187.813ZM300.138 162.339C299.494 162.339 298.877 162.595 298.422 163.05C297.967 163.505 297.712 164.122 297.712 164.765V180.535C297.712 181.178 297.967 181.795 298.422 182.25C298.877 182.705 299.494 182.961 300.138 182.961H359.499C360.142 182.961 360.759 182.705 361.215 182.25C361.67 181.795 361.925 181.178 361.925 180.535V164.765C361.925 164.122 361.67 163.505 361.215 163.05C360.759 162.595 360.142 162.339 359.499 162.339H300.138Z", fill: "#426572" }),
        React.createElement("path", { d: "M411.369 250.081H92.242C88.3967 250.077 84.7099 248.547 81.9912 245.828C79.272 243.109 77.7427 239.422 77.7383 235.577V55.9442C77.7427 52.0989 79.272 48.4125 81.9912 45.6933C84.7099 42.9741 88.3967 41.4449 92.242 41.4404H411.369C415.214 41.4449 418.902 42.9741 421.619 45.6933C424.34 48.4125 425.869 52.0989 425.873 55.9442V235.573C425.869 239.419 424.34 243.107 421.623 245.827C418.902 248.547 415.214 250.077 411.369 250.081ZM92.242 46.2925C89.6834 46.2958 87.2302 47.3139 85.4208 49.1229C83.6113 50.9324 82.5936 53.3855 82.5904 55.9442V235.573C82.5936 238.132 83.6113 240.585 85.4208 242.394C87.2302 244.204 89.6834 245.222 92.242 245.225H411.369C413.928 245.222 416.383 244.204 418.19 242.394C419.998 240.585 421.017 238.132 421.021 235.573V55.9442C421.017 53.3855 419.998 50.9324 418.19 49.1229C416.383 47.3139 413.928 46.2958 411.369 46.2925H92.242Z", fill: "#426572" }),
        React.createElement("path", { opacity: "0.1", d: "M44.9299 77.7905C45.5631 78.0849 46.2533 78.2365 46.9516 78.2353H44.9299V77.7905Z", fill: "#606060" }),
        React.createElement("path", { opacity: "0.2", d: "M160.216 31.7361V81.1668C160.216 82.4538 159.705 83.6879 158.794 84.5981C157.885 85.5078 156.651 86.0189 155.364 86.0189H67.4232V77.1234H44.9297V20.8189C44.9297 19.532 45.4408 18.2979 46.3509 17.3879C47.2607 16.478 48.4948 15.9668 49.7818 15.9668H148.894V31.7361H160.216Z", fill: "#606060" }),
        React.createElement("path", { d: "M38.4615 76.2085H143.995C146.674 76.2085 148.847 74.036 148.847 71.3564V11.918C148.847 9.23822 146.674 7.06586 143.995 7.06586H38.4615C35.7817 7.06586 33.6094 9.23822 33.6094 11.918V71.3564C33.6094 74.036 35.7817 76.2085 38.4615 76.2085Z", fill: "white" }),
        React.createElement("path", { d: "M148.038 70.3511H73.2344V74.7988H148.038V70.3511Z", fill: "#DEE6F1" }),
        React.createElement("path", { d: "M34.4648 71.8662V12.428C34.4648 11.1412 34.9761 9.907 35.886 8.99707C36.7959 8.08714 38.0301 7.57593 39.3169 7.57593H73.6375V76.7183H39.3169C38.0301 76.7183 36.7959 76.2072 35.886 75.2974C34.9761 74.3873 34.4648 73.1532 34.4648 71.8662Z", fill: "#3E74FF" }),
        React.createElement("path", { d: "M44.9308 77.7906C45.564 78.085 46.2542 78.237 46.9525 78.2354H40.0787C39.4162 78.235 38.7609 78.0987 38.1531 77.8351C37.5453 77.5715 36.9979 77.1861 36.5447 76.7029C36.1572 76.2881 35.844 75.8093 35.6188 75.2877C35.545 75.1147 35.4802 74.938 35.4247 74.758C35.2927 74.3116 35.226 73.8487 35.2266 73.3833V13.9451C35.2266 12.6583 35.7378 11.4241 36.6477 10.5142C37.5577 9.60423 38.7918 9.09302 40.0787 9.09302H46.9525C45.6655 9.09302 44.4314 9.60423 43.5216 10.5142C42.6115 11.4241 42.1004 12.6583 42.1004 13.9451V73.3833C42.0992 74.4002 42.4206 75.3912 43.0182 76.2137C43.1408 76.3916 43.2758 76.5606 43.4226 76.7191C43.5596 76.8614 43.7044 76.9961 43.8552 77.1234C44.1823 77.3927 44.5442 77.6171 44.9308 77.7906Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M144.042 79.5496H38.5086C37.4881 79.5512 36.479 79.3345 35.5488 78.9148C34.2642 78.3431 33.1727 77.4115 32.4064 76.2324C31.64 75.0533 31.2316 73.6777 31.2305 72.2715V12.8333C31.2343 11.379 31.6708 9.9587 32.4845 8.75332C33.2982 7.54793 34.4521 6.61196 35.7995 6.0646L36.2039 5.86243H36.3575C37.0513 5.64643 37.7739 5.53734 38.5005 5.53896H144.034C145.786 5.54607 147.478 6.18239 148.8 7.33197C150.122 8.48156 150.988 10.068 151.239 11.8022C151.288 12.1383 151.312 12.4775 151.312 12.8171V72.2553C151.314 73.7683 150.84 75.2438 149.957 76.4726C149.288 77.4199 148.402 78.193 147.373 78.7284C146.344 79.2637 145.202 79.5452 144.042 79.5496ZM37.2956 10.7307C36.9266 10.9438 36.6201 11.2502 36.4072 11.6194C36.1943 11.9885 36.0823 12.4072 36.0826 12.8333V72.2715C36.0834 72.7413 36.2206 73.201 36.4776 73.5941C36.7345 73.9875 37.1002 74.298 37.5301 74.4872C37.8375 74.6267 38.1712 74.6983 38.5086 74.6975H144.042C144.429 74.6963 144.81 74.6021 145.153 74.4238C145.496 74.245 145.792 73.9867 146.015 73.6705C146.309 73.2633 146.468 72.774 146.468 72.2715V12.8333C146.468 12.7263 146.459 12.6196 146.444 12.5139C146.366 11.9314 146.08 11.3968 145.639 11.0094C145.197 10.6219 144.629 10.408 144.042 10.4072H38.5086C38.243 10.4055 37.9791 10.4493 37.7282 10.5366L37.2956 10.7307Z", fill: "#426572" }),
        React.createElement("path", { d: "M75.2544 8.68872H70.4023V76.6181H75.2544V8.68872Z", fill: "#426572" }),
        React.createElement("path", { d: "M398.73 172.367V272.592C398.73 275.272 400.903 277.444 403.583 277.444H459.835C462.515 277.444 464.687 275.272 464.687 272.592V172.367C464.687 169.688 462.515 167.515 459.835 167.515H403.583C400.903 167.515 398.73 169.688 398.73 172.367Z", fill: "white" }),
        React.createElement("path", { d: "M464.687 174.238V273.415C464.683 274.836 464.116 276.197 463.114 277.203C462.111 278.209 460.752 278.779 459.333 278.789H404.108C402.684 278.784 401.32 278.217 400.313 277.21C399.306 276.203 398.739 274.839 398.734 273.415V269.833H449.463C450.89 269.828 452.257 269.258 453.264 268.247C454.271 267.236 454.837 265.866 454.837 264.439V168.864H459.333C460.752 168.874 462.111 169.444 463.114 170.45C464.116 171.456 464.683 172.818 464.687 174.238Z", fill: "#DEE6F1" }),
        React.createElement("path", { d: "M459.19 279.921H402.493C401.025 279.917 399.595 279.452 398.405 278.591C397.49 277.939 396.743 277.077 396.227 276.079C395.71 275.08 395.44 273.973 395.438 272.849V172.168C395.436 171.178 395.645 170.199 396.052 169.297C396.607 168.052 397.511 166.994 398.654 166.252C399.797 165.509 401.13 165.113 402.493 165.112H459.194C460.605 165.12 461.98 165.547 463.145 166.339C464.309 167.131 465.215 168.252 465.74 169.56L465.939 169.964V170.106C466.145 170.773 466.25 171.469 466.25 172.168V272.849C466.242 274.546 465.627 276.185 464.511 277.466C463.399 278.748 461.863 279.587 460.185 279.832C459.857 279.886 459.522 279.916 459.19 279.921ZM402.493 169.993C402.065 169.992 401.646 170.116 401.287 170.349C400.928 170.583 400.645 170.915 400.472 171.307C400.345 171.586 400.28 171.889 400.282 172.196V272.877C400.284 273.228 400.37 273.574 400.532 273.886C400.694 274.197 400.929 274.466 401.216 274.669C401.586 274.933 402.03 275.075 402.485 275.073H459.186C459.283 275.08 459.38 275.08 459.477 275.073C460.007 275 460.488 274.739 460.84 274.338C461.192 273.937 461.386 273.422 461.39 272.89V172.208C461.39 171.966 461.349 171.725 461.268 171.497L461.078 171.092C460.884 170.764 460.605 170.492 460.274 170.302C459.942 170.112 459.566 170.011 459.186 170.009L402.493 169.993Z", fill: "#426572" }),
        React.createElement("path", { d: "M451.426 203.411H411.121V208.263H451.426V203.411Z", fill: "#426572" }),
        React.createElement("path", { d: "M451.426 189.976H411.121V194.828H451.426V189.976Z", fill: "#426572" }),
        React.createElement("path", { d: "M451.426 218.638H411.121V223.49H451.426V218.638Z", fill: "#426572" }),
        React.createElement("path", { d: "M329.098 228.65H391.5C393.061 228.65 393.065 226.224 391.5 226.224H329.098C327.537 226.224 327.533 228.65 329.098 228.65Z", fill: "white" }),
        React.createElement("path", { d: "M304.969 228.65H321.211C322.772 228.65 322.776 226.224 321.211 226.224H304.969C303.408 226.224 303.404 228.65 304.969 228.65Z", fill: "white" }))));

const FPLogo = () => (React.createElement("svg", { width: "158", height: "40", viewBox: "0 0 158 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M44.7695 18.0209V1.00696H56.9705V4.12604H48.3578V7.81264H56.7117V10.9317H48.4296V18.0194L44.7695 18.0209Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M59.1104 1.94325C59.1103 1.55897 59.2256 1.18329 59.4417 0.863743C59.6577 0.544192 59.9649 0.295124 60.3243 0.148044C60.6838 0.000964415 61.0793 -0.0375191 61.4608 0.0374621C61.8424 0.112443 62.1929 0.29752 62.4679 0.569281C62.743 0.841043 62.9303 1.18728 63.0061 1.56419C63.0819 1.9411 63.0428 2.33176 62.8938 2.68674C62.7449 3.04172 62.4926 3.34507 62.169 3.55843C61.8455 3.7718 61.4651 3.88557 61.0761 3.88538C60.5556 3.88172 60.0575 3.67587 59.6895 3.31235C59.3215 2.94883 59.1131 2.45683 59.1094 1.94275L59.1104 1.94325ZM59.3833 18.0213V5.70022H62.6678V18.0213H59.3833Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M74.4101 18.0218V10.5642C74.4582 10.253 74.4317 9.93495 74.3328 9.63565C74.2339 9.33635 74.0653 9.06413 73.8406 8.84085C73.6159 8.61757 73.3413 8.44945 73.0389 8.35C72.7364 8.25055 72.4146 8.22253 72.0992 8.26821C71.5419 8.26713 70.9921 8.39481 70.4937 8.64102C69.9952 8.88724 69.562 9.24517 69.2285 9.68624V18.0218H65.9844V5.70116H69.2568V7.30338C69.8041 6.69193 70.4786 6.20437 71.2342 5.87401C71.9898 5.54366 72.8087 5.37829 73.6349 5.38921C74.1759 5.32477 74.7246 5.3814 75.2404 5.5549C75.7562 5.72841 76.2259 6.01434 76.6147 6.39151C77.0034 6.76868 77.3012 7.22742 77.4861 7.73373C77.6709 8.24005 77.7381 8.78096 77.6825 9.31639V18.0218H74.4101Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M81.5868 14.9022V8.52179H79.4766V5.68622H81.5433V2.32605H84.8446V5.70069H87.3853V8.53627H84.888V14.1081C84.888 14.8738 85.3044 15.4558 86.0361 15.4558C86.4442 15.4707 86.8449 15.3455 87.17 15.1014L87.8588 17.5541C87.0749 18.1427 86.099 18.4254 85.1174 18.3482C84.6417 18.4157 84.1567 18.3735 83.7002 18.225C83.2438 18.0764 82.8283 17.8256 82.4863 17.4921C82.1443 17.1585 81.8851 16.7514 81.729 16.3024C81.5729 15.8535 81.524 15.3749 81.5863 14.9042L81.5868 14.9022Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M95.2649 5.38879C98.9967 5.38879 101.523 8.13952 101.523 12.18V12.8888H92.3077C92.4289 13.7236 92.8674 14.4814 93.534 15.0083C94.2006 15.5352 95.0454 15.7916 95.8965 15.7253C97.1191 15.729 98.3019 15.296 99.2266 14.506L100.662 16.5903C99.2176 17.7604 97.3907 18.3703 95.5236 18.3059C94.6428 18.354 93.7616 18.2198 92.9364 17.9118C92.1113 17.6038 91.3604 17.1289 90.7319 16.5175C90.1034 15.9061 89.6113 15.1717 89.287 14.3614C88.9627 13.5511 88.8135 12.6828 88.8488 11.8121C88.8275 10.97 88.9783 10.1323 89.2922 9.34903C89.6061 8.56578 90.0766 7.85307 90.6757 7.25351C91.2747 6.65395 91.99 6.17985 92.7788 5.85955C93.5676 5.53924 94.4136 5.3793 95.2664 5.38929L95.2649 5.38879ZM92.2506 10.6487H98.4085C98.389 10.2658 98.291 9.89073 98.1206 9.54626C97.9502 9.2018 97.7108 8.89504 97.417 8.64455C97.1232 8.39405 96.7809 8.20502 96.411 8.08887C96.0411 7.97273 95.6512 7.93189 95.2649 7.96881C94.5141 7.96192 93.788 8.23334 93.2299 8.72949C92.6719 9.22563 92.3224 9.91043 92.2506 10.6487Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M109.778 5.38616C110.725 5.32776 111.671 5.50177 112.533 5.89266C113.394 6.28355 114.145 6.87916 114.716 7.62627L112.563 9.59685C112.273 9.17542 111.88 8.83262 111.421 8.5998C110.962 8.36698 110.451 8.25158 109.936 8.26416C109.468 8.25473 109.004 8.34253 108.574 8.52185C108.143 8.70117 107.756 8.968 107.436 9.30498C107.117 9.64197 106.873 10.0416 106.72 10.4778C106.568 10.914 106.51 11.3771 106.55 11.837C106.51 12.2981 106.568 12.7625 106.72 13.2001C106.873 13.6378 107.116 14.0391 107.435 14.3783C107.754 14.7175 108.141 14.987 108.572 15.1695C109.002 15.3521 109.467 15.4436 109.936 15.4382C110.449 15.4473 110.957 15.3318 111.416 15.1019C111.874 14.872 112.268 14.5347 112.563 14.1195L114.716 16.0761C114.146 16.8259 113.397 17.4243 112.535 17.8177C111.673 18.2112 110.726 18.3874 109.778 18.3307C108.902 18.3706 108.027 18.2304 107.209 17.9187C106.391 17.6071 105.647 17.1309 105.025 16.5204C104.403 15.9098 103.916 15.1782 103.595 14.372C103.274 13.5658 103.126 12.7025 103.161 11.837C103.133 10.9749 103.285 10.1164 103.608 9.31525C103.932 8.51415 104.42 7.78783 105.041 7.18197C105.663 6.57611 106.405 6.10381 107.22 5.79475C108.035 5.4857 108.906 5.34659 109.778 5.38616Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M125.309 18.0209V10.5204C125.309 8.80492 124.39 8.26585 122.969 8.26585C122.413 8.27124 121.866 8.40175 121.368 8.64746C120.871 8.89317 120.437 9.24762 120.099 9.68389V18.0194H116.797V1.00696H120.069V7.3165C120.62 6.70137 121.299 6.21163 122.06 5.88114C122.821 5.55065 123.645 5.38728 124.476 5.40233C125.014 5.3226 125.563 5.3647 126.082 5.52542C126.601 5.68615 127.076 5.9613 127.472 6.33008C127.867 6.69886 128.173 7.15162 128.365 7.65412C128.557 8.15663 128.631 8.69573 128.581 9.23068V18.0209H125.309Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M44.7695 39.5695V22.5535H52.8364C53.5874 22.5147 54.3386 22.6272 55.0441 22.8844C55.7497 23.1415 56.3948 23.5378 56.9403 24.0491C57.4858 24.5605 57.9202 25.1761 58.2171 25.8586C58.5139 26.5411 58.667 27.2762 58.667 28.019C58.667 28.7618 58.5139 29.4969 58.2171 30.1794C57.9202 30.8619 57.4858 31.4776 56.9403 31.9889C56.3948 32.5002 55.7497 32.8965 55.0441 33.1537C54.3386 33.4108 53.5874 33.5234 52.8364 33.4845H48.4296V39.5819L44.7695 39.5695ZM52.3342 25.6586H48.4296V30.3505H52.3342C52.662 30.3764 52.9917 30.3349 53.3026 30.2288C53.6134 30.1226 53.8986 29.9541 54.1403 29.7337C54.3819 29.5133 54.5748 29.2459 54.7067 28.9483C54.8386 28.6507 54.9066 28.3294 54.9066 28.0045C54.9066 27.6797 54.8386 27.3583 54.7067 27.0607C54.5748 26.7631 54.3819 26.4957 54.1403 26.2754C53.8986 26.055 53.6134 25.8865 53.3026 25.7803C52.9917 25.6742 52.662 25.6327 52.3342 25.6586Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M60.8164 39.5676V27.2465H64.0889V28.9196C64.5723 28.3287 65.1793 27.848 65.8683 27.5103C66.5573 27.1726 67.3121 26.9859 68.0809 26.963V30.125C67.3581 29.9873 66.6116 30.0348 65.9128 30.2632C65.2139 30.4915 64.5859 30.893 64.0889 31.4293V39.5651L60.8164 39.5676Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M69.7734 23.4899C69.7734 23.1057 69.8888 22.7301 70.1049 22.4106C70.321 22.0911 70.6281 21.8421 70.9875 21.6951C71.3469 21.5481 71.7423 21.5096 72.1238 21.5846C72.5053 21.6595 72.8558 21.8445 73.1308 22.1162C73.4059 22.3879 73.5932 22.734 73.6691 23.1109C73.7449 23.4877 73.706 23.8783 73.5571 24.2333C73.4083 24.5882 73.1562 24.8916 72.8328 25.1051C72.5094 25.3186 72.1291 25.4325 71.7401 25.4325C71.2185 25.4325 70.7183 25.2278 70.3495 24.8635C69.9806 24.4992 69.7734 24.0051 69.7734 23.4899ZM70.1181 39.568V27.2468H73.3915V39.568H70.1181Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M92.1365 39.568V31.784C92.1365 30.636 91.6054 29.8134 90.2703 29.8134C89.7577 29.8352 89.2573 29.9747 88.8088 30.2209C88.3603 30.467 87.9761 30.813 87.6866 31.2315V39.567H84.3707V31.784C84.3707 30.636 83.8538 29.8134 82.5192 29.8134C82.0069 29.8363 81.5069 29.9763 81.0586 30.2223C80.6102 30.4684 80.2258 30.8138 79.9355 31.2315V39.567H76.6055V27.2469H79.89V28.8491C80.3919 28.2612 81.0153 27.7861 81.7184 27.456C82.4215 27.1258 83.188 26.9481 83.9665 26.9349C84.7159 26.8593 85.4689 27.0405 86.0992 27.4481C86.7295 27.8556 87.1988 28.4648 87.4284 29.1735C87.9143 28.489 88.5584 27.9287 89.3073 27.5391C90.0562 27.1495 90.8884 26.9419 91.7347 26.9334C92.2395 26.8794 92.7501 26.9396 93.2278 27.1094C93.7055 27.2792 94.1378 27.5542 94.4919 27.9136C94.846 28.2729 95.1127 28.7072 95.2716 29.1835C95.4306 29.6597 95.4777 30.1655 95.4094 30.6624V39.568H92.1365Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M98.3242 23.4896C98.3242 23.1054 98.4396 22.7298 98.6557 22.4104C98.8718 22.0909 99.1789 21.8419 99.5383 21.6949C99.8977 21.5478 100.293 21.5094 100.675 21.5843C101.056 21.6593 101.407 21.8443 101.682 22.116C101.957 22.3877 102.144 22.7338 102.22 23.1106C102.296 23.4875 102.257 23.8781 102.108 24.233C101.959 24.588 101.707 24.8914 101.384 25.1049C101.06 25.3183 100.68 25.4323 100.291 25.4323C99.7693 25.4323 99.2691 25.2276 98.9003 24.8633C98.5314 24.499 98.3242 24.0048 98.3242 23.4896ZM98.6688 39.5677V27.2466H101.942V39.5677H98.6688Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M105.844 36.4484V30.0679H103.777V27.2324H105.844V23.8722H109.145V27.2468H111.686V30.0824H109.145V35.6542C109.145 36.4199 109.562 37.0723 110.293 37.0723C110.702 37.0872 111.102 36.962 111.427 36.7179L112.116 39.1706C111.336 39.7573 110.365 40.04 109.387 39.9647C108.904 40.0373 108.409 39.9963 107.945 39.8451C107.48 39.6938 107.058 39.4365 106.713 39.094C106.367 38.7516 106.109 38.3336 105.957 37.8739C105.806 37.4143 105.767 36.9259 105.842 36.4484H105.844Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M113.598 23.4899C113.598 23.1057 113.713 22.7301 113.929 22.4106C114.145 22.0911 114.452 21.8421 114.812 21.6951C115.171 21.5481 115.567 21.5096 115.948 21.5846C116.33 21.6595 116.68 21.8445 116.955 22.1162C117.23 22.3879 117.417 22.734 117.493 23.1109C117.569 23.4877 117.53 23.8783 117.381 24.2333C117.233 24.5882 116.98 24.8916 116.657 25.1051C116.334 25.3186 115.953 25.4325 115.564 25.4325C115.043 25.4325 114.543 25.2278 114.174 24.8635C113.805 24.4992 113.598 24.0051 113.598 23.4899ZM113.928 39.568V27.2468H117.212V39.568H113.928Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M123.704 39.5683L118.68 27.2472H122.196L125.412 35.8273L128.67 27.2472H132.217L127.193 39.5683H123.704Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M139.378 26.9349C143.11 26.9349 145.637 29.6856 145.637 33.7261V34.4349H136.364C136.486 35.2693 136.924 36.0268 137.59 36.5534C138.257 37.0801 139.101 37.3365 139.952 37.2704C141.177 37.2729 142.361 36.8344 143.282 36.0371L144.718 38.1334C143.273 39.3035 141.446 39.9134 139.579 39.849C138.696 39.9005 137.811 39.7749 136.978 39.4798C136.145 39.1848 135.381 38.7263 134.732 38.1319C134.083 37.5376 133.563 36.8197 133.202 36.0216C132.842 35.2234 132.648 34.3613 132.634 33.4874C132.619 32.6134 132.784 31.7456 133.118 30.9362C133.452 30.1267 133.948 29.3923 134.577 28.7773C135.205 28.1622 135.954 27.6792 136.776 27.3572C137.599 27.0353 138.479 26.8811 139.364 26.9039L139.378 26.9349ZM136.307 32.1953H142.466C142.452 31.8139 142.359 31.4394 142.195 31.094C142.031 30.7487 141.797 30.4397 141.509 30.1855C141.221 29.9313 140.884 29.7372 140.518 29.6148C140.152 29.4923 139.765 29.4441 139.38 29.473C138.612 29.452 137.866 29.7225 137.294 30.229C136.722 30.7354 136.369 31.4392 136.307 32.1953Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M148.377 35.6981C149.586 36.7102 151.1 37.2985 152.683 37.3712C154.119 37.3712 154.779 36.889 154.779 36.1233C154.779 35.3577 153.703 34.9464 152.281 34.7053C150.128 34.306 147.372 33.7979 147.372 30.862C147.372 28.7921 149.195 26.9772 152.482 26.9772C154.3 26.9415 156.074 27.5387 157.491 28.6643L156.2 30.8759C155.202 29.9502 153.88 29.4419 152.511 29.4579C151.319 29.4579 150.544 29.8832 150.544 30.6059C150.544 31.3287 151.535 31.6411 152.927 31.9246C155.065 32.3359 157.937 32.9029 157.937 35.9676C157.937 38.2362 155.999 39.9232 152.539 39.9232C150.495 39.9623 148.506 39.2669 146.941 37.9661L148.377 35.6981Z", fill: "#0F2C5E" }),
    React.createElement("path", { d: "M25.3992 0.61454C23.7061 0.48454 5.34938 0.61454 5.34938 0.61454C5.34938 0.61454 1.46178 0.105484 0.530376 4.89188C0.385806 5.63548 0.524706 7.25488 0.530376 8.95048C0.535235 10.8033 0.478136 13.5409 0.530376 16.5145C0.644574 23.0317 0.714218 30.2345 0.714218 30.2345C0.714218 30.2345 -0.176682 33.719 5.34775 36.0278C10.8722 38.3366 13.1893 32.8481 13.1893 32.8481L16.0852 28.4481C16.0852 28.4481 21.0755 26.4438 21.1646 26.3141C21.2537 26.1845 28.4716 19.3434 28.4716 19.3434C28.4716 19.3434 30.6548 16.1203 30.6548 15.9903C30.6548 15.8603 31.457 11.1106 31.457 11.1106L30.9225 7.5829L28.962 2.74657C28.962 2.74657 27.0923 0.74414 25.3992 0.61454Z", fill: "white" }),
    React.createElement("g", { filter: "url(#filter0_d_5_1191)" },
        React.createElement("path", { d: "M25.3992 0.616494C23.7061 0.486494 5.34938 0.616494 5.34938 0.616494C5.34938 0.616494 1.46178 0.107438 0.530376 4.89384C0.385806 5.63744 0.524706 7.25683 0.530376 8.95243C0.535235 10.8052 0.478136 13.5429 0.530376 16.5165C0.644574 23.0337 0.714218 30.2364 0.714218 30.2364C0.714218 30.2364 -0.176682 33.721 5.34775 36.0298C10.8722 38.3386 13.1893 32.8501 13.1893 32.8501L16.0852 28.4501C16.0852 28.4501 21.0755 26.4457 21.1646 26.3161C21.2537 26.1865 28.4716 19.3454 28.4716 19.3454C28.4716 19.3454 30.6548 16.1223 30.6548 15.9923C30.6548 15.8623 31.457 11.1126 31.457 11.1126L30.9225 7.58485L28.962 2.74852C28.962 2.74852 27.0923 0.746094 25.3992 0.616494Z", fill: "white" })),
    React.createElement("mask", { id: "mask0_5_1191", maskUnits: "userSpaceOnUse", x: "0", y: "-1", width: "38", height: "42" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.7673 4.0116C27.9886 1.204 27.9797 1.1796 27.9797 1.1796C27.6765 0.951781 27.3539 0.750233 27.0155 0.5772C26.6674 0.374575 26.2929 0.220068 25.9023 0.118C25.4616 0.0203309 25.0098 -0.0193464 24.5586 -4.57279e-07H5.7427C4.99124 -0.0168534 4.24448 0.121369 3.55018 0.405828C2.85588 0.690287 2.22931 1.11472 1.71054 1.652C0.642058 2.67573 0.0271087 4.0755 0 5.5456V30.68C0.0510419 32.145 0.662267 33.5364 1.71054 34.574C1.95351 34.692 2.07703 34.928 2.32162 35.046L7.08675 38.584C7.20824 38.82 7.45324 38.938 7.57554 39.056C8.47448 39.6666 9.53877 39.9955 10.6297 40C11.3133 40.0126 11.9926 39.8908 12.6281 39.6417C13.2636 39.3926 13.8426 39.0212 14.3315 38.5491C14.8204 38.077 15.2094 37.5136 15.4758 36.8917C15.7423 36.2698 15.8809 35.6017 15.8836 34.9264V34.3364C15.8761 33.8468 16.0643 33.374 16.4074 33.0205C16.7506 32.6671 17.2209 32.4615 17.7165 32.4484H18.4495C29.0792 32.4484 37.6319 27.0208 37.6319 16.4012V16.2832C37.6319 11.0916 35.5553 6.8436 31.7673 4.0116ZM3.17689 34.3364V34.2184H3.0554V34.0984H2.81243V33.9804H2.69094V33.8604H2.56945V33.7424C2.14666 33.3486 1.8092 32.8742 1.57755 32.3478C1.34589 31.8214 1.22485 31.254 1.22176 30.68V5.5456C1.2114 4.95178 1.32546 4.36227 1.55675 3.81406C1.78805 3.26586 2.13159 2.77081 2.56581 2.36C3.4258 1.55411 4.55766 1.09166 5.7427 1.062H24.5586C24.9251 1.062 25.2916 1.18 25.5362 1.18C25.869 1.27825 26.1955 1.39647 26.5138 1.534C27.2178 1.87804 27.8106 2.4093 28.2255 3.068C28.6266 3.7055 28.8383 4.44144 28.8366 5.192C28.8199 6.25748 28.3813 7.27411 27.6149 8.024C26.7768 8.77268 25.6902 9.19242 24.5603 9.204H13.562C13.1303 9.1965 12.7016 9.27639 12.3023 9.43874C11.9031 9.60109 11.5417 9.84246 11.2404 10.148C10.9317 10.4364 10.6858 10.7839 10.5178 11.1694C10.3497 11.5548 10.263 11.9701 10.263 12.3898C10.263 12.8095 10.3497 13.2248 10.5178 13.6102C10.6858 13.9957 10.9317 14.3432 11.2404 14.6316C11.5417 14.9371 11.9031 15.1785 12.3023 15.3409C12.7016 15.5032 13.1303 15.5831 13.562 15.5756H18.9382C20.0317 15.5878 21.0797 16.0095 21.8705 16.7556C22.2568 17.122 22.5641 17.5617 22.7741 18.0483C22.984 18.5349 23.0922 19.0584 23.0922 19.5874C23.0922 20.1164 22.984 20.6399 22.7741 21.1265C22.5641 21.6131 22.2568 22.0528 21.8705 22.4192C21.4952 22.811 21.0393 23.1191 20.5336 23.3227C20.0279 23.5264 19.484 23.6209 18.9382 23.6H12.7068C12.0658 23.6109 11.4535 23.8643 10.9962 24.308C10.7679 24.5205 10.5852 24.7764 10.4593 25.0602C10.3334 25.3441 10.2667 25.6501 10.2632 25.96V26.078V26.196V26.314V26.432V26.55V26.668V26.786V26.904V27.022V27.14V27.258V27.376V27.494V27.612V27.73V30.68C10.2614 31.2547 10.1413 31.823 9.91024 32.3504C9.67919 32.8778 9.34201 33.3533 8.91919 33.748C8.50203 34.16 8.00672 34.4867 7.46159 34.7095C6.91646 34.9322 6.33222 35.0466 5.7423 35.046C4.83496 35.065 3.94226 34.8181 3.17689 34.3364Z", fill: "white" })),
    React.createElement("g", { mask: "url(#mask0_5_1191)" },
        React.createElement("path", { d: "M-14.7372 -22.0629L-3.27193 -28.4628C6.50256 -33.9169 18.9998 -30.6792 24.644 -21.2333L31.8413 -9.18538C37.4845 0.261191 34.136 12.3404 24.3611 17.7948L12.8959 24.1947C3.12136 29.6488 -9.37586 26.4111 -15.0201 16.9652L-22.217 4.91707C-27.8605 -4.52929 -24.5117 -16.6088 -14.7372 -22.0629Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M1.99267 27.6356L32.9269 10.3745C35.0371 9.19273 37.531 8.87143 39.8776 9.47903C42.2241 10.0866 44.2377 11.5751 45.4896 13.6274L63.9262 44.4904C64.5283 45.502 64.919 46.6223 65.0755 47.7855C65.2319 48.9486 65.1509 50.1309 64.8371 51.2626C64.5233 52.3943 63.9832 53.4525 63.2486 54.3746C62.514 55.2967 61.5999 56.0641 60.5601 56.6315L29.6259 73.8926C27.5154 75.0744 25.0212 75.3955 22.6746 74.7876C20.328 74.1797 18.3143 72.6908 17.0627 70.6381L-1.37346 39.7767C-1.9755 38.7651 -2.36627 37.6447 -2.52272 36.4816C-2.67917 35.3185 -2.59812 34.1361 -2.28435 33.0044C-1.97059 31.8727 -1.43047 30.8146 -0.695878 29.8925C0.0387124 28.9704 0.952884 28.203 1.99267 27.6356Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M4.25781 -19.3466L45.0074 -42.0846L68.5248 -2.71625L27.7753 20.0218L4.25781 -19.3466Z", fill: "#3E74FF" }),
        React.createElement("path", { d: "M17.5738 11.1007L41.0767 50.4441L0.354706 73.1669L-23.1482 33.8235L17.5738 11.1007Z", fill: "#3E74FF" })),
    React.createElement("defs", null,
        React.createElement("filter", { id: "filter0_d_5_1191", x: "-1.93516", y: "-0.641284", width: "35.7922", height: "40.8381", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
            React.createElement("feOffset", { dy: "1.2" }),
            React.createElement("feGaussianBlur", { stdDeviation: "1.2" }),
            React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.161 0" }),
            React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_5_1191" }),
            React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_5_1191", result: "shape" })))));

const SandboxSvg = () => (React.createElement("svg", { width: "192", height: "148", viewBox: "0 0 192 148", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { "clip-path": "url(#clip0_120_3945)" },
        React.createElement("path", { d: "M186.631 59.3929C186.639 59.3671 186.648 59.3408 186.656 59.3149C186.652 59.3263 186.648 59.3372 186.645 59.3486L186.631 59.3929Z", fill: "#2F2E41" }),
        React.createElement("path", { d: "M172.514 0.0971069H0.0749512V110.167H172.514V0.0971069Z", fill: "#E6E6E6" }),
        React.createElement("path", { d: "M167.587 13.9041H5.00928V103.657H167.587V13.9041Z", fill: "white" }),
        React.createElement("path", { d: "M172.443 0H0.00390625V7.30146H172.443V0Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M5.44519 5.08496C6.19508 5.08496 6.80298 4.47908 6.80298 3.73169C6.80298 2.9843 6.19508 2.37842 5.44519 2.37842C4.69531 2.37842 4.0874 2.9843 4.0874 3.73169C4.0874 4.47908 4.69531 5.08496 5.44519 5.08496Z", fill: "white" }),
        React.createElement("path", { d: "M10.5985 5.08496C11.3484 5.08496 11.9563 4.47908 11.9563 3.73169C11.9563 2.9843 11.3484 2.37842 10.5985 2.37842C9.84863 2.37842 9.24072 2.9843 9.24072 3.73169C9.24072 4.47908 9.84863 5.08496 10.5985 5.08496Z", fill: "white" }),
        React.createElement("path", { d: "M15.7548 5.08496C16.5046 5.08496 17.1126 4.47908 17.1126 3.73169C17.1126 2.9843 16.5046 2.37842 15.7548 2.37842C15.0049 2.37842 14.397 2.9843 14.397 3.73169C14.397 4.47908 15.0049 5.08496 15.7548 5.08496Z", fill: "white" }),
        React.createElement("path", { d: "M154.469 33.3876H93.5969V39.9314H154.469V33.3876Z", fill: "#2955D9" }),
        React.createElement("path", { d: "M154.469 51.5535H93.5969V54.8254H154.469V51.5535Z", fill: "#E6E6E6" }),
        React.createElement("path", { d: "M154.469 61.5404H93.5969V64.8123H154.469V61.5404Z", fill: "#E6E6E6" }),
        React.createElement("path", { d: "M154.469 71.6535H93.5969V74.9254H154.469V71.6535Z", fill: "#E6E6E6" }),
        React.createElement("path", { d: "M69.4594 30.2763H15.9656V83.5921H69.4594V30.2763Z", fill: "#E6E6E6" }),
        React.createElement("path", { d: "M16.4065 29.855L15.5625 30.6962L68.9828 83.9386L69.8268 83.0974L16.4065 29.855Z", fill: "white" }),
        React.createElement("path", { d: "M68.9828 29.8566L15.5625 83.0991L16.4065 83.9403L69.8268 30.6978L68.9828 29.8566Z", fill: "white" }),
        React.createElement("path", { d: "M192.03 77.0367H126.841V144.039H192.03V77.0367Z", fill: "#3F3D56" }),
        React.createElement("path", { d: "M171.798 106.932H146.928M161.85 117.466L164.959 114.368L161.85 111.269M156.876 111.269L153.767 114.368L156.876 117.466M146.928 105.444L146.928 115.855C146.928 117.937 146.928 118.978 147.335 119.774C147.692 120.473 148.263 121.042 148.965 121.399C149.763 121.804 150.808 121.804 152.897 121.804H165.829C167.919 121.804 168.963 121.804 169.761 121.399C170.463 121.042 171.034 120.473 171.391 119.774C171.798 118.978 171.798 117.937 171.798 115.855V105.444C171.798 103.362 171.798 102.321 171.391 101.526C171.034 100.826 170.463 100.257 169.761 99.9008C168.963 99.4955 167.919 99.4955 165.829 99.4955L152.897 99.4955C150.808 99.4955 149.763 99.4955 148.965 99.9008C148.263 100.257 147.692 100.826 147.335 101.526C146.928 102.321 146.928 103.362 146.928 105.444Z", stroke: "white", strokeWidth: "3.09837", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_120_3945" },
            React.createElement("rect", { width: "192", height: "148", fill: "white" })))));

export { Accordion, AccordionDetails, AccordionIcon, AccordionSummary, AccordionTitle, Autocomplete, Avatar, Banner, BreadcrumbText as BreadCrumbText, Breadcrumbs as BreadCrumbs, Button, Card, Checkbox, Checklist, ChecklistDesc, ChecklistItem, ChecklistStatus, ChecklistTitle, Chip, ChipContainer, CodeBlock, Col, CollapseButton, Colors, Container, Content, DashboardLayout, DataCard, DataItem, DataTable, DatePickerMui, Daterangepicker, DaySelector, Description, DoughnutChart as DonutChart, Drawer, Dropdown, ErrorCrossSvg, ErrorSvg, FPLogo, Feature, FileUploader, FixedWrapper, Footer, hamburgerButton as HamburgerButton, Header, Icon, InfoCard, Label, LandingImage, Layout, List, ListItem, Loader, Menu, MenuIconIcon as MenuIcon, MenuItem, MenuText, Message, Modal, MultiSelector, NavList, NavListItem, NoRowsOverlay as NoRows, OptionGroup, OptionGroupTitle, OptionList, OptionListItem, OrderStatus, OutlineTable, PageTitle, PairList, PairListItem, PairListKey, PairListValue, Panel, PanelBlock, PanelBlockTitle, PanelBlockInfo as PanelBlockinfo, PanelCard, PanelCol, PanelRow, PanelTitle, Radio, Row, SandboxSvg, SearchAutocomplete, SelectableList, SelectableListItem, Selector, Sidebar, Slider, SmartCard, SmartCardGroup, SnippetList, SnippetListItem, Spotlight as SpotLight, Status, StatusBadge, Tabs, Tag, Text, TextArea, TextInput, Toast, ToggleSwitch, Tooltip, Typo, VideoPlayer, WidgetList, WidgetListItem, tailWindClass };
